import { toCSSValue as toCSSValue_1$1, getToken as getToken_1, toSpacingCSSValue as toSpacingCSSValue_1 } from './tokens.js';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __classPrivateFieldGet$1(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$6=window,e$a=t$6.ShadowRoot&&(void 0===t$6.ShadyCSS||t$6.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s$c=Symbol(),n$c=new WeakMap;let o$c = class o{constructor(t,e,n){if(this._$cssResult$=!0,n!==s$c)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e;}get styleSheet(){let t=this.o;const s=this.t;if(e$a&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=n$c.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&n$c.set(s,t));}return t}toString(){return this.cssText}};const r$a=t=>new o$c("string"==typeof t?t:t+"",void 0,s$c),S$5=(s,n)=>{e$a?s.adoptedStyleSheets=n.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):n.forEach((e=>{const n=document.createElement("style"),o=t$6.litNonce;void 0!==o&&n.setAttribute("nonce",o),n.textContent=e.cssText,s.appendChild(n);}));},c$5=e$a?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return r$a(e)})(t):t;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var s$b;const e$9=window,r$9=e$9.trustedTypes,h$5=r$9?r$9.emptyScript:"",o$b=e$9.reactiveElementPolyfillSupport,n$b={toAttribute(t,i){switch(i){case Boolean:t=t?h$5:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t);}return t},fromAttribute(t,i){let s=t;switch(i){case Boolean:s=null!==t;break;case Number:s=null===t?null:Number(t);break;case Object:case Array:try{s=JSON.parse(t);}catch(t){s=null;}}return s}},a$6=(t,i)=>i!==t&&(i==i||t==t),l$8={attribute:!0,type:String,converter:n$b,reflect:!1,hasChanged:a$6},d$5="finalized";let u$5 = class u extends HTMLElement{constructor(){super(),this._$Ei=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$El=null,this._$Eu();}static addInitializer(t){var i;this.finalize(),(null!==(i=this.h)&&void 0!==i?i:this.h=[]).push(t);}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((i,s)=>{const e=this._$Ep(s,i);void 0!==e&&(this._$Ev.set(e,s),t.push(e));})),t}static createProperty(t,i=l$8){if(i.state&&(i.attribute=!1),this.finalize(),this.elementProperties.set(t,i),!i.noAccessor&&!this.prototype.hasOwnProperty(t)){const s="symbol"==typeof t?Symbol():"__"+t,e=this.getPropertyDescriptor(t,s,i);void 0!==e&&Object.defineProperty(this.prototype,t,e);}}static getPropertyDescriptor(t,i,s){return {get(){return this[i]},set(e){const r=this[t];this[i]=e,this.requestUpdate(t,r,s);},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||l$8}static finalize(){if(this.hasOwnProperty(d$5))return !1;this[d$5]=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),void 0!==t.h&&(this.h=[...t.h]),this.elementProperties=new Map(t.elementProperties),this._$Ev=new Map,this.hasOwnProperty("properties")){const t=this.properties,i=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const s of i)this.createProperty(s,t[s]);}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(i){const s=[];if(Array.isArray(i)){const e=new Set(i.flat(1/0).reverse());for(const i of e)s.unshift(c$5(i));}else void 0!==i&&s.push(c$5(i));return s}static _$Ep(t,i){const s=i.attribute;return !1===s?void 0:"string"==typeof s?s:"string"==typeof t?t.toLowerCase():void 0}_$Eu(){var t;this._$E_=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Eg(),this.requestUpdate(),null===(t=this.constructor.h)||void 0===t||t.forEach((t=>t(this)));}addController(t){var i,s;(null!==(i=this._$ES)&&void 0!==i?i:this._$ES=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(s=t.hostConnected)||void 0===s||s.call(t));}removeController(t){var i;null===(i=this._$ES)||void 0===i||i.splice(this._$ES.indexOf(t)>>>0,1);}_$Eg(){this.constructor.elementProperties.forEach(((t,i)=>{this.hasOwnProperty(i)&&(this._$Ei.set(i,this[i]),delete this[i]);}));}createRenderRoot(){var t;const s=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return S$5(s,this.constructor.elementStyles),s}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostConnected)||void 0===i?void 0:i.call(t)}));}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostDisconnected)||void 0===i?void 0:i.call(t)}));}attributeChangedCallback(t,i,s){this._$AK(t,s);}_$EO(t,i,s=l$8){var e;const r=this.constructor._$Ep(t,s);if(void 0!==r&&!0===s.reflect){const h=(void 0!==(null===(e=s.converter)||void 0===e?void 0:e.toAttribute)?s.converter:n$b).toAttribute(i,s.type);this._$El=t,null==h?this.removeAttribute(r):this.setAttribute(r,h),this._$El=null;}}_$AK(t,i){var s;const e=this.constructor,r=e._$Ev.get(t);if(void 0!==r&&this._$El!==r){const t=e.getPropertyOptions(r),h="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==(null===(s=t.converter)||void 0===s?void 0:s.fromAttribute)?t.converter:n$b;this._$El=r,this[r]=h.fromAttribute(i,t.type),this._$El=null;}}requestUpdate(t,i,s){let e=!0;void 0!==t&&(((s=s||this.constructor.getPropertyOptions(t)).hasChanged||a$6)(this[t],i)?(this._$AL.has(t)||this._$AL.set(t,i),!0===s.reflect&&this._$El!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,s))):e=!1),!this.isUpdatePending&&e&&(this._$E_=this._$Ej());}async _$Ej(){this.isUpdatePending=!0;try{await this._$E_;}catch(t){Promise.reject(t);}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Ei&&(this._$Ei.forEach(((t,i)=>this[i]=t)),this._$Ei=void 0);let i=!1;const s=this._$AL;try{i=this.shouldUpdate(s),i?(this.willUpdate(s),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostUpdate)||void 0===i?void 0:i.call(t)})),this.update(s)):this._$Ek();}catch(t){throw i=!1,this._$Ek(),t}i&&this._$AE(s);}willUpdate(t){}_$AE(t){var i;null===(i=this._$ES)||void 0===i||i.forEach((t=>{var i;return null===(i=t.hostUpdated)||void 0===i?void 0:i.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t);}_$Ek(){this._$AL=new Map,this.isUpdatePending=!1;}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$E_}shouldUpdate(t){return !0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,i)=>this._$EO(i,this[i],t))),this._$EC=void 0),this._$Ek();}updated(t){}firstUpdated(t){}};u$5[d$5]=!0,u$5.elementProperties=new Map,u$5.elementStyles=[],u$5.shadowRootOptions={mode:"open"},null==o$b||o$b({ReactiveElement:u$5}),(null!==(s$b=e$9.reactiveElementVersions)&&void 0!==s$b?s$b:e$9.reactiveElementVersions=[]).push("1.6.3");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t$5;const i$6=window,s$a=i$6.trustedTypes,e$8=s$a?s$a.createPolicy("lit-html",{createHTML:t=>t}):void 0,o$a="$lit$",n$a=`lit$${(Math.random()+"").slice(9)}$`,l$7="?"+n$a,h$4=`<${l$7}>`,r$8=document,u$4=()=>r$8.createComment(""),d$4=t=>null===t||"object"!=typeof t&&"function"!=typeof t,c$4=Array.isArray,v$1=t=>c$4(t)||"function"==typeof(null==t?void 0:t[Symbol.iterator]),a$5="[ \t\n\f\r]",f$1=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,_$1=/-->/g,m$2=/>/g,p$2=RegExp(`>|${a$5}(?:([^\\s"'>=/]+)(${a$5}*=${a$5}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),g$1=/'/g,$$1=/"/g,y$1=/^(?:script|style|textarea|title)$/i,w$1=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),x=w$1(1),b$1=w$1(2),T$1=Symbol.for("lit-noChange"),A$1=Symbol.for("lit-nothing"),E$1=new WeakMap,C$1=r$8.createTreeWalker(r$8,129,null,!1);function P$1(t,i){if(!Array.isArray(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==e$8?e$8.createHTML(i):i}const V$1=(t,i)=>{const s=t.length-1,e=[];let l,r=2===i?"<svg>":"",u=f$1;for(let i=0;i<s;i++){const s=t[i];let d,c,v=-1,a=0;for(;a<s.length&&(u.lastIndex=a,c=u.exec(s),null!==c);)a=u.lastIndex,u===f$1?"!--"===c[1]?u=_$1:void 0!==c[1]?u=m$2:void 0!==c[2]?(y$1.test(c[2])&&(l=RegExp("</"+c[2],"g")),u=p$2):void 0!==c[3]&&(u=p$2):u===p$2?">"===c[0]?(u=null!=l?l:f$1,v=-1):void 0===c[1]?v=-2:(v=u.lastIndex-c[2].length,d=c[1],u=void 0===c[3]?p$2:'"'===c[3]?$$1:g$1):u===$$1||u===g$1?u=p$2:u===_$1||u===m$2?u=f$1:(u=p$2,l=void 0);const w=u===p$2&&t[i+1].startsWith("/>")?" ":"";r+=u===f$1?s+h$4:v>=0?(e.push(d),s.slice(0,v)+o$a+s.slice(v)+n$a+w):s+n$a+(-2===v?(e.push(void 0),i):w);}return [P$1(t,r+(t[s]||"<?>")+(2===i?"</svg>":"")),e]};let N$1 = class N{constructor({strings:t,_$litType$:i},e){let h;this.parts=[];let r=0,d=0;const c=t.length-1,v=this.parts,[a,f]=V$1(t,i);if(this.el=N.createElement(a,e),C$1.currentNode=this.el.content,2===i){const t=this.el.content,i=t.firstChild;i.remove(),t.append(...i.childNodes);}for(;null!==(h=C$1.nextNode())&&v.length<c;){if(1===h.nodeType){if(h.hasAttributes()){const t=[];for(const i of h.getAttributeNames())if(i.endsWith(o$a)||i.startsWith(n$a)){const s=f[d++];if(t.push(i),void 0!==s){const t=h.getAttribute(s.toLowerCase()+o$a).split(n$a),i=/([.?@])?(.*)/.exec(s);v.push({type:1,index:r,name:i[2],strings:t,ctor:"."===i[1]?H$1:"?"===i[1]?L$1:"@"===i[1]?z$1:k$1});}else v.push({type:6,index:r});}for(const i of t)h.removeAttribute(i);}if(y$1.test(h.tagName)){const t=h.textContent.split(n$a),i=t.length-1;if(i>0){h.textContent=s$a?s$a.emptyScript:"";for(let s=0;s<i;s++)h.append(t[s],u$4()),C$1.nextNode(),v.push({type:2,index:++r});h.append(t[i],u$4());}}}else if(8===h.nodeType)if(h.data===l$7)v.push({type:2,index:r});else {let t=-1;for(;-1!==(t=h.data.indexOf(n$a,t+1));)v.push({type:7,index:r}),t+=n$a.length-1;}r++;}}static createElement(t,i){const s=r$8.createElement("template");return s.innerHTML=t,s}};function S$4(t,i,s=t,e){var o,n,l,h;if(i===T$1)return i;let r=void 0!==e?null===(o=s._$Co)||void 0===o?void 0:o[e]:s._$Cl;const u=d$4(i)?void 0:i._$litDirective$;return (null==r?void 0:r.constructor)!==u&&(null===(n=null==r?void 0:r._$AO)||void 0===n||n.call(r,!1),void 0===u?r=void 0:(r=new u(t),r._$AT(t,s,e)),void 0!==e?(null!==(l=(h=s)._$Co)&&void 0!==l?l:h._$Co=[])[e]=r:s._$Cl=r),void 0!==r&&(i=S$4(t,r._$AS(t,i.values),r,e)),i}let M$1 = class M{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i;}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){var i;const{el:{content:s},parts:e}=this._$AD,o=(null!==(i=null==t?void 0:t.creationScope)&&void 0!==i?i:r$8).importNode(s,!0);C$1.currentNode=o;let n=C$1.nextNode(),l=0,h=0,u=e[0];for(;void 0!==u;){if(l===u.index){let i;2===u.type?i=new R$1(n,n.nextSibling,this,t):1===u.type?i=new u.ctor(n,u.name,u.strings,this,t):6===u.type&&(i=new Z$1(n,this,t)),this._$AV.push(i),u=e[++h];}l!==(null==u?void 0:u.index)&&(n=C$1.nextNode(),l++);}return C$1.currentNode=r$8,o}v(t){let i=0;for(const s of this._$AV)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++;}};let R$1 = class R{constructor(t,i,s,e){var o;this.type=2,this._$AH=A$1,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cp=null===(o=null==e?void 0:e.isConnected)||void 0===o||o;}get _$AU(){var t,i;return null!==(i=null===(t=this._$AM)||void 0===t?void 0:t._$AU)&&void 0!==i?i:this._$Cp}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===(null==t?void 0:t.nodeType)&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=S$4(this,t,i),d$4(t)?t===A$1||null==t||""===t?(this._$AH!==A$1&&this._$AR(),this._$AH=A$1):t!==this._$AH&&t!==T$1&&this._(t):void 0!==t._$litType$?this.g(t):void 0!==t.nodeType?this.$(t):v$1(t)?this.T(t):this._(t);}k(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}$(t){this._$AH!==t&&(this._$AR(),this._$AH=this.k(t));}_(t){this._$AH!==A$1&&d$4(this._$AH)?this._$AA.nextSibling.data=t:this.$(r$8.createTextNode(t)),this._$AH=t;}g(t){var i;const{values:s,_$litType$:e}=t,o="number"==typeof e?this._$AC(t):(void 0===e.el&&(e.el=N$1.createElement(P$1(e.h,e.h[0]),this.options)),e);if((null===(i=this._$AH)||void 0===i?void 0:i._$AD)===o)this._$AH.v(s);else {const t=new M$1(o,this),i=t.u(this.options);t.v(s),this.$(i),this._$AH=t;}}_$AC(t){let i=E$1.get(t.strings);return void 0===i&&E$1.set(t.strings,i=new N$1(t)),i}T(t){c$4(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const o of t)e===i.length?i.push(s=new R(this.k(u$4()),this.k(u$4()),this,this.options)):s=i[e],s._$AI(o),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e);}_$AR(t=this._$AA.nextSibling,i){var s;for(null===(s=this._$AP)||void 0===s||s.call(this,!1,!0,i);t&&t!==this._$AB;){const i=t.nextSibling;t.remove(),t=i;}}setConnected(t){var i;void 0===this._$AM&&(this._$Cp=t,null===(i=this._$AP)||void 0===i||i.call(this,t));}};let k$1 = class k{constructor(t,i,s,e,o){this.type=1,this._$AH=A$1,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=o,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=A$1;}get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}_$AI(t,i=this,s,e){const o=this.strings;let n=!1;if(void 0===o)t=S$4(this,t,i,0),n=!d$4(t)||t!==this._$AH&&t!==T$1,n&&(this._$AH=t);else {const e=t;let l,h;for(t=o[0],l=0;l<o.length-1;l++)h=S$4(this,e[s+l],i,l),h===T$1&&(h=this._$AH[l]),n||(n=!d$4(h)||h!==this._$AH[l]),h===A$1?t=A$1:t!==A$1&&(t+=(null!=h?h:"")+o[l+1]),this._$AH[l]=h;}n&&!e&&this.j(t);}j(t){t===A$1?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,null!=t?t:"");}};let H$1 = class H extends k$1{constructor(){super(...arguments),this.type=3;}j(t){this.element[this.name]=t===A$1?void 0:t;}};const I$1=s$a?s$a.emptyScript:"";let L$1 = class L extends k$1{constructor(){super(...arguments),this.type=4;}j(t){t&&t!==A$1?this.element.setAttribute(this.name,I$1):this.element.removeAttribute(this.name);}};let z$1 = class z extends k$1{constructor(t,i,s,e,o){super(t,i,s,e,o),this.type=5;}_$AI(t,i=this){var s;if((t=null!==(s=S$4(this,t,i,0))&&void 0!==s?s:A$1)===T$1)return;const e=this._$AH,o=t===A$1&&e!==A$1||t.capture!==e.capture||t.once!==e.once||t.passive!==e.passive,n=t!==A$1&&(e===A$1||o);o&&this.element.removeEventListener(this.name,this,e),n&&this.element.addEventListener(this.name,this,t),this._$AH=t;}handleEvent(t){var i,s;"function"==typeof this._$AH?this._$AH.call(null!==(s=null===(i=this.options)||void 0===i?void 0:i.host)&&void 0!==s?s:this.element,t):this._$AH.handleEvent(t);}};let Z$1 = class Z{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s;}get _$AU(){return this._$AM._$AU}_$AI(t){S$4(this,t);}};const B$1=i$6.litHtmlPolyfillSupport;null==B$1||B$1(N$1,R$1),(null!==(t$5=i$6.litHtmlVersions)&&void 0!==t$5?t$5:i$6.litHtmlVersions=[]).push("2.8.0");const D$1=(t,i,s)=>{var e,o;const n=null!==(e=null==s?void 0:s.renderBefore)&&void 0!==e?e:i;let l=n._$litPart$;if(void 0===l){const t=null!==(o=null==s?void 0:s.renderBefore)&&void 0!==o?o:null;n._$litPart$=l=new R$1(i.insertBefore(u$4(),t),t,void 0,null!=s?s:{});}return l._$AI(t),l};

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$4=window,e$7=t$4.ShadowRoot&&(void 0===t$4.ShadyCSS||t$4.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s$9=Symbol(),n$9=new WeakMap;let o$9 = class o{constructor(t,e,n){if(this._$cssResult$=!0,n!==s$9)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e;}get styleSheet(){let t=this.o;const s=this.t;if(e$7&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=n$9.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&n$9.set(s,t));}return t}toString(){return this.cssText}};const r$7=t=>new o$9("string"==typeof t?t:t+"",void 0,s$9),i$5=(t,...e)=>{const n=1===t.length?t[0]:e.reduce(((e,s,n)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(s)+t[n+1]),t[0]);return new o$9(n,t,s$9)},S$3=(s,n)=>{e$7?s.adoptedStyleSheets=n.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):n.forEach((e=>{const n=document.createElement("style"),o=t$4.litNonce;void 0!==o&&n.setAttribute("nonce",o),n.textContent=e.cssText,s.appendChild(n);}));},c$3=e$7?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return r$7(e)})(t):t;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var s$8;const e$6=window,r$6=e$6.trustedTypes,h$3=r$6?r$6.emptyScript:"",o$8=e$6.reactiveElementPolyfillSupport,n$8={toAttribute(t,i){switch(i){case Boolean:t=t?h$3:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t);}return t},fromAttribute(t,i){let s=t;switch(i){case Boolean:s=null!==t;break;case Number:s=null===t?null:Number(t);break;case Object:case Array:try{s=JSON.parse(t);}catch(t){s=null;}}return s}},a$4=(t,i)=>i!==t&&(i==i||t==t),l$6={attribute:!0,type:String,converter:n$8,reflect:!1,hasChanged:a$4},d$3="finalized";let u$3 = class u extends HTMLElement{constructor(){super(),this._$Ei=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$El=null,this._$Eu();}static addInitializer(t){var i;this.finalize(),(null!==(i=this.h)&&void 0!==i?i:this.h=[]).push(t);}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((i,s)=>{const e=this._$Ep(s,i);void 0!==e&&(this._$Ev.set(e,s),t.push(e));})),t}static createProperty(t,i=l$6){if(i.state&&(i.attribute=!1),this.finalize(),this.elementProperties.set(t,i),!i.noAccessor&&!this.prototype.hasOwnProperty(t)){const s="symbol"==typeof t?Symbol():"__"+t,e=this.getPropertyDescriptor(t,s,i);void 0!==e&&Object.defineProperty(this.prototype,t,e);}}static getPropertyDescriptor(t,i,s){return {get(){return this[i]},set(e){const r=this[t];this[i]=e,this.requestUpdate(t,r,s);},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||l$6}static finalize(){if(this.hasOwnProperty(d$3))return !1;this[d$3]=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),void 0!==t.h&&(this.h=[...t.h]),this.elementProperties=new Map(t.elementProperties),this._$Ev=new Map,this.hasOwnProperty("properties")){const t=this.properties,i=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const s of i)this.createProperty(s,t[s]);}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(i){const s=[];if(Array.isArray(i)){const e=new Set(i.flat(1/0).reverse());for(const i of e)s.unshift(c$3(i));}else void 0!==i&&s.push(c$3(i));return s}static _$Ep(t,i){const s=i.attribute;return !1===s?void 0:"string"==typeof s?s:"string"==typeof t?t.toLowerCase():void 0}_$Eu(){var t;this._$E_=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Eg(),this.requestUpdate(),null===(t=this.constructor.h)||void 0===t||t.forEach((t=>t(this)));}addController(t){var i,s;(null!==(i=this._$ES)&&void 0!==i?i:this._$ES=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(s=t.hostConnected)||void 0===s||s.call(t));}removeController(t){var i;null===(i=this._$ES)||void 0===i||i.splice(this._$ES.indexOf(t)>>>0,1);}_$Eg(){this.constructor.elementProperties.forEach(((t,i)=>{this.hasOwnProperty(i)&&(this._$Ei.set(i,this[i]),delete this[i]);}));}createRenderRoot(){var t;const s=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return S$3(s,this.constructor.elementStyles),s}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostConnected)||void 0===i?void 0:i.call(t)}));}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostDisconnected)||void 0===i?void 0:i.call(t)}));}attributeChangedCallback(t,i,s){this._$AK(t,s);}_$EO(t,i,s=l$6){var e;const r=this.constructor._$Ep(t,s);if(void 0!==r&&!0===s.reflect){const h=(void 0!==(null===(e=s.converter)||void 0===e?void 0:e.toAttribute)?s.converter:n$8).toAttribute(i,s.type);this._$El=t,null==h?this.removeAttribute(r):this.setAttribute(r,h),this._$El=null;}}_$AK(t,i){var s;const e=this.constructor,r=e._$Ev.get(t);if(void 0!==r&&this._$El!==r){const t=e.getPropertyOptions(r),h="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==(null===(s=t.converter)||void 0===s?void 0:s.fromAttribute)?t.converter:n$8;this._$El=r,this[r]=h.fromAttribute(i,t.type),this._$El=null;}}requestUpdate(t,i,s){let e=!0;void 0!==t&&(((s=s||this.constructor.getPropertyOptions(t)).hasChanged||a$4)(this[t],i)?(this._$AL.has(t)||this._$AL.set(t,i),!0===s.reflect&&this._$El!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,s))):e=!1),!this.isUpdatePending&&e&&(this._$E_=this._$Ej());}async _$Ej(){this.isUpdatePending=!0;try{await this._$E_;}catch(t){Promise.reject(t);}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Ei&&(this._$Ei.forEach(((t,i)=>this[i]=t)),this._$Ei=void 0);let i=!1;const s=this._$AL;try{i=this.shouldUpdate(s),i?(this.willUpdate(s),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostUpdate)||void 0===i?void 0:i.call(t)})),this.update(s)):this._$Ek();}catch(t){throw i=!1,this._$Ek(),t}i&&this._$AE(s);}willUpdate(t){}_$AE(t){var i;null===(i=this._$ES)||void 0===i||i.forEach((t=>{var i;return null===(i=t.hostUpdated)||void 0===i?void 0:i.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t);}_$Ek(){this._$AL=new Map,this.isUpdatePending=!1;}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$E_}shouldUpdate(t){return !0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,i)=>this._$EO(i,this[i],t))),this._$EC=void 0),this._$Ek();}updated(t){}firstUpdated(t){}};u$3[d$3]=!0,u$3.elementProperties=new Map,u$3.elementStyles=[],u$3.shadowRootOptions={mode:"open"},null==o$8||o$8({ReactiveElement:u$3}),(null!==(s$8=e$6.reactiveElementVersions)&&void 0!==s$8?s$8:e$6.reactiveElementVersions=[]).push("1.6.3");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var l$5,o$7;let s$7 = class s extends u$3{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0;}createRenderRoot(){var t,e;const i=super.createRenderRoot();return null!==(t=(e=this.renderOptions).renderBefore)&&void 0!==t||(e.renderBefore=i.firstChild),i}update(t){const i=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=D$1(i,this.renderRoot,this.renderOptions);}connectedCallback(){var t;super.connectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!0);}disconnectedCallback(){var t;super.disconnectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!1);}render(){return T$1}};s$7.finalized=!0,s$7._$litElement$=!0,null===(l$5=globalThis.litElementHydrateSupport)||void 0===l$5||l$5.call(globalThis,{LitElement:s$7});const n$7=globalThis.litElementPolyfillSupport;null==n$7||n$7({LitElement:s$7});(null!==(o$7=globalThis.litElementVersions)&&void 0!==o$7?o$7:globalThis.litElementVersions=[]).push("3.3.3");

/**
 * Re-dispatches an event from the provided element.
 *
 * This function is useful for forwarding non-composed events, such as `change`
 * events.
 *
 * @example
 * class MyInput extends LitElement {
 *   render() {
 *     return html`<input @change=${this.redispatchEvent}>`;
 *   }
 *
 *   protected redispatchEvent(event: Event) {
 *     redispatchEvent(this, event);
 *   }
 * }
 *
 * Source: https://github.com/material-components/material-web/blob/c633e85192b20d7ad0930f131957ecefbb8a2f96/controller/events.ts
 *
 * @param element The element to dispatch the event from.
 * @param event The event to re-dispatch.
 * @return Whether or not the event was dispatched (if cancelable).
 */
function redispatchEvent(element, event) {
    /**
     * For composed events or bubbling events in SSR light DOM, stop their
     * propagation and dispatch the copy.
     */
    if (event.bubbles && (!element.shadowRoot || event.composed)) {
        event.stopPropagation();
    }
    const copy = Reflect.construct(event.constructor, [event.type, event]);
    const dispatched = element.dispatchEvent(copy);
    if (!dispatched) {
        event.preventDefault();
    }
    return dispatched;
}
/**
 * Check if `event` happened on the given `element`.
 * @returns `true` if the event happened on the given element, `false` otherwise.
 */
function isInsideElement(event, element) {
    if (element.shadowRoot) {
        return event.composedPath().includes(element);
    }
    if (event.target == null) {
        return false;
    }
    return element.contains(event.target);
}

class Component extends s$7 {
    constructor() {
        super(...arguments);
        this.emit = (eventName, options) => {
            const event = new CustomEvent(eventName, {
                bubbles: true,
                cancelable: true,
                composed: true,
                ...options,
            });
            this.dispatchEvent(event);
        };
        /**
         * Re-dispatches an event.
         * This function is useful for forwarding non-composed events, such as `change`
         * events.
         *
         * @example
         * class MyInput extends LitElement {
         *   render() {
         *     return html`<input @change=${this.reemit}>`;
         *   }
         *
         * }
         *
         * @param event The event to re-dispatch.
         */
        this.reemit = (event) => {
            redispatchEvent(this, event);
        };
    }
}

/**
 * Get token as lit's `CSSResult`
 * @param {NonColorToken} token - Miranda token
 * @returns {CSSResult}
 */
function getToken$1(token) {
    return r$7(toCSSValue_1$1(token));
}

/**
 * Get color token as lit's `CSSResult`
 * @param {ColorToken} token - Color token
 * @param {number} [alpha] - opacity
 * @returns {CSSResult}
 */
function getColor(token, alpha = 1) {
    return r$7(toCSSValue_1$1(token, alpha));
}

/**
 * Apply right margin.
 * @param {MarginValue} margin
 */
function mr(margin) {
    return r$7(`
		margin-inline-end: ${margin}
	`);
}
/**
 * Apply left margin.
 * @param {MarginValue} margin
 */
function ml(margin) {
    return r$7(`
		margin-inline-start: ${margin}
	`);
}
/**
 * Apply right/left margins.
 * @param {MarginValue} margin
 */
function mx(margin) {
    return r$7(`
		${ml(margin)};
		${mr(margin)}
	`);
}
/**
 * Apply top margin.
 * @param {MarginValue} margin
 */
function mt(margin) {
    return r$7(`
		margin-block-start: ${margin}
	`);
}
/**
 * Apply bottom margin.
 * @param {MarginValue} margin
 */
function mb(margin) {
    return r$7(`
		margin-block-end: ${margin}
	`);
}
/**
 * Apply top/bottom margins.
 * @param {MarginValue} margin
 */
function my(margin) {
    return r$7(`
		${mt(margin)};
		${mb(margin)}
	`);
}
/**
 * Apply right/left/top/bottom margins.
 * @param {MarginValue} margin
 */
function m$1(margin) {
    return r$7(`
		${mx(margin)};
		${my(margin)}
	`);
}

/**
 * Convert a screen media query config to its CSS equivalent.
 *
 * Receives the style content to be applied inside this media query setup.
 * Notice that we consume the raw token value for the media query because variables do not work in media or container queries.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_custom_properties MDN, Using CSS Custom Properties}
 */
function mediaDesktop(content) {
    return r$7(`
	@media screen and (min-width: ${getToken_1('media-screen-desktop')}) {
		${content}
	}
`);
}
/**
 * Convert a screen media query config to its CSS equivalent.
 *
 * Receives the style content to be applied inside this media query setup.
 * Notice that we consume the raw token value for the media query because variables do not work in media or container queries.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_custom_properties MDN, Using CSS Custom Properties}
 */
function mediaTablet(content) {
    return r$7(`
	@media screen and (min-width: ${getToken_1('media-screen-tablet')}) {
		${content}
	}
`);
}

/**
 * Produces array for non-array value.
 *
 * @param {*} value Value to be converted/returned.
 * @return {Array<*>} Returns `value` itself if it is an array or
 * an array containing the provided `value`.
 */
function toArray(value) {
    if (value == null) {
        return [];
    }
    if (Array.isArray(value)) {
        return value;
    }
    return [value];
}

const pseudoClassMap = {
    active: [':active'],
    disabled: ['.is-disabled', ':disabled'],
    focus: ['.is-focused', ':focus', ':focus-visible', ':focus-within'],
    hover: [':hover'],
    visited: [':visited'],
};
function isPseudoClass(value) {
    return Object.keys(pseudoClassMap).includes(value);
}
function isNegated(pseudoClass) {
    return pseudoClass.startsWith('not.');
}
function joinIs(value) {
    const array = toArray(value).filter((item) => item.trim() !== '');
    if (array.length === 0) {
        return '';
    }
    if (array.length === 1) {
        return array[0];
    }
    return `:is(${array.join(', ')})`;
}
function toString(selectors, subSelectors, combinator, pseudoClasses) {
    let result = joinIs(selectors);
    for (const pseudoClass of pseudoClasses) {
        if (isNegated(pseudoClass)) {
            const posPseudoClass = pseudoClass.slice(4);
            result = `${result}:not(${pseudoClassMap[posPseudoClass].join(', ')})`;
        }
        else {
            result = `${result}${joinIs(pseudoClassMap[pseudoClass])}`;
        }
    }
    const resultSubSelector = joinIs(subSelectors);
    if (resultSubSelector) {
        let resultCombinator = ` ${combinator} `;
        if (combinator == null) {
            resultCombinator = '';
        }
        if (combinator === ' ') {
            resultCombinator = combinator;
        }
        return `${result}${resultCombinator}${resultSubSelector}`;
    }
    return result;
}
/**
 * # on
 *
 * Style utility to compose pseudo-classes.
 *
 * ## List of supported pseudo-classes
 * - active
 * - disabled
 * - focus
 * - hover
 * - visited
 *
 * ## Usage
 * You can compose multiple pseudo-classes by chaining them. You can also negate
 * some pseudo-class calling `.not` before it. The order that they are chained
 * will be respected.
 *
 * ```js
 * css`
 *     ${on('.button').not.disabled.not.active.focus} {
 *         color: tomato;
 *     }
 * `;
 * ```
 * Will result in:
 * ```css
 * .button:not(.is-disabled, :disabled):not(:active):is(.is-focused, :focus, :focus-visible, :focus-within) {
 *     color: tomato;
 * }
 * ```
 *
 * @param selectors A single selector or a list of selectors that will have the
 * pseudo-classes concatenated to it.
 * @param subSelectors A single selector or a list of selectors that will be
 * combined with the resulting selectors.
 * @param combinator Will be used to combine the resulting selectors with the
 * subSelectors. The default value is the [Descendant Combinator (`' '`)](https://developer.mozilla.org/en-US/docs/Web/CSS/Descendant_combinator).
 * If `null` is provided, no combinator will be used, i.e., they will be joined
 * without any character between them.
 */
function on(selectors, subSelectors, combinator = ' ') {
    const pseudoClasses = [];
    let not = false;
    /*
     * It's not possible to instantiate a CSSResult manually as `lit` has a
     * mecanism to prevent this.
     * https://github.com/lit/lit/blob/main/packages/reactive-element/src/css-tag.ts#L58
     *
     * To circunvent this limitation, a `Proxy` arround an instance returned by
     * the `unsafeCSS` is being created and it is overriding the getter for
     * `cssText`, which holds the css text, allowing to customize the selector.
     * Additional getters for each supported pseudo-class and a getter for the
     * negating condition `not` are also being created at this time. These
     * additional getters return the same proxy instance, so they can be
     * chained.
     */
    const augumentedCSSResult = new Proxy(r$7(''), {
        get(target, prop, receiver) {
            if (prop === 'cssText') {
                return toString(selectors, subSelectors, combinator, pseudoClasses);
            }
            if (prop === 'not') {
                not = !not;
                return augumentedCSSResult;
            }
            if (isPseudoClass(prop)) {
                pseudoClasses.push(not ? `not.${prop}` : prop);
                not = false;
                return augumentedCSSResult;
            }
            return Reflect.get(target, prop, receiver);
        },
    });
    return augumentedCSSResult;
}

/**
 * Apply right padding.
 * @param {string | number} padding
 */
function pr(padding) {
    return r$7(`
		padding-inline-start: ${padding}
	`);
}
/**
 * Apply left padding.
 * @param {string | number} padding
 */
function pl(padding) {
    return r$7(`
		padding-inline-end: ${padding}
	`);
}
/**
 * Apply right/left paddings.
 * @param {string | number} padding
 */
function px(padding) {
    return r$7(`
		${pl(padding)};
		${pr(padding)}
	`);
}
/**
 * Apply top padding.
 * @param {string | number} padding
 */
function pt(padding) {
    return r$7(`
		padding-block-start: ${padding}
	`);
}
/**
 * Apply bottom padding.
 * @param {string | number} padding
 */
function pb(padding) {
    return r$7(`
		padding-block-end: ${padding}
	`);
}
/**
 * Apply top/bottom paddings.
 * @param {string | number} padding
 */
function py(padding) {
    return r$7(`
		${pt(padding)};
		${pb(padding)}
	`);
}
/**
 * Apply right/left/top/bottom paddings.
 * @param {string | number} padding
 */
function p$1(padding) {
    return r$7(`
		${px(padding)};
		${py(padding)}
	`);
}

function skeleton() {
    return r$7(`animation: skeleton-loading 1s linear infinite alternate;`);
}
skeleton.styles = () => {
    return i$5 `
		@keyframes skeleton-loading {
			0% {
				background-color: ${getColor('color-background-tertiary')};
				opacity: 0.3;
			}
			50% {
				background-color: ${getColor('color-background-tertiary')};
				opacity: 0.6;
			}
			100% {
				background-color: ${getColor('color-background-tertiary')};
			}
		}
	`;
};

/** @type {TransitionConfig} */
const DEFAULT_TRANSITION_CONFIG = {
    property: 'all',
    delay: '0s',
    duration: '0.35s',
    easing: 'ease-in-out',
};
/**
 * @param {TransitionConfig} config
 */
function toTransition(config) {
    const safeConfig = { ...DEFAULT_TRANSITION_CONFIG, ...config };
    // property name | duration | easing function | delay
    return r$7(`${safeConfig.property} ${safeConfig.duration} ${safeConfig.easing} ${safeConfig.delay}`);
}
/**
 * Convert a transition config to its CSS equivalent.
 * @param {TransitionConfig | TransitionConfig[]} configs
 */
function transition(configs) {
    const transitionStyle = toArray(configs)
        .map((config) => toTransition(config))
        .join(', ');
    return r$7(`
		transition: ${transitionStyle}
	`);
}

const typographyVariants = [
    'body-lg-bold',
    'body-lg',
    'body-md-bold-underline',
    'body-md-bold',
    'body-md-underline',
    'body-md',
    'body-sm-bold-underline',
    'body-sm-bold',
    'body-sm-underline',
    'body-sm',
    'button-lg',
    'button-md',
    'button-sm',
    'chips-md',
    'chips-sm',
    'heading-lg-bold',
    'heading-lg',
    'heading-md-bold',
    'heading-md',
    'heading-sm-bold',
    'heading-sm',
    'hero-lg-bold',
    'hero-lg',
    'hero-md-bold',
    'hero-md',
    'hero-sm-bold',
    'hero-sm',
    'number-md',
    'number-sm',
    'table-header-md',
    'table-header-sm',
];
/**
 * Apply set of tokens for a given typography `variant`.
 * @param {TypographyVariant} [variant]
 * @returns {String}
 */
function getVariant(variant) {
    switch (variant) {
        case 'hero-lg-bold':
            return `
				font-family: ${getToken$1('font-family-title')};
				line-height: ${getToken$1('line-height-6')};
				font-size: ${getToken$1('font-size-9')};
				font-weight: ${getToken$1('font-weight-bold')}
			`;
        case 'hero-lg':
            return `
				font-family: ${getToken$1('font-family-title')};
				line-height: ${getToken$1('line-height-6')};
				font-size: ${getToken$1('font-size-9')};
				font-weight: ${getToken$1('font-weight-regular')}
			`;
        case 'hero-md-bold':
            return `
				font-family: ${getToken$1('font-family-title')};
				line-height: ${getToken$1('line-height-6')};
				font-size: ${getToken$1('font-size-8')};
				font-weight: ${getToken$1('font-weight-bold')}
			`;
        case 'hero-md':
            return `
				font-family: ${getToken$1('font-family-title')};
				line-height: ${getToken$1('line-height-6')};
				font-size: ${getToken$1('font-size-8')};
				font-weight: ${getToken$1('font-weight-regular')}
			`;
        case 'hero-sm-bold':
            return `
				font-family: ${getToken$1('font-family-title')};
				line-height: ${getToken$1('line-height-6')};
				font-size: ${getToken$1('font-size-7')};
				font-weight: ${getToken$1('font-weight-bold')}
			`;
        case 'hero-sm':
            return `
				font-family: ${getToken$1('font-family-title')};
				line-height: ${getToken$1('line-height-6')};
				font-size: ${getToken$1('font-size-7')};
				font-weight: ${getToken$1('font-weight-regular')}
			`;
        case 'heading-lg-bold':
            return `
					font-family: ${getToken$1('font-family-title')};
					line-height: ${getToken$1('line-height-5')};
					font-size: ${getToken$1('font-size-6')};
					font-weight: ${getToken$1('font-weight-bold')}
				`;
        case 'heading-lg':
            return `
				font-family: ${getToken$1('font-family-title')};
				line-height: ${getToken$1('line-height-5')};
				font-size: ${getToken$1('font-size-6')};
				font-weight: ${getToken$1('font-weight-regular')}
			`;
        case 'heading-md-bold':
            return `
				font-family: ${getToken$1('font-family-title')};
				line-height: ${getToken$1('line-height-5')};
				font-size: ${getToken$1('font-size-5')};
				font-weight: ${getToken$1('font-weight-bold')}
			`;
        case 'heading-md':
            return `
				font-family: ${getToken$1('font-family-title')};
				line-height: ${getToken$1('line-height-5')};
				font-size: ${getToken$1('font-size-5')};
				font-weight: ${getToken$1('font-weight-regular')}
			`;
        case 'heading-sm-bold':
            return `
				font-family: ${getToken$1('font-family-title')};
				line-height: ${getToken$1('line-height-5')};
				font-size: ${getToken$1('font-size-4')};
				font-weight: ${getToken$1('font-weight-bold')}
			`;
        case 'heading-sm':
            return `
				font-family: ${getToken$1('font-family-title')};
				line-height: ${getToken$1('line-height-5')};
				font-size: ${getToken$1('font-size-4')};
				font-weight: ${getToken$1('font-weight-regular')}
			`;
        case 'body-lg-bold':
            return `
					font-family: ${getToken$1('font-family-default')};
					line-height: ${getToken$1('line-height-6')};
					font-size: ${getToken$1('font-size-5')};
					font-weight: ${getToken$1('font-weight-bold')}
				`;
        case 'body-lg':
            return `
					font-family: ${getToken$1('font-family-default')};
					line-height: ${getToken$1('line-height-6')};
					font-size: ${getToken$1('font-size-5')};
					font-weight: ${getToken$1('font-weight-regular')}
				`;
        case 'body-md':
        case 'number-md':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-5')};
				font-size: ${getToken$1('font-size-3')};
				font-weight: ${getToken$1('font-weight-regular')}
			`;
        case 'body-md-underline':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-5')};
				font-size: ${getToken$1('font-size-3')};
				font-weight: ${getToken$1('font-weight-regular')};
				text-decoration: underline
			`;
        case 'body-md-bold':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-5')};
				font-size: ${getToken$1('font-size-3')};
				font-weight: ${getToken$1('font-weight-bold')}
			`;
        case 'body-md-bold-underline':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-5')};
				font-size: ${getToken$1('font-size-3')};
				font-weight: ${getToken$1('font-weight-bold')};
				text-decoration: underline
			`;
        case 'body-sm':
        case 'number-sm':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-4')};
				font-size: ${getToken$1('font-size-2')};
				font-weight: ${getToken$1('font-weight-regular')}
			`;
        case 'body-sm-underline':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-4')};
				font-size: ${getToken$1('font-size-2')};
				font-weight: ${getToken$1('font-weight-regular')};
				text-decoration: underline
			`;
        case 'body-sm-bold':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-4')};
				font-size: ${getToken$1('font-size-2')};
				font-weight: ${getToken$1('font-weight-bold')}
			`;
        case 'body-sm-bold-underline':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-4')};
				font-size: ${getToken$1('font-size-2')};
				font-weight: ${getToken$1('font-weight-bold')};
				text-decoration: underline
			`;
        case 'button-lg':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-1')};
				font-size: ${getToken$1('font-size-4')};
				font-weight: ${getToken$1('font-weight-bold')}
			`;
        case 'button-md':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-1')};
				font-size: ${getToken$1('font-size-3')};
				font-weight: ${getToken$1('font-weight-bold')}
			`;
        case 'button-sm':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-1')};
				font-size: ${getToken$1('font-size-2')};
				font-weight: ${getToken$1('font-weight-bold')}
			`;
        case 'table-header-md':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-1')};
				font-size: ${getToken$1('font-size-3')};
				font-weight: ${getToken$1('font-weight-medium')};
				text-transform: uppercase
			`;
        case 'table-header-sm':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-1')};
				font-size: ${getToken$1('font-size-2')};
				font-weight: ${getToken$1('font-weight-regular')}
			`;
        case 'chips-md':
            return `
					font-family: ${getToken$1('font-family-default')};
					line-height: ${getToken$1('line-height-1')};
					font-size: ${getToken$1('font-size-2')};
					font-weight: ${getToken$1('font-weight-bold')}
				`;
        case 'chips-sm':
            return `
				font-family: ${getToken$1('font-family-default')};
				line-height: ${getToken$1('line-height-1')};
				font-size: ${getToken$1('font-size-1')};
				font-weight: ${getToken$1('font-weight-medium')};
				text-transform: uppercase
			`;
        default:
            return '';
    }
}
/**
 * Apply set of tokens for a given typography `variant`.
 * @param {TypographyVariant} [variant]
 * @returns {CSSResult}
 */
function typography(variant) {
    const defaultStyle = r$7(`
		font-style: normal;
		font-stretch: normal;
		letter-spacing: normal;

		font-synthesis: none;
		text-rendering: optimizeLegibility;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		-webkit-text-size-adjust: 100%;
	`);
    return r$7(`${defaultStyle}\n${getVariant(variant)}`);
}

function styles$J() {
    return i$5 `
		:host {
			background-color: ${getColor('color-background-primary')};
			width: 100%;
		}

		slot[name='title']::slotted(:not(m-accordion-title)),
		slot[name='content']::slotted(:not(m-accordion-content)) {
			display: none;
		}

		.m-accordion {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			border-radius: ${getToken$1('border-radius-s')};
			border: 1px solid ${getColor('color-border-input')};
			overflow: hidden;
		}

		.m-accordion-header {
			margin: 0;
			width: 100%;
		}

		.m-accordion-trigger {
			${typography('body-md-bold')};
			display: flex;
			margin: 0;
			cursor: pointer;
			width: 100%;
			padding: ${getToken$1('spacing-3')} ${getToken$1('spacing-4')};
			color: ${getColor('color-text-primary')};
			outline: none;
			border: none;
			align-items: center;
			background-color: ${getColor('color-background-primary')};
		}

		.m-accordion-trigger:focus {
			background-color: ${getColor('color-background-tertiary')};
		}

		.m-accordion-trigger:hover {
			background-color: ${getColor('color-background-tertiary')};
		}

		.m-accordion-trigger:active {
			background-color: ${getColor('color-background-highlight')};
		}

		.m-accordion-trigger:disabled {
			background-color: ${getColor('color-background-primary')};
			cursor: default;
			color: ${getColor('color-text-disabled')};
		}

		.m-accordion-trigger:disabled m-icon {
			--m-icon-color: ${getColor('color-text-disabled')};
		}

		.m-accordion-trigger[aria-expanded='true']:not([disabled]) m-icon {
			transform: rotate(180deg);
		}

		.m-accordion-panel {
			height: auto;
			width: 100%;
		}

		@media (prefers-reduced-motion: no-preference) {
			.m-accordion-trigger {
				${transition([{ property: 'background-color' }])};
			}

			m-icon {
				${transition([{ property: 'transform' }])};
			}

			.m-accordion-panel {
				${transition([{ property: 'height' }, { property: 'visibility' }])};
				will-change: height;
			}
		}
	`;
}
function accordionTitleStyles() {
    return i$5 `
		:host {
			display: flex;
			text-align: left;
			justify-content: center;
			width: 100%;
		}

		.m-accordion-text {
			flex: 1;
			padding-left: ${getToken$1('spacing-1')};
		}
	`;
}
function accordionContentStyles() {
    return i$5 `
		.m-accordion-content {
			padding: ${getToken$1('spacing-2')} ${getToken$1('spacing-4')} ${getToken$1('spacing-4')};
		}
	`;
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$2$1=window,e$4=t$2$1.ShadowRoot&&(void 0===t$2$1.ShadyCSS||t$2$1.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s$5=Symbol(),n$5=new WeakMap;let o$5 = class o{constructor(t,e,n){if(this._$cssResult$=!0,n!==s$5)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e;}get styleSheet(){let t=this.o;const s=this.t;if(e$4&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=n$5.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&n$5.set(s,t));}return t}toString(){return this.cssText}};const r$4=t=>new o$5("string"==typeof t?t:t+"",void 0,s$5),S$2=(s,n)=>{e$4?s.adoptedStyleSheets=n.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):n.forEach((e=>{const n=document.createElement("style"),o=t$2$1.litNonce;void 0!==o&&n.setAttribute("nonce",o),n.textContent=e.cssText,s.appendChild(n);}));},c$2=e$4?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return r$4(e)})(t):t;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var s$4;const e$3$1=window,r$3=e$3$1.trustedTypes,h$2=r$3?r$3.emptyScript:"",o$4=e$3$1.reactiveElementPolyfillSupport,n$4={toAttribute(t,i){switch(i){case Boolean:t=t?h$2:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t);}return t},fromAttribute(t,i){let s=t;switch(i){case Boolean:s=null!==t;break;case Number:s=null===t?null:Number(t);break;case Object:case Array:try{s=JSON.parse(t);}catch(t){s=null;}}return s}},a$2=(t,i)=>i!==t&&(i==i||t==t),l$3={attribute:!0,type:String,converter:n$4,reflect:!1,hasChanged:a$2},d$2="finalized";let u$2 = class u extends HTMLElement{constructor(){super(),this._$Ei=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$El=null,this._$Eu();}static addInitializer(t){var i;this.finalize(),(null!==(i=this.h)&&void 0!==i?i:this.h=[]).push(t);}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((i,s)=>{const e=this._$Ep(s,i);void 0!==e&&(this._$Ev.set(e,s),t.push(e));})),t}static createProperty(t,i=l$3){if(i.state&&(i.attribute=!1),this.finalize(),this.elementProperties.set(t,i),!i.noAccessor&&!this.prototype.hasOwnProperty(t)){const s="symbol"==typeof t?Symbol():"__"+t,e=this.getPropertyDescriptor(t,s,i);void 0!==e&&Object.defineProperty(this.prototype,t,e);}}static getPropertyDescriptor(t,i,s){return {get(){return this[i]},set(e){const r=this[t];this[i]=e,this.requestUpdate(t,r,s);},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||l$3}static finalize(){if(this.hasOwnProperty(d$2))return !1;this[d$2]=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),void 0!==t.h&&(this.h=[...t.h]),this.elementProperties=new Map(t.elementProperties),this._$Ev=new Map,this.hasOwnProperty("properties")){const t=this.properties,i=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const s of i)this.createProperty(s,t[s]);}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(i){const s=[];if(Array.isArray(i)){const e=new Set(i.flat(1/0).reverse());for(const i of e)s.unshift(c$2(i));}else void 0!==i&&s.push(c$2(i));return s}static _$Ep(t,i){const s=i.attribute;return !1===s?void 0:"string"==typeof s?s:"string"==typeof t?t.toLowerCase():void 0}_$Eu(){var t;this._$E_=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Eg(),this.requestUpdate(),null===(t=this.constructor.h)||void 0===t||t.forEach((t=>t(this)));}addController(t){var i,s;(null!==(i=this._$ES)&&void 0!==i?i:this._$ES=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(s=t.hostConnected)||void 0===s||s.call(t));}removeController(t){var i;null===(i=this._$ES)||void 0===i||i.splice(this._$ES.indexOf(t)>>>0,1);}_$Eg(){this.constructor.elementProperties.forEach(((t,i)=>{this.hasOwnProperty(i)&&(this._$Ei.set(i,this[i]),delete this[i]);}));}createRenderRoot(){var t;const s=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return S$2(s,this.constructor.elementStyles),s}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostConnected)||void 0===i?void 0:i.call(t)}));}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostDisconnected)||void 0===i?void 0:i.call(t)}));}attributeChangedCallback(t,i,s){this._$AK(t,s);}_$EO(t,i,s=l$3){var e;const r=this.constructor._$Ep(t,s);if(void 0!==r&&!0===s.reflect){const h=(void 0!==(null===(e=s.converter)||void 0===e?void 0:e.toAttribute)?s.converter:n$4).toAttribute(i,s.type);this._$El=t,null==h?this.removeAttribute(r):this.setAttribute(r,h),this._$El=null;}}_$AK(t,i){var s;const e=this.constructor,r=e._$Ev.get(t);if(void 0!==r&&this._$El!==r){const t=e.getPropertyOptions(r),h="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==(null===(s=t.converter)||void 0===s?void 0:s.fromAttribute)?t.converter:n$4;this._$El=r,this[r]=h.fromAttribute(i,t.type),this._$El=null;}}requestUpdate(t,i,s){let e=!0;void 0!==t&&(((s=s||this.constructor.getPropertyOptions(t)).hasChanged||a$2)(this[t],i)?(this._$AL.has(t)||this._$AL.set(t,i),!0===s.reflect&&this._$El!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,s))):e=!1),!this.isUpdatePending&&e&&(this._$E_=this._$Ej());}async _$Ej(){this.isUpdatePending=!0;try{await this._$E_;}catch(t){Promise.reject(t);}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Ei&&(this._$Ei.forEach(((t,i)=>this[i]=t)),this._$Ei=void 0);let i=!1;const s=this._$AL;try{i=this.shouldUpdate(s),i?(this.willUpdate(s),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostUpdate)||void 0===i?void 0:i.call(t)})),this.update(s)):this._$Ek();}catch(t){throw i=!1,this._$Ek(),t}i&&this._$AE(s);}willUpdate(t){}_$AE(t){var i;null===(i=this._$ES)||void 0===i||i.forEach((t=>{var i;return null===(i=t.hostUpdated)||void 0===i?void 0:i.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t);}_$Ek(){this._$AL=new Map,this.isUpdatePending=!1;}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$E_}shouldUpdate(t){return !0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,i)=>this._$EO(i,this[i],t))),this._$EC=void 0),this._$Ek();}updated(t){}firstUpdated(t){}};u$2[d$2]=!0,u$2.elementProperties=new Map,u$2.elementStyles=[],u$2.shadowRootOptions={mode:"open"},null==o$4||o$4({ReactiveElement:u$2}),(null!==(s$4=e$3$1.reactiveElementVersions)&&void 0!==s$4?s$4:e$3$1.reactiveElementVersions=[]).push("1.6.3");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t$1$1;const i$1$1=window,s$3$1=i$1$1.trustedTypes,e$2$1=s$3$1?s$3$1.createPolicy("lit-html",{createHTML:t=>t}):void 0,o$3$1="$lit$",n$3$1=`lit$${(Math.random()+"").slice(9)}$`,l$2="?"+n$3$1,h$1=`<${l$2}>`,r$2=document,u$1=()=>r$2.createComment(""),d$1=t=>null===t||"object"!=typeof t&&"function"!=typeof t,c$1=Array.isArray,v=t=>c$1(t)||"function"==typeof(null==t?void 0:t[Symbol.iterator]),a$1="[ \t\n\f\r]",f=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,_=/-->/g,m=/>/g,p=RegExp(`>|${a$1}(?:([^\\s"'>=/]+)(${a$1}*=${a$1}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),g=/'/g,$=/"/g,y=/^(?:script|style|textarea|title)$/i,w=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),b=w(2),T=Symbol.for("lit-noChange"),A=Symbol.for("lit-nothing"),E=new WeakMap,C=r$2.createTreeWalker(r$2,129,null,!1);function P(t,i){if(!Array.isArray(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==e$2$1?e$2$1.createHTML(i):i}const V=(t,i)=>{const s=t.length-1,e=[];let l,r=2===i?"<svg>":"",u=f;for(let i=0;i<s;i++){const s=t[i];let d,c,v=-1,a=0;for(;a<s.length&&(u.lastIndex=a,c=u.exec(s),null!==c);)a=u.lastIndex,u===f?"!--"===c[1]?u=_:void 0!==c[1]?u=m:void 0!==c[2]?(y.test(c[2])&&(l=RegExp("</"+c[2],"g")),u=p):void 0!==c[3]&&(u=p):u===p?">"===c[0]?(u=null!=l?l:f,v=-1):void 0===c[1]?v=-2:(v=u.lastIndex-c[2].length,d=c[1],u=void 0===c[3]?p:'"'===c[3]?$:g):u===$||u===g?u=p:u===_||u===m?u=f:(u=p,l=void 0);const w=u===p&&t[i+1].startsWith("/>")?" ":"";r+=u===f?s+h$1:v>=0?(e.push(d),s.slice(0,v)+o$3$1+s.slice(v)+n$3$1+w):s+n$3$1+(-2===v?(e.push(void 0),i):w);}return [P(t,r+(t[s]||"<?>")+(2===i?"</svg>":"")),e]};class N{constructor({strings:t,_$litType$:i},e){let h;this.parts=[];let r=0,d=0;const c=t.length-1,v=this.parts,[a,f]=V(t,i);if(this.el=N.createElement(a,e),C.currentNode=this.el.content,2===i){const t=this.el.content,i=t.firstChild;i.remove(),t.append(...i.childNodes);}for(;null!==(h=C.nextNode())&&v.length<c;){if(1===h.nodeType){if(h.hasAttributes()){const t=[];for(const i of h.getAttributeNames())if(i.endsWith(o$3$1)||i.startsWith(n$3$1)){const s=f[d++];if(t.push(i),void 0!==s){const t=h.getAttribute(s.toLowerCase()+o$3$1).split(n$3$1),i=/([.?@])?(.*)/.exec(s);v.push({type:1,index:r,name:i[2],strings:t,ctor:"."===i[1]?H:"?"===i[1]?L:"@"===i[1]?z:k});}else v.push({type:6,index:r});}for(const i of t)h.removeAttribute(i);}if(y.test(h.tagName)){const t=h.textContent.split(n$3$1),i=t.length-1;if(i>0){h.textContent=s$3$1?s$3$1.emptyScript:"";for(let s=0;s<i;s++)h.append(t[s],u$1()),C.nextNode(),v.push({type:2,index:++r});h.append(t[i],u$1());}}}else if(8===h.nodeType)if(h.data===l$2)v.push({type:2,index:r});else {let t=-1;for(;-1!==(t=h.data.indexOf(n$3$1,t+1));)v.push({type:7,index:r}),t+=n$3$1.length-1;}r++;}}static createElement(t,i){const s=r$2.createElement("template");return s.innerHTML=t,s}}function S$1(t,i,s=t,e){var o,n,l,h;if(i===T)return i;let r=void 0!==e?null===(o=s._$Co)||void 0===o?void 0:o[e]:s._$Cl;const u=d$1(i)?void 0:i._$litDirective$;return (null==r?void 0:r.constructor)!==u&&(null===(n=null==r?void 0:r._$AO)||void 0===n||n.call(r,!1),void 0===u?r=void 0:(r=new u(t),r._$AT(t,s,e)),void 0!==e?(null!==(l=(h=s)._$Co)&&void 0!==l?l:h._$Co=[])[e]=r:s._$Cl=r),void 0!==r&&(i=S$1(t,r._$AS(t,i.values),r,e)),i}class M{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i;}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){var i;const{el:{content:s},parts:e}=this._$AD,o=(null!==(i=null==t?void 0:t.creationScope)&&void 0!==i?i:r$2).importNode(s,!0);C.currentNode=o;let n=C.nextNode(),l=0,h=0,u=e[0];for(;void 0!==u;){if(l===u.index){let i;2===u.type?i=new R(n,n.nextSibling,this,t):1===u.type?i=new u.ctor(n,u.name,u.strings,this,t):6===u.type&&(i=new Z(n,this,t)),this._$AV.push(i),u=e[++h];}l!==(null==u?void 0:u.index)&&(n=C.nextNode(),l++);}return C.currentNode=r$2,o}v(t){let i=0;for(const s of this._$AV)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++;}}class R{constructor(t,i,s,e){var o;this.type=2,this._$AH=A,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cp=null===(o=null==e?void 0:e.isConnected)||void 0===o||o;}get _$AU(){var t,i;return null!==(i=null===(t=this._$AM)||void 0===t?void 0:t._$AU)&&void 0!==i?i:this._$Cp}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===(null==t?void 0:t.nodeType)&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=S$1(this,t,i),d$1(t)?t===A||null==t||""===t?(this._$AH!==A&&this._$AR(),this._$AH=A):t!==this._$AH&&t!==T&&this._(t):void 0!==t._$litType$?this.g(t):void 0!==t.nodeType?this.$(t):v(t)?this.T(t):this._(t);}k(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}$(t){this._$AH!==t&&(this._$AR(),this._$AH=this.k(t));}_(t){this._$AH!==A&&d$1(this._$AH)?this._$AA.nextSibling.data=t:this.$(r$2.createTextNode(t)),this._$AH=t;}g(t){var i;const{values:s,_$litType$:e}=t,o="number"==typeof e?this._$AC(t):(void 0===e.el&&(e.el=N.createElement(P(e.h,e.h[0]),this.options)),e);if((null===(i=this._$AH)||void 0===i?void 0:i._$AD)===o)this._$AH.v(s);else {const t=new M(o,this),i=t.u(this.options);t.v(s),this.$(i),this._$AH=t;}}_$AC(t){let i=E.get(t.strings);return void 0===i&&E.set(t.strings,i=new N(t)),i}T(t){c$1(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const o of t)e===i.length?i.push(s=new R(this.k(u$1()),this.k(u$1()),this,this.options)):s=i[e],s._$AI(o),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e);}_$AR(t=this._$AA.nextSibling,i){var s;for(null===(s=this._$AP)||void 0===s||s.call(this,!1,!0,i);t&&t!==this._$AB;){const i=t.nextSibling;t.remove(),t=i;}}setConnected(t){var i;void 0===this._$AM&&(this._$Cp=t,null===(i=this._$AP)||void 0===i||i.call(this,t));}}class k{constructor(t,i,s,e,o){this.type=1,this._$AH=A,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=o,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=A;}get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}_$AI(t,i=this,s,e){const o=this.strings;let n=!1;if(void 0===o)t=S$1(this,t,i,0),n=!d$1(t)||t!==this._$AH&&t!==T,n&&(this._$AH=t);else {const e=t;let l,h;for(t=o[0],l=0;l<o.length-1;l++)h=S$1(this,e[s+l],i,l),h===T&&(h=this._$AH[l]),n||(n=!d$1(h)||h!==this._$AH[l]),h===A?t=A:t!==A&&(t+=(null!=h?h:"")+o[l+1]),this._$AH[l]=h;}n&&!e&&this.j(t);}j(t){t===A?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,null!=t?t:"");}}class H extends k{constructor(){super(...arguments),this.type=3;}j(t){this.element[this.name]=t===A?void 0:t;}}const I=s$3$1?s$3$1.emptyScript:"";class L extends k{constructor(){super(...arguments),this.type=4;}j(t){t&&t!==A?this.element.setAttribute(this.name,I):this.element.removeAttribute(this.name);}}class z extends k{constructor(t,i,s,e,o){super(t,i,s,e,o),this.type=5;}_$AI(t,i=this){var s;if((t=null!==(s=S$1(this,t,i,0))&&void 0!==s?s:A)===T)return;const e=this._$AH,o=t===A&&e!==A||t.capture!==e.capture||t.once!==e.once||t.passive!==e.passive,n=t!==A&&(e===A||o);o&&this.element.removeEventListener(this.name,this,e),n&&this.element.addEventListener(this.name,this,t),this._$AH=t;}handleEvent(t){var i,s;"function"==typeof this._$AH?this._$AH.call(null!==(s=null===(i=this.options)||void 0===i?void 0:i.host)&&void 0!==s?s:this.element,t):this._$AH.handleEvent(t);}}class Z{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s;}get _$AU(){return this._$AM._$AU}_$AI(t){S$1(this,t);}}const B=i$1$1.litHtmlPolyfillSupport;null==B||B(N,R),(null!==(t$1$1=i$1$1.litHtmlVersions)&&void 0!==t$1$1?t$1$1:i$1$1.litHtmlVersions=[]).push("2.8.0");const D=(t,i,s)=>{var e,o;const n=null!==(e=null==s?void 0:s.renderBefore)&&void 0!==e?e:i;let l=n._$litPart$;if(void 0===l){const t=null!==(o=null==s?void 0:s.renderBefore)&&void 0!==o?o:null;n._$litPart$=l=new R(i.insertBefore(u$1(),t),t,void 0,null!=s?s:{});}return l._$AI(t),l};

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$3=window,e$1$1=t$3.ShadowRoot&&(void 0===t$3.ShadyCSS||t$3.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s$2$1=Symbol(),n$2$1=new WeakMap;let o$2$1 = class o{constructor(t,e,n){if(this._$cssResult$=!0,n!==s$2$1)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e;}get styleSheet(){let t=this.o;const s=this.t;if(e$1$1&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=n$2$1.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&n$2$1.set(s,t));}return t}toString(){return this.cssText}};const r$1=t=>new o$2$1("string"==typeof t?t:t+"",void 0,s$2$1),i$4=(t,...e)=>{const n=1===t.length?t[0]:e.reduce(((e,s,n)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(s)+t[n+1]),t[0]);return new o$2$1(n,t,s$2$1)},S=(s,n)=>{e$1$1?s.adoptedStyleSheets=n.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):n.forEach((e=>{const n=document.createElement("style"),o=t$3.litNonce;void 0!==o&&n.setAttribute("nonce",o),n.textContent=e.cssText,s.appendChild(n);}));},c=e$1$1?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return r$1(e)})(t):t;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var s$1$1;const e$5=window,r$5=e$5.trustedTypes,h=r$5?r$5.emptyScript:"",o$1$1=e$5.reactiveElementPolyfillSupport,n$1$1={toAttribute(t,i){switch(i){case Boolean:t=t?h:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t);}return t},fromAttribute(t,i){let s=t;switch(i){case Boolean:s=null!==t;break;case Number:s=null===t?null:Number(t);break;case Object:case Array:try{s=JSON.parse(t);}catch(t){s=null;}}return s}},a$3=(t,i)=>i!==t&&(i==i||t==t),l$1$1={attribute:!0,type:String,converter:n$1$1,reflect:!1,hasChanged:a$3},d="finalized";class u extends HTMLElement{constructor(){super(),this._$Ei=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$El=null,this._$Eu();}static addInitializer(t){var i;this.finalize(),(null!==(i=this.h)&&void 0!==i?i:this.h=[]).push(t);}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((i,s)=>{const e=this._$Ep(s,i);void 0!==e&&(this._$Ev.set(e,s),t.push(e));})),t}static createProperty(t,i=l$1$1){if(i.state&&(i.attribute=!1),this.finalize(),this.elementProperties.set(t,i),!i.noAccessor&&!this.prototype.hasOwnProperty(t)){const s="symbol"==typeof t?Symbol():"__"+t,e=this.getPropertyDescriptor(t,s,i);void 0!==e&&Object.defineProperty(this.prototype,t,e);}}static getPropertyDescriptor(t,i,s){return {get(){return this[i]},set(e){const r=this[t];this[i]=e,this.requestUpdate(t,r,s);},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||l$1$1}static finalize(){if(this.hasOwnProperty(d))return !1;this[d]=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),void 0!==t.h&&(this.h=[...t.h]),this.elementProperties=new Map(t.elementProperties),this._$Ev=new Map,this.hasOwnProperty("properties")){const t=this.properties,i=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const s of i)this.createProperty(s,t[s]);}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(i){const s=[];if(Array.isArray(i)){const e=new Set(i.flat(1/0).reverse());for(const i of e)s.unshift(c(i));}else void 0!==i&&s.push(c(i));return s}static _$Ep(t,i){const s=i.attribute;return !1===s?void 0:"string"==typeof s?s:"string"==typeof t?t.toLowerCase():void 0}_$Eu(){var t;this._$E_=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Eg(),this.requestUpdate(),null===(t=this.constructor.h)||void 0===t||t.forEach((t=>t(this)));}addController(t){var i,s;(null!==(i=this._$ES)&&void 0!==i?i:this._$ES=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(s=t.hostConnected)||void 0===s||s.call(t));}removeController(t){var i;null===(i=this._$ES)||void 0===i||i.splice(this._$ES.indexOf(t)>>>0,1);}_$Eg(){this.constructor.elementProperties.forEach(((t,i)=>{this.hasOwnProperty(i)&&(this._$Ei.set(i,this[i]),delete this[i]);}));}createRenderRoot(){var t;const s=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return S(s,this.constructor.elementStyles),s}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostConnected)||void 0===i?void 0:i.call(t)}));}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostDisconnected)||void 0===i?void 0:i.call(t)}));}attributeChangedCallback(t,i,s){this._$AK(t,s);}_$EO(t,i,s=l$1$1){var e;const r=this.constructor._$Ep(t,s);if(void 0!==r&&!0===s.reflect){const h=(void 0!==(null===(e=s.converter)||void 0===e?void 0:e.toAttribute)?s.converter:n$1$1).toAttribute(i,s.type);this._$El=t,null==h?this.removeAttribute(r):this.setAttribute(r,h),this._$El=null;}}_$AK(t,i){var s;const e=this.constructor,r=e._$Ev.get(t);if(void 0!==r&&this._$El!==r){const t=e.getPropertyOptions(r),h="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==(null===(s=t.converter)||void 0===s?void 0:s.fromAttribute)?t.converter:n$1$1;this._$El=r,this[r]=h.fromAttribute(i,t.type),this._$El=null;}}requestUpdate(t,i,s){let e=!0;void 0!==t&&(((s=s||this.constructor.getPropertyOptions(t)).hasChanged||a$3)(this[t],i)?(this._$AL.has(t)||this._$AL.set(t,i),!0===s.reflect&&this._$El!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,s))):e=!1),!this.isUpdatePending&&e&&(this._$E_=this._$Ej());}async _$Ej(){this.isUpdatePending=!0;try{await this._$E_;}catch(t){Promise.reject(t);}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Ei&&(this._$Ei.forEach(((t,i)=>this[i]=t)),this._$Ei=void 0);let i=!1;const s=this._$AL;try{i=this.shouldUpdate(s),i?(this.willUpdate(s),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostUpdate)||void 0===i?void 0:i.call(t)})),this.update(s)):this._$Ek();}catch(t){throw i=!1,this._$Ek(),t}i&&this._$AE(s);}willUpdate(t){}_$AE(t){var i;null===(i=this._$ES)||void 0===i||i.forEach((t=>{var i;return null===(i=t.hostUpdated)||void 0===i?void 0:i.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t);}_$Ek(){this._$AL=new Map,this.isUpdatePending=!1;}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$E_}shouldUpdate(t){return !0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,i)=>this._$EO(i,this[i],t))),this._$EC=void 0),this._$Ek();}updated(t){}firstUpdated(t){}}u[d]=!0,u.elementProperties=new Map,u.elementStyles=[],u.shadowRootOptions={mode:"open"},null==o$1$1||o$1$1({ReactiveElement:u}),(null!==(s$1$1=e$5.reactiveElementVersions)&&void 0!==s$1$1?s$1$1:e$5.reactiveElementVersions=[]).push("1.6.3");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var l$4,o$6;let s$6 = class s extends u{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0;}createRenderRoot(){var t,e;const i=super.createRenderRoot();return null!==(t=(e=this.renderOptions).renderBefore)&&void 0!==t||(e.renderBefore=i.firstChild),i}update(t){const i=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=D(i,this.renderRoot,this.renderOptions);}connectedCallback(){var t;super.connectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!0);}disconnectedCallback(){var t;super.disconnectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!1);}render(){return T}};s$6.finalized=!0,s$6._$litElement$=!0,null===(l$4=globalThis.litElementHydrateSupport)||void 0===l$4||l$4.call(globalThis,{LitElement:s$6});const n$6=globalThis.litElementPolyfillSupport;null==n$6||n$6({LitElement:s$6});(null!==(o$6=globalThis.litElementVersions)&&void 0!==o$6?o$6:globalThis.litElementVersions=[]).push("3.3.3");

var themes$1 = {};

/**
 * Auto-generated file
 * Do not edit directly
 */
var LoadsmartTheme = {
    "brand-color-brand": "20, 214, 77",
    "brand-color-brand-accent-1": "0, 215, 215",
    "brand-color-brand-accent-2": "132, 241, 30",
    "border-radius-none": "0px",
    "border-radius-s": "4px",
    "border-radius-m": "8px",
    "border-radius-l": "16px",
    "border-radius-circle": "50%",
    "border-none": 0,
    "border-thin": "1px",
    "border-medium": "2px",
    "border-thick": "4px",
    "color-background-primary": "252, 252, 255",
    "color-background-secondary": "248, 249, 251",
    "color-background-tertiary": "230, 237, 242",
    "color-background-highlight": "202, 219, 221",
    "color-background-inverted": "32, 41, 49",
    "color-background-secondary-inverted": "61, 74, 85",
    "color-border-input": "193, 206, 217",
    "color-border": "230, 237, 242",
    "color-divider": "230, 237, 242",
    "color-brand": "20, 214, 77",
    "color-brand-accent-1": "0, 215, 215",
    "color-brand-accent-2": "132, 241, 30",
    "color-primary-20": "202, 219, 221",
    "color-primary-60": "0, 84, 84",
    "color-primary-100": "0, 51, 51",
    "color-accent-20": "229, 245, 255",
    "color-accent-60": "0, 98, 159",
    "color-accent-100": "15, 66, 97",
    "color-neutral-0": "252, 252, 255",
    "color-neutral-10": "248, 249, 251",
    "color-neutral-20": "230, 237, 242",
    "color-neutral-40": "193, 206, 217",
    "color-neutral-60": "94, 118, 138",
    "color-neutral-80": "92, 106, 118",
    "color-neutral-90": "61, 74, 85",
    "color-neutral-100": "32, 41, 49",
    "color-success-20": "227, 247, 239",
    "color-success-60": "3, 124, 94",
    "color-success-100": "0, 94, 71",
    "color-danger-20": "255, 233, 230",
    "color-danger-60": "186, 27, 27",
    "color-danger-100": "104, 0, 3",
    "color-warning-20": "255, 243, 214",
    "color-warning-60": "248, 182, 14",
    "color-warning-100": "102, 63, 25",
    "color-text-primary": "32, 41, 49",
    "color-text-secondary": "61, 74, 85",
    "color-text-tertiary": "92, 106, 118",
    "color-text-placeholder": "94, 118, 138",
    "color-text-disabled": "193, 206, 217",
    "color-text-inverted": "252, 252, 255",
    "color-text-secondary-inverted": "193, 206, 217",
    "color-text-error": "186, 27, 27",
    "color-text-highlight": "0, 98, 159",
    "color-text-link": "0, 84, 84",
    "font-family-default": "'Manrope', sans-serif",
    "font-family-title": "'PlusJakartaSans', 'Manrope', sans-serif",
    "font-size-1": "0.625rem",
    "font-size-2": "0.75rem",
    "font-size-3": "0.875rem",
    "font-size-4": "1rem",
    "font-size-5": "1.25rem",
    "font-size-6": "1.625rem",
    "font-size-7": "2.375rem",
    "font-size-8": "3rem",
    "font-size-9": "3.625rem",
    "font-weight-regular": 500,
    "font-weight-medium": 600,
    "font-weight-bold": 700,
    "line-height-1": "100%",
    "line-height-2": "125%",
    "line-height-3": "130%",
    "line-height-4": "140%",
    "line-height-5": "150%",
    "line-height-6": "180%",
    "media-screen-desktop": "1025px",
    "media-screen-tablet": "481px",
    "opacity-0": "0%",
    "opacity-20": "20%",
    "opacity-40": "40%",
    "opacity-60": "60%",
    "opacity-100": "100%",
    "elevation-1": "0px 0px 2px rgba(94, 118, 138, 0.1), 0px 1px 6px 2px rgba(61, 74, 85, 0.15)",
    "elevation-2": "0px 1px 3px rgba(94, 118, 138, 0.2), 0px 4px 8px 3px rgba(61, 74, 85, 0.15)",
    "elevation-3": "0px 0px 4px rgba(94, 118, 138, 0.2), 0px 6px 12px 6px rgba(61, 74, 85, 0.15)",
    "elevation-4": "0px 5px 6px 4px rgba(94, 118, 138, 0.2), 0px 8px 10px rgba(61, 74, 85, 0.1)",
    "glow-primary": "0.0px 0.0px 4.0px 0px rgb(3, 124, 94, .5)",
    "glow-warning": "0.0px 0.0px 4.0px 0px rgba(255, 206, 79, 1.0)",
    "spacing-1": "4px",
    "spacing-2": "8px",
    "spacing-3": "12px",
    "spacing-4": "16px",
    "spacing-5": "20px",
    "spacing-6": "24px",
    "spacing-8": "32px",
    "spacing-10": "40px",
    "spacing-12": "48px",
    "spacing-14": "56px",
    "spacing-16": "64px",
    "spacing-20": "80px",
    "spacing-30": "120px",
    "spacing-0-5": "2px",
    "global-height-small": "1.75rem",
    "global-height-default": "2.5rem",
    "global-height-large": "3rem",
    "platform-font-default": "'Manrope', sans-serif",
    "platform-font-title": "'PlusJakartaSans', 'Manrope', sans-serif"
};

themes$1.LoadsmartTheme = LoadsmartTheme;

var themes = themes$1;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Sort an array of strings in a special way that considers numeric parts within the strings.
 *
 * @param values - An array of strings to be sorted.
 * @returns - A new array containing the sorted strings.
 */
function sortNumericValues(values) {
    // Create a copy of the input array to avoid modifying the original array.
    return __spreadArray([], values, true).sort(function (a, b) {
        return a.localeCompare(b, undefined, {
            numeric: true,
            sensitivity: 'base',
        });
    });
}

function extractTokens(tokens, prefix) {
    return tokens.filter(function (token) {
        return token.startsWith(prefix);
    });
}
function excludeTokens(tokens, prefix) {
    return tokens.filter(function (token) {
        return !token.startsWith(prefix);
    });
}
var ALL_TOKENS = Object.keys(themes.LoadsmartTheme);
// We strip brand and platform-specific tokens as they should not be used directly.
var TOKENS = sortNumericValues(excludeTokens(excludeTokens(ALL_TOKENS, 'brand-'), 'platform-'));
extractTokens(TOKENS, 'color-background-');
extractTokens(TOKENS, 'border-radius-');
extractTokens(TOKENS, 'border-');
extractTokens(TOKENS, 'color-');
extractTokens(TOKENS, 'elevation-');
extractTokens(TOKENS, 'font-family-');
extractTokens(TOKENS, 'font-size-');
extractTokens(TOKENS, 'font-weight-');
extractTokens(TOKENS, 'global-');
extractTokens(TOKENS, 'glow-');
extractTokens(TOKENS, 'line-height-');
extractTokens(TOKENS, 'opacity-');
var SPACING_TOKENS = extractTokens(TOKENS, 'spacing-');
extractTokens(TOKENS, 'media-');
__spreadArray(['none'], SPACING_TOKENS, true);

/**
 * Get token value.
 *
 * @example
 * ```js
 * getToken('color-primary')
 * ```
 *
 * @param token - Token whose value should be retrieved.
 * @returns {TokenValue | undefined} Token value or `undefined` otherwise.
 */
function getToken(token) {
    return themes.LoadsmartTheme[token];
}

function toCSSVariable(token) {
    var value = getToken(token);
    if (value == null) {
        return value;
    }
    return "--m-".concat(token);
}

function toCSSValue(token, alpha) {
    var value = getToken(token);
    if (value == null) {
        return '';
    }
    if (token.startsWith('color-')) {
        return "rgba(var(".concat(toCSSVariable(token), ", ").concat(value, "), ").concat(alpha !== null && alpha !== void 0 ? alpha : 1, ")");
    }
    return "var(".concat(toCSSVariable(token), ", ").concat(value, ")");
}
var toCSSValue_1 = toCSSValue;

function styles$I() {
    return [
        i$4 `
			:host {
				--m-icon-size: 16px;
				--m-icon-color: ${r$1(toCSSValue_1('color-text-primary'))};

				display: inline-flex;
				align-items: center;
				justify-content: center;

				inline-size: var(--m-icon-size);
				block-size: var(--m-icon-size);
			}

			svg {
				transition: color 0.35s ease-in-out 0s, fill 0.35s ease-in-out 0s;

				inline-size: var(--m-icon-size);
				block-size: var(--m-icon-size);

				color: var(--m-icon-color);
				fill: var(--m-icon-color);
			}
		`,
    ];
}

function __variableDynamicImportRuntime0__(path) {
  switch (path) {
    case './icons/add-circle.ts': return import('./add-circle-0qLnvhBY-GGrg54mQ.js');
    case './icons/alarm.ts': return import('./alarm-D_p1J-TN-Bq3CyRcn.js');
    case './icons/alert-circle.ts': return import('./alert-circle-CxLfIb5W-z_mZ0TFH.js');
    case './icons/anchor.ts': return import('./anchor-CI1qb5OU-DM73TACa.js');
    case './icons/arrow-corner-up.ts': return import('./arrow-corner-up-Cgsfb2VA-CW20Xl6B.js');
    case './icons/arrow-download.ts': return import('./arrow-download-Cg8lpNxg-UmN27kmC.js');
    case './icons/arrow-left.ts': return import('./arrow-left-BWbiwAlJ-DCMyeXg0.js');
    case './icons/arrow-right.ts': return import('./arrow-right-CGhYVY-B-BKHWZY6c.js');
    case './icons/arrow-sort-down.ts': return import('./arrow-sort-down-5tG_UVNn-CmE1r9rt.js');
    case './icons/arrow-sort-up-down.ts': return import('./arrow-sort-up-down-C-bBzaOZ-HeAFfRjQ.js');
    case './icons/arrow-sort-up.ts': return import('./arrow-sort-up-DOcc-29--Chbnj855.js');
    case './icons/arrow-upload.ts': return import('./arrow-upload-BDT2cpG7-CRYnuWXG.js');
    case './icons/asterisk.ts': return import('./asterisk-BVKf_lWx-CXD18dGS.js');
    case './icons/attention.ts': return import('./attention-HycM-Lha-DAgRVzP6.js');
    case './icons/automatic.ts': return import('./automatic-By4wu8OM-ipmY6q4S.js');
    case './icons/back.ts': return import('./back-DHcZFktd-DO1qdS2r.js');
    case './icons/bank.ts': return import('./bank-Cs7zp4ME-DjIbFgx7.js');
    case './icons/bell-cancel.ts': return import('./bell-cancel-BGXDQQ3u-IyxPH-Oc.js');
    case './icons/bell.ts': return import('./bell-J2Y0D5aE-JVari6BG.js');
    case './icons/blind-bol.ts': return import('./blind-bol-1E54CMBz-C8uynSVe.js');
    case './icons/bolt-off.ts': return import('./bolt-off-Bvc6tpxg-BMA4_quy.js');
    case './icons/bolt.ts': return import('./bolt-CZSfGbyW-IcEf3UIx.js');
    case './icons/box.ts': return import('./box-DsnTO8Gb-BGJZlNyL.js');
    case './icons/burguer-menu.ts': return import('./burguer-menu-DxFV5SeW-B_YzKPeJ.js');
    case './icons/calendar.ts': return import('./calendar-DWqeAg_M-BGy17cJh.js');
    case './icons/camera.ts': return import('./camera-DenlGAIK-B1yHIy0Z.js');
    case './icons/canada-flag.ts': return import('./canada-flag-uvHb6Ruv-BhK3lffP.js');
    case './icons/caret-down.ts': return import('./caret-down-SJLXcKsm-LuueiBxO.js');
    case './icons/caret-left.ts': return import('./caret-left-XrjBUdKu-C6V_1Lsu.js');
    case './icons/caret-right.ts': return import('./caret-right-EP5cnwZ2-Dm0E_PLe.js');
    case './icons/caret-up.ts': return import('./caret-up-kePctY2C-BkK5N6xt.js');
    case './icons/chat.ts': return import('./chat-2qysLBcH-ChzyanQh.js');
    case './icons/check.ts': return import('./check-B6zmw52D-CVeVNF4p.js');
    case './icons/clock.ts': return import('./clock-CtLg9J3T-lvV0lX1y.js');
    case './icons/close.ts': return import('./close-DtRzmLcE-DGuUGsaD.js');
    case './icons/clown.ts': return import('./clown-_JHH3ua3-CrKhzdQd.js');
    case './icons/code.ts': return import('./code-MuMg98Iu-CFT6tArJ.js');
    case './icons/comment.ts': return import('./comment-Cxg5FUx5-BzO6mdJg.js');
    case './icons/company.ts': return import('./company-QfAE18CJ-BAWm_gJF.js');
    case './icons/contract.ts': return import('./contract-BCT2TxzP-ciFIoTzP.js');
    case './icons/corner-down-r.ts': return import('./corner-down-r-DN-XHGSA-DQ1Q2OFA.js');
    case './icons/corner-down.ts': return import('./corner-down-Bg-VdgGM-Ca_g_SIl.js');
    case './icons/corner-up.ts': return import('./corner-up-Bsp7ce2J-CoM54PTx.js');
    case './icons/credit-card.ts': return import('./credit-card-CDmhF2FA-D6EzrJvj.js');
    case './icons/delivery.ts': return import('./delivery-DTlnUuMh-B_hKtftC.js');
    case './icons/dislike.ts': return import('./dislike-DQm_kAjg-DkHA4niy.js');
    case './icons/dollar-circle.ts': return import('./dollar-circle-Rv0VBvQH-DDos5qX-.js');
    case './icons/dollar.ts': return import('./dollar-BKuO8jgg-DS6khl10.js');
    case './icons/dots-horizontal.ts': return import('./dots-horizontal-C6FpQ43V-DyoPEhgC.js');
    case './icons/dots-vertical.ts': return import('./dots-vertical-Cw561Gs6-BTmXdb0a.js');
    case './icons/double-caret-left.ts': return import('./double-caret-left-DtdkhBmW-C8dghd36.js');
    case './icons/double-caret-right.ts': return import('./double-caret-right-CormI7p8-DAUvTxzq.js');
    case './icons/down.ts': return import('./down-CW1oKKC0-BLv9GnjO.js');
    case './icons/download.ts': return import('./download-BCFD3B7H-CKsIJ8_L.js');
    case './icons/dropdown.ts': return import('./dropdown-BD1b1pzO-BQ5uQJ9s.js');
    case './icons/email-filled.ts': return import('./email-filled-ZxWatuZV-CsLwyZDz.js');
    case './icons/email.ts': return import('./email-BMpfMMEx-CTOoAGyI.js');
    case './icons/export.ts': return import('./export-B-7PhzU3-CBsp-S8M.js');
    case './icons/eye.ts': return import('./eye-B_X6xaJJ-CbMwyG1d.js');
    case './icons/fast.ts': return import('./fast-CHXFqIHr-Dh1wDN9j.js');
    case './icons/favorite.ts': return import('./favorite-BL_kCWvH-rfSn37WY.js');
    case './icons/file.ts': return import('./file-Cr9Fq7_W-BYp1nQ1a.js');
    case './icons/filter.ts': return import('./filter-DuAobpy9-BBAlkEx7.js');
    case './icons/flag.ts': return import('./flag-DrMLFFc0-DwCOVyso.js');
    case './icons/folder.ts': return import('./folder-BY6WuzUt-DZq2zR8z.js');
    case './icons/funnel.ts': return import('./funnel-KjMlIdLf-DdNuUBZv.js');
    case './icons/gear.ts': return import('./gear-IcvEkshe-Km4Ir_-S.js');
    case './icons/graph.ts': return import('./graph-CKoiGB2B-C1HhlAyx.js');
    case './icons/hand-tap.ts': return import('./hand-tap-D9yTgdS5-DLFaYS7P.js');
    case './icons/hand.ts': return import('./hand-uQYA5eYg-DytxScoT.js');
    case './icons/high-signal.ts': return import('./high-signal-DL3kvlVu-DijS0NEo.js');
    case './icons/history.ts': return import('./history-C9N3TM2W-D1knOY9X.js');
    case './icons/home.ts': return import('./home-8tw5hWNp-BLo1_Lvd.js');
    case './icons/hourglass.ts': return import('./hourglass-Bmj0vBld-Bl_THqFS.js');
    case './icons/import-2.ts': return import('./import-2-FX2JN1GK-PJ3j7B3v.js');
    case './icons/import.ts': return import('./import-DI4za_gd-7QAxhJkL.js');
    case './icons/indeterminate.ts': return import('./indeterminate-DzpkVxXo-DstKy9xy.js');
    case './icons/info-circle.ts': return import('./info-circle-BFtKoBJB-Chi_zZz9.js');
    case './icons/info.ts': return import('./info-CfMiz4Hn-BlT-tD4l.js');
    case './icons/kanban.ts': return import('./kanban-CI2g4qua-Di-IKBRK.js');
    case './icons/like.ts': return import('./like-B-oCYOX4-DOEG-jmJ.js');
    case './icons/link.ts': return import('./link-BQrT2dOS-DyD0lkc4.js');
    case './icons/list.ts': return import('./list-BSm4pbTT-kgr7Shoj.js');
    case './icons/loadsmart-logo.ts': return import('./loadsmart-logo-iYK5V8cM-C0nG7MOH.js');
    case './icons/log-out.ts': return import('./log-out-CeGBN_Bt-DiUZ-xaE.js');
    case './icons/low-signal.ts': return import('./low-signal-221N8aZZ-D0LsVixm.js');
    case './icons/map.ts': return import('./map-D94obxQo-DBT00gDY.js');
    case './icons/medal.ts': return import('./medal-CBazr7ae-BXn4c0B1.js');
    case './icons/megaphone.ts': return import('./megaphone-CFJj3XUl-Bmv1dR5A.js');
    case './icons/mexico-flag.ts': return import('./mexico-flag-DhX1DicF-CLjqZRcS.js');
    case './icons/minus.ts': return import('./minus-D_coZSTe-BGgxSdIl.js');
    case './icons/network-signal.ts': return import('./network-signal-IAIANH7j-BulWRhqC.js');
    case './icons/next.ts': return import('./next-DiBA_7zd-DcoZ6I1o.js');
    case './icons/no-awarded.ts': return import('./no-awarded-pNU7y6Wl-Buz9U5wt.js');
    case './icons/notes-lock.ts': return import('./notes-lock-BOhxLur0-DOnGjPRb.js');
    case './icons/order.ts': return import('./order-DdiXvrj5-CYj9vj24.js');
    case './icons/padlock-open.ts': return import('./padlock-open-CnAjiSm7-BNcT_53j.js');
    case './icons/padlock.ts': return import('./padlock-BGxAztmQ-D78GV-w4.js');
    case './icons/pencil.ts': return import('./pencil-BlKMvuVj-BNQ-E_Bz.js');
    case './icons/phone.ts': return import('./phone-HWhKnhVD-C_YbVi5S.js');
    case './icons/pin-map.ts': return import('./pin-map-CrZUCl1m-BKKaj6AC.js');
    case './icons/pin.ts': return import('./pin-DxXJy4G0-BqDRGYdh.js');
    case './icons/plugs.ts': return import('./plugs-B33BcbRX-BxKd_oP9.js');
    case './icons/plus.ts': return import('./plus-DnwMNkv--AJbRha22.js');
    case './icons/pre-confirmed-load.ts': return import('./pre-confirmed-load-DJj_CBy--CX-i1WM4.js');
    case './icons/print.ts': return import('./print-DRrwQaFe-DeDuF8YN.js');
    case './icons/profile.ts': return import('./profile-CeBXUApe-BQ4bAVRX.js');
    case './icons/question-dot.ts': return import('./question-KbLGqPey-DLvUL8Mv.js').then(function (n) { return n.q; });
    case './icons/question.ts': return import('./question-KbLGqPey-DLvUL8Mv.js').then(function (n) { return n.a; });
    case './icons/redo.ts': return import('./redo-dF3qMIB1-eH2j_gMO.js');
    case './icons/refresh.ts': return import('./refresh-B1txoBDG-Cz0Ig02r.js');
    case './icons/reloading.ts': return import('./reloading-DkhAbjYA-CrlBY7o5.js');
    case './icons/road.ts': return import('./road-Dlhed0lf-Dxlc46sS.js');
    case './icons/round-trip.ts': return import('./round-trip-CHfH-wxM-HS0ejeDl.js');
    case './icons/satellite.ts': return import('./satellite-CJfVBJgm-AxQeH0vu.js');
    case './icons/search.ts': return import('./search-Cc-Sqmed-CSF_6C_k.js');
    case './icons/send.ts': return import('./send-DPw2tbOB-DuzUOf6J.js');
    case './icons/share.ts': return import('./share-DgzzFOfO-C8vy6iW6.js');
    case './icons/ship.ts': return import('./ship-BPPRvwHA-DnDhusO1.js');
    case './icons/signal.ts': return import('./signal-CI0LJoJ8-BBDVL_ou.js');
    case './icons/sparkle.ts': return import('./sparkle-c6jI0j9h-B4D-UsB9.js');
    case './icons/star.ts': return import('./star-ByoZbmDA-BdhnarvR.js');
    case './icons/tag-chevron.ts': return import('./tag-chevron-BKVrPiaq-C-n2yA07.js');
    case './icons/tag.ts': return import('./tag-BfJc9Es1-WifJoY_i.js');
    case './icons/telephone.ts': return import('./telephone-Cet2qrjr-Dr9c7LrK.js');
    case './icons/terminal.ts': return import('./terminal-DRK0aOeM-Bla0KYs9.js');
    case './icons/timer.ts': return import('./timer-BdqnPXir-B6khrOF2.js');
    case './icons/tms-ready.ts': return import('./tms-ready-CkXcxn1m-BxecdGCr.js');
    case './icons/trash.ts': return import('./trash-DumnKee8-C0OHxFu8.js');
    case './icons/trend-down.ts': return import('./trend-down-Ctt-pan0-KunI14Py.js');
    case './icons/trend-up.ts': return import('./trend-up-DijD5fI6-C18iIbny.js');
    case './icons/trophee.ts': return import('./trophee-C8DAmA4X-yUPFPArv.js');
    case './icons/truck.ts': return import('./truck-BT6u6e_p-Bysf-HkF.js');
    case './icons/undo.ts': return import('./undo-zdWVb40--D-7vgS-k.js');
    case './icons/united-states-flag.ts': return import('./united-states-flag-CShwC_op-DTdVdkAm.js');
    case './icons/up-down.ts': return import('./up-down-YfAETOfk-GrAydt0W.js');
    case './icons/up.ts': return import('./up-Dk3jsDx5-fcvL-Ohc.js');
    case './icons/upgrade.ts': return import('./upgrade-0Mt7nTAu-CKV3UQWG.js');
    case './icons/upload.ts': return import('./upload-CIz02mU8-BFndakeu.js');
    case './icons/user.ts': return import('./user-BzEEoFEJ-CCT-rTrQ.js');
    case './icons/wallet.ts': return import('./wallet-Bgp0vTnP-DfdSll0O.js');
    case './icons/warehouse.ts': return import('./warehouse-B4zxOh0_-B2Eqz2ME.js');
    case './icons/wifi-off.ts': return import('./wifi-off-0RiHJjGp-DtlHE9Ab.js');
    case './icons/wifi.ts': return import('./wifi-xe0UPu63-D_fah4Rj.js');
    case './icons/x-small.ts': return import('./x-small-Caouxv5u-C-bD5q_Q.js');
    case './icons/x.ts': return import('./x-DOU0G9v1-CmXvYqcL.js');
    case './icons/zoom-in.ts': return import('./zoom-in-gpbSUrHj-UfqYl2rf.js');
    case './icons/zoom-out.ts': return import('./zoom-out-BRUGbd0S-D4tzLlmX.js');
    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }

/**
 * Alphabetically sorted list of available icons
 *
 * The file names of the icons in the `icons` directory should match the names
 */
const AVAILABLE_ICONS = [
    'add-circle',
    'alarm',
    'alert-circle',
    'anchor',
    'arrow-corner-up',
    'arrow-download',
    'arrow-left',
    'arrow-right',
    'arrow-sort-down',
    'arrow-sort-up-down',
    'arrow-sort-up',
    'arrow-upload',
    'asterisk',
    'attention',
    'automatic',
    'back',
    'bank',
    'bell-cancel',
    'bell',
    'blind-bol',
    'bolt-off',
    'bolt',
    'box',
    'burguer-menu',
    'calendar',
    'camera',
    'canada-flag',
    'caret-down',
    'caret-left',
    'caret-right',
    'caret-up',
    'chat',
    'check',
    'clock',
    'close',
    'clown',
    'code',
    'comment',
    'company',
    'contract',
    'corner-down-r',
    'corner-down',
    'corner-up',
    'delivery',
    'dislike',
    'dollar',
    'dots-horizontal',
    'dots-vertical',
    'double-caret-left',
    'double-caret-right',
    'down',
    'download',
    'dropdown',
    'email-filled',
    'email',
    'export',
    'eye',
    'fast',
    'favorite',
    'file',
    'filter',
    'flag',
    'folder',
    'funnel',
    'gear',
    'graph',
    'hand-tap',
    'high-signal',
    'history',
    'home',
    'hourglass',
    'import-2',
    'import',
    'indeterminate',
    'info-circle',
    'info',
    'kanban',
    'like',
    'link',
    'list',
    'loadsmart-logo',
    'log-out',
    'low-signal',
    'map',
    'medal',
    'megaphone',
    'mexico-flag',
    'minus',
    'network-signal',
    'next',
    'no-awarded',
    'notes-lock',
    'order',
    'padlock-open',
    'padlock',
    'pencil',
    'phone',
    'pin-map',
    'pin',
    'plugs',
    'plus',
    'pre-confirmed-load',
    'print',
    'profile',
    'question-dot',
    /**
     * @deprecated Use `question-dot` instead
     */
    'question',
    'redo',
    'refresh',
    'reloading',
    'road',
    'round-trip',
    'satellite',
    'search',
    'send',
    'share',
    'ship',
    'signal',
    'sparkle',
    'star',
    'tag-chevron',
    'tag',
    'telephone',
    'terminal',
    'timer',
    'tms-ready',
    'trash',
    'trend-down',
    'trend-up',
    'trophee',
    'truck',
    'undo',
    'united-states-flag',
    'up-down',
    'up',
    'upgrade',
    'upload',
    'user',
    'wallet',
    'warehouse',
    'wifi-off',
    'wifi',
    'x-small',
    'x',
    'zoom-in',
    'zoom-out',
];
const createIcon = (iconName) => {
    return [iconName, () => __variableDynamicImportRuntime0__(`./icons/${iconName}.ts`)];
};
const icons = new Map(AVAILABLE_ICONS.map((iconName) => createIcon(iconName)));

var iconPlaceholder = b `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><rect width="44" height="44" x="2" y="2" fill="currentColor" rx="4"/></svg>`;

var _Icon_setError, _Icon_loadIcon;
/**
 * The icon's `color` and `size` are intentionally not set by default so that they can be customized via:
 * - setting color and size CSS custom properties
 * - setting color and size attributes
 * Notice that setting color and size through their attributes will override any set CSS custom properties!
 */
class Icon extends s$6 {
    static get properties() {
        return {
            name: { type: String, reflect: true },
            size: { type: String },
            color: { type: String },
            status: { type: String, state: true },
        };
    }
    constructor() {
        super();
        this.icon = null;
        this.status = 'idle';
        _Icon_setError.set(this, (message) => {
            this.status = 'error';
            console.error(message);
        });
        _Icon_loadIcon.set(this, async () => {
            this.icon = null;
            this.status = 'loading';
            this.name = this.name ?? this.getAttribute('name');
            if (this.name == null) {
                __classPrivateFieldGet(this, _Icon_setError, "f").call(this, 'Missing icon name');
                return;
            }
            if (!icons.has(this.name)) {
                __classPrivateFieldGet(this, _Icon_setError, "f").call(this, `The icon name "${this.name}" does not exist!`);
                return;
            }
            try {
                const { default: iconModule } = await icons.get(this.name)();
                this.icon = iconModule;
                this.requestUpdate();
                this.status = 'loaded';
            }
            catch {
                __classPrivateFieldGet(this, _Icon_setError, "f").call(this, `failed loading icon "${this.name}".`);
            }
        });
        this.icon = null;
        this.status = 'idle';
    }
    connectedCallback() {
        super.connectedCallback();
        __classPrivateFieldGet(this, _Icon_loadIcon, "f").call(this);
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('name')) {
            __classPrivateFieldGet(this, _Icon_loadIcon, "f").call(this);
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('size') && this.size != null) {
            this.style.setProperty('--m-icon-size', `${parseInt(String(this.size), 10) || 16}px`);
        }
        if (changedProperties.has('color') && this.color != null) {
            this.style.setProperty('--m-icon-color', toCSSValue_1(this.color));
        }
    }
    render() {
        if (this.status === 'error') {
            return iconPlaceholder;
        }
        return this.icon;
    }
}
_Icon_setError = new WeakMap(), _Icon_loadIcon = new WeakMap();
Icon.styles = [styles$I()];
window.customElements.define('m-icon', Icon);

var _Accordion_instances, _Accordion_accordionTrigger_get, _Accordion_accordionPanel_get, _Accordion_accordionContent_get, _Accordion_handleExpand, _Accordion_toggle, _Accordion_handleTransition;
class Accordion extends Component {
    static get properties() {
        return {
            disabled: { type: Boolean, reflect: true },
            expanded: { type: Boolean, reflect: true },
        };
    }
    constructor() {
        super();
        _Accordion_instances.add(this);
        _Accordion_handleTransition.set(this, () => {
            if (this.expanded && !this.disabled) {
                __classPrivateFieldGet$1(this, _Accordion_instances, "a", _Accordion_accordionPanel_get).style.height = 'auto';
            }
        });
        this.disabled = false;
        this.expanded = false;
        this.resizeObserver = new ResizeObserver((records) => {
            this.panelHeight = records[0].target.scrollHeight;
        });
    }
    firstUpdated() {
        __classPrivateFieldGet$1(this, _Accordion_instances, "a", _Accordion_accordionContent_get).style.transition = 'visibility 0.35s';
        __classPrivateFieldGet$1(this, _Accordion_instances, "a", _Accordion_accordionContent_get).setAttribute('role', 'region');
        this.resizeObserver.observe(__classPrivateFieldGet$1(this, _Accordion_instances, "a", _Accordion_accordionPanel_get));
        __classPrivateFieldGet$1(this, _Accordion_instances, "a", _Accordion_accordionPanel_get).addEventListener('transitionend', __classPrivateFieldGet$1(this, _Accordion_handleTransition, "f"));
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('expanded') ||
            changedProperties.has('disabled')) {
            __classPrivateFieldGet$1(this, _Accordion_instances, "m", _Accordion_handleExpand).call(this);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        __classPrivateFieldGet$1(this, _Accordion_instances, "a", _Accordion_accordionPanel_get).removeEventListener('transitionend', __classPrivateFieldGet$1(this, _Accordion_handleTransition, "f"));
        this.resizeObserver.disconnect();
    }
    render() {
        return x `
			<article class="m-accordion">
				<h3 class="m-accordion-header">
					<button
						id="accordion-trigger"
						class="m-accordion-trigger"
						@click="${__classPrivateFieldGet$1(this, _Accordion_instances, "m", _Accordion_toggle)}"
						?disabled=${Boolean(this.disabled)}
						aria-controls="section"
						tabindex="0"
						type="button"
					>
						<slot name="title"></slot>
						<m-icon name="caret-down"></m-icon>
					</button>
				</h3>
				<section
					id="section"
					class="m-accordion-panel"
					aria-labelledby="accordion-trigger"
				>
					<slot name="content"></slot>
				</section>
			</article>
		`;
    }
}
_Accordion_handleTransition = new WeakMap(), _Accordion_instances = new WeakSet(), _Accordion_accordionTrigger_get = function _Accordion_accordionTrigger_get() {
    return this.renderRoot.querySelector('.m-accordion-trigger');
}, _Accordion_accordionPanel_get = function _Accordion_accordionPanel_get() {
    return this.renderRoot.querySelector('.m-accordion-panel');
}, _Accordion_accordionContent_get = function _Accordion_accordionContent_get() {
    return this.querySelector('m-accordion-content');
}, _Accordion_handleExpand = function _Accordion_handleExpand() {
    __classPrivateFieldGet$1(this, _Accordion_instances, "a", _Accordion_accordionTrigger_get).setAttribute('aria-expanded', `${this.expanded && !this.disabled}`);
    __classPrivateFieldGet$1(this, _Accordion_instances, "a", _Accordion_accordionPanel_get).style.height = `${this.panelHeight}px`;
    if (this.expanded && !this.disabled) {
        __classPrivateFieldGet$1(this, _Accordion_instances, "a", _Accordion_accordionContent_get).style.visibility = 'visible';
    }
    else {
        setTimeout(() => {
            __classPrivateFieldGet$1(this, _Accordion_instances, "a", _Accordion_accordionPanel_get).style.height = '0px';
            __classPrivateFieldGet$1(this, _Accordion_instances, "a", _Accordion_accordionContent_get).style.visibility = 'hidden';
        });
    }
}, _Accordion_toggle = function _Accordion_toggle() {
    this.expanded = !this.expanded;
    this.emit('m-toggle', {
        detail: { name: 'accordion', value: this.expanded },
    });
};
Accordion.styles = [styles$J()];
window.customElements.define('m-accordion', Accordion);

class AccordionTitle extends Component {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'button');
        this.slot = 'title';
    }
    render() {
        return x `
			<slot name="leading"></slot>
			<div class="m-accordion-text"><slot></slot></div>
		`;
    }
}
AccordionTitle.styles = [accordionTitleStyles()];
window.customElements.define('m-accordion-title', AccordionTitle);

class AccordionContent extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.slot = 'content';
    }
    render() {
        return x `<div class="m-accordion-content"><slot></slot></div>`;
    }
}
AccordionContent.styles = [accordionContentStyles()];
window.customElements.define('m-accordion-content', AccordionContent);

function styles$H() {
    return i$5 `
		:host {
			display: block;
		}
	`;
}

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const e$3=Symbol.for(""),l$1=t=>{if((null==t?void 0:t.r)===e$3)return null==t?void 0:t._$litStatic$},o$3=t=>({_$litStatic$:t,r:e$3}),i$3=(t,...r)=>({_$litStatic$:r.reduce(((r,e,l)=>r+(t=>{if(void 0!==t._$litStatic$)return t._$litStatic$;throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t}. Use 'unsafeStatic' to pass non-literal values, but\n            take care to ensure page security.`)})(e)+t[l+1]),t[0]),r:e$3}),s$3=new Map,a=t=>(r,...e)=>{const o=e.length;let i,a;const n=[],u=[];let c,$=0,f=!1;for(;$<o;){for(c=r[$];$<o&&void 0!==(a=e[$],i=l$1(a));)c+=i+r[++$],f=!0;$!==o&&u.push(a),n.push(c),$++;}if($===o&&n.push(r[o]),f){const t=n.join("$$lit$$");void 0===(r=s$3.get(t))&&(n.raw=n,s$3.set(t,r=n)),e=u;}return t(r,...e)},n$3=a(x);

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const l=l=>null!=l?l:A$1;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$2={ATTRIBUTE:1,CHILD:2,PROPERTY:3,BOOLEAN_ATTRIBUTE:4,EVENT:5,ELEMENT:6},e$2=t=>(...e)=>({_$litDirective$:t,values:e});let i$2 = class i{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,e,i){this._$Ct=t,this._$AM=e,this._$Ci=i;}_$AS(t,e){return this.update(t,e)}update(t,e){return this.render(...e)}};

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const o$2=e$2(class extends i$2{constructor(t){var i;if(super(t),t.type!==t$2.ATTRIBUTE||"class"!==t.name||(null===(i=t.strings)||void 0===i?void 0:i.length)>2)throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.")}render(t){return " "+Object.keys(t).filter((i=>t[i])).join(" ")+" "}update(i,[s]){var r,o;if(void 0===this.it){this.it=new Set,void 0!==i.strings&&(this.nt=new Set(i.strings.join(" ").split(/\s/).filter((t=>""!==t))));for(const t in s)s[t]&&!(null===(r=this.nt)||void 0===r?void 0:r.has(t))&&this.it.add(t);return this.render(s)}const e=i.element.classList;this.it.forEach((t=>{t in s||(e.remove(t),this.it.delete(t));}));for(const t in s){const i=!!s[t];i===this.it.has(t)||(null===(o=this.nt)||void 0===o?void 0:o.has(t))||(i?(e.add(t),this.it.add(t)):(e.remove(t),this.it.delete(t)));}return T$1}});

var _FormControl_form, _FormControl_updateAssignedForm;
class FormControl extends s$7 {
    constructor() {
        super(...arguments);
        _FormControl_form.set(this, void 0);
        this.getForm = () => {
            return __classPrivateFieldGet$1(this, _FormControl_form, "f");
        };
        _FormControl_updateAssignedForm.set(this, () => {
            if (this.hasAttribute('form')) {
                const doc = this.getRootNode();
                const formId = this.getAttribute('form');
                __classPrivateFieldSet(this, _FormControl_form, doc.getElementById(formId), "f");
            }
            else {
                // Fall back to the closest containing form
                __classPrivateFieldSet(this, _FormControl_form, this.closest('form'), "f");
            }
        });
    }
    static get properties() {
        return {
            form: { type: String, reflect: true },
        };
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('form') || __classPrivateFieldGet$1(this, _FormControl_form, "f") == null) {
            __classPrivateFieldGet$1(this, _FormControl_updateAssignedForm, "f").call(this);
        }
    }
}
_FormControl_form = new WeakMap(), _FormControl_updateAssignedForm = new WeakMap();

function styles$G() {
    return i$5 `
		:host {
			--m-button-background-color: transparent;
			--m-button-base-size: ${getToken$1('global-height-default')};
			--m-button-border-color: ${getColor('color-neutral-90')};
			--m-button-border-radius: ${getToken$1('border-radius-s')};
			--m-button-color: ${getColor('color-text-secondary')};
			--m-button-outline-color: ${getColor('color-primary-100')};
			--m-button-outline-offset: 2px;
			--m-button-padding-x: ${getToken$1('spacing-4')};
			--m-button-padding-y: ${getToken$1('spacing-3')};
			/**
			 * Useful when overriding via host :slotted query.
			 */
			--m-button-font-size: ${getToken$1('font-size-3')};
		}

		:host([size='small']) {
			--m-button-base-size: ${getToken$1('global-height-small')};
		}

		:host([size='large']) {
			--m-button-base-size: ${getToken$1('global-height-large')};
		}

		:host([variant|='icon']) {
			--m-button-border-radius: ${getToken$1('border-radius-circle')};

			min-inline-size: var(--m-button-base-size);
			inline-size: var(--m-button-base-size);
		}

		:host {
			display: inline-block;
			min-block-size: var(--m-button-base-size);
			block-size: var(--m-button-base-size);
			border-radius: var(--m-button-border-radius);
		}

		.button {
			${transition([
        { property: 'color' },
        { property: 'background-color' },
        { property: 'border-color' },
    ])};

			${typography('button-md')};
			font-size: var(--m-button-font-size);

			cursor: pointer;
			position: relative;

			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;

			block-size: 100%;
			inline-size: 100%;
			box-sizing: border-box;

			text-decoration: none;

			gap: ${getToken$1('spacing-1')};

			padding-inline: var(--m-button-padding-x);
			padding-block: var(--m-button-padding-y);

			background-color: var(--m-button-background-color);
			color: var(--m-button-color);
			border: 1px solid var(--m-button-border-color);

			border-radius: var(--m-button-border-radius);
		}

		${on('.button').disabled} {
			cursor: default;
		}

		${on('.button', '*').disabled} {
			pointer-events: none;
		}

		${on('.button').not.disabled.focus} {
			outline: 1px solid var(--m-button-outline-color);
			outline-offset: var(--m-button-outline-offset);
		}

		${on('.button').not.disabled.hover} {
			--m-button-background-color: ${getColor('color-background-inverted')};
			--m-button-border-color: ${getColor('color-background-inverted')};
			--m-button-color: ${getColor('color-text-inverted')};
		}

		::slotted(*) {
			display: inline-flex;
			align-items: center;

			${p$1(0)};
			${m$1(0)};

			pointer-events: none;
		}

		slot[name='leading']::slotted(span),
		slot[name='trailing']::slotted(span) {
			justify-content: center;
		}
	`;
}

function styles$F() {
    return [
        styles$G(),
        i$5 `
			.button.is-loading:not(.-icon, .-icon-secondary) *:not(.loader) {
				visibility: hidden;
			}

			.button.-primary {
				--m-button-background-color: ${getColor('color-primary-60')};
				--m-button-border-color: ${getColor('color-primary-60')};
				--m-button-color: ${getColor('color-text-inverted')};
			}

			${on('.button.-primary').disabled} {
				--m-button-background-color: ${getColor('color-primary-20')};
				--m-button-border-color: ${getColor('color-primary-20')};
			}

			${on('.button.-primary').not.disabled.focus} {
				--m-button-border-color: ${getColor('color-primary-60')};
				--m-button-outline-color: ${getColor('color-primary-60')};
			}

			${on('.button.-primary').not.disabled.hover},
			${on('.button.-primary').not.disabled.active} {
				--m-button-background-color: ${getColor('color-primary-100')};
				--m-button-border-color: ${getColor('color-primary-100')};
			}

			.button.-primary.is-loading {
				--m-button-background-color: ${getColor('color-primary-60')};
				--m-button-border-color: ${getColor('color-primary-60')};
				--m-button-color: ${getColor('color-text-inverted')};
			}

			.button.-secondary {
				--m-button-background-color: transparent;
				--m-button-border-color: ${getColor('color-primary-100')};
				--m-button-color: ${getColor('color-primary-100')};
			}

			${on('.button.-secondary').disabled} {
				--m-button-border-color: ${getColor('color-text-disabled')};
				--m-button-color: ${getColor('color-text-disabled')};
			}

			${on('.button.-secondary').not.disabled.focus} {
				--m-button-border-color: ${getColor('color-primary-100')};
				--m-button-color: ${getColor('color-primary-100')};

				--m-button-outline-color: ${getColor('color-primary-60')};
			}

			${on('.button.-secondary').not.disabled.hover},
			${on('.button.-secondary').not.disabled.active} {
				--m-button-background-color: ${getColor('color-background-tertiary')};
				--m-button-border-color: ${getColor('color-primary-60')};
				--m-button-color: ${getColor('color-primary-60')};
			}

			.button.-secondary.is-loading {
				--m-button-background-color: transparent;

				--m-button-border-color: ${getColor('color-primary-100')};
				--m-button-color: ${getColor('color-primary-100')};
			}

			.button.-tertiary {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
				--m-button-color: ${getColor('color-primary-100')};
			}

			${on('.button.-tertiary').disabled} {
				--m-button-color: ${getColor('color-text-disabled')};
			}

			${on('.button.-tertiary').not.disabled.focus} {
				--m-button-color: ${getColor('color-primary-100')};
				--m-button-outline-color: ${getColor('color-primary-60')};
			}

			${on('.button.-tertiary').not.disabled.hover} {
				--m-button-background-color: ${getColor('color-background-tertiary')};
				--m-button-border-color: ${getColor('color-background-tertiary')};
				--m-button-color: ${getColor('color-primary-60')};
			}

			${on('.button.-tertiary').not.disabled.active} {
				--m-button-background-color: ${getColor('color-neutral-20')};
				--m-button-border-color: ${getColor('color-neutral-20')};
				--m-button-color: ${getColor('color-primary-60')};
			}

			.button.-tertiary.is-loading {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
				--m-button-color: ${getColor('color-primary-100')};
			}

			.button.-warning {
				--m-button-background-color: ${getColor('color-warning-60')};
				--m-button-border-color: ${getColor('color-warning-60')};
				--m-button-color: ${getColor('color-text-primary')};
			}

			${on('.button.-warning').disabled} {
				--m-button-background-color: ${getColor('color-warning-20')};
				--m-button-border-color: ${getColor('color-warning-20')};
				--m-button-color: ${getColor('color-text-inverted')};
			}

			${on('.button.-warning').not.disabled.focus} {
				--m-button-background-color: ${getColor('color-warning-60')};
				--m-button-outline-color: ${getColor('color-warning-60')};
			}

			${on('.button.-warning').not.disabled.hover},
			${on('.button.-warning').not.disabled.active} {
				--m-button-background-color: ${getColor('color-warning-100')};
				--m-button-border-color: ${getColor('color-warning-100')};
				--m-button-color: ${getColor('color-text-inverted')};
			}

			.button.-warning.is-loading {
				--m-button-background-color: ${getColor('color-warning-60')};
				--m-button-border-color: ${getColor('color-warning-60')};
				--m-button-color: ${getColor('color-text-primary')};
			}

			.button.-danger {
				--m-button-background-color: ${getColor('color-danger-60')};
				--m-button-border-color: ${getColor('color-danger-60')};
				--m-button-color: ${getColor('color-text-inverted')};
			}

			${on('.button.-danger').disabled} {
				--m-button-background-color: ${getColor('color-danger-20')};
				--m-button-border-color: ${getColor('color-danger-20')};
			}

			${on('.button.-danger').not.disabled.focus} {
				--m-button-background-color: ${getColor('color-danger-60')};
				--m-button-outline-color: ${getColor('color-danger-60')};
			}

			${on('.button.-danger').not.disabled.hover},
			${on('.button.-danger').not.disabled.active} {
				--m-button-background-color: ${getColor('color-danger-100')};
				--m-button-border-color: ${getColor('color-danger-100')};
			}

			.button.-danger.is-loading {
				--m-button-background-color: ${getColor('color-danger-60')};
				--m-button-border-color: ${getColor('color-danger-60')};
				--m-button-color: ${getColor('color-text-inverted')};
			}

			.button.-icon,
			.button.-icon-secondary {
				--m-button-color: ${getColor('color-neutral-90')};
				--m-button-padding-x: ${getToken$1('spacing-1')};
				--m-button-padding-y: ${getToken$1('spacing-1')};
			}

			.button.-icon {
				--m-button-background-color: ${getColor('color-background-tertiary')};
				--m-button-border-color: ${getColor('color-background-tertiary')};
			}

			.button.-icon-secondary {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
			}

			.button.-icon slot[name='leading']::slotted(*),
			.button.-icon slot[name='trailing']::slotted(*),
			.button.-icon-secondary slot[name='leading']::slotted(*),
			.button.-icon-secondary slot[name='trailing']::slotted(*) {
				display: none;
			}

			${on(['.button.-icon', '.button.-icon-secondary']).disabled} {
				--m-button-color: ${getColor('color-neutral-40')};
			}

			${on('.button.-icon').disabled} {
				--m-button-background-color: ${getColor('color-neutral-20')};
				--m-button-border-color: ${getColor('color-neutral-20')};
			}

			${on('.button.-icon-secondary').disabled} {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
			}

			${on(['.button.-icon', '.button.-icon-secondary']).not.disabled.focus} {
				--m-button-color: ${getColor('color-primary-60')};
				--m-button-outline-color: ${getColor('color-primary-60')};
			}

			${on('.button.-icon').not.disabled.focus} {
				--m-button-background-color: ${getColor('color-neutral-20')};
			}

			${on('.button.-icon-secondary').not.disabled.focus} {
				--m-button-background-color: transparent;
			}

			${on(['.button.-icon', '.button.-icon-secondary']).not.disabled.hover},
			${on(['.button.-icon', '.button.-icon-secondary']).not.disabled.active} {
				--m-button-color: ${getColor('color-primary-60')};
			}

			${on('.button.-icon').not.disabled.hover},
			${on('.button.-icon').not.disabled.active} {
				--m-button-background-color: ${getColor('color-background-highlight')};
				--m-button-border-color: ${getColor('color-background-highlight')};
			}

			${on('.button.-icon-secondary').not.disabled.hover},
			${on('.button.-icon-secondary').not.disabled.active} {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
			}

			.button.-small {
				--m-button-padding-y: ${getToken$1('spacing-2')};

				${typography('button-sm')};
			}

			.button.-large {
				--m-button-padding-y: ${getToken$1('spacing-4')};

				${typography('button-lg')};
			}

			.loader {
				position: absolute;

				pointer-events: none;
			}

			:host .loader {
				--m-dot-size: 8px;
			}

			:host([size='small']) .loader {
				--m-dot-size: 6px;
			}

			:host([size='large']) .loader {
				--m-dot-size: 10px;
			}
		`,
    ];
}

const DEFAULT_SIZE$2 = 10;
function styles$E() {
    return i$5 `
		:host {
			color: inherit;
			block-size: var(--m-dot-size, ${DEFAULT_SIZE$2}px);
			display: flex;
			gap: ${getToken$1('spacing-1')};
		}

		:host svg {
			block-size: 100%;
		}

		@keyframes fade-out {
			0% {
				opacity: 1;
			}

			100% {
				opacity: 0.6;
			}
		}

		:host svg circle {
			animation: fade-out 1s infinite;
		}

		:host #dot-1 {
			animation-delay: 0s;
		}

		:host #dot-2 {
			animation-delay: 0.1s;
		}

		:host #dot-3 {
			animation-delay: 0.2s;
		}
	`;
}

var _DotsLoader_instances, _DotsLoader_getSize;
function createDot(id) {
    return b$1 `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 48 48"><circle id=dot-${id} cx="24" cy="24" r="24"/></svg>`;
}
class DotsLoader extends s$7 {
    constructor() {
        super(...arguments);
        _DotsLoader_instances.add(this);
    }
    static get properties() {
        return {
            size: { type: String, reflect: true },
        };
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('size')) {
            this.style.setProperty('--m-dot-size', __classPrivateFieldGet$1(this, _DotsLoader_instances, "m", _DotsLoader_getSize).call(this));
        }
    }
    render() {
        return x `${[createDot(1), createDot(2), createDot(3)]}`;
    }
}
_DotsLoader_instances = new WeakSet(), _DotsLoader_getSize = function _DotsLoader_getSize() {
    const parsedSize = parseInt(this.size ?? String(DEFAULT_SIZE$2), 10);
    if (Number.isNaN(parsedSize)) {
        return `${DEFAULT_SIZE$2}px`;
    }
    return `${parsedSize || DEFAULT_SIZE$2}px`;
};
DotsLoader.styles = [styles$E()];
window.customElements.define('m-dots-loader', DotsLoader);

var _Button_instances, _Button_element_get, _Button_isDisabled, _Button_getRole, _Button_setDisabled, _Button_setTabIndex, _Button_handleClick, _Button_isLink;
class Button extends FormControl {
    /**
     * Which HTML tag should be used to render this element.
     */
    get tag() {
        const as = __classPrivateFieldGet$1(this, _Button_instances, "m", _Button_isLink).call(this) ? 'a' : 'button';
        return i$3 `${o$3(as)}`;
    }
    static get properties() {
        return {
            ...FormControl.properties,
            role: { type: String, reflect: true },
            loading: { type: Boolean, reflect: true },
            disabled: { type: Boolean, reflect: true },
            variant: { type: String, reflect: true },
            size: { type: String, reflect: true },
            type: { type: String },
            // anchor attributes
            href: { type: String, reflect: true },
            target: { type: String },
            download: { type: String },
        };
    }
    constructor() {
        super();
        _Button_instances.add(this);
        _Button_isDisabled.set(this, () => {
            return Boolean(this.disabled) || Boolean(this.loading);
        });
        _Button_getRole.set(this, () => {
            return __classPrivateFieldGet$1(this, _Button_instances, "m", _Button_isLink).call(this) ? 'link' : 'button';
        });
        _Button_setDisabled.set(this, () => {
            const disabled = __classPrivateFieldGet$1(this, _Button_isDisabled, "f").call(this);
            this.setAttribute('aria-disabled', String(disabled));
        });
        _Button_setTabIndex.set(this, () => {
            if (this.disabled) {
                this.setAttribute('tabindex', '-1');
                return;
            }
            this.removeAttribute('tabindex');
        });
        _Button_handleClick.set(this, (event) => {
            if (this.disabled || this.loading) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            /**
             * https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormElement/submit
             */
            if (this.type === 'submit') {
                this.getForm()?.requestSubmit();
                return;
            }
            if (this.type === 'reset') {
                this.getForm()?.reset();
            }
        });
        this.disabled = false;
        this.loading = false;
        this.size = 'default';
        this.type = 'button';
        this.variant = 'secondary';
        this.target = '_self';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', __classPrivateFieldGet$1(this, _Button_getRole, "f").call(this));
        this.addEventListener('click', __classPrivateFieldGet$1(this, _Button_handleClick, "f"));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', __classPrivateFieldGet$1(this, _Button_handleClick, "f"));
    }
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        if (changedProperties.has('href')) {
            this.setAttribute('role', __classPrivateFieldGet$1(this, _Button_getRole, "f").call(this));
        }
        __classPrivateFieldGet$1(this, _Button_setTabIndex, "f").call(this);
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('disabled') || changedProperties.has('loading')) {
            __classPrivateFieldGet$1(this, _Button_setDisabled, "f").call(this);
        }
    }
    render() {
        const isLink = __classPrivateFieldGet$1(this, _Button_instances, "m", _Button_isLink).call(this);
        return n$3 `
			<${this.tag}
				class=${o$2({
            button: true,
            '-primary': this.variant === 'primary',
            '-secondary': this.variant === 'secondary',
            '-tertiary': this.variant === 'tertiary',
            '-warning': this.variant === 'warning',
            '-danger': this.variant === 'danger',
            '-icon': this.variant === 'icon',
            '-icon-secondary': this.variant === 'icon-secondary',
            '-small': this.size === 'small',
            '-default': this.size === 'default',
            '-large': this.size === 'large',
            'is-loading': Boolean(this.loading),
            'is-disabled': __classPrivateFieldGet$1(this, _Button_isDisabled, "f").call(this),
        })}
				type=${!isLink ? this.type : A$1}
				?disabled="${!isLink ? __classPrivateFieldGet$1(this, _Button_isDisabled, "f").call(this) : A$1}"
				aria-disabled=${this.disabled && isLink ? 'true' : 'false'}
				role=${l(this.role)}
				href=${isLink ? this.href : A$1}
				target=${isLink ? l(this.target) : A$1}
				download=${isLink ? l(this.download) : A$1}
				rel=${isLink && this.target === '_blank' ? 'noreferrer noopener' : A$1}
			>
				${this.loading && !['icon', 'icon-secondary'].includes(this.variant)
            ? n$3 `<m-dots-loader class="loader"></m-dots-loader>`
            : A$1}
				<slot name="leading"></slot>
				<slot></slot>
				<slot name="trailing"></slot>
			</${this.tag}>
		`;
    }
    focus(options) {
        __classPrivateFieldGet$1(this, _Button_instances, "a", _Button_element_get)?.focus(options);
    }
}
_Button_isDisabled = new WeakMap(), _Button_getRole = new WeakMap(), _Button_setDisabled = new WeakMap(), _Button_setTabIndex = new WeakMap(), _Button_handleClick = new WeakMap(), _Button_instances = new WeakSet(), _Button_element_get = function _Button_element_get() {
    return this.renderRoot?.querySelector('.button') ?? null;
}, _Button_isLink = function _Button_isLink() {
    return Boolean(this.href);
};
Button.styles = [styles$F()];
window.customElements.define('m-button', Button);

class BackButton extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'back-button';
    }
    render() {
        return x `
			<m-button variant="icon" size="default">
				<m-icon name="arrow-left"></m-icon>
			</m-button>
		`;
    }
}
BackButton.styles = [styles$H()];
window.customElements.define('m-back-button', BackButton);

function styles$D() {
    return i$5 `
		:host {
			--m-host-size: 24px;
			--m-badge-size: 12px;
			--m-badge-border-radius: ${getToken$1('border-radius-circle')};

			display: inline-flex;
			position: relative;
			inline-size: var(--m-host-size);
			block-size: var(--m-host-size);
		}

		:host([size='small']) {
			--m-host-size: 16px;
			--m-badge-size: 8px;
		}

		.badge {
			display: flex;
			position: absolute;
			top: 0;
			inline-size: var(--m-badge-size);
			block-size: var(--m-badge-size);
			align-items: center;
			justify-content: center;
			color: ${getColor('color-text-inverted')};
			background-color: ${getColor('color-text-error')};
			font-size: ${getToken$1('font-size-1')};
			border-radius: var(--m-badge-border-radius);
		}

		:host([placement='top-left']) .badge {
			right: calc(100% - var(--m-badge-size) / 2);
		}

		:host([placement='top-right']) .badge {
			left: calc(100% - var(--m-badge-size) / 2);
		}

		.badge.-hidden {
			display: none;
		}

		:host([size='default']) .badge.-large-badge {
			inline-size: 18px;
			--m-badge-border-radius: ${getToken$1('border-radius-m')};
		}

		:host([size='default']) .badge.-extra-large-badge {
			inline-size: 24px;
			--m-badge-border-radius: ${getToken$1('border-radius-m')};
		}
	`;
}

var _Badge_instances, _Badge_counter_get, _Badge_formatCounter;
class Badge extends s$7 {
    static get properties() {
        return {
            counter: { type: Number, reflect: true },
            placement: { type: String, reflect: true },
            size: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        _Badge_instances.add(this);
        this.counter = 1;
        this.placement = 'top-right';
        this.size = 'default';
    }
    render() {
        return x `
			<slot></slot>
			<span
				class=${o$2({
            badge: true,
            '-hidden': __classPrivateFieldGet$1(this, _Badge_instances, "a", _Badge_counter_get) <= 0,
            '-large-badge': __classPrivateFieldGet$1(this, _Badge_instances, "a", _Badge_counter_get) >= 10 && __classPrivateFieldGet$1(this, _Badge_instances, "a", _Badge_counter_get) < 100,
            '-extra-large-badge': __classPrivateFieldGet$1(this, _Badge_instances, "a", _Badge_counter_get) >= 100,
        })}
				>${__classPrivateFieldGet$1(this, _Badge_instances, "m", _Badge_formatCounter).call(this)}</span
			>
		`;
    }
}
_Badge_instances = new WeakSet(), _Badge_counter_get = function _Badge_counter_get() {
    if (typeof this.counter !== 'number' ||
        Number.isNaN(this.counter) ||
        this.counter < 0) {
        return 0;
    }
    return this.counter;
}, _Badge_formatCounter = function _Badge_formatCounter() {
    if (this.size === 'default') {
        return __classPrivateFieldGet$1(this, _Badge_instances, "a", _Badge_counter_get) > 99 ? '99+' : __classPrivateFieldGet$1(this, _Badge_instances, "a", _Badge_counter_get);
    }
    return A$1;
};
Badge.styles = [styles$D()];
window.customElements.define('m-badge', Badge);

class BannerActionPrimary extends Button {
    constructor() {
        super();
        this.size = 'small';
    }
    connectedCallback() {
        super.connectedCallback();
        // This sets the slot to which the banner-action-primary should be assigned inside the banner-actions component.
        this.setAttribute('slot', 'primary-action');
    }
}
window.customElements.define('m-banner-action-primary', BannerActionPrimary);

class BannerActionSecondary extends Button {
    constructor() {
        super();
        this.variant = 'tertiary';
        this.size = 'small';
    }
    connectedCallback() {
        super.connectedCallback();
        // This sets the slot to which the banner-action-secondary should be assigned inside the banner-actions component.
        this.setAttribute('slot', 'secondary-action');
    }
}
window.customElements.define('m-banner-action-secondary', BannerActionSecondary);

function styles$C() {
    return i$5 `
		:host {
			display: flex;
			justify-content: flex-end;
			gap: ${getToken$1('spacing-2')};
		}
	`;
}

class BannerActions extends s$7 {
    connectedCallback() {
        super.connectedCallback();
        // This sets the slot to which the banner-actions should be assigned inside the banner component.
        this.setAttribute('slot', 'actions');
    }
    render() {
        return x `
			<slot name="secondary-action"></slot>
			<slot name="primary-action"></slot>
		`;
    }
}
BannerActions.styles = [styles$C()];
window.customElements.define('m-banner-actions', BannerActions);

function styles$B() {
    return i$5 `
		:host {
			${typography('body-md')};
			color: ${getColor('color-text-secondary')};
		}
	`;
}

class BannerDescription extends s$7 {
    connectedCallback() {
        super.connectedCallback();
        // This sets the slot to which the banner-description should be assigned inside the banner component.
        this.setAttribute('slot', 'description');
    }
    render() {
        return x `<slot></slot>`;
    }
}
BannerDescription.styles = [styles$B()];
window.customElements.define('m-banner-description', BannerDescription);

class BannerIcon extends s$7 {
    connectedCallback() {
        super.connectedCallback();
        // This sets the slot to which the banner-icon should be assigned inside the banner component.
        this.setAttribute('slot', 'icon');
    }
    render() {
        return x `<slot></slot>`;
    }
}
window.customElements.define('m-banner-icon', BannerIcon);

function styles$A() {
    return i$5 `
		:host {
			${typography('body-md-bold')};
			color: ${getColor('color-text-secondary')};
		}
	`;
}

class BannerTitle extends s$7 {
    connectedCallback() {
        super.connectedCallback();
        // This sets the slot to which the banner-title should be assigned inside the banner component.
        this.setAttribute('slot', 'title');
    }
    render() {
        return x `<slot></slot>`;
    }
}
BannerTitle.styles = [styles$A()];
window.customElements.define('m-banner-title', BannerTitle);

function styles$z() {
    return i$5 `
		:host {
			display: block;
			width: 100%;
		}

		:host([dismissed]) {
			display: none;
		}

		.banner {
			background-color: var(
				--m-banner-background-color,
				${getColor('color-background-secondary')}
			);
			border: var(--m-banner-border, 1px solid ${getColor('color-border-input')});
			border-radius: var(--m-banner-border-radius, ${getToken$1('border-radius-m')});
			padding-inline: var(--m-banner-padding-x, ${getToken$1('spacing-6')});
			padding-block: var(--m-banner-padding-y, ${getToken$1('spacing-4')});
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-end;
			gap: ${getToken$1('spacing-6')};
		}

		.banner.-success {
			--m-banner-background-color: ${getColor('color-success-20')};
			--m-banner-border: 1px solid ${getColor('color-success-20')};
			--m-banner-icon-color: ${getColor('color-success-60')};
		}

		.banner.-warning {
			--m-banner-background-color: ${getColor('color-warning-20')};
			--m-banner-border: 1px solid ${getColor('color-warning-20')};
			--m-banner-icon-color: ${getColor('color-warning-100')};
		}

		.banner.-danger {
			--m-banner-background-color: ${getColor('color-danger-20')};
			--m-banner-border: 1px solid ${getColor('color-danger-20')};
			--m-banner-icon-color: ${getColor('color-danger-60')};
		}

		.banner.-with-description {
			flex-direction: column;
		}

		.wrapper {
			display: flex;
			gap: ${getToken$1('spacing-6')};
			align-items: center;
			flex-grow: 1;
		}

		slot[name='icon'] > m-icon,
		slot[name='icon']::slotted(*) {
			--m-icon-color: var(--m-banner-icon-color, ${getColor('color-neutral-90')});
			--m-icon-size: var(--m-banner-icon-size, 24px);

			fill: var(--m-banner-icon-color, ${getColor('color-neutral-90')});
			block-size: var(--m-banner-icon-size, 24px);
			inline-size: var(--m-banner-icon-size, 24px);
		}

		.content {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			gap: ${getToken$1('spacing-1')};
		}
	`;
}

const BASE_PIXELS = 16;
/**
 * Convert the provided value from `px` to `rem` as lit's `CSSResult`.
 *
 * @example
 * // Considering 1rem = 16px
 * toRem(10); // returns '0.625rem'
 * toRem('16px'); // returns '1rem'
 *
 * @param {number | string} value - value, in pixels, to convert.
 * @param {number} base - value, in pixels, to be considered for 1rem.
 * @returns {CSSResult}
 */
function toRem(value, base = BASE_PIXELS) {
    return r$7(`${parseInt(String(value), 10) / base}rem`);
}

function styles$y() {
    return i$5 `
		:host {
			/**
			 * TODO: name is misleading here.
			 * rename to --m-close-button-background-color
			 */
			--m-close-button-color: transparent;
			--m-close-button-icon-color: ${getColor('color-text-primary')};
			--m-close-button-outline-color: ${getColor('color-primary-100')};
			--m-close-button-outline-offset: 2px;

			display: inline-flex;

			align-items: center;
			justify-content: center;

			width: var(--button-size);
			height: var(--button-size);
			min-width: var(--button-size);
			min-height: var(--button-size);

			cursor: pointer;

			${m$1(0)};
			${p$1(0)};

			background-color: var(--m-close-button-color);
			border: none;
			border-radius: 50%;

			${transition([{ property: 'background-color' }])};
		}

		:host([hidden]) {
			display: none;
		}

		:host([size='small']) {
			--button-size: ${toRem('12px')};
			--icon-size: ${toRem('8px')};
		}

		:host([size='default']) {
			--button-size: ${toRem('16px')};
			--icon-size: ${toRem('12px')};
		}

		:host([size='large']) {
			--button-size: ${toRem('20px')};
			--icon-size: ${toRem('16px')};
		}

		:host([inverted]) {
			--m-close-button-color: transparent;
			--m-close-button-icon-color: ${getColor('color-text-inverted')};
		}

		m-icon {
			--m-icon-size: var(--icon-size);
			--m-icon-color: var(--m-close-button-icon-color);
		}

		:host(:not([disabled]):focus) {
			outline: 1px solid var(--m-close-button-outline-color);
			outline-offset: var(--m-close-button-outline-offset);
		}

		:host(:not([disabled]):hover) {
			--m-close-button-color: ${getColor('color-text-primary')};
			--m-close-button-icon-color: ${getColor('color-text-inverted')};
		}

		:host([inverted]:not([disabled]):hover) {
			--m-close-button-color: ${getColor('color-text-inverted')};
			--m-close-button-icon-color: ${getColor('color-text-primary')};
		}

		:host([disabled]) {
			--m-close-button-icon-color: ${getColor('color-text-disabled')};

			cursor: default;
			pointer-events: none;
		}

		:host([disabled]) * {
			pointer-events: none;
			user-select: none;
		}
	`;
}

var _KeyboardSupportController_handleKeyUp;
function getShortcutKey(shortcut) {
    const keys = [
        shortcut.alt ? 'alt' : '',
        shortcut.ctrl ? 'ctrl' : '',
        shortcut.meta ? 'cmd' : '',
        shortcut.shift ? 'shift' : '',
        shortcut.key.toLowerCase(),
    ];
    return keys.filter(Boolean).join('+');
}
/**
 * Enable a component to implement behavior based on shortcuts.
 */
class KeyboardSupportController {
    constructor(host, keymap, options) {
        this.keymap = new Map();
        _KeyboardSupportController_handleKeyUp.set(this, (event) => {
            const shortcut = getShortcutKey({
                key: event.key,
                meta: event.metaKey,
                shift: event.shiftKey,
                ctrl: event.ctrlKey,
                alt: event.altKey,
            });
            if (this.keymap.has(shortcut)) {
                const handler = this.keymap.get(shortcut);
                handler(event);
                return;
            }
            console.debug('no handler for shortcut', shortcut);
        });
        this.keymap = new Map(toArray(keymap).reduce((map, { shortcut, handler }) => {
            return map.concat(toArray(shortcut).map((s) => {
                return [getShortcutKey(s), handler];
            }));
        }, []));
        this.getEventTarget = options?.getEventTarget ?? (() => host);
        (this.host = host).addController(this);
    }
    async hostConnected() {
        this.getEventTarget(this.host).addEventListener('keyup', __classPrivateFieldGet$1(this, _KeyboardSupportController_handleKeyUp, "f"));
    }
    hostDisconnected() {
        this.getEventTarget(this.host).removeEventListener('keyup', __classPrivateFieldGet$1(this, _KeyboardSupportController_handleKeyUp, "f"));
    }
}
_KeyboardSupportController_handleKeyUp = new WeakMap();

var _CloseButton_instances, _CloseButton_controllers, _CloseButton_button_get, _CloseButton_handleClick;
class CloseButton extends Component {
    static get properties() {
        return {
            controls: { type: String },
            disabled: { type: Boolean, reflect: true },
            inverted: { type: Boolean, reflect: true },
            label: { type: String },
            size: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        _CloseButton_instances.add(this);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - This property is not used directly, but we need it to add the keyboard controller
        _CloseButton_controllers.set(this, void 0);
        _CloseButton_handleClick.set(this, () => {
            if (this.disabled) {
                return;
            }
            this.emit('m-close');
        });
        this.disabled = false;
        this.inverted = false;
        this.label = 'Close';
        this.size = 'default';
        __classPrivateFieldSet(this, _CloseButton_controllers, {
            keyboard: new KeyboardSupportController(this, [
                {
                    shortcut: [
                        {
                            key: 'Enter',
                        },
                        {
                            key: ' ',
                        },
                    ],
                    handler: (event) => {
                        const { target } = event;
                        if (!target) {
                            return;
                        }
                        __classPrivateFieldGet$1(this, _CloseButton_handleClick, "f").call(this);
                    },
                },
            ]),
        }, "f");
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'button');
        if (this.controls) {
            this.setAttribute('aria-controls', this.controls);
        }
        this.addEventListener('click', __classPrivateFieldGet$1(this, _CloseButton_handleClick, "f"));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', __classPrivateFieldGet$1(this, _CloseButton_handleClick, "f"));
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('label') && !this.hasAttribute('aria-label')) {
            if (this.label) {
                this.setAttribute('aria-label', this.label);
            }
            else {
                this.removeAttribute('aria-label');
            }
        }
        if (changedProperties.has('disabled')) {
            if (this.disabled) {
                this.setAttribute('aria-disabled', 'true');
                this.setAttribute('tabindex', '-1');
            }
            else {
                this.setAttribute('tabindex', '0');
                this.removeAttribute('aria-disabled');
            }
        }
    }
    render() {
        return x `<m-icon name="close"></m-icon>`;
    }
    focus(options) {
        __classPrivateFieldGet$1(this, _CloseButton_instances, "a", _CloseButton_button_get)?.focus(options);
    }
}
_CloseButton_controllers = new WeakMap(), _CloseButton_handleClick = new WeakMap(), _CloseButton_instances = new WeakSet(), _CloseButton_button_get = function _CloseButton_button_get() {
    return this.renderRoot.querySelector('button') ?? null;
};
CloseButton.styles = [styles$y()];
window.customElements.define('m-close-button', CloseButton);

/**
 * Based on the `HTMLElementTagNameMap`, from lib.dom.d.ts
 */
const HTML_TAGS = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'menu',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'slot',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
];

/* eslint-disable max-classes-per-file -- Mixins need to have declare more than one class */
/**
 * This mixin allows a component to render with different types of tags, based on the provided `allowedTags`.
 * Be aware that, this mixin does **NOT** change the type (TS-wise) of your component, so, for tags that have their specific
 * attributes (e.g., button, a), your component must accept and properly render those attributes.
 * This is just a convenience layer for rendering a dynamically provided tag.
 *
 * TL;DR; either limit the tags you will allow for component, or add the additional attributes to your component to
 * comply with the tags that will be supported.
 */
const PolymorphicTagMixin = ({ superClass, allowedTags = HTML_TAGS, fallbackTag = 'div', }) => {
    class PolymorphicTag extends superClass {
        static get properties() {
            return {
                as: { type: String },
            };
        }
        attributeChangedCallback(name, oldVal, newVal) {
            super.attributeChangedCallback(name, oldVal, newVal);
            if (name === 'as') {
                if (newVal === null || !allowedTags.includes(newVal)) {
                    this.as = fallbackTag;
                }
                else {
                    this.as = newVal;
                }
            }
        }
        get tag() {
            return i$3 `${o$3(this.as)}`;
        }
    }
    return PolymorphicTag;
};

function styles$x() {
    return i$5 `
		:host {
			--m-text-color: ${getColor('color-text-primary')};
			--m-text-display: inline-block;
			--m-text-max-width: initial;
			--m-text-padding: 0;
			--m-text-margin: 0;

			display: contents;
		}

		.m-text {
			${transition([{ property: 'color' }])};

			${typography()};

			color: var(--m-text-color);
			display: var(--m-text-display);
			padding: var(--m-text-padding);
			margin: var(--m-text-margin);
		}

		.-body-lg-bold {
			${typography('body-lg-bold')};
		}

		.-body-lg {
			${typography('body-lg')};
		}

		.-body-md-bold-underline {
			${typography('body-md-bold-underline')};
		}

		.-body-md-bold {
			${typography('body-md-bold')};
		}

		.-body-md-underline {
			${typography('body-md-underline')};
		}

		.-body-md {
			${typography('body-md')};
		}

		.-body-sm-bold-underline {
			${typography('body-sm-bold-underline')};
		}

		.-body-sm-bold {
			${typography('body-sm-bold')};
		}

		.-body-sm-underline {
			${typography('body-sm-underline')};
		}

		.-body-sm {
			${typography('body-sm')};
		}

		.-button-lg {
			${typography('button-lg')};
		}

		.-button-md {
			${typography('button-md')};
		}

		.-button-sm {
			${typography('button-sm')};
		}

		.-chips-md {
			${typography('chips-md')};
		}

		.-chips-sm {
			${typography('chips-sm')};
		}

		.-heading-lg-bold {
			${typography('heading-lg-bold')};
		}

		.-heading-lg {
			${typography('heading-lg')};
		}

		.-heading-md-bold {
			${typography('heading-md-bold')};
		}

		.-heading-md {
			${typography('heading-md')};
		}

		.-heading-sm-bold {
			${typography('heading-sm-bold')};
		}

		.-heading-sm {
			${typography('heading-sm')};
		}

		.-hero-lg-bold {
			${typography('hero-lg-bold')};
		}

		.-hero-lg {
			${typography('hero-lg')};
		}

		.-hero-md-bold {
			${typography('hero-md-bold')};
		}

		.-hero-md {
			${typography('hero-md')};
		}

		.-hero-sm-bold {
			${typography('hero-sm-bold')};
		}

		.-hero-sm {
			${typography('hero-sm')};
		}

		.-number-md {
			${typography('number-md')};
		}

		.-number-sm {
			${typography('number-sm')};
		}

		.-table-header-md {
			${typography('table-header-md')};
		}

		.-table-header-sm {
			${typography('table-header-sm')};
		}

		.-ellipsized {
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			max-width: var(--m-text-max-width);
		}
	`;
}

/* eslint-disable lit/binding-positions, lit/no-invalid-html  */
class Text extends PolymorphicTagMixin({
    superClass: s$7,
    allowedTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span'],
    fallbackTag: 'span',
}) {
    static get properties() {
        return {
            color: { type: String, reflect: true },
            ellipsized: { type: Boolean, reflect: true },
            variant: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.as = 'span';
        this.ellipsized = false;
        this.variant = 'body-md';
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('color') && this.color) {
            this.style.setProperty('--m-text-color', toCSSValue_1$1(this.color));
        }
    }
    render() {
        return n$3 `
			<${this.tag}
				class=${o$2({
            'm-text': true,
            '-body-lg-bold': this.variant === 'body-lg-bold',
            '-body-lg': this.variant === 'body-lg',
            '-body-md-bold-underline': this.variant === 'body-md-bold-underline',
            '-body-md-bold': this.variant === 'body-md-bold',
            '-body-md-underline': this.variant === 'body-md-underline',
            '-body-md': this.variant === 'body-md',
            '-body-sm-bold-underline': this.variant === 'body-sm-bold-underline',
            '-body-sm-bold': this.variant === 'body-sm-bold',
            '-body-sm-underline': this.variant === 'body-sm-underline',
            '-body-sm': this.variant === 'body-sm',
            '-button-lg': this.variant === 'button-lg',
            '-button-md': this.variant === 'button-md',
            '-button-sm': this.variant === 'button-sm',
            '-chips-md': this.variant === 'chips-md',
            '-chips-sm': this.variant === 'chips-sm',
            '-heading-lg-bold': this.variant === 'heading-lg-bold',
            '-heading-lg': this.variant === 'heading-lg',
            '-heading-md-bold': this.variant === 'heading-md-bold',
            '-heading-md': this.variant === 'heading-md',
            '-heading-sm-bold': this.variant === 'heading-sm-bold',
            '-heading-sm': this.variant === 'heading-sm',
            '-hero-lg-bold': this.variant === 'hero-lg-bold',
            '-hero-lg': this.variant === 'hero-lg',
            '-hero-md-bold': this.variant === 'hero-md-bold',
            '-hero-md': this.variant === 'hero-md',
            '-hero-sm-bold': this.variant === 'hero-sm-bold',
            '-hero-sm': this.variant === 'hero-sm',
            '-number-md': this.variant === 'number-md',
            '-number-sm': this.variant === 'number-sm',
            '-table-header-md': this.variant === 'table-header-md',
            '-table-header-sm': this.variant === 'table-header-sm',
            '-ellipsized': Boolean(this.ellipsized),
        })}
			>
				<slot></slot>
			</${this.tag}>
		`;
    }
}
Text.styles = [styles$x()];
window.customElements.define('m-text', Text);

var _Banner_primaryAction, _Banner_handleDismissClick;
function getIcon(variant) {
    switch (variant) {
        case 'success': {
            return 'check';
        }
        case 'warning':
        case 'danger': {
            return 'attention';
        }
        case 'neutral':
        default: {
            return 'info-circle';
        }
    }
}
function getPrimaryActionVariant(variant) {
    switch (variant) {
        case 'warning': {
            return 'warning';
        }
        case 'danger': {
            return 'danger';
        }
        case 'success':
        case 'neutral':
        default: {
            return 'primary';
        }
    }
}
class Banner extends Component {
    static get properties() {
        return {
            variant: { type: String },
            dismissible: { type: Boolean },
            dismissed: { type: Boolean, reflect: true },
        };
    }
    constructor() {
        super();
        /**
         * Reference for the Primary Action
         */
        _Banner_primaryAction.set(this, void 0);
        _Banner_handleDismissClick.set(this, () => {
            this.dismissed = true;
            this.emit('m-dismiss', { composed: true });
        });
        this.variant = 'neutral';
        this.dismissible = false;
        this.dismissed = false;
    }
    get primaryAction() {
        if (__classPrivateFieldGet$1(this, _Banner_primaryAction, "f") == null) {
            __classPrivateFieldSet(this, _Banner_primaryAction, this.querySelector('m-banner-action-primary'), "f");
        }
        return __classPrivateFieldGet$1(this, _Banner_primaryAction, "f");
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        // Force the primary action to have a variant based on the banner's variant
        if (changedProperties.has('variant') && this.primaryAction != null) {
            this.primaryAction.variant = getPrimaryActionVariant(this.variant);
        }
    }
    render() {
        if (this.dismissed) {
            return A$1;
        }
        const hasDescription = this.querySelector(`*[slot='description']`) != null;
        const hasActions = this.querySelector(`*[slot='actions']`) != null;
        const closeButton = x `
			<m-close-button
				id="close"
				label="Dismiss"
				@click=${__classPrivateFieldGet$1(this, _Banner_handleDismissClick, "f")}
			></m-close-button>
		`;
        return x `
			<div
				class=${o$2({
            banner: true,
            '-success': this.variant === 'success',
            '-warning': this.variant === 'warning',
            '-danger': this.variant === 'danger',
            '-with-description': hasDescription,
        })}
			>
				<div class="wrapper">
					<slot name="icon">
						<m-icon name="${getIcon(this.variant)}"></m-icon>
					</slot>
					<div class="content">
						<slot name="title"></slot>
						<slot name="description"></slot>
					</div>
					${this.dismissible && !hasActions ? closeButton : A$1}
				</div>
				<slot name="actions"></slot>
			</div>
		`;
    }
}
_Banner_primaryAction = new WeakMap(), _Banner_handleDismissClick = new WeakMap();
Banner.styles = [styles$z()];
window.customElements.define('m-banner', Banner);

function styles$w() {
    return i$5 `
		:host {
			display: block;
			box-sizing: border-box;
			width: 100%;
		}
		.body-wrapper {
			padding: ${getToken$1('spacing-4')};

			slot[name='page-body']::slotted(*) {
				max-width: 1280px;
				margin: auto;
			}
		}

		${mediaDesktop(i$5 `
			.body-wrapper {
				padding: ${getToken$1('spacing-6')};
			}
		`)}
	`;
}

class Body extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        // this sets the slot to which the m-body should be assigned inside the page-content component.
        this.slot = 'page-body';
    }
    render() {
        return n$3 `<div class="body-wrapper"><slot></slot></div>`;
    }
}
Body.styles = [styles$w()];
window.customElements.define('m-body', Body);

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const i$1="important",n$2=" !"+i$1,o$1=e$2(class extends i$2{constructor(t){var e;if(super(t),t.type!==t$2.ATTRIBUTE||"style"!==t.name||(null===(e=t.strings)||void 0===e?void 0:e.length)>2)throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.")}render(t){return Object.keys(t).reduce(((e,r)=>{const s=t[r];return null==s?e:e+`${r=r.includes("-")?r:r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g,"-$&").toLowerCase()}:${s};`}),"")}update(e,[r]){const{style:s}=e.element;if(void 0===this.ht){this.ht=new Set;for(const t in r)this.ht.add(t);return this.render(r)}this.ht.forEach((t=>{null==r[t]&&(this.ht.delete(t),t.includes("-")?s.removeProperty(t):s[t]="");}));for(const t in r){const e=r[t];if(null!=e){this.ht.add(t);const r="string"==typeof e&&e.endsWith(n$2);t.includes("-")||r?s.setProperty(t,r?e.slice(0,-11):e,r?i$1:""):s[t]=e;}}return T$1}});

function cardStyles() {
    return i$5 `
		:host {
			--m-card-background-color: ${getColor('color-background-primary')};
			--m-card-padding: ${getToken$1('spacing-6')};
			--m-card-body-padding: var(--m-card-padding);
			--m-card-border-default: solid 1px ${getColor('color-border')};
			--m-card-border-top: var(--m-card-border-default);
			--m-card-border-left: var(--m-card-border-default);
			--m-card-border-bottom: var(--m-card-border-default);
			--m-card-border-right: var(--m-card-border-default);
			--m-card-border-radius: ${getToken$1('border-radius-s')};
		}

		.m-card {
			position: relative;
			display: flex;
			flex-direction: row;

			background-color: var(--m-card-background-color);
			border-radius: var(--m-card-border-radius);
			border-top: var(--m-card-border-top);
			border-left: var(--m-card-border-left);
			border-bottom: var(--m-card-border-bottom);
			border-right: var(--m-card-border-right);
		}

		.m-card-flag {
			position: absolute;
			top: -1px;
			bottom: -1px;
			left: -1px;
			display: block;

			box-sizing: border-box;
			border: 1px solid var(--m-card-flag-color);
			background-color: var(--m-card-flag-color);
			width: ${getToken$1('border-thick')};
			border-top-left-radius: ${getToken$1('border-radius-s')};
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
			border-bottom-left-radius: ${getToken$1('border-radius-s')};
		}

		.m-card-content {
			display: flex;
			flex: 1;
			flex-direction: column;
		}

		::slotted(m-divider) {
			--m-divider-margin-top: ${getToken$1('spacing-4')};
		}

		.m-title-wrapper {
			padding: var(--m-card-padding);
		}

		.hidden {
			display: none;
		}

		.m-title-wrapper > m-stack {
			flex: 1;
		}

		.m-collapse-trigger {
			${typography('body-md-bold')};
			display: flex;
			margin: 0;
			cursor: pointer;
			color: ${getColor('color-text-primary')};
			outline: none;
			border: none;
			align-items: center;
			background-color: ${getColor('color-background-primary')};
		}

		.m-collapsed-content {
			display: none;
		}

		.m-collapse-trigger[aria-expanded='true'] m-icon {
			transform: rotate(180deg);
		}

		@media (prefers-reduced-motion: no-preference) {
			m-icon {
				${transition([{ property: 'transform' }])};
			}
		}
	`;
}
function cardBodyStyles() {
    return i$5 `
		.m-card-body {
			padding: var(--m-card-body-padding);
		}
	`;
}
function cardSubtitleStyles() {
    return i$5 `
		:host {
			--m-card-subtitle-margin-top: ${getToken$1('spacing-2')};
		}

		.m-card-subtitle {
			${typography('body-md')};

			margin-block-start: var(--m-card-subtitle-margin-top);

			color: ${getColor('color-text-tertiary')};
		}
	`;
}
function cardTitleStyles() {
    return i$5 `
		.m-card-title {
			${typography('heading-sm-bold')};
			color: ${getColor('color-text-primary')};
			display: flex;
			align-items: center;
			gap: ${getToken$1('spacing-1')};
		}

		slot[name='leading']::slotted(*) {
			display: inline-flex;
			flex-flow: row nowrap;
			align-items: center;
			justify-content: center;
			pointer-events: none;
		}
	`;
}
function cardDividerStyles() {
    return i$5 `
		:host {
			--m-divider-margin-top: 0;
		}
	`;
}

const ALIGN_ITEMS_VALUES = [
    'baseline',
    'center',
    'flex-start',
    'flex-end',
    'stretch',
];
const JUSTIFY_CONTENT_VALUES = [
    'center',
    'flex-start',
    'flex-end',
    'space-between',
    'space-around',
    'space-evenly',
];

var _BaseLayout_setOrRemoveProperty;
class BaseLayout extends s$7 {
    constructor() {
        super(...arguments);
        _BaseLayout_setOrRemoveProperty.set(this, (cssVar, value) => {
            if (value) {
                this.style.setProperty(cssVar, toSpacingCSSValue_1(value));
            }
            else {
                this.style.removeProperty(cssVar);
            }
        });
    }
    static get properties() {
        return {
            padding: { type: String },
            paddingX: { type: String, attribute: 'padding-x' },
            paddingY: { type: String, attribute: 'padding-y' },
            paddingT: { type: String, attribute: 'padding-t' },
            paddingB: { type: String, attribute: 'padding-b' },
            paddingL: { type: String, attribute: 'padding-l' },
            paddingR: { type: String, attribute: 'padding-r' },
        };
    }
    /* eslint-disable-next-line class-methods-use-this */
    getCSSPropertiesPrefix() {
        return 'layout';
    }
    update(changedProperties) {
        super.update(changedProperties);
        const cssPropertiesPrefix = this.getCSSPropertiesPrefix();
        if (changedProperties.has('padding')) {
            this.style.setProperty(`--m-${cssPropertiesPrefix}-padding`, toSpacingCSSValue_1(this.padding));
        }
        if (changedProperties.has('paddingX')) {
            __classPrivateFieldGet$1(this, _BaseLayout_setOrRemoveProperty, "f").call(this, `--m-${cssPropertiesPrefix}-padding-x`, this.paddingX);
        }
        if (changedProperties.has('paddingY')) {
            __classPrivateFieldGet$1(this, _BaseLayout_setOrRemoveProperty, "f").call(this, `--m-${cssPropertiesPrefix}-padding-y`, this.paddingY);
        }
        if (changedProperties.has('paddingT')) {
            __classPrivateFieldGet$1(this, _BaseLayout_setOrRemoveProperty, "f").call(this, `--m-${cssPropertiesPrefix}-padding-t`, this.paddingT);
        }
        if (changedProperties.has('paddingB')) {
            __classPrivateFieldGet$1(this, _BaseLayout_setOrRemoveProperty, "f").call(this, `--m-${cssPropertiesPrefix}-padding-b`, this.paddingB);
        }
        if (changedProperties.has('paddingL')) {
            __classPrivateFieldGet$1(this, _BaseLayout_setOrRemoveProperty, "f").call(this, `--m-${cssPropertiesPrefix}-padding-l`, this.paddingL);
        }
        if (changedProperties.has('paddingR')) {
            __classPrivateFieldGet$1(this, _BaseLayout_setOrRemoveProperty, "f").call(this, `--m-${cssPropertiesPrefix}-padding-r`, this.paddingR);
        }
    }
    render() {
        return x `<slot></slot>`;
    }
}
_BaseLayout_setOrRemoveProperty = new WeakMap();

function getBaseLayoutStyles(cssPropertiesPrefix) {
    return i$5 `
		:host {
			/** reset layout custom properties to avoid inheritance */
			--m-${r$7(cssPropertiesPrefix)}-padding-x: initial;
			--m-${r$7(cssPropertiesPrefix)}-padding-y: initial;
			--m-${r$7(cssPropertiesPrefix)}-padding-t: initial;
			--m-${r$7(cssPropertiesPrefix)}-padding-r: initial;
			--m-${r$7(cssPropertiesPrefix)}-padding-b: initial;
			--m-${r$7(cssPropertiesPrefix)}-padding-l: initial;
			--m-${r$7(cssPropertiesPrefix)}-padding: initial;

			padding-block-start: var(
				--m-${r$7(cssPropertiesPrefix)}-padding-t,
				var(
					--m-${r$7(cssPropertiesPrefix)}-padding-y,
					var(--m-${r$7(cssPropertiesPrefix)}-padding, 0)
				)
			);
			padding-block-end: var(
				--m-${r$7(cssPropertiesPrefix)}-padding-b,
				var(
					--m-${r$7(cssPropertiesPrefix)}-padding-y,
					var(--m-${r$7(cssPropertiesPrefix)}-padding, 0)
				)
			);
			padding-inline-start: var(
				--m-${r$7(cssPropertiesPrefix)}-padding-l,
				var(
					--m-${r$7(cssPropertiesPrefix)}-padding-x,
					var(--m-${r$7(cssPropertiesPrefix)}-padding, 0)
				)
			);
			padding-inline-end: var(
				--m-${r$7(cssPropertiesPrefix)}-padding-r,
				var(
					--m-${r$7(cssPropertiesPrefix)}-padding-x,
					var(--m-${r$7(cssPropertiesPrefix)}-padding, 0)
				)
			);
		}
	`;
}

const defaultBoxProps = {
    padding: 'spacing-4',
    borderRadius: 'border-radius-s',
    borderWidth: 'border-none',
    borderColor: 'color-border',
    textAlign: 'left',
};

function boxStyles() {
    return i$5 `
		:host {
			--m-box-padding: ${getToken$1(defaultBoxProps.padding)};
			--m-box-background-color: transparent;
			--m-box-border-radius: ${getToken$1(defaultBoxProps.borderRadius)};
			--m-box-border-width: ${getToken$1(defaultBoxProps.borderWidth)};
			--m-box-border-color: ${getColor(defaultBoxProps.borderColor)};
			--m-box-text-align: ${r$7(defaultBoxProps.textAlign)};

			box-sizing: border-box;

			background-color: var(--m-box-background-color);
			border-radius: var(--m-box-border-radius);
			border-style: solid;
			border-width: var(--m-box-border-width);
			border-color: var(--m-box-border-color);
			text-align: var(--m-box-text-align);
			display: block;
		}
	`;
}

class Box extends BaseLayout {
    static get properties() {
        return {
            ...super.properties,
            backgroundColor: { type: String, attribute: 'background-color' },
            borderRadius: { type: String, attribute: 'border-radius' },
            borderWidth: { type: String, attribute: 'border-width' },
            borderColor: { type: String, attribute: 'border-color' },
            textAlign: { type: String, attribute: 'text-align' },
        };
    }
    /* eslint-disable-next-line class-methods-use-this */
    getCSSPropertiesPrefix() {
        return Box.CSSPropertiesPrefix;
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('backgroundColor')) {
            this.style.setProperty('--m-box-background-color', (this.backgroundColor && toCSSValue_1$1(this.backgroundColor)) ??
                'transparent');
        }
        if (changedProperties.has('borderRadius')) {
            this.style.setProperty('--m-box-border-radius', (this.borderRadius && toCSSValue_1$1(this.borderRadius)) ??
                toCSSValue_1$1(defaultBoxProps.borderRadius));
        }
        if (changedProperties.has('borderWidth')) {
            this.style.setProperty('--m-box-border-width', (this.borderWidth && toCSSValue_1$1(this.borderWidth)) ??
                toCSSValue_1$1(defaultBoxProps.borderWidth));
        }
        if (changedProperties.has('borderColor')) {
            this.style.setProperty('--m-box-border-color', (this.borderColor && toCSSValue_1$1(this.borderColor)) ??
                toCSSValue_1$1(defaultBoxProps.borderColor));
        }
        if (changedProperties.has('textAlign')) {
            this.style.setProperty('--m-box-text-align', this.textAlign || defaultBoxProps.textAlign);
        }
    }
    render() {
        return x `<slot></slot>`;
    }
}
Box.CSSPropertiesPrefix = 'box';
Box.styles = [
    getBaseLayoutStyles(Box.CSSPropertiesPrefix),
    boxStyles(),
];
window.customElements.define('m-box', Box);

const defaultGroupProps = {
    gap: 'spacing-4',
    align: 'stretch',
    justify: 'flex-start',
};

function groupStyles() {
    return i$5 `
		:host {
			--m-group-gap: ${getToken$1(defaultGroupProps.gap)};
			--m-group-align: ${r$7(defaultGroupProps.align)};
			--m-group-justify: ${r$7(defaultGroupProps.justify)};

			display: flex;
			flex-wrap: wrap;
			gap: var(--m-group-gap);
			align-items: var(--m-group-align);
			justify-content: var(--m-group-justify);
		}
	`;
}

class Group extends BaseLayout {
    static get properties() {
        return {
            ...super.properties,
            gap: { type: String },
            align: { type: String },
            justify: { type: String },
        };
    }
    /* eslint-disable-next-line class-methods-use-this */
    getCSSPropertiesPrefix() {
        return Group.CSSPropertiesPrefix;
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('gap')) {
            this.style.setProperty('--m-group-gap', toSpacingCSSValue_1(this.gap, defaultGroupProps.gap));
        }
        if (changedProperties.has('align')) {
            this.style.setProperty('--m-group-align', this.align || defaultGroupProps.align);
        }
        if (changedProperties.has('justify')) {
            this.style.setProperty('--m-group-justify', this.justify || defaultGroupProps.justify);
        }
    }
    render() {
        return x `<slot></slot>`;
    }
}
Group.CSSPropertiesPrefix = 'group';
Group.styles = [
    getBaseLayoutStyles(Group.CSSPropertiesPrefix),
    groupStyles(),
];
window.customElements.define('m-group', Group);

const defaultStackProps = {
    gap: 'spacing-4',
    align: 'stretch',
    justify: 'flex-start',
};

function stackStyles() {
    return i$5 `
		:host {
			--m-stack-gap: ${getToken$1(defaultStackProps.gap)};
			--m-stack-align: ${r$7(defaultStackProps.align)};
			--m-stack-justify: ${r$7(defaultStackProps.justify)};

			display: flex;
			flex-direction: column;

			row-gap: var(--m-stack-gap);
			align-items: var(--m-stack-align);
			justify-content: var(--m-stack-justify);
		}
	`;
}

class Stack extends BaseLayout {
    static get properties() {
        return {
            ...super.properties,
            gap: { type: String },
            align: { type: String },
            justify: { type: String },
        };
    }
    /* eslint-disable-next-line class-methods-use-this */
    getCSSPropertiesPrefix() {
        return Stack.CSSPropertiesPrefix;
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('gap')) {
            this.style.setProperty('--m-stack-gap', toSpacingCSSValue_1(this.gap, defaultStackProps.gap));
        }
        if (changedProperties.has('align')) {
            this.style.setProperty('--m-stack-align', this.align || defaultStackProps.align);
        }
        if (changedProperties.has('justify')) {
            this.style.setProperty('--m-stack-justify', this.justify || defaultStackProps.justify);
        }
    }
    render() {
        return x `<slot></slot>`;
    }
}
Stack.CSSPropertiesPrefix = 'stack';
Stack.styles = [
    getBaseLayoutStyles(Stack.CSSPropertiesPrefix),
    stackStyles(),
];
window.customElements.define('m-stack', Stack);

const defaultGridProps = {
    gap: 'spacing-4',
    minColumnWidth: getToken_1('spacing-30'),
};

function gridStyles() {
    return i$5 `
		:host {
			--m-grid-gap: ${getToken$1(defaultGridProps.gap)};
			--m-grid-min-column-width: ${r$7(defaultGridProps.minColumnWidth)};

			display: grid;

			row-gap: var(--m-grid-row-gap, var(--m-grid-gap));
			column-gap: var(--m-grid-column-gap, var(--m-grid-gap));

			grid-template-columns: repeat(
				auto-fit,
				minmax(min(var(--m-grid-min-column-width), 100%), 1fr)
			);
		}
	`;
}

class Grid extends BaseLayout {
    static get properties() {
        return {
            ...super.properties,
            gap: { type: String },
            rowGap: { type: String, attribute: 'row-gap' },
            columnGap: { type: String, attribute: 'column-gap' },
            minColumnWidth: { type: String, attribute: 'min-column-width' },
        };
    }
    /* eslint-disable-next-line class-methods-use-this */
    getCSSPropertiesPrefix() {
        return Grid.CSSPropertiesPrefix;
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('gap')) {
            this.style.setProperty('--m-grid-gap', toSpacingCSSValue_1(this.gap, defaultGridProps.gap));
        }
        if (changedProperties.has('rowGap')) {
            if (this.rowGap) {
                this.style.setProperty('--m-grid-row-gap', toSpacingCSSValue_1(this.rowGap));
            }
            else {
                this.style.removeProperty('--m-grid-row-gap');
            }
        }
        if (changedProperties.has('columnGap')) {
            if (this.columnGap) {
                this.style.setProperty('--m-grid-column-gap', toSpacingCSSValue_1(this.columnGap));
            }
            else {
                this.style.removeProperty('--m-grid-column-gap');
            }
        }
        if (changedProperties.has('minColumnWidth')) {
            this.style.setProperty('--m-grid-min-column-width', this.minColumnWidth || defaultGridProps.minColumnWidth);
        }
    }
    render() {
        return x `<slot></slot>`;
    }
}
Grid.CSSPropertiesPrefix = 'grid';
Grid.styles = [
    getBaseLayoutStyles(Grid.CSSPropertiesPrefix),
    gridStyles(),
];
window.customElements.define('m-grid', Grid);

const defaultSidebarProps = {
    gap: 'spacing-4',
    sideWidth: 'auto',
    minContentWidth: '50%',
    reversed: false,
};

function getFlexDirectionValue(reversed) {
    return reversed ? 'row-reverse' : 'row';
}
function sidebarStyles() {
    return i$5 `
		:host {
			--m-sidebar-gap: ${getToken$1(defaultSidebarProps.gap)};
			--m-sidebar-flex-direction: ${r$7(getFlexDirectionValue(defaultSidebarProps.reversed))};
			--m-sidebar-side-width: ${r$7(defaultSidebarProps.sideWidth)};
			--m-sidebar-min-content-width: ${r$7(defaultSidebarProps.minContentWidth)};

			display: flex;
			flex-wrap: wrap;
			flex-direction: var(--m-sidebar-flex-direction);

			gap: var(--m-sidebar-gap);
		}

		slot[name='sidebar']::slotted(*) {
			flex-basis: var(--m-sidebar-side-width);
			flex-grow: 1;
		}

		slot[name='content']::slotted(*) {
			flex-basis: 0;
			flex-grow: 999;
			min-width: var(--m-sidebar-min-content-width);
		}
	`;
}

class Sidebar extends BaseLayout {
    static get properties() {
        return {
            ...super.properties,
            gap: { type: String },
            sideWidth: { type: String, attribute: 'side-width' },
            minContentWidth: { type: String, attribute: 'min-content-width' },
            reversed: { type: Boolean },
        };
    }
    constructor() {
        super();
        this.gap = defaultSidebarProps.gap;
        this.sideWidth = defaultSidebarProps.sideWidth;
        this.minContentWidth = defaultSidebarProps.minContentWidth;
        this.reversed = defaultSidebarProps.reversed;
    }
    /* eslint-disable-next-line class-methods-use-this */
    getCSSPropertiesPrefix() {
        return Sidebar.CSSPropertiesPrefix;
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('gap')) {
            this.style.setProperty('--m-sidebar-gap', toSpacingCSSValue_1(this.gap, defaultSidebarProps.gap));
        }
        if (changedProperties.has('sideWidth')) {
            this.style.setProperty('--m-sidebar-side-width', this.sideWidth || defaultSidebarProps.sideWidth);
        }
        if (changedProperties.has('minContentWidth')) {
            this.style.setProperty('--m-sidebar-min-content-width', this.minContentWidth || defaultSidebarProps.minContentWidth);
        }
        if (changedProperties.has('reversed')) {
            this.style.setProperty('--m-sidebar-flex-direction', getFlexDirectionValue(this.reversed));
        }
    }
    render() {
        return x `
			<slot name="sidebar"></slot>
			<slot name="content"></slot>
		`;
    }
}
Sidebar.CSSPropertiesPrefix = 'sidebar';
Sidebar.styles = [
    getBaseLayoutStyles(Sidebar.CSSPropertiesPrefix),
    sidebarStyles(),
];
window.customElements.define('m-sidebar', Sidebar);

const defaultSwitcherProps = {
    gap: 'spacing-4',
    threshold: '10rem',
};

function switcherStyles() {
    return i$5 `
		:host {
			--m-switcher-gap: ${getToken$1(defaultSwitcherProps.gap)};
			--m-switcher-threshold: ${r$7(defaultSwitcherProps.threshold)};

			display: flex;
			flex-wrap: wrap;

			row-gap: var(--m-switcher-row-gap, var(--m-switcher-gap));
			column-gap: var(--m-switcher-column-gap, var(--m-switcher-gap));
		}

		::slotted(*) {
			flex-basis: calc((var(--m-switcher-threshold) - 100%) * 999);
			flex-grow: 1;
		}
	`;
}

class Switcher extends BaseLayout {
    static get properties() {
        return {
            ...super.properties,
            gap: { type: String },
            rowGap: { type: String, attribute: 'row-gap' },
            columnGap: { type: String, attribute: 'column-gap' },
            threshold: { type: String },
            limit: { type: Number },
        };
    }
    /* eslint-disable-next-line class-methods-use-this */
    getCSSPropertiesPrefix() {
        return Switcher.CSSPropertiesPrefix;
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('gap')) {
            this.style.setProperty('--m-switcher-gap', toSpacingCSSValue_1(this.gap, defaultSwitcherProps.gap));
        }
        if (changedProperties.has('rowGap')) {
            if (this.rowGap) {
                this.style.setProperty('--m-switcher-row-gap', toSpacingCSSValue_1(this.rowGap));
            }
            else {
                this.style.removeProperty('--m-switcher-row-gap');
            }
        }
        if (changedProperties.has('columnGap')) {
            if (this.columnGap) {
                this.style.setProperty('--m-switcher-column-gap', toSpacingCSSValue_1(this.columnGap));
            }
            else {
                this.style.removeProperty('--m-switcher-column-gap');
            }
        }
        if (changedProperties.has('threshold')) {
            this.style.setProperty('--m-switcher-threshold', this.threshold || defaultSwitcherProps.threshold);
        }
    }
    render() {
        const limitStyles = this.limit
            ? x `
					<style>
						::slotted(*:nth-last-child(n + ${this.limit + 1})) {
							flex-basis: 100%;
						}
						::slotted(*:nth-last-child(n + ${this.limit + 1}) ~ *) {
							flex-basis: 100%;
						}
					</style>
			  `
            : '';
        return x `
			${limitStyles}
			<slot></slot>
		`;
    }
}
Switcher.CSSPropertiesPrefix = 'switcher';
Switcher.styles = [
    getBaseLayoutStyles(Switcher.CSSPropertiesPrefix),
    switcherStyles(),
];
window.customElements.define('m-switcher', Switcher);

/**
 * Create an array containing a range of numbers between
 * and including the specified `start` and `stop` values,
 * with a fixed step interval of 1.
 * @param start the start value of the range
 * @param stop  the stop value of the range
 */
function range(start, stop) {
    const step = 1;
    return Array.from({ length: (stop - start) / step + 1 }, (_, index) => start + index * step);
}

const COLUMNS = 4;
const defaultRowProps = {
    gap: 'spacing-4',
};

function generateSlicedStyles(prefix) {
    return r$7(range(1, COLUMNS)
        .map((index) => {
        return `
				:host {
                    flex: 1 1 0%;
                    max-inline-size: ${(index * 100) / COLUMNS}%;
				}

				:host([${prefix}="${index}"]) {
                    flex: 0 0 ${(index * 100) / COLUMNS}%;
                    max-inline-size: ${(index * 100) / COLUMNS}%;
				}

				:host([offset-${prefix}="${index}"]) {
                    margin-inline-start: ${(index * 100) / COLUMNS}%;
				}
			`;
    })
        .join('\n'));
}
function containerStyles() {
    return i$5 `
		:host {
			--m-column-gap: ${getToken$1(defaultRowProps.gap)};
			--m-row-gap: ${getToken$1(defaultRowProps.gap)};

			display: block;
			box-sizing: border-box;

			inline-size: 100%;
			padding-inline: calc(var(--m-column-gap) / -2);
			padding-block: 0;
			margin-inline: auto;
			margin-block: 0;
		}
	`;
}
function rowStyles() {
    return i$5 `
		:host {
			display: flex;
			flex-wrap: wrap;
			margin-inline: calc(var(--m-column-gap) / -2);
			box-sizing: border-box;

			row-gap: var(--m-row-gap);
		}

		:host(:not(:first-of-type)) {
			margin-block: var(--m-row-gap);
		}
	`;
}
function columnStyles() {
    return i$5 `
		:host {
			position: relative;
			inline-size: 100%;
			min-block-size: 1px;
			padding-inline: calc(var(--m-column-gap) / 2);

			box-sizing: border-box;
		}

		${generateSlicedStyles('sm')}

		${mediaTablet(generateSlicedStyles('md'))}

		${mediaDesktop(generateSlicedStyles('lg'))}
	`;
}

class Container extends s$7 {
    render() {
        return x `<slot name="row"></slot>`;
    }
}
Container.CSSPropertiesPrefix = 'container';
Container.styles = [containerStyles()];
window.customElements.define('m-container', Container);

class Row extends s$7 {
    static get properties() {
        return {
            ...super.properties,
            gap: { type: String },
            columnGap: { type: String, attribute: 'column-gap' },
            rowGap: { type: String, attribute: 'row-gap' },
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'row');
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('gap')) {
            const gap = toSpacingCSSValue_1(this.gap, defaultRowProps.gap);
            this.style.setProperty('--m-row-gap', gap);
            this.style.setProperty('--m-column-gap', gap);
        }
        if (changedProperties.has('rowGap')) {
            if (this.rowGap) {
                this.style.setProperty('--m-row-gap', toSpacingCSSValue_1(this.rowGap));
            }
            else {
                this.style.removeProperty('--m-row-gap');
            }
        }
        if (changedProperties.has('columnGap')) {
            if (this.columnGap) {
                this.style.setProperty('--m-column-gap', toSpacingCSSValue_1(this.columnGap));
            }
            else {
                this.style.removeProperty('--m-column-gap');
            }
        }
    }
    render() {
        return x `<slot name="column"></slot>`;
    }
}
Row.CSSPropertiesPrefix = 'row';
Row.styles = [rowStyles()];
window.customElements.define('m-row', Row);

class Column extends s$7 {
    static get properties() {
        return {
            ...super.properties,
            sm: { type: String, reflect: true },
            md: { type: String, reflect: true },
            lg: { type: String, reflect: true },
            offsetSm: {
                type: String,
                reflect: true,
                attribute: 'offset-sm',
            },
            offsetMd: { type: String, reflect: true, attribute: 'offset-md' },
            offsetLg: {
                type: String,
                reflect: true,
                attribute: 'offset-lg',
            },
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.slot = 'column';
    }
    update(changedProperties) {
        /**
         * before the update happens, we ensure that the column size set for the `sm` and `md` breakpoint are
         * replicated to the `md` and `lg` breakpoints, respectively, in case there is no value
         * set for them.
         * the same applies for the offset values.
         */
        if (changedProperties.has('sm')) {
            this.md = this.md ?? this.sm;
            this.lg = this.lg ?? this.md;
        }
        if (changedProperties.has('md')) {
            this.lg = this.lg ?? this.md;
        }
        this.offsetSm = this.offsetSm ?? undefined;
        if (changedProperties.has('offsetSm')) {
            this.offsetMd = this.offsetMd ?? this.offsetSm;
            this.offsetLg = this.offsetLg ?? this.offsetMd;
        }
        if (changedProperties.has('offsetMd')) {
            this.offsetLg = this.offsetLg ?? this.offsetMd;
        }
        super.update(changedProperties);
    }
    render() {
        return x `<slot></slot>`;
    }
}
Column.CSSPropertiesPrefix = 'column';
Column.styles = [columnStyles()];
window.customElements.define('m-column', Column);

var _Card_instances, _Card_toggle;
const defaultFlagColor = 'color-background-inverted';
class Card extends Component {
    static get properties() {
        return {
            flagged: { type: Boolean },
            flagColor: { type: String, attribute: 'flag-color' },
            collapsible: { type: Boolean },
            collapsed: { type: Boolean, reflect: true },
            initialCollapsed: { type: Boolean, attribute: 'initial-collapsed' },
        };
    }
    constructor() {
        super();
        _Card_instances.add(this);
        this.flagged = false;
        this.flagColor = defaultFlagColor;
        this.collapsible = false;
        this.collapsed = false;
        this.initialCollapsed = false;
    }
    /**
     * Keeping the method name to avoid breaking changes.
     * #toggle was added to keep the pattern used in all
     * the other components, with the same behavior.
     */
    toggleCollapse() {
        __classPrivateFieldGet$1(this, _Card_instances, "m", _Card_toggle).call(this);
    }
    isExpanded() {
        if (!this.collapsible) {
            return undefined;
        }
        return this.collapsed ? 'false' : 'true';
    }
    firstUpdated() {
        this.collapsed = Boolean(this.initialCollapsed);
        const title = this.querySelector('m-card-title');
        const subTitle = this.querySelector('m-card-subtitle');
        const wrapperElement = this.renderRoot.querySelector('.m-title-wrapper');
        if (wrapperElement) {
            if (title || subTitle) {
                wrapperElement.classList.remove('hidden');
            }
            else {
                wrapperElement.classList.add('hidden');
            }
        }
    }
    render() {
        return x `
			<div
				class="m-card"
				style="${o$1({
            '--m-card-flag-color': toCSSValue_1$1(this.flagColor),
        })}"
			>
				${this.flagged ? x `<span class="m-card-flag"></span>` : A$1}
				<div class="m-card-content">
					<m-group justify="space-between" class="m-title-wrapper">
						<m-stack gap="none">
							<slot name="title"></slot>
							<slot name="subtitle"></slot>
						</m-stack>
						${this.collapsible
            ? x `<button
									title="toggle card collapse"
									id="collapse-trigger"
									class="m-collapse-trigger"
									@click="${__classPrivateFieldGet$1(this, _Card_instances, "m", _Card_toggle)}"
									aria-expanded="${l(this.isExpanded())}"
									type="button"
							  >
									<m-icon
										aria-label="toggle card collapse"
										name="caret-down"
									></m-icon>
							  </button>`
            : A$1}
					</m-group>
					${this.collapsed ? A$1 : x `<slot name="divider"></slot>`}
					<m-stack
						class="${o$2({
            'm-collapsed-content': !!this.collapsed,
            'm-card-content': !this.collapsed,
        })}"
						gap="none"
					>
						<slot name="body"></slot>
						<slot name="footer"></slot>
					</m-stack>
				</div>
			</div>
		`;
    }
}
_Card_instances = new WeakSet(), _Card_toggle = function _Card_toggle() {
    if (!this.collapsible) {
        return;
    }
    this.collapsed = !this.collapsed;
    this.emit('m-toggle', {
        detail: { name: 'card', value: this.collapsed },
    });
};
Card.styles = [cardStyles()];
window.customElements.define('m-card', Card);

class CardBody extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'body';
    }
    render() {
        return x `
			<div class="m-card-body">
				<slot></slot>
			</div>
		`;
    }
}
CardBody.styles = [cardBodyStyles()];
window.customElements.define('m-card-body', CardBody);

class CardSubtitle extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'subtitle';
    }
    render() {
        return x `
			<div class="m-card-subtitle">
				<slot></slot>
			</div>
		`;
    }
}
CardSubtitle.styles = [cardSubtitleStyles()];
window.customElements.define('m-card-subtitle', CardSubtitle);

class CardTitle extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'title';
    }
    render() {
        return x `
			<div class="m-card-title">
				<slot name="leading"></slot>
				<slot></slot>
			</div>
		`;
    }
}
CardTitle.styles = [cardTitleStyles()];
window.customElements.define('m-card-title', CardTitle);

function styles$v() {
    return i$5 `
		.m-divider {
			border: 0;
			border-block-end: solid 1px ${getColor('color-divider')};
			margin-block-start: var(
				--m-divider-margin-top,
				var(--m-divider-margin-y, 0)
			);
			margin-block-end: var(
				--m-divider-margin-bottom,
				var(--m-divider-margin-y, 0)
			);
		}
	`;
}

class Divider extends s$7 {
    render() {
        return x `<hr class="m-divider" />`;
    }
}
Divider.styles = [styles$v()];
window.customElements.define('m-divider', Divider);

class CardDivider extends Divider {
    constructor() {
        super();
        this.slot = 'divider';
    }
}
CardDivider.styles = [...Divider.styles, cardDividerStyles()];
CardDivider.properties = {
    slot: { attribute: true, type: String, reflect: true },
};
window.customElements.define('m-card-divider', CardDivider);

class CardFooter extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
            gap: { type: String },
            align: { type: String },
            justify: { type: String },
        };
    }
    constructor() {
        super();
        this.slot = 'footer';
        this.gap = 'spacing-2';
        this.align = 'stretch';
        this.justify = 'flex-start';
    }
    render() {
        return x `<div class="m-card-footer">
			<m-card-divider></m-card-divider>
			<m-group
				gap=${this.gap}
				align=${this.align}
				justify=${this.justify}
				padding-x="spacing-6"
				padding-y="spacing-6"
			>
				<slot></slot>
			</m-group>
		</div>`;
    }
}
window.customElements.define('m-card-footer', CardFooter);

class CardActionPrimary extends Button {
    constructor() {
        super();
        this.type = 'button';
        this.variant = 'primary';
    }
}
window.customElements.define('m-card-action-primary', CardActionPrimary);

class CardActionSecondary extends Button {
    constructor() {
        super();
        this.type = 'button';
        this.variant = 'secondary';
    }
}
window.customElements.define('m-card-action-secondary', CardActionSecondary);

class CardActionTertiary extends Button {
    constructor() {
        super();
        this.type = 'button';
        this.variant = 'tertiary';
    }
}
window.customElements.define('m-card-action-tertiary', CardActionTertiary);

const baseTransitionConfig = {
    delay: '0s',
    duration: '0.35s',
    easing: 'ease-in-out',
};
function styles$u() {
    return i$5 `
		${on('.check-input-label').not.disabled.focus} {
			border-radius: 2px;
			outline: 1px solid ${getColor('color-primary-60')};
		}

		.check-input-label {
			${typography('body-md')};

			gap: ${getToken$1('spacing-1')};
			align-items: center;
			display: inline-flex;
			padding: 4px 2px;
			position: relative;
		}

		.check-input-label,
		.check-input {
			cursor: pointer;
		}

		.check-input {
			--checkbox-input-size: ${getToken$1('font-size-4')};

			color: ${getColor('color-text-tertiary')};
			width: var(--checkbox-input-size);
			height: var(--checkbox-input-size);
			background: ${getColor('color-background-primary')};
			appearance: none;
			outline: none;
			border-style: solid;
			border-radius: ${getToken$1('border-radius-s')};
			border-color: ${getColor('color-border-input')};
			border-width: ${getToken$1('border-thin')};
			margin: 0;
			flex-grow: 0;
			flex-shrink: 0;
			flex-basis: var(--checkbox-input-size);
			${transition([
        {
            property: 'border',
            ...baseTransitionConfig,
        },
        {
            property: 'background',
            ...baseTransitionConfig,
        },
    ])};
		}

		.check-input:indeterminate,
		.check-input:checked {
			background: ${getColor('color-primary-60')};
			border-color: ${getColor('color-primary-60')};
		}

		${on('.check-input').disabled} {
			background: ${getColor('color-background-tertiary')};
			cursor: not-allowed;
		}

		${on('.check-input:indeterminate').disabled},
		${on('.check-input:checked').disabled} {
			background: ${getColor('color-primary-20')};
			border-color: ${getColor('color-primary-20')};
		}

		${on('.check-input:indeterminate').not.disabled.hover},
		${on('.check-input:checked').not.disabled.hover} {
			background: ${getColor('color-primary-100')};
			border-color: ${getColor('color-primary-100')};
		}

		${on('.check-input').not.disabled.hover} {
			border-color: ${getColor('color-primary-100')};
		}

		:host([disabled]) .check-input-label {
			cursor: not-allowed;
			color: ${getColor('color-text-disabled')};
		}

		.check-icon,
		.indeterminate-icon {
			--m-icon-size: 1em;
			--m-icon-color: ${getColor('color-text-inverted')};

			position: absolute;

			pointer-events: none;
			border-width: ${getToken$1('border-thin')};
			border-style: solid;
			border-color: transparent;
			border-radius: ${getToken$1('border-radius-s')};
			display: none;
		}

		.check-input:checked:not(:indeterminate) ~ .check-icon,
		.check-input:indeterminate:not(:checked) ~ .indeterminate-icon {
			display: inline-flex;
		}
	`;
}

const CHANGE_EVENT = 'm-change';

var _Checkbox_instances, _Checkbox_setAttributes, _Checkbox_handleChange;
class Checkbox extends s$7 {
    static get properties() {
        return {
            name: { type: String, reflect: true },
            disabled: { type: Boolean, reflect: true },
            checked: { type: Boolean, reflect: true },
            indeterminate: { type: Boolean, reflect: true },
        };
    }
    constructor() {
        super();
        _Checkbox_instances.add(this);
        _Checkbox_handleChange.set(this, (event) => {
            const checkboxInput = event.target;
            const customEvent = new CustomEvent(CHANGE_EVENT, {
                cancelable: false,
                composed: false,
                bubbles: true,
                detail: {
                    checked: checkboxInput.checked,
                    indeterminate: checkboxInput.indeterminate,
                },
            });
            this.dispatchEvent(customEvent);
            this.checked = checkboxInput.checked;
            this.indeterminate = checkboxInput.indeterminate;
        });
        this.name = undefined;
        this.disabled = false;
        this.checked = false;
        this.indeterminate = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'checkbox');
    }
    disconnectedCallback() {
        super.connectedCallback();
    }
    firstUpdated() {
        this.input = this.renderRoot.querySelector('input');
        this.label = this.renderRoot.querySelector('label');
    }
    updated() {
        __classPrivateFieldGet$1(this, _Checkbox_instances, "m", _Checkbox_setAttributes).call(this);
    }
    render() {
        return x `
			<label for="${l(this.id)}" class="check-input-label">
				<input
					id="${l(this.id)}"
					name="${l(this.name)}"
					type="checkbox"
					class="check-input"
					?disabled="${this.disabled}"
					?checked="${this.checked}"
					@change=${__classPrivateFieldGet$1(this, _Checkbox_handleChange, "f")}
				/>
				<m-icon name="check" class="check-icon"></m-icon>
				<m-icon name="indeterminate" class="indeterminate-icon"></m-icon>
				<slot name="leading"></slot>
				<slot></slot>
			</label>
		`;
    }
    focus(options) {
        this.input?.focus(options);
    }
}
_Checkbox_handleChange = new WeakMap(), _Checkbox_instances = new WeakSet(), _Checkbox_setAttributes = function _Checkbox_setAttributes() {
    this.setAttribute('aria-disabled', String(this.disabled ?? false));
    this.setAttribute('aria-checked', this.indeterminate ? 'mixed' : String(this.checked ?? false));
    this.input.indeterminate = this.indeterminate;
    this.input.checked = this.checked;
};
Checkbox.styles = [styles$u()];
window.customElements.define('m-checkbox', Checkbox);

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let s$2 = class s extends Event{constructor(s,t,e){super("context-request",{bubbles:!0,composed:!0}),this.context=s,this.callback=t,this.subscribe=e??!1;}};

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function n$1(n){return n}

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */let s$1 = class s{constructor(t,s,i,h){if(this.subscribe=!1,this.provided=!1,this.value=void 0,this.t=(t,s)=>{this.unsubscribe&&(this.unsubscribe!==s&&(this.provided=!1,this.unsubscribe()),this.subscribe||this.unsubscribe()),this.value=t,this.host.requestUpdate(),this.provided&&!this.subscribe||(this.provided=!0,this.callback&&this.callback(t,s)),this.unsubscribe=s;},this.host=t,void 0!==s.context){const t=s;this.context=t.context,this.callback=t.callback,this.subscribe=t.subscribe??!1;}else this.context=s,this.callback=i,this.subscribe=h??!1;this.host.addController(this);}hostConnected(){this.dispatchRequest();}hostDisconnected(){this.unsubscribe&&(this.unsubscribe(),this.unsubscribe=void 0);}dispatchRequest(){this.host.dispatchEvent(new s$2(this.context,this.t,this.subscribe));}};

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class s{get value(){return this.o}set value(s){this.setValue(s);}setValue(s,t=!1){const i=t||!Object.is(s,this.o);this.o=s,i&&this.updateObservers();}constructor(s){this.subscriptions=new Map,this.updateObservers=()=>{for(const[s,{disposer:t}]of this.subscriptions)s(this.o,t);},void 0!==s&&(this.value=s);}addCallback(s,t,i){if(!i)return void s(this.value);this.subscriptions.has(s)||this.subscriptions.set(s,{disposer:()=>{this.subscriptions.delete(s);},consumerHost:t});const{disposer:h}=this.subscriptions.get(s);s(this.value,h);}clearCallbacks(){this.subscriptions.clear();}}

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */let e$1 = class e extends Event{constructor(t){super("context-provider",{bubbles:!0,composed:!0}),this.context=t;}};class i extends s{constructor(s,e,i){super(void 0!==e.context?e.initialValue:i),this.onContextRequest=t=>{const s=t.composedPath()[0];t.context===this.context&&s!==this.host&&(t.stopPropagation(),this.addCallback(t.callback,s,t.subscribe));},this.onProviderRequest=s=>{const e=s.composedPath()[0];if(s.context!==this.context||e===this.host)return;const i=new Set;for(const[s,{consumerHost:e}]of this.subscriptions)i.has(s)||(i.add(s),e.dispatchEvent(new s$2(this.context,s,!0)));s.stopPropagation();},this.host=s,void 0!==e.context?this.context=e.context:this.context=e,this.attachListeners(),this.host.addController?.(this);}attachListeners(){this.host.addEventListener("context-request",this.onContextRequest),this.host.addEventListener("context-provider",this.onProviderRequest);}hostConnected(){this.host.dispatchEvent(new e$1(this.context));}}

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */let t$1 = class t{constructor(){this.pendingContextRequests=new Map,this.onContextProvider=t=>{const s=this.pendingContextRequests.get(t.context);if(void 0===s)return;this.pendingContextRequests.delete(t.context);const{requests:o}=s;for(const{elementRef:s,callbackRef:n}of o){const o=s.deref(),c=n.deref();void 0===o||void 0===c||o.dispatchEvent(new s$2(t.context,c,!0));}},this.onContextRequest=e=>{if(!0!==e.subscribe)return;const t=e.composedPath()[0],s=e.callback;let o=this.pendingContextRequests.get(e.context);void 0===o&&this.pendingContextRequests.set(e.context,o={callbacks:new WeakMap,requests:[]});let n=o.callbacks.get(t);void 0===n&&o.callbacks.set(t,n=new WeakSet),n.has(s)||(n.add(s),o.requests.push({elementRef:new WeakRef(t),callbackRef:new WeakRef(s)}));};}attach(e){e.addEventListener("context-request",this.onContextRequest),e.addEventListener("context-provider",this.onContextProvider);}detach(e){e.removeEventListener("context-request",this.onContextRequest),e.removeEventListener("context-provider",this.onContextProvider);}};

/**
 * Function that returns a `Promise` that will resolve when all the scheduled
 * animations for the provided target are either finished or canceled.
 *
 * Optionally, you can pass an option to include the animations for the elements
 * that are part of the subtree of the provided target.
 */
async function waitForAnimations(animatable, options) {
    const animations = animatable.getAnimations(options);
    const promises = animations.map(({ finished }) => finished);
    await Promise.allSettled(promises);
}

let isAttached = false;
/**
 * This function cover the late upgrade for context providers.
 * Check https://github.com/lit/lit/tree/main/packages/labs/context#late-upgraded-context-providers
 * for more details.
 */
function attachContextRoot() {
    if (isAttached) {
        return;
    }
    const root = new t$1();
    root.attach(document.body);
    isAttached = true;
}

const dialogContext = n$1(Symbol('dialog'));

function styles$t() {
    return i$5 `
		:host {
			--margin: ${getToken$1('spacing-6')};
			--padding: ${getToken$1('spacing-6')};
			--gap: ${getToken$1('spacing-6')};
		}

		slot::slotted(*) {
			padding-inline: var(--padding);
			padding-block: calc(var(--gap) / 2);
		}

		dialog {
			box-sizing: border-box;
			padding: calc(var(--padding) - (var(--gap) / 2)) 0;
			border: none;
			border-radius: ${getToken$1('border-radius-m')};
			background-color: ${getColor('color-background-primary')};
			box-shadow: ${getToken$1('elevation-4')};
			width: auto;
			max-height: calc(100% - var(--margin));

			${transition([{ property: 'max-width' }])};
		}

		dialog[open] {
			display: flex;
			flex-direction: column;
		}

		dialog.-size-small {
			max-width: min(${toRem('400px')}, calc(100vw - var(--margin)));
		}

		dialog.-size-medium {
			max-width: min(${toRem('600px')}, calc(100% - var(--margin)));
		}

		dialog.-size-large {
			max-width: min(${toRem('800px')}, calc(100% - var(--margin)));
		}

		dialog.-size-extra-large {
			max-width: min(${toRem('1000px')}, calc(100% - var(--margin)));
		}

		dialog::backdrop {
			background-color: ${getColor('color-background-secondary-inverted', 0.4)};
		}

		@media (prefers-reduced-motion: no-preference) {
			dialog[open] {
				animation: show-dialog 0.25s ease forwards;
			}

			dialog.is-hiding {
				animation: hide-dialog 0.25s ease forwards;
			}

			dialog[open]::backdrop {
				animation: show-backdrop 0.25s ease forwards;
			}

			dialog.is-hiding::backdrop {
				animation: hide-backdrop 0.25s ease forwards;
			}
		}

		@keyframes show-dialog {
			from {
				opacity: 0;
				transform: translateY(250px);
			}
		}

		@keyframes hide-dialog {
			to {
				opacity: 0;
				transform: scale(0.75);
			}
		}

		@keyframes show-backdrop {
			from {
				opacity: 0;
			}
		}

		@keyframes hide-backdrop {
			to {
				opacity: 0;
			}
		}
	`;
}

var _Dialog_instances, _Dialog_contextProvider, _Dialog_dialog_get, _Dialog_toggleVisibility, _Dialog_emitLifecycleEvent, _Dialog_emitCloseEvent, _Dialog_handleClick, _Dialog_handleCancel;
attachContextRoot();
class Dialog extends Component {
    static get properties() {
        return {
            open: { type: Boolean, reflect: true },
            size: { type: String, reflect: true },
            variant: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        _Dialog_instances.add(this);
        _Dialog_contextProvider.set(this, new i(this, dialogContext, {
            variant: 'neutral',
        }));
        this.open = false;
        this.size = 'small';
        this.variant = 'neutral';
    }
    render() {
        return x `
			<dialog
				class="${o$2({
            '-size-small': this.size === 'small' || !this.size,
            '-size-medium': this.size === 'medium',
            '-size-large': this.size === 'large',
            '-size-extra-large': this.size === 'extra-large',
        })}"
				@click=${__classPrivateFieldGet$1(this, _Dialog_instances, "m", _Dialog_handleClick)}
				@cancel=${__classPrivateFieldGet$1(this, _Dialog_instances, "m", _Dialog_handleCancel)}
			>
				<slot name="header"></slot>
				<slot name="body"></slot>
				<slot name="footer"></slot>
				<slot name="actions"></slot>
			</dialog>
		`;
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('variant')) {
            __classPrivateFieldGet$1(this, _Dialog_contextProvider, "f").setValue({
                variant: this.variant ?? 'neutral',
            });
        }
        if (changedProperties.has('open')) {
            __classPrivateFieldGet$1(this, _Dialog_instances, "m", _Dialog_toggleVisibility).call(this, changedProperties.get('open'));
        }
    }
    /**
     * Make the dialog visible
     */
    show() {
        this.open = true;
    }
    /**
     * Hide the dialog
     */
    hide() {
        this.open = false;
    }
}
_Dialog_contextProvider = new WeakMap(), _Dialog_instances = new WeakSet(), _Dialog_dialog_get = function _Dialog_dialog_get() {
    return this.renderRoot?.querySelector('dialog');
}, _Dialog_toggleVisibility = async function _Dialog_toggleVisibility(wasOpen) {
    const dialog = __classPrivateFieldGet$1(this, _Dialog_instances, "a", _Dialog_dialog_get);
    if (dialog) {
        if (!wasOpen && this.open) {
            this.style.display = 'block';
            __classPrivateFieldGet$1(this, _Dialog_instances, "m", _Dialog_emitLifecycleEvent).call(this, 'm-opening');
            dialog.showModal();
            await waitForAnimations(dialog);
            __classPrivateFieldGet$1(this, _Dialog_instances, "m", _Dialog_emitLifecycleEvent).call(this, 'm-opened');
        }
        else if (wasOpen && !this.open) {
            __classPrivateFieldGet$1(this, _Dialog_instances, "m", _Dialog_emitLifecycleEvent).call(this, 'm-closing');
            dialog.classList.add('is-hiding');
            await waitForAnimations(dialog);
            dialog.classList.remove('is-hiding');
            dialog.close();
            __classPrivateFieldGet$1(this, _Dialog_instances, "m", _Dialog_emitLifecycleEvent).call(this, 'm-closed');
            this.style.display = 'none';
        }
        else if (wasOpen == null && !this.open) {
            this.style.display = 'none';
        }
    }
}, _Dialog_emitLifecycleEvent = function _Dialog_emitLifecycleEvent(type) {
    this.emit(type, {
        cancelable: false,
        bubbles: false,
    });
}, _Dialog_emitCloseEvent = function _Dialog_emitCloseEvent() {
    if (this.open) {
        this.emit('m-close');
    }
}, _Dialog_handleClick = function _Dialog_handleClick(event) {
    const isClickingOnTheDialog = event.target instanceof HTMLDialogElement;
    const rect = __classPrivateFieldGet$1(this, _Dialog_instances, "a", _Dialog_dialog_get)?.getBoundingClientRect();
    if (isClickingOnTheDialog && rect) {
        const isClickingOnTheBackdrop = event.clientY < rect.top ||
            event.clientY > rect.bottom ||
            event.clientX < rect.left ||
            event.clientX > rect.right;
        if (isClickingOnTheBackdrop) {
            event.preventDefault();
            event.stopPropagation();
            __classPrivateFieldGet$1(this, _Dialog_instances, "m", _Dialog_emitCloseEvent).call(this);
        }
    }
}, _Dialog_handleCancel = function _Dialog_handleCancel(event) {
    event.preventDefault();
    __classPrivateFieldGet$1(this, _Dialog_instances, "m", _Dialog_emitCloseEvent).call(this);
};
Dialog.styles = [styles$t()];
window.customElements.define('m-dialog', Dialog);

const DIALOG_SIZES = [
    'small',
    'medium',
    'large',
    'extra-large',
];
const DIALOG_VARIANTS = [
    'neutral',
    'success',
    'warning',
    'danger',
];

var _DialogActionPrimary_contextCallback;
class DialogActionPrimary extends Button {
    constructor() {
        super();
        _DialogActionPrimary_contextCallback.set(this, (value) => {
            switch (value.variant) {
                case 'danger':
                    this.variant = 'danger';
                    break;
                case 'warning':
                    this.variant = 'warning';
                    break;
                case 'neutral':
                case 'success':
                default:
                    this.variant = 'primary';
            }
        });
        this.type = 'button';
        this.variant = 'primary';
        this.context = new s$1(this, {
            context: dialogContext,
            callback: __classPrivateFieldGet$1(this, _DialogActionPrimary_contextCallback, "f"),
            subscribe: true,
        });
    }
}
_DialogActionPrimary_contextCallback = new WeakMap();
window.customElements.define('m-dialog-action-primary', DialogActionPrimary);

class DialogActionSecondary extends Button {
    constructor() {
        super();
        this.type = 'button';
        this.variant = 'secondary';
    }
}
window.customElements.define('m-dialog-action-secondary', DialogActionSecondary);

class DialogActionTertiary extends Button {
    constructor() {
        super();
        this.type = 'button';
        this.variant = 'tertiary';
    }
}
window.customElements.define('m-dialog-action-tertiary', DialogActionTertiary);

class DialogActions extends Group {
    constructor() {
        super();
        this.align = 'center';
        this.gap = 'spacing-3';
        this.justify = 'flex-end';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'actions');
    }
}
window.customElements.define('m-dialog-actions', DialogActions);

function styles$s() {
    return i$5 `
		:host {
			overflow-y: auto;
			overscroll-behavior: contain;

			${typography('body-md')};
		}
	`;
}

class DialogBody extends s$7 {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'body');
    }
    render() {
        return x `<slot></slot>`;
    }
}
DialogBody.styles = [styles$s()];
window.customElements.define('m-dialog-body', DialogBody);

class DialogClose extends CloseButton {
    constructor() {
        super();
        this.size = 'large';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'close');
    }
}
window.customElements.define('m-dialog-close', DialogClose);

class DialogFooter extends s$7 {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'footer');
    }
    render() {
        return x `<slot></slot>`;
    }
}
window.customElements.define('m-dialog-footer', DialogFooter);

function styles$r() {
    return i$5 `
		h1 {
			margin: 0;
			padding: 0;

			${typography('heading-md-bold')};
		}
	`;
}

var _DialogHeader_instances, _DialogHeader_context, _DialogHeader_icon_get;
class DialogHeader extends Component {
    constructor() {
        super();
        _DialogHeader_instances.add(this);
        _DialogHeader_context.set(this, void 0);
        __classPrivateFieldSet(this, _DialogHeader_context, new s$1(this, {
            context: dialogContext,
            subscribe: true,
        }), "f");
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'header');
    }
    render() {
        return x `
			<m-group gap="spacing-6" align="center">
				<m-group gap="spacing-1" align="center" style="flex-grow: 1;">
					${__classPrivateFieldGet$1(this, _DialogHeader_instances, "a", _DialogHeader_icon_get)}
					<h1><slot></slot></h1>
				</m-group>
				<slot name="close"></slot>
			</m-group>
		`;
    }
}
_DialogHeader_context = new WeakMap(), _DialogHeader_instances = new WeakSet(), _DialogHeader_icon_get = function _DialogHeader_icon_get() {
    const { value } = __classPrivateFieldGet$1(this, _DialogHeader_context, "f");
    let name;
    let color;
    switch (value?.variant) {
        case 'danger':
            name = 'attention';
            color = 'color-danger-60';
            break;
        case 'warning':
            name = 'info-circle';
            color = 'color-warning-60';
            break;
        case 'success':
            name = 'check';
            color = 'color-success-60';
            break;
        case 'neutral':
        default:
            return A$1;
    }
    return x `
			<m-icon name=${name} color=${color} size="24" aria-hidden="true"></m-icon>
		`;
};
DialogHeader.styles = [styles$r()];
window.customElements.define('m-dialog-header', DialogHeader);

function styles$q() {
    return i$5 `
		:host {
			--padding: ${getToken$1('spacing-6')};
			--m-drawer-header-border: none;
			--m-drawer-actions-border: none;
			--m-drawer-body-padding-block: 0;
			--m-drawer-background-color: ${getColor('color-background-primary')};
		}

		:host([divided]) {
			--m-drawer-header-border: 1px solid ${getColor('color-divider')};
			--m-drawer-actions-border: 1px solid ${getColor('color-divider')};
			--m-drawer-body-padding-block: var(--padding);
			--m-drawer-background-color: ${getColor('color-background-secondary')};
		}

		:host([size='small']) dialog {
			max-width: ${toRem('416px')};
		}

		:host([size='medium']) dialog {
			max-width: 640px;
		}

		:host([size='large']) dialog {
			max-width: 760px;
		}

		dialog {
			box-sizing: border-box;
			padding: 0;
			border: none;
			background-color: var(--m-drawer-background-color);
			box-shadow: ${getToken$1('elevation-4')};
			width: 100%;
			height: 100%;
			max-height: 100%;
			position: fixed;
			top: 0;
			right: 0;
			left: auto;
			margin: 0;

			${transition([{ property: 'max-width' }])};
		}

		dialog[open] {
			display: flex;
			flex-direction: column;
		}

		dialog::backdrop {
			background-color: ${getColor('color-background-secondary-inverted', 0.4)};
		}

		@media (prefers-reduced-motion: no-preference) {
			dialog[open] {
				animation: show-dialog 0.25s ease forwards;
			}

			dialog.is-hiding {
				animation: hide-dialog 0.25s ease forwards;
			}

			dialog[open]::backdrop {
				animation: show-backdrop 0.25s ease forwards;
			}

			dialog.is-hiding::backdrop {
				animation: hide-backdrop 0.25s ease forwards;
			}
		}

		@keyframes show-dialog {
			from {
				opacity: 0;
				transform: translateX(250px);
			}
		}

		@keyframes hide-dialog {
			to {
				opacity: 0;
				transform: translateX(250px);
			}
		}

		@keyframes show-backdrop {
			from {
				opacity: 0;
			}
		}

		@keyframes hide-backdrop {
			to {
				opacity: 0;
			}
		}
	`;
}

var _Drawer_instances, _Drawer_dialog_get, _Drawer_toggleVisibility, _Drawer_emitLifecycleEvent, _Drawer_emitCloseEvent, _Drawer_handleClick, _Drawer_handleCancel;
attachContextRoot();
class Drawer extends Component {
    static get properties() {
        return {
            open: { type: Boolean, reflect: true },
            size: { type: String, reflect: true },
            divided: { type: Boolean, reflect: true },
        };
    }
    constructor() {
        super();
        _Drawer_instances.add(this);
        this.open = false;
        this.size = 'small';
        this.divided = false;
    }
    render() {
        return x `
			<dialog @click=${__classPrivateFieldGet$1(this, _Drawer_instances, "m", _Drawer_handleClick)} @cancel=${__classPrivateFieldGet$1(this, _Drawer_instances, "m", _Drawer_handleCancel)}>
				<slot name="header"></slot>
				<slot name="body"></slot>
				<slot name="actions"></slot>
			</dialog>
		`;
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('open')) {
            __classPrivateFieldGet$1(this, _Drawer_instances, "m", _Drawer_toggleVisibility).call(this, changedProperties.get('open'));
        }
    }
    /**
     * Make the drawer visible
     */
    show() {
        this.open = true;
    }
    /**
     * Hide the drawer
     */
    hide() {
        this.open = false;
    }
}
_Drawer_instances = new WeakSet(), _Drawer_dialog_get = function _Drawer_dialog_get() {
    return this.renderRoot?.querySelector('dialog');
}, _Drawer_toggleVisibility = async function _Drawer_toggleVisibility(wasOpen) {
    const dialog = __classPrivateFieldGet$1(this, _Drawer_instances, "a", _Drawer_dialog_get);
    if (dialog) {
        if (!wasOpen && this.open) {
            this.style.display = 'block';
            __classPrivateFieldGet$1(this, _Drawer_instances, "m", _Drawer_emitLifecycleEvent).call(this, 'm-opening');
            dialog.showModal();
            await waitForAnimations(dialog);
            __classPrivateFieldGet$1(this, _Drawer_instances, "m", _Drawer_emitLifecycleEvent).call(this, 'm-opened');
        }
        else if (wasOpen && !this.open) {
            __classPrivateFieldGet$1(this, _Drawer_instances, "m", _Drawer_emitLifecycleEvent).call(this, 'm-closing');
            dialog.classList.add('is-hiding');
            await waitForAnimations(dialog);
            dialog.classList.remove('is-hiding');
            dialog.close();
            __classPrivateFieldGet$1(this, _Drawer_instances, "m", _Drawer_emitLifecycleEvent).call(this, 'm-closed');
            this.style.display = 'none';
        }
        else if (wasOpen == null && !this.open) {
            this.style.display = 'none';
        }
    }
}, _Drawer_emitLifecycleEvent = function _Drawer_emitLifecycleEvent(type) {
    this.emit(type, {
        cancelable: false,
        bubbles: false,
    });
}, _Drawer_emitCloseEvent = function _Drawer_emitCloseEvent() {
    if (this.open) {
        this.emit('m-close');
    }
}, _Drawer_handleClick = function _Drawer_handleClick(event) {
    const isClickingOnTheDrawer = event.target instanceof HTMLDialogElement;
    const rect = __classPrivateFieldGet$1(this, _Drawer_instances, "a", _Drawer_dialog_get)?.getBoundingClientRect();
    if (isClickingOnTheDrawer && rect) {
        const isClickingOnTheBackdrop = event.clientY < rect.top ||
            event.clientY > rect.bottom ||
            event.clientX < rect.left ||
            event.clientX > rect.right;
        if (isClickingOnTheBackdrop) {
            event.preventDefault();
            event.stopPropagation();
            __classPrivateFieldGet$1(this, _Drawer_instances, "m", _Drawer_emitCloseEvent).call(this);
        }
    }
}, _Drawer_handleCancel = function _Drawer_handleCancel(event) {
    event.preventDefault();
    __classPrivateFieldGet$1(this, _Drawer_instances, "m", _Drawer_emitCloseEvent).call(this);
};
Drawer.styles = [styles$q()];
window.customElements.define('m-drawer', Drawer);

const DRAWER_SIZES = ['small', 'medium', 'large'];

class DrawerActionPrimary extends Button {
    constructor() {
        super();
        this.variant = 'primary';
    }
}
window.customElements.define('m-drawer-action-primary', DrawerActionPrimary);

class DrawerActionSecondary extends Button {
    constructor() {
        super();
        this.variant = 'secondary';
    }
}
window.customElements.define('m-drawer-action-secondary', DrawerActionSecondary);

class DrawerActionTertiary extends Button {
    constructor() {
        super();
        this.variant = 'tertiary';
    }
}
window.customElements.define('m-drawer-action-tertiary', DrawerActionTertiary);

function styles$p() {
    return i$5 `
		:host {
			margin-top: auto;
			padding-inline: var(--padding);
			padding-block: var(--padding);
			background-color: ${getColor('color-background-primary')};
			border-top: var(--m-drawer-actions-border);
		}
	`;
}

class DrawerActions extends Group {
    constructor() {
        super();
        this.align = 'center';
        this.gap = 'spacing-3';
        this.justify = 'flex-end';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'actions');
    }
}
DrawerActions.styles = [...Group.styles, styles$p()];
window.customElements.define('m-drawer-actions', DrawerActions);

function styles$o() {
    return i$5 `
		:host {
			overflow-y: auto;
			overscroll-behavior: contain;
			padding-inline: var(--padding);
			padding-block: var(--m-drawer-body-padding-block);

			${typography('body-md')};
		}
	`;
}

class DrawerBody extends s$7 {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'body');
    }
    render() {
        return x `<slot></slot>`;
    }
}
DrawerBody.styles = [styles$o()];
window.customElements.define('m-drawer-body', DrawerBody);

class DrawerClose extends CloseButton {
    constructor() {
        super();
        this.size = 'large';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'close');
    }
}
window.customElements.define('m-drawer-close', DrawerClose);

function styles$n() {
    return i$5 `
		:host {
			padding-inline: var(--padding);
			padding-block: var(--padding);
			background-color: ${getColor('color-background-primary')};
			border-bottom: var(--m-drawer-header-border);
		}

		h1 {
			margin: 0;
			padding: 0;

			${typography('heading-md-bold')};
		}
	`;
}

class DrawerHeader extends Component {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'header';
    }
    render() {
        return x `
			<m-group gap="spacing-6" align="center">
				<m-group gap="spacing-1" align="center" style="flex-grow: 1;">
					<slot name="leading"></slot>
					<h1><slot></slot></h1>
				</m-group>
				<slot name="close"></slot>
			</m-group>
		`;
    }
}
DrawerHeader.styles = [styles$n()];
window.customElements.define('m-drawer-header', DrawerHeader);

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides = ['top', 'right', 'bottom', 'left'];
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp$1(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp$1(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$map$so;
                const placement = (_overflowsData$map$so = overflowsData.map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp$1(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp$1(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};

function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle$1(element);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = currentWin.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = currentWin.frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

const topLayerSelectors = [':popover-open', ':modal'];
function isTopLayer(floating) {
  return topLayerSelectors.some(selector => {
    try {
      return floating.matches(selector);
    } catch (e) {
      return false;
    }
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const x = rect.left + scroll.scrollLeft - offsets.x;
  const y = rect.top + scroll.scrollTop - offsets.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const window = getWindow(element);
  if (!isHTMLElement(element) || isTopLayer(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      ...(await getDimensionsFn(data.floating))
    }
  };
};

function isRTL(element) {
  return getComputedStyle$1(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = shift$1;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = flip$1;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = hide$1;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = arrow$1;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

/* eslint-disable @typescript-eslint/ban-types */
function offsetParent(element) {
    return offsetParentPolyfill(element);
}
function flatTreeParent(element) {
    if (element.assignedSlot) {
        return element.assignedSlot;
    }
    if (element.parentNode instanceof ShadowRoot) {
        return element.parentNode.host;
    }
    return element.parentNode;
}
function offsetParentPolyfill(element) {
    // Do an initial walk to check for display:none ancestors.
    for (let ancestor = element; ancestor; ancestor = flatTreeParent(ancestor)) {
        if (!(ancestor instanceof Element)) {
            continue;
        }
        if (getComputedStyle(ancestor).display === 'none') {
            return null;
        }
    }
    for (let ancestor = flatTreeParent(element); ancestor; ancestor = flatTreeParent(ancestor)) {
        if (!(ancestor instanceof Element)) {
            continue;
        }
        const style = getComputedStyle(ancestor);
        // Display:contents nodes aren't in the layout tree so they should be skipped.
        if (style.display === 'contents') {
            continue;
        }
        if (style.position !== 'static' || style.filter !== 'none') {
            return ancestor;
        }
        if (ancestor.tagName === 'BODY') {
            return ancestor;
        }
    }
    return null;
}

function supportsPopover() {
    // this is the recommended way to check for support https://developer.mozilla.org/en-US/docs/Web/API/Popover_API/Using#showing_popovers_via_javascript
    return Object.hasOwn(HTMLElement.prototype, 'popover');
}
/**
 * Checks if the given element is a popover (i.e. uses the Popover).
 */
function isPopover(element) {
    if (!element) {
        return false;
    }
    return supportsPopover() && element.matches('[popover]');
}
/**
 * Get manually calculated offset because floating-ui's offset middleware fails
 * to calculate the correct offset when the reference is small.
 */
function getPositionOffset(arrow, direction, offset) {
    const size = 'var(--m-popover-arrow-size)';
    switch (direction) {
        case 'top':
        case 'left':
            return arrow ? `-1 * ${size} - ${offset}px` : `-1 * ${offset}px`;
        case 'bottom':
        case 'right':
            return arrow ? `${size} + ${offset}px` : `${offset}px`;
        default:
            return '0px';
    }
}

var _Popover_updateCleanup, _Popover_getArrowPosition;
const POPOVER_PLACEMENT_VALUES = [
    'top',
    'left',
    'right',
    'bottom',
    'top-start',
    'top-end',
    'bottom-start',
    'bottom-end',
];
class Popover extends Component {
    static get properties() {
        return {
            position: { type: String, reflect: true },
            placement: { type: String },
            open: { type: Boolean, reflect: true },
            asPopover: { type: Boolean, attribute: 'as-popover' },
        };
    }
    constructor() {
        super();
        _Popover_updateCleanup.set(this, void 0);
        // eslint-disable-next-line class-methods-use-this
        this.getFloatingOffset = () => {
            return 10;
        };
        // eslint-disable-next-line class-methods-use-this
        this.renderArrow = () => {
            return x `<span id="arrow"></span>`;
        };
        this.reposition = async (reason) => {
            if (this.floating == null || this.reference == null) {
                console.warn('[popover]', 'both floating and reference elements should be available', { reference: this.reference, floating: this.floating });
                return;
            }
            const { x, y, placement, middlewareData } = await computePosition(this.reference, this.floating, {
                strategy: this.position ?? 'fixed',
                placement: this.placement ?? 'bottom-start',
                // source: https://floating-ui.com/docs/platform#shadow-dom-fix
                platform: {
                    ...platform,
                    getOffsetParent: (element) => {
                        return platform.getOffsetParent(element, offsetParent);
                    },
                },
                middleware: [
                    // to prevent the floating element from overflowing on the main axis of its placement
                    flip(),
                    // preventing overflow while maintaining the desired placement as best as possible.
                    shift(),
                    /**
                     * positioning data for an arrow element (triangle or caret) inside the floating element.
                     * the padding here is to account for the floating element's border-radius.
                     */
                    this.arrow ? arrow({ element: this.arrow, padding: 10 }) : undefined,
                    // to hide the floating element in applicable situations.
                    hide(),
                ],
            });
            if (middlewareData.hide?.referenceHidden) {
                // we skip repositioning if the reference element is hidden
                Object.assign(this.floating.style, {
                    visibility: 'hidden',
                });
                return;
            }
            const [side] = placement.split('-');
            const hasArrow = this.arrow != null;
            const mainSideIncrement = {
                top: {
                    x: '0px',
                    y: getPositionOffset(hasArrow, 'top', this.getFloatingOffset()),
                },
                bottom: {
                    x: '0px',
                    y: getPositionOffset(hasArrow, 'bottom', this.getFloatingOffset()),
                },
                right: {
                    x: getPositionOffset(hasArrow, 'right', this.getFloatingOffset()),
                    y: '0px',
                },
                left: {
                    x: getPositionOffset(hasArrow, 'left', this.getFloatingOffset()),
                    y: '0px',
                },
            };
            Object.assign(this.floating.style, {
                visibility: 'visible',
                top: `calc(${y}px + ${mainSideIncrement[side].y})`,
                left: `calc(${x}px + ${mainSideIncrement[side].x})`,
            });
            if (this.arrow != null && middlewareData.arrow) {
                Object.assign(this.arrow.style, __classPrivateFieldGet$1(this, _Popover_getArrowPosition, "f").call(this, middlewareData.arrow, side));
            }
            this.emit('m-popover-reposition', { detail: { reason } });
        };
        // Reference: https://floating-ui.com/docs/arrow#visualization
        _Popover_getArrowPosition.set(this, (coords, side) => {
            if (this.floating == null ||
                this.reference == null ||
                this.arrow == null ||
                coords == null) {
                return {};
            }
            const staticSide = {
                top: 'bottom',
                right: 'left',
                bottom: 'top',
                left: 'right',
            }[side];
            const { x, y } = coords;
            const arrowLen = this.arrow.offsetWidth;
            return {
                left: x != null ? `${x}px` : '',
                top: y != null ? `${y}px` : '',
                // Ensure the static side gets unset when flipping to other placements' axes.
                right: '',
                bottom: '',
                [staticSide]: `${-arrowLen / 2}px`,
            };
        });
        this.position = 'fixed';
        this.placement = 'top-end';
        this.open = false;
        this.asPopover = false;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        __classPrivateFieldGet$1(this, _Popover_updateCleanup, "f")?.call(this);
    }
    firstUpdated() {
        if (this.asPopover && supportsPopover() && this.floating) {
            /**
             * setting this attribute to manual means the popover must always be explicitly hidden
             * Reference: https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/popover
             */
            this.floating.setAttribute('popover', 'manual');
        }
        if (this.open) {
            this.show();
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (this.open &&
            changedProperties.get('placement') != null &&
            this.placement != null) {
            this.reposition('placement');
        }
    }
    get reference() {
        return this.getReferenceElement();
    }
    get floating() {
        return this.getFloatingElement();
    }
    get arrow() {
        return this.getArrowElement();
    }
    show() {
        if (this.open) {
            return;
        }
        this.open = true;
        if (!this.reference || !this.floating) {
            return;
        }
        if (isPopover(this.floating)) {
            this.floating.showPopover();
        }
        __classPrivateFieldSet(this, _Popover_updateCleanup, autoUpdate(this.reference, this.floating, () => {
            this.reposition('auto');
        }), "f");
    }
    hide() {
        if (!this.open) {
            return;
        }
        this.open = false;
        if (this.floating != null && isPopover(this.floating)) {
            this.floating.hidePopover();
        }
        __classPrivateFieldGet$1(this, _Popover_updateCleanup, "f")?.call(this);
    }
    toggle() {
        if (this.open) {
            this.hide();
        }
        else {
            this.show();
        }
    }
}
_Popover_updateCleanup = new WeakMap(), _Popover_getArrowPosition = new WeakMap();

const DEFAULT_SELECTORS = {
    referenceSelector: "slot[name='reference']::slotted(*),",
    floatingSelector: "slot[name='floating']::slotted(*)",
};
function styles$m(selectors = DEFAULT_SELECTORS) {
    const { referenceSelector, floatingSelector } = {
        ...DEFAULT_SELECTORS,
        ...selectors,
    };
    return [
        i$5 `
			:host {
				--m-popover-background-color: ${getColor('color-background-secondary-inverted')};
				--m-popover-border-radius: ${getToken$1('border-radius-m')};
				--m-popover-border-width: 0;
				--m-popover-border-style: none;
				--m-popover-overflow-x: hidden;
				--m-popover-overflow-y: visible;
				--m-popover-border-color: transparent;
				--m-popover-color: ${getColor('color-text-inverted')};
				--m-popover-elevation: ${getToken$1('elevation-2')};
				--m-popover-width: initial;
				--m-popover-min-width: initial;
				--m-popover-max-width: initial;
				--m-popover-z-index: 10;
				--m-popover-floating-spacing-x: ${getToken$1('spacing-4')};
				--m-popover-floating-spacing-y: ${getToken$1('spacing-2')};

				--m-popover-arrow-size: 12px;
				--m-popover-arrow-offset: calc(-1 * (var(--m-popover-arrow-size) / 2));

				position: relative;
			}

			${r$7(referenceSelector)} {
				display: inline-flex;
			}

			${r$7(floatingSelector)} {
				${transition([{ property: 'box-shadow' }])};
				${typography('body-md')};

				padding-inline: var(--m-popover-floating-spacing-x);
				padding-block: var(--m-popover-floating-spacing-y);
				margin: 0;

				display: none;

				box-sizing: border-box;
				inline-size: var(--m-popover-width);
				min-inline-size: var(--m-popover-min-width);
				max-inline-size: var(--m-popover-max-width);

				overflow-x: var(--m-popover-overflow-x);
				overflow-y: var(--m-popover-overflow-y);

				border-width: var(--m-popover-border-width);
				border-style: var(--m-popover-border-style);
				border-color: var(--m-popover-border-color);
				border-radius: var(--m-popover-border-radius);

				background-color: var(--m-popover-background-color);
				color: var(--m-popover-color);

				box-shadow: var(--m-popover-elevation);
				z-index: var(--m-popover-z-index);
			}

			:host([position='absolute']) ${r$7(floatingSelector)} {
				position: absolute;
			}

			:host([position='fixed']) ${r$7(floatingSelector)} {
				position: fixed;
			}

			:host([open]) ${r$7(floatingSelector)}, :host([open]) #arrow {
				display: inline-block;
			}

			#arrow {
				display: none;
				position: absolute;
				inline-size: var(--m-popover-arrow-size);
				block-size: var(--m-popover-arrow-size);
				background-color: var(--m-popover-background-color);
				transform: rotate(45deg);

				pointer-events: none;
			}

			.-absolute {
				position: absolute;
			}

			.-fixed {
				position: fixed;
			}
		`,
    ];
}

var _BoundaryController_instances, _BoundaryController_subscribe, _BoundaryController_unsubscribe, _BoundaryController_handleEvent, _BoundaryController_handleBlurEvent;
class BoundaryController {
    constructor(host, active) {
        _BoundaryController_instances.add(this);
        this.activate = () => {
            if (this.active) {
                return;
            }
            __classPrivateFieldGet$1(this, _BoundaryController_instances, "m", _BoundaryController_subscribe).call(this);
            this.active = true;
        };
        this.deactivate = () => {
            if (!this.active) {
                return;
            }
            __classPrivateFieldGet$1(this, _BoundaryController_instances, "m", _BoundaryController_unsubscribe).call(this);
            this.active = false;
        };
        _BoundaryController_handleEvent.set(this, (event) => {
            const isInside = isInsideElement(event, this.host);
            if (!isInside ||
                (event instanceof KeyboardEvent && event.key === 'Escape')) {
                this.host.dispatchEvent(new CustomEvent('m-interact-out'));
            }
            else if (isInside) {
                this.host.dispatchEvent(new CustomEvent('m-interact-in'));
            }
        });
        _BoundaryController_handleBlurEvent.set(this, (event) => {
            const isInside = isInsideElement(event, this.host);
            if (!isInside) {
                this.host.dispatchEvent(new CustomEvent('m-interact-out'));
            }
        });
        this.host = host;
        this.active = Boolean(active ?? false);
        this.host.addController(this);
    }
    hostConnected() {
        if (this.active) {
            __classPrivateFieldGet$1(this, _BoundaryController_instances, "m", _BoundaryController_subscribe).call(this);
        }
        else {
            __classPrivateFieldGet$1(this, _BoundaryController_instances, "m", _BoundaryController_unsubscribe).call(this);
        }
    }
    hostDisconnected() {
        if (this.active) {
            __classPrivateFieldGet$1(this, _BoundaryController_instances, "m", _BoundaryController_unsubscribe).call(this);
        }
    }
}
_BoundaryController_handleEvent = new WeakMap(), _BoundaryController_handleBlurEvent = new WeakMap(), _BoundaryController_instances = new WeakSet(), _BoundaryController_subscribe = function _BoundaryController_subscribe() {
    document.addEventListener('mousedown', __classPrivateFieldGet$1(this, _BoundaryController_handleEvent, "f"));
    document.addEventListener('keyup', __classPrivateFieldGet$1(this, _BoundaryController_handleEvent, "f"));
    document.addEventListener('touchend', __classPrivateFieldGet$1(this, _BoundaryController_handleEvent, "f"));
    window.addEventListener('blur', __classPrivateFieldGet$1(this, _BoundaryController_handleBlurEvent, "f"), true);
}, _BoundaryController_unsubscribe = function _BoundaryController_unsubscribe() {
    document.removeEventListener('mousedown', __classPrivateFieldGet$1(this, _BoundaryController_handleEvent, "f"));
    document.removeEventListener('keyup', __classPrivateFieldGet$1(this, _BoundaryController_handleEvent, "f"));
    document.removeEventListener('touchend', __classPrivateFieldGet$1(this, _BoundaryController_handleEvent, "f"));
    window.removeEventListener('blur', __classPrivateFieldGet$1(this, _BoundaryController_handleBlurEvent, "f"), true);
};

var _FocusManagerController_instances, _FocusManagerController_focusElement, _FocusManagerController_focusIndex, _FocusManagerController_focusPosition, _FocusManagerController_getIndexOfQueried, _FocusManagerController_findQueriedById, _FocusManagerController_handleKeyPress, _FocusManagerController_clearBufferAfterDelay, _FocusManagerController_findMatchInRange;
function isDisabled(element) {
    return (element != null &&
        typeof element === 'object' &&
        'disabled' in element &&
        element.disabled === true);
}
/**
 * Check if `keyboardEventKey` is a character, and more specifically, anything
 * other than a space, tab, or newline.
 */
function isPrintableCharacter(keyboardEventKey) {
    const printableCharacterRegex = /\S/;
    return (keyboardEventKey.length === 1 &&
        printableCharacterRegex.test(keyboardEventKey));
}
/**
 * Manages **virtual/visual** focus, for a11y purposes.
 */
class FocusManagerController {
    constructor(host, options) {
        _FocusManagerController_instances.add(this);
        this.activeDescendant = null;
        _FocusManagerController_focusElement.set(this, (element) => {
            if (!element || isDisabled(element) || !element.id) {
                console.debug('could not focus element', element, !element?.id ? ' element has no id' : '');
                return;
            }
            this.clear();
            this.activeDescendant = element.id;
            this.getInteractiveElement(this.host).setAttribute('aria-activedescendant', element.id);
            element.classList.add('is-focused');
            element.scrollIntoView({
                block: 'nearest',
                inline: 'nearest',
                behavior: 'smooth',
            });
        });
        _FocusManagerController_focusIndex.set(this, (index) => {
            __classPrivateFieldGet$1(this, _FocusManagerController_focusElement, "f").call(this, this.queried.at(index));
        });
        _FocusManagerController_focusPosition.set(this, (position) => {
            const currentFocusedIndex = __classPrivateFieldGet$1(this, _FocusManagerController_instances, "m", _FocusManagerController_getIndexOfQueried).call(this, this.focused);
            switch (position) {
                case 'first':
                    __classPrivateFieldGet$1(this, _FocusManagerController_focusIndex, "f").call(this, 0);
                    break;
                case 'last':
                    __classPrivateFieldGet$1(this, _FocusManagerController_focusIndex, "f").call(this, this.queried.length - 1);
                    break;
                case 'previous': {
                    if (currentFocusedIndex === -1) {
                        console.debug('focus previous, could not get current focused.');
                        return;
                    }
                    // it's ok to have a negative index here. `Array.prototype.at()` will handle that correctly.
                    const previousItemIndex = (currentFocusedIndex - 1 + this.queried.length) % this.queried.length;
                    __classPrivateFieldGet$1(this, _FocusManagerController_focusIndex, "f").call(this, previousItemIndex);
                    break;
                }
                case 'next': {
                    if (currentFocusedIndex === -1) {
                        console.debug('focus next, could not get current focused.');
                        return;
                    }
                    const nextItemIndex = (currentFocusedIndex + 1) % this.queried.length;
                    __classPrivateFieldGet$1(this, _FocusManagerController_focusIndex, "f").call(this, nextItemIndex);
                    break;
                }
            }
        });
        /**
         * Moves focus to the next item with a label that starts with the typed character
         * if such item exists. Otherwise, focus does not move.
         */
        _FocusManagerController_handleKeyPress.set(this, (event) => {
            const { key } = event;
            if (!isPrintableCharacter(key)) {
                return;
            }
            const searchIndex = __classPrivateFieldGet$1(this, _FocusManagerController_instances, "m", _FocusManagerController_getIndexOfQueried).call(this, this.focused);
            this.quickSearchBuffer += key;
            __classPrivateFieldGet$1(this, _FocusManagerController_clearBufferAfterDelay, "f").call(this);
            // run search in elements after the currently virtually focused element (if any)
            let nextMatch = __classPrivateFieldGet$1(this, _FocusManagerController_findMatchInRange, "f").call(this, searchIndex + 1, this.queried.length);
            if (!nextMatch) {
                // run search in elements before the currently virtually focused element (if any)
                nextMatch = __classPrivateFieldGet$1(this, _FocusManagerController_findMatchInRange, "f").call(this, 0, searchIndex);
            }
            if (nextMatch != null) {
                this.focus(nextMatch);
            }
        });
        _FocusManagerController_clearBufferAfterDelay.set(this, () => {
            if (this.quickSearchBufferTimeout) {
                window.clearTimeout(this.quickSearchBufferTimeout);
                this.quickSearchBufferTimeout = null;
            }
            this.quickSearchBufferTimeout = window.setTimeout(() => {
                this.quickSearchBuffer = '';
                this.quickSearchBufferTimeout = null;
            }, 500);
        });
        _FocusManagerController_findMatchInRange.set(this, (startAt, endAt) => {
            for (let i = startAt; i < endAt; i++) {
                /**
                 * [!] Be aware that `innerText` can be expensive as it takes CSS styles into account (it triggers a reflow to
                 * ensure up-to-date computed styles).
                 * Source: https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent#differences_from_innertext
                 * // TODO: evaluate replacing `innerText` with `textContent`.
                 */
                const label = this.queried[i].innerText.toLowerCase();
                if (label && label.indexOf(this.quickSearchBuffer) === 0) {
                    return this.queried[i];
                }
            }
            return null;
        });
        this.query = toArray(options.query).join(',');
        this.focusOnType = Boolean(options.focusOnType ?? true);
        this.getInteractiveElement =
            options.getInteractiveElement ??
                (() => {
                    return host;
                });
        this.quickSearchBuffer = '';
        (this.host = host).addController(this);
    }
    hostConnected() {
        if (!this.focusOnType) {
            console.debug('focus on type is disabled. Controller will not listen to keyup events');
            return;
        }
        this.host.addEventListener('keyup', __classPrivateFieldGet$1(this, _FocusManagerController_handleKeyPress, "f"));
    }
    hostDisconnected() {
        this.host.removeEventListener('keyup', __classPrivateFieldGet$1(this, _FocusManagerController_handleKeyPress, "f"));
    }
    /**
     * Get the list of elements matching the given `options.query`.
     */
    get queried() {
        return Array.from(this.host.querySelectorAll(this.query));
    }
    /**
     * Get the currently focused element, based on `activeDescendant`.
     */
    get focused() {
        if (!this.activeDescendant) {
            return null;
        }
        return __classPrivateFieldGet$1(this, _FocusManagerController_instances, "m", _FocusManagerController_findQueriedById).call(this, this.activeDescendant);
    }
    /**
     * If none of the options are selected, the first option receives focus; otherwise, the
     * focus moves to the next option.
     * If we are at the end of the `queried` array, the focus moves to the first option.
     */
    focusNext() {
        this.focus('next');
    }
    /**
     * If none of the options are selected, the last option receives focus; otherwise, the
     * focus moves to the next option.
     * If we are at the start of the `queried` array, the focus moves to the last option.
     */
    focusPrevious() {
        this.focus('previous');
    }
    /**
     * Focus the first element in `queried`.
     */
    focusFirst() {
        this.focus(0);
    }
    /**
     * Focus the last element in `queried`.
     */
    focusLast() {
        this.focus(this.queried.length - 1);
    }
    /**
     * Focus the given element or the element at the given index or position, based on `queried`.
     */
    focus(where) {
        if (typeof where === 'number') {
            __classPrivateFieldGet$1(this, _FocusManagerController_focusIndex, "f").call(this, where);
        }
        else if (typeof where === 'string') {
            __classPrivateFieldGet$1(this, _FocusManagerController_focusPosition, "f").call(this, where);
        }
        else {
            __classPrivateFieldGet$1(this, _FocusManagerController_focusElement, "f").call(this, where);
        }
    }
    /**
     * Remove the visual focus (`.is-focused` class) from the currently focused element and
     * clear the `activeDescendant` attribute.
     */
    clear() {
        this.getInteractiveElement(this.host).removeAttribute('aria-activedescendant');
        const element = this.focused;
        this.activeDescendant = null;
        if (!element) {
            return;
        }
        element.classList.remove('is-focused');
    }
}
_FocusManagerController_focusElement = new WeakMap(), _FocusManagerController_focusIndex = new WeakMap(), _FocusManagerController_focusPosition = new WeakMap(), _FocusManagerController_handleKeyPress = new WeakMap(), _FocusManagerController_clearBufferAfterDelay = new WeakMap(), _FocusManagerController_findMatchInRange = new WeakMap(), _FocusManagerController_instances = new WeakSet(), _FocusManagerController_getIndexOfQueried = function _FocusManagerController_getIndexOfQueried(element) {
    if (!element) {
        return -1;
    }
    return this.queried.indexOf(element);
}, _FocusManagerController_findQueriedById = function _FocusManagerController_findQueriedById(id) {
    return (this.queried.find((element) => {
        return element.id === id;
    }) ?? null);
};

const TRIGGER_SELECTOR = '[aria-haspopup="true"]';
const MENU_SELECTOR = '[role="menu"]';
const ITEM_SELECTOR = '[role="menuitem"]';

function dropdownStyles() {
    return [
        styles$m({
            referenceSelector: `::slotted(${TRIGGER_SELECTOR})`,
            floatingSelector: `::slotted(${MENU_SELECTOR})`,
        }),
        i$5 `
			:host {
				--m-popover-floating-spacing-x: ${getToken$1('spacing-2')};
				--m-popover-floating-spacing-y: ${getToken$1('spacing-2')};
				/* TODO: figure out a way to avoid layout shift when using narrow triggers */
				--m-popover-width: max-content;
				--m-popover-min-width: 16ch;

				display: inline-block;
			}

			::slotted(${r$7(MENU_SELECTOR)}) {
				--m-popover-background-color: ${getColor('color-background-primary')};

				outline: none;
			}

			:host([open]) ::slotted(${r$7(MENU_SELECTOR)}) {
				display: inline-flex;

				flex-direction: column;
			}
		`,
    ];
}
function triggerStyles() {
    return [
        i$5 `
			:host {
				--m-dropdown-trigger-background-color: ${getColor('color-background-primary')};
				--m-dropdown-trigger-border-color: ${getColor('color-border-input')};
				--m-dropdown-trigger-border-radius: ${getToken$1('border-radius-s')};
				--m-dropdown-trigger-color: ${getColor('color-text-tertiary')};
				--m-dropdown-trigger-padding-x: ${getToken$1('spacing-2')};
				--m-dropdown-trigger-padding-y: ${getToken$1('spacing-2')};
				--m-dropdown-trigger-height: ${getToken$1('global-height-default')};

				${transition([
            { property: 'color' },
            { property: 'background-color' },
            { property: 'border-color' },
        ])};

				${typography('body-md')};

				cursor: pointer;
				position: relative;

				display: flex;
				align-items: center;
				justify-content: flex-start;
				overflow: hidden;

				block-size: var(--m-dropdown-trigger-height);
				inline-size: 100%;
				box-sizing: border-box;

				text-decoration: none;

				gap: ${getToken$1('spacing-1')};

				${px('var(--m-dropdown-trigger-padding-x)')};
				${py('var(--m-dropdown-trigger-padding-y)')};

				background-color: var(--m-dropdown-trigger-background-color);
				color: var(--m-dropdown-trigger-color);
				border: 1px solid var(--m-dropdown-trigger-border-color);

				border-radius: var(--m-dropdown-trigger-border-radius);

				outline: none;
			}

			:host(:not([disabled]):hover) {
				--m-dropdown-trigger-border-color: ${getColor('color-primary-60')};
			}

			:host(:not([disabled]):is(:focus, :focus-within, :focus-visible)) {
				--m-dropdown-trigger-border-color: ${getColor('color-primary-100')};
			}

			:host([disabled]) {
				--m-dropdown-trigger-background-color: ${getColor('color-background-tertiary')};
				--m-dropdown-trigger-color: ${getColor('color-text-placeholder')};

				cursor: default;
				pointer-events: none;
			}

			:host([disabled]) *,
			:host([disabled]) ::slotted(*) {
				pointer-events: none;
				user-select: none;
			}

			:host-context([size='small']) {
				--m-dropdown-trigger-border-color: ${getColor('color-border-input', 0)};
				--m-dropdown-trigger-padding-y: ${getToken$1('spacing-1')};
				--m-dropdown-trigger-height: ${getToken$1('global-height-small')};
				--m-dropdown-trigger-background-color: transparent;
			}

			:host-context([size='small']:not([disabled]):hover) {
				--m-dropdown-trigger-border-color: ${getColor('color-border-input')};
			}

			:host-context([size='small'][disabled]) {
				--m-dropdown-trigger-color: ${getColor('color-text-disabled')};
			}

			:host-context([size='large']) {
				--m-dropdown-trigger-padding-y: ${getToken$1('spacing-3')};
				--m-dropdown-trigger-height: ${getToken$1('global-height-large')};
			}
		`,
        i$5 `
			.indicator {
				--m-icon-size: 12px;
				--m-icon-color: ${getColor('color-text-placeholder')};

				${transition([
            {
                property: 'transform',
            },
        ])};

				margin: 0 0 0 auto;
			}

			:host([aria-expanded='true']) .indicator {
				transform: rotate(180deg);
			}

			:host-context([size='small'][disabled]) .indicator {
				--m-icon-color: ${getColor('color-text-disabled')};
			}
		`,
    ];
}
function itemStyles() {
    return [
        i$5 `
			:host {
				--m-dropdown-item-background-color: ${getColor('color-background-primary')};
				--m-dropdown-item-color: ${getColor('color-text-secondary')};

				${transition([
            { property: 'color' },
            { property: 'background-color' },
        ])};
				${typography('body-md')};

				block-size: 36px;

				cursor: pointer;
				position: relative;

				box-sizing: border-box;

				display: inline-flex;
				align-items: center;
				justify-content: flex-start;
				text-decoration: none;

				gap: ${getToken$1('spacing-2')};

				${px(getToken$1('spacing-1'))};
				${py(getToken$1('spacing-2'))};

				background-color: var(--m-dropdown-item-background-color);
				color: var(--m-dropdown-item-color);

				border: none;

				border-radius: ${getToken$1('border-radius-s')};
			}

			slot[name='leading']::slotted(*),
			slot[name='trailing']::slotted(*) {
				display: inline-flex;
				align-items: center;
				justify-content: center;

				${p$1(0)};
				${m$1(0)};
			}

			:host([destructive]) {
				--m-dropdown-item-color: ${getColor('color-text-error')};
			}

			:host(:not([disabled]):hover),
			:host(:is(:focus, :focus-within, :focus-visible, .is-focused)) {
				--m-dropdown-item-background-color: ${getColor('color-background-tertiary')};

				font-weight: ${getToken$1('font-weight-bold')};
				outline: none;
			}

			:host(:not([disabled]):is(:active, .is-active)) {
				--m-dropdown-item-background-color: ${getColor('color-background-highlight')};
			}

			:host([disabled]) {
				--m-dropdown-item-color: ${getColor('color-text-disabled')};

				pointer-events: none;
				user-select: none;

				cursor: default;
			}

			:host([disabled]) ::slotted(*) {
				pointer-events: none;
				user-select: none;
			}
		`,
    ];
}

var _Dropdown_controllers, _Dropdown_handleClick, _Dropdown_handleClickOutside;
class Dropdown extends Popover {
    static get properties() {
        return {
            ...Popover.properties,
            disabled: {
                type: Boolean,
                reflect: true,
            },
            size: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        _Dropdown_controllers.set(this, void 0);
        // eslint-disable-next-line class-methods-use-this
        this.getFloatingOffset = () => {
            return 4;
        };
        _Dropdown_handleClick.set(this, (event) => {
            const { target } = event;
            if (!target) {
                return;
            }
            if (target.matches(ITEM_SELECTOR)) {
                /**
                 * we set focus so we can trigger the item click event when the user
                 * presses <Enter> or <Space>, through the KeyboardSupportController.
                 */
                __classPrivateFieldGet$1(this, _Dropdown_controllers, "f").focus.focus(target);
                this.collapse();
            }
            /**
             * <Enter> or <Space> keys also trigger the click event.
             * In that case, we do not want to respond to the key event, since
             * the keyboard shortcut will handle it for us.
             * To distinguish between a keypress event and click, we can use the `detail` property,
             * which determines how many times the element was clicked. For a keyboard event, this
             * should be 0; for a click event, it should be at least 1.
             * References:
             * - https://css-tricks.com/when-a-click-is-not-just-a-click/
             * - https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
             */
            if (target.matches(TRIGGER_SELECTOR) &&
                event.detail > 0) {
                this.toggle();
            }
        });
        _Dropdown_handleClickOutside.set(this, () => {
            this.collapse();
        });
        this.position = 'absolute';
        this.placement = 'bottom-end';
        this.disabled = false;
        __classPrivateFieldSet(this, _Dropdown_controllers, {
            boundary: new BoundaryController(this),
            focus: new FocusManagerController(this, {
                query: ITEM_SELECTOR,
                getInteractiveElement: () => {
                    return this.getFloatingElement();
                },
            }),
            keyboard: new KeyboardSupportController(this, [
                {
                    shortcut: {
                        key: 'ArrowUp',
                    },
                    handler: (event) => {
                        const { target } = event;
                        if (!target || this.disabled) {
                            return;
                        }
                        if (target.matches(TRIGGER_SELECTOR)) {
                            this.expand({ position: 'last' });
                            return;
                        }
                        if (target.matches(MENU_SELECTOR)) {
                            __classPrivateFieldGet$1(this, _Dropdown_controllers, "f").focus.focusPrevious();
                        }
                    },
                },
                {
                    shortcut: {
                        key: 'ArrowDown',
                    },
                    handler: (event) => {
                        const { target } = event;
                        if (!target || this.disabled) {
                            return;
                        }
                        if (target.matches(TRIGGER_SELECTOR)) {
                            this.expand({ position: 'first' });
                            return;
                        }
                        if (target.matches(MENU_SELECTOR)) {
                            __classPrivateFieldGet$1(this, _Dropdown_controllers, "f").focus.focusNext();
                        }
                    },
                },
                {
                    shortcut: [
                        {
                            key: 'Enter',
                        },
                        {
                            key: ' ',
                        },
                    ],
                    handler: (event) => {
                        const { target } = event;
                        if (!target || this.disabled) {
                            return;
                        }
                        if (target.matches(TRIGGER_SELECTOR)) {
                            this.toggle({ position: 'first' });
                            return;
                        }
                        if (target.matches(MENU_SELECTOR)) {
                            const item = __classPrivateFieldGet$1(this, _Dropdown_controllers, "f").focus.focused;
                            if (item?.disabled) {
                                return;
                            }
                            item.click();
                        }
                    },
                },
                {
                    shortcut: [
                        {
                            key: 'Tab',
                        },
                        {
                            key: 'Tab',
                            shift: true,
                        },
                    ],
                    handler: (event) => {
                        const { target } = event;
                        if (!target) {
                            return;
                        }
                        if (target.matches(TRIGGER_SELECTOR) &&
                            this.open) {
                            __classPrivateFieldGet$1(this, _Dropdown_handleClickOutside, "f").call(this);
                        }
                    },
                },
            ]),
        }, "f");
        this.addEventListener('click', __classPrivateFieldGet$1(this, _Dropdown_handleClick, "f"));
        this.addEventListener('m-interact-out', __classPrivateFieldGet$1(this, _Dropdown_handleClickOutside, "f"));
    }
    firstUpdated() {
        if (this.floating?.id) {
            this.reference?.setAttribute('aria-controls', this.floating.id);
        }
        if (this.reference?.id) {
            this.floating?.setAttribute('aria-labelledby', this.reference.id);
        }
        super.firstUpdated();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('open')) {
            if (this.open) {
                this.reference?.setAttribute('aria-expanded', 'true');
            }
            else {
                this.reference?.removeAttribute('aria-expanded');
            }
        }
        if (changedProperties.has('disabled') && this.reference) {
            this.reference.disabled = this.disabled;
        }
    }
    getReferenceElement() {
        return this.querySelector(TRIGGER_SELECTOR);
    }
    getFloatingElement() {
        return this.querySelector(MENU_SELECTOR);
    }
    // eslint-disable-next-line class-methods-use-this
    getArrowElement() {
        return null;
    }
    render() {
        return x `<slot></slot>`;
    }
    async expand(args) {
        const { position = 'first' } = args || {};
        this.show();
        await this.updateComplete;
        this.floating?.focus();
        __classPrivateFieldGet$1(this, _Dropdown_controllers, "f").focus.focus(position);
        __classPrivateFieldGet$1(this, _Dropdown_controllers, "f").boundary.activate();
        this.emit('m-expand');
    }
    async collapse() {
        this.hide();
        await this.updateComplete;
        __classPrivateFieldGet$1(this, _Dropdown_controllers, "f").boundary.deactivate();
        __classPrivateFieldGet$1(this, _Dropdown_controllers, "f").focus.clear();
        this.reference?.focus();
        this.emit('m-collapse');
    }
    toggle(args) {
        if (this.open) {
            this.collapse();
        }
        else {
            this.expand(args);
        }
    }
}
_Dropdown_controllers = new WeakMap(), _Dropdown_handleClick = new WeakMap(), _Dropdown_handleClickOutside = new WeakMap();
Dropdown.styles = [dropdownStyles()];
window.customElements.define('m-dropdown', Dropdown);

let counter = 0;
/**
 * Generates a unique id for our elements, prepending the given `prefix`.
 * @param prefix - Id prefix. Defaults to 'm'
 */
function generateId(prefix = 'm') {
    counter += 1;
    /**
     * prefixing with 'm' to ensure we always start with a letter.
     * https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id
     */
    const id = `${prefix}-${counter}`;
    /**
     * Embracing the unlikelyhood of having 9007199254740991 elements we id-d with this approach
     * at the same time in the document (in which case we would have a collision).
     */
    if (counter === Number.MAX_SAFE_INTEGER) {
        counter = 0;
    }
    return id;
}

/**
 * Sets the element id with a random value, in case it is not already set.
 */
const WithIdElementMixin = (superClass, prefix = 'm') => {
    class WithIdElement extends superClass {
        connectedCallback() {
            super.connectedCallback();
            if (!this.hasAttribute('id')) {
                this.id = generateId(prefix);
            }
        }
    }
    return WithIdElement;
};

class DropdownTrigger extends WithIdElementMixin(Component) {
    static get properties() {
        return {
            disabled: { type: Boolean, reflect: true },
        };
    }
    constructor() {
        super();
        this.disabled = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'button');
        this.setAttribute('tabindex', '0');
        this.setAttribute('aria-haspopup', 'true');
    }
    render() {
        return x `
			<slot name="leading"></slot>
			<slot></slot>
			<m-icon name="caret-down" class="indicator"></m-icon>
		`;
    }
}
DropdownTrigger.styles = [triggerStyles()];
window.customElements.define('m-dropdown-trigger', DropdownTrigger);

class DropdownMenu extends WithIdElementMixin(Component) {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'menu');
        this.setAttribute('tabindex', '-1');
    }
    render() {
        return x `<slot name="menu-item"></slot>`;
    }
}
window.customElements.define('m-dropdown-menu', DropdownMenu);

class DropdownItem extends WithIdElementMixin(Component) {
    static get properties() {
        return {
            disabled: { type: Boolean, reflect: true },
            destructive: { type: Boolean, reflect: true },
        };
    }
    constructor() {
        super();
        this.handleClick = (event) => {
            if (this.disabled) {
                event.stopPropagation();
                event.preventDefault();
            }
        };
        this.disabled = false;
        this.destructive = false;
        this.addEventListener('click', this.handleClick);
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'menu-item');
        this.setAttribute('role', 'menuitem');
        this.setAttribute('tabindex', '-1');
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('disabled')) {
            if (this.disabled) {
                this.setAttribute('aria-disabled', 'true');
            }
            else {
                this.removeAttribute('aria-disabled');
            }
        }
    }
    render() {
        return x `
			<slot name="leading"></slot>
			<slot></slot>
			<slot name="trailing"></slot>
		`;
    }
}
DropdownItem.styles = [itemStyles()];
window.customElements.define('m-dropdown-item', DropdownItem);

const emptyStateContext = n$1(Symbol('empty-state'));

function getActionSize(variant) {
    switch (variant) {
        case 'panel':
        case 'card':
        case 'card-horizontal':
            return 'small';
        case 'page':
        default:
            return 'default';
    }
}

var _EmptyStateAction_contextCallback;
class EmptyStateAction extends Button {
    constructor() {
        super();
        _EmptyStateAction_contextCallback.set(this, ({ variant }) => {
            this.size = getActionSize(variant);
        });
        this.type = 'button';
        this.variant = 'primary';
        this.context = new s$1(this, {
            context: emptyStateContext,
            callback: __classPrivateFieldGet$1(this, _EmptyStateAction_contextCallback, "f"),
            subscribe: true,
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'action');
    }
}
_EmptyStateAction_contextCallback = new WeakMap();
window.customElements.define('m-empty-state-action', EmptyStateAction);

var _EmptyStateHeader_contextCallback;
class EmptyStateHeader extends Text {
    constructor() {
        super();
        _EmptyStateHeader_contextCallback.set(this, (value) => {
            switch (value.variant) {
                case 'panel':
                    this.variant = 'body-md-bold';
                    break;
                case 'card':
                case 'card-horizontal':
                    this.variant = 'body-sm-bold';
                    break;
                case 'page':
                default:
                    this.variant = 'heading-sm-bold';
            }
        });
        this.variant = 'heading-sm-bold';
        this.context = new s$1(this, {
            context: emptyStateContext,
            callback: __classPrivateFieldGet$1(this, _EmptyStateHeader_contextCallback, "f"),
            subscribe: true,
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'header');
    }
}
_EmptyStateHeader_contextCallback = new WeakMap();
window.customElements.define('m-empty-state-header', EmptyStateHeader);

function styles$l() {
    return i$5 `
		slot {
			display: block;
		}

		:host {
			max-width: 320px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: ${getToken$1('spacing-4')};
		}

		:host([variant|='card']) {
			gap: ${getToken$1('spacing-2')};
		}

		:host([variant='card-horizontal']) {
			flex-direction: row;
			max-width: 100%;
		}

		.empty-state-body {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			text-align: center;
			gap: ${getToken$1('spacing-2')};
		}

		/* Hide illustration when it isn't a supported element */
		slot[name='illustration']::slotted(
				:not(m-empty-state-illustration, img, svg)
			) {
			display: none;
		}

		/* Illustration Wrapper */

		.illustration-wrapper {
			overflow: hidden;
			max-width: 320px;
			max-height: 240px;
		}

		:host([variant='panel']) .illustration-wrapper {
			max-width: 160px;
			max-height: 120px;
		}

		:host([variant='card']) .illustration-wrapper {
			max-height: 36px;
			max-width: 36px;
		}

		:host([variant='card-horizontal']) .illustration-wrapper {
			max-height: 24px;
			max-width: 24px;
		}

		/* Illustration */

		slot[name='illustration'] img,
		slot[name='illustration']::slotted(:is(img, svg)) {
			display: block;
			object-fit: scale-down;
			max-width: 320px;
			max-height: 240px;
		}

		:host([variant='panel']) slot[name='illustration'] img,
		:host([variant='panel']) slot[name='illustration']::slotted(:is(img, svg)) {
			max-width: 160px;
			max-height: 120px;
		}

		:host([variant='card']) slot[name='illustration'] img,
		:host([variant='card']) slot[name='illustration']::slotted(:is(img, svg)) {
			max-width: 36px;
			max-height: 36px;
		}

		:host([variant='card-horizontal']) slot[name='illustration'] img,
		:host([variant='card-horizontal'])
			slot[name='illustration']::slotted(:is(img, svg)) {
			max-width: 24px;
			max-height: 24px;
		}

		/* Header */

		slot[name='header'] {
			${getColor('color-text-primary')};
			${typography('heading-sm-bold')};
		}

		:host([variant='panel']) slot[name='header'] {
			${typography('body-md-bold')};
		}

		:host([variant|='card']) slot[name='header'] {
			${typography('body-sm-bold')};
		}

		/* Message */

		slot[name='message'] {
			${getColor('color-text-secondary')};
			${typography('body-md')};
		}

		:host([variant='panel']) slot[name='message'] {
			${typography('body-sm')};
		}
	`;
}
function illustrationStyles() {
    return i$5 `
		m-empty-state > m-empty-state-illustration :is(img, svg) {
			display: block;
			object-fit: scale-down;
			max-width: 320px;
			max-height: 240px;
		}

		m-empty-state[variant='panel'] > m-empty-state-illustration :is(img, svg) {
			max-width: 160px;
			max-height: 120px;
		}

		m-empty-state[variant='card'] > m-empty-state-illustration :is(img, svg) {
			width: 36px;
			height: 36px;
		}

		m-empty-state[variant='card-horizontal']
			> m-empty-state-illustration
			:is(img, svg) {
			width: 24px;
			height: 24px;
		}
	`;
}

const style = document.createElement('style');
style.textContent = illustrationStyles().cssText;
document.head.appendChild(style);
class EmptyStateIllustration extends s$7 {
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'illustration');
    }
}
window.customElements.define('m-empty-state-illustration', EmptyStateIllustration);

var _EmptyStateMessage_contextCallback;
class EmptyStateMessage extends Text {
    constructor() {
        super();
        _EmptyStateMessage_contextCallback.set(this, (value) => {
            switch (value.variant) {
                case 'panel':
                    this.variant = 'body-sm';
                    break;
                case 'page':
                default:
                    this.variant = 'body-md';
            }
        });
        this.variant = 'body-md';
        this.context = new s$1(this, {
            context: emptyStateContext,
            callback: __classPrivateFieldGet$1(this, _EmptyStateMessage_contextCallback, "f"),
            subscribe: true,
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'message');
    }
}
_EmptyStateMessage_contextCallback = new WeakMap();
window.customElements.define('m-empty-state-message', EmptyStateMessage);

var _EmptyState_instances, _EmptyState_contextProvider, _EmptyState_handleClickAction;
attachContextRoot();
/**
 * @fires m-action
 */
class EmptyState extends Component {
    static get properties() {
        return {
            variant: { type: String, reflect: true },
            illustration: { type: String, reflect: true },
            header: { type: String, reflect: true },
            message: { type: String, reflect: true },
            action: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        _EmptyState_instances.add(this);
        _EmptyState_contextProvider.set(this, new i(this, {
            context: emptyStateContext,
            initialValue: {
                variant: undefined,
            },
        }));
        this.variant = 'page';
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('variant')) {
            __classPrivateFieldGet$1(this, _EmptyState_contextProvider, "f").setValue({
                variant: this.variant ?? 'page',
            });
        }
    }
    render() {
        const illustration = this.illustration
            ? n$3 `<img role="presentation" src=${this.illustration} />`
            : A$1;
        const body = this.variant?.startsWith('card')
            ? n$3 `<slot name="header">${this.header}</slot>`
            : n$3 `
					<div class="empty-state-body">
						<slot name="header">${this.header}</slot>
						<slot name="message">${this.message}</slot>
					</div>
			  `;
        const action = this.action
            ? n$3 `
					<m-button
						type="button"
						variant="primary"
						size=${getActionSize(this.variant)}
						@click=${__classPrivateFieldGet$1(this, _EmptyState_instances, "m", _EmptyState_handleClickAction)}
						>${this.action}</m-button
					>
			  `
            : A$1;
        return n$3 `
			<div class="illustration-wrapper">
				<slot name="illustration">${illustration}</slot>
			</div>
			${body}
			<slot name="action">${action}</slot>
		`;
    }
}
_EmptyState_contextProvider = new WeakMap(), _EmptyState_instances = new WeakSet(), _EmptyState_handleClickAction = function _EmptyState_handleClickAction(event) {
    event.preventDefault();
    event.stopPropagation();
    this.emit('m-action');
};
EmptyState.styles = [styles$l()];
window.customElements.define('m-empty-state', EmptyState);

const EMPTY_STATE_VARIANTS = [
    'page',
    'panel',
    'card',
    'card-horizontal',
];

const fieldContext = n$1(Symbol('field'));

function styles$k() {
    return [
        i$5 `
			:host {
				--m-field-hint-color: ${getColor('color-text-tertiary')};
			}

			m-group {
				${px(getToken$1('spacing-2'))};
			}

			.-status-danger {
				--m-field-hint-color: ${getColor('color-danger-60')};
			}

			.hint {
				${typography('body-sm')};
				color: var(--m-field-hint-color);
			}
		`,
    ];
}

var _FieldHint_instances, _FieldHint_getStatus;
class FieldHint extends Component {
    static get properties() {
        return {
            status: { type: String },
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        _FieldHint_instances.add(this);
        this.field = new s$1(this, {
            context: fieldContext,
            subscribe: true,
        });
        this.slot = 'hint';
    }
    render() {
        const commonClasses = {
            '-status-default': __classPrivateFieldGet$1(this, _FieldHint_instances, "m", _FieldHint_getStatus).call(this) === 'default',
            '-status-danger': __classPrivateFieldGet$1(this, _FieldHint_instances, "m", _FieldHint_getStatus).call(this) === 'danger',
        };
        return x ` <m-group
			gap="spacing-0-5"
			align="center"
			class=${o$2(commonClasses)}
		>
			<slot name="leading"
				>${__classPrivateFieldGet$1(this, _FieldHint_instances, "m", _FieldHint_getStatus).call(this) === 'danger'
            ? x `<m-icon
							name="attention"
							size="10"
							color="color-danger-60"
					  ></m-icon>`
            : A$1}</slot
			>
			<span
				class=${o$2({
            hint: true,
            ...commonClasses,
        })}
				><slot></slot>
			</span>
		</m-group>`;
    }
}
_FieldHint_instances = new WeakSet(), _FieldHint_getStatus = function _FieldHint_getStatus() {
    return this.status || this.field.value?.status;
};
FieldHint.styles = [styles$k()];
window.customElements.define('m-field-hint', FieldHint);

function styles$j() {
    return [
        i$5 `
			.label {
				${typography('body-md')};

				display: inline-flex;
				align-items: center;
				justify-content: flex-start;
				gap: ${getToken$1('spacing-0-5')};

				margin: 0;
				padding: 0;

				color: ${getColor('color-text-tertiary')};
			}

			.required {
				color: ${getColor('color-text-error')};
			}

			.-size-small {
				${typography('body-sm')};
			}
		`,
    ];
}

class Label extends Component {
    static get properties() {
        return {
            required: { type: Boolean },
            size: { type: String },
            slot: { type: String, reflect: true },
        };
    }
    requiredTemplate() {
        return this.isRequired()
            ? // The space between the asterisk and the label is required by design
                x `<span class="required" aria-hidden="true"> *</span>`
            : A$1;
    }
    labelClassList() {
        const size = this.getSize();
        return o$2({
            label: true,
            '-size-small': size === 'small',
        });
    }
    render() {
        return x `<label class=${this.labelClassList()}
			><slot></slot>${this.requiredTemplate()}</label
		>`;
    }
    getSize() {
        return this.size;
    }
    isRequired() {
        return Boolean(this.required);
    }
}
Label.styles = [styles$j()];
window.customElements.define('m-label', Label);

class FieldLabel extends Label {
    constructor() {
        super(...arguments);
        this.field = new s$1(this, {
            context: fieldContext,
            subscribe: true,
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('slot', 'label');
    }
    isRequired() {
        if (this.required != null) {
            return this.required;
        }
        return Boolean(this.field.value?.required);
    }
    getSize() {
        return this.size ?? this.field.value?.size;
    }
}
window.customElements.define('m-field-label', FieldLabel);

attachContextRoot();
class Field extends Component {
    static get properties() {
        return {
            label: { type: String },
            hint: { type: String },
            required: { type: Boolean },
            status: { type: String },
            size: { type: String },
            align: { type: String },
        };
    }
    constructor() {
        super();
        this.provider = new i(this, fieldContext, {
            required: false,
            size: 'default',
            status: 'default',
        });
        this.required = false;
        this.status = 'default';
        this.size = 'default';
        this.align = 'stretch';
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('required') ||
            changedProperties.has('status') ||
            changedProperties.has('size')) {
            this.provider.setValue({
                required: this.required,
                status: this.status,
                size: this.size,
            });
        }
    }
    render() {
        return x `<m-stack gap="spacing-1" align="${l(this.align)}">
			<slot name="label"
				>${this.label
            ? x `<m-field-label>${this.label}</m-field-label>`
            : A$1}</slot
			>

			<slot></slot>

			<slot name="hint">
				${this.hint ? x `<m-field-hint>${this.hint}</m-field-hint>` : A$1}
			</slot>
		</m-stack>`;
    }
}
window.customElements.define('m-field', Field);

const FIELD_STATUSES = ['default', 'danger'];

function styles$i() {
    return i$5 `
		:host {
			--m-header-background-color: ${getColor('color-background-primary')};

			display: block;
		}

		.m-header {
			display: flex;
			flex-wrap: wrap;
			background-color: var(--m-header-background-color);
			padding: ${getToken$1('spacing-6')};
			gap: ${getToken$1('spacing-4')};
			align-items: center;
		}

		@media screen and (max-width: 1025px) {
			.m-header {
				padding: ${getToken$1('spacing-4')};
			}
		}
	`;
}
function headerTitleStyles() {
    return i$5 `
		:host {
			display: block;
			${typography('body-lg-bold')};
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			max-width: 400px;
		}
		@media screen and (max-width: 1025px) {
			:host {
				${typography('body-md-bold')};
			}
		}
	`;
}
function headerActionStyles() {
    return i$5 `
		:host {
			display: flex;
			gap: ${getToken$1('spacing-4')};
		}
	`;
}
function headerContentStyles() {
    return i$5 `
		:host {
			display: flex;
			gap: ${getToken$1('spacing-4')};
			align-items: center;
			flex-grow: 100;
		}
	`;
}
function subHeaderStyles() {
    return i$5 `
		:host {
			--m-subheader-background-color: var(
				--m-header-background-color,
				${getColor('color-background-primary')}
			);

			display: block;
		}
		.content {
			padding: ${getToken$1('spacing-6')};
			background-color: var(--m-subheader-background-color);
		}
	`;
}

class Header extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        // this sets the slot to which the m-header should be assigned inside the page-content component.
        this.slot = 'page-header';
    }
    render() {
        return x `
			<div class="m-header">
				<slot name="back-button"></slot>
				<slot name="content"></slot>
				<slot name="actions"></slot>
			</div>
			<slot name="sub-header"></slot>
		`;
    }
}
Header.styles = [styles$i()];
window.customElements.define('m-header', Header);

class HeaderActions extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        // this sets the slot to which the header-actions should be assigned inside the Header component.
        this.slot = 'actions';
    }
    render() {
        return n$3 `<slot></slot>`;
    }
}
HeaderActions.styles = [headerActionStyles()];
window.customElements.define('m-header-actions', HeaderActions);

class HeaderContent extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        // this sets the slot to which the header-content should be assigned inside the Header component.
        this.slot = 'content';
    }
    render() {
        return n$3 `<slot name="title"></slot> <slot></slot>`;
    }
}
HeaderContent.styles = [headerContentStyles()];
window.customElements.define('m-header-content', HeaderContent);

class HeaderTitle extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        // this sets the slot to which the header-title should be assigned inside the Header component.
        this.slot = 'title';
    }
    render() {
        return n$3 `<slot></slot>`;
    }
}
HeaderTitle.styles = [headerTitleStyles()];
window.customElements.define('m-header-title', HeaderTitle);

class SubHeader extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        // this sets the slot to which the sub-header should be assigned inside the Header component.
        this.slot = 'sub-header';
    }
    render() {
        return n$3 ` <m-divider></m-divider>
			<div class="content">
				<slot></slot>
			</div>`;
    }
}
SubHeader.styles = [subHeaderStyles()];
window.customElements.define('m-sub-header', SubHeader);

const defaultLabeledValueLabelProps = {
    color: 'color-text-tertiary',
    variant: 'body-sm',
};
class LabeledValueLabel extends Text {
    static get properties() {
        return {
            ...super.properties,
            role: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.color = defaultLabeledValueLabelProps.color;
        this.variant = defaultLabeledValueLabelProps.variant;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'term');
        this.setAttribute('slot', 'label');
    }
    update(changedProperties) {
        if (changedProperties.has('color') &&
            (this.color === undefined || this.color === null)) {
            this.color = defaultLabeledValueLabelProps.color;
        }
        if (changedProperties.has('variant') &&
            (this.variant === undefined || this.variant === null)) {
            this.variant = defaultLabeledValueLabelProps.variant;
        }
        super.update(changedProperties);
    }
}
window.customElements.define('m-labeled-value-label', LabeledValueLabel);

class LabeledValueValue extends Text {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'definition');
        this.setAttribute('slot', 'value');
    }
}
window.customElements.define('m-labeled-value-value', LabeledValueValue);

const defaultLabeledValueProps = {
    gap: 'spacing-2',
    justify: 'flex-start',
};
class LabeledValue extends s$7 {
    constructor() {
        super();
        this.inline = false;
        this.gap = defaultLabeledValueProps.gap;
        this.justify = defaultLabeledValueProps.justify;
    }
    static get properties() {
        return {
            inline: { type: Boolean },
            label: { type: String },
            value: { type: String },
            gap: { type: String },
            align: { type: String },
            justify: { type: String },
            fallbackValue: { type: String, attribute: 'fallback-value' },
            labelVariant: { type: String, attribute: 'label-variant' },
            labelColor: { type: String, attribute: 'label-color' },
            valueVariant: { type: String, attribute: 'value-variant' },
            valueColor: { type: String, attribute: 'value-color' },
        };
    }
    getFallback() {
        return x `<slot name="fallback">${this.fallbackValue ?? '-'}</slot>`;
    }
    getLabel() {
        return x `<slot name="label"
			><m-labeled-value-label
				variant=${this.getLabelVariant()}
				color=${l(this.labelColor)}
				>${this.label}</m-labeled-value-label
			></slot
		>`;
    }
    getValue() {
        return x `<slot name="value"
			><m-labeled-value-value
				variant=${l(this.valueVariant)}
				color=${l(this.valueColor)}
				>${this.value ?? this.getFallback()}</m-labeled-value-value
			></slot
		>`;
    }
    getLabelVariant() {
        if (this.labelVariant) {
            return this.labelVariant;
        }
        return this.inline ? 'body-md' : 'body-sm';
    }
    get wrapperAlign() {
        if (this.align) {
            return this.align;
        }
        return this.inline ? 'center' : 'flex-start';
    }
    bodyTemplate() {
        return x `${this.getLabel()} ${this.getValue()}`;
    }
    render() {
        if (this.inline) {
            return x `<m-group
				gap="${l(this.gap)}"
				align="${this.wrapperAlign}"
				justify="${l(this.justify)}"
				>${this.bodyTemplate()}</m-group
			>`;
        }
        return x `<m-stack
			gap="${l(this.gap)}"
			align="${this.wrapperAlign}"
			justify="${l(this.justify)}"
			>${this.bodyTemplate()}</m-stack
		>`;
    }
}
window.customElements.define('m-labeled-value', LabeledValue);

function styles$h() {
    return i$5 `
		.m-link {
			color: ${getColor('color-text-link')};
		}

		.m-link.-small {
			${typography('body-sm-bold-underline')};
		}

		.m-link.-default {
			${typography('body-md-bold-underline')};
		}

		.m-link.-large {
			${typography('heading-md-bold')};
			text-decoration: none;
		}

		@media (prefers-reduced-motion: no-preference) {
			.m-link {
				${transition({ property: 'color', duration: '250ms' })}
			}
		}

		${on('.m-link').not.disabled.hover},
		${on('.m-link').not.disabled.active},
		${on('.m-link').not.disabled.visited.hover} {
			color: ${getColor('color-primary-100')};
		}

		${on('.m-link').not.disabled.not.active.focus} {
			border-radius: ${getToken$1('border-radius-s')};
			outline: 1px solid ${getColor('color-primary-60')};
			outline-offset: 4px;
			text-decoration: none;
		}

		${on('.m-link').not.disabled.not.focus.visited} {
			color: ${getColor('color-accent-60')};
		}

		${on('.m-link').disabled} {
			color: ${getColor('color-primary-20')};
		}
	`;
}

var _Link_instances, _Link_disabled_get, _Link_href_get, _Link_rel_get, _Link_handleClick;
const UNSAFE_URL = /^javascript:/i;
class Link extends Component {
    static get properties() {
        return {
            href: { type: String, reflect: true },
            target: { type: String, reflect: true },
            rel: { type: String, reflect: true },
            download: { type: String, reflect: true },
            ping: { type: String, reflect: true },
            referrerpolicy: { type: String, reflect: true },
            size: { type: String, reflect: true },
            disabled: { type: Boolean, reflect: true },
        };
    }
    constructor() {
        super();
        _Link_instances.add(this);
        this.size = 'default';
    }
    render() {
        return x `
			<a
				class=${o$2({
            'm-link': true,
            '-small': this.size === 'small',
            '-default': this.size === 'default',
            '-large': this.size === 'large',
            'is-disabled': __classPrivateFieldGet$1(this, _Link_instances, "a", _Link_disabled_get),
        })}
				href=${l(__classPrivateFieldGet$1(this, _Link_instances, "a", _Link_href_get))}
				target=${l(this.target)}
				rel=${l(__classPrivateFieldGet$1(this, _Link_instances, "a", _Link_rel_get))}
				download=${l(this.download)}
				ping=${l(this.ping)}
				referrerpolicy=${l(this.referrerpolicy)}
				@click=${__classPrivateFieldGet$1(this, _Link_instances, "m", _Link_handleClick)}
				><slot></slot
			></a>
		`;
    }
}
_Link_instances = new WeakSet(), _Link_disabled_get = function _Link_disabled_get() {
    return this.disabled || !this.href || UNSAFE_URL.test(this.href.trim());
}, _Link_href_get = function _Link_href_get() {
    return !__classPrivateFieldGet$1(this, _Link_instances, "a", _Link_disabled_get) ? this.href : undefined;
}, _Link_rel_get = function _Link_rel_get() {
    let result = this.rel;
    if (this.target === '_blank') {
        const rel = new Set((this.rel ?? '').split(/\s+/).filter(Boolean));
        // If the developers are deliberately setting the `referrerpolicy`,
        // they should know what they are doing, so we must not override it.
        if (!this.referrerpolicy?.trim()) {
            rel.add('noreferrer');
        }
        // If the developers are deliberately setting the `rel="opener"`,
        // they should know what they are doing, so we must not override it.
        if (!rel.has('opener')) {
            rel.add('noopener');
        }
        result = Array.from(rel).join(' ');
    }
    return result;
}, _Link_handleClick = function _Link_handleClick(event) {
    if (__classPrivateFieldGet$1(this, _Link_instances, "a", _Link_disabled_get)) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    }
    return undefined;
};
Link.styles = [styles$h()];
window.customElements.define('m-link', Link);

function styles$g() {
    return i$5 `
		:host {
			display: block;
			box-sizing: border-box;
			width: 100%;
		}

		slot[name='page-header']::slotted(*) {
			border-bottom: ${getToken$1('border-thin')} solid ${getColor('color-border')};
		}
	`;
}

class PageContent extends s$7 {
    render() {
        return x `
			<slot name="page-header"></slot>
			<slot name="page-body"></slot>
		`;
    }
}
PageContent.styles = [styles$g()];
window.customElements.define('m-page-content', PageContent);

function styles$f() {
    return i$5 `
		:host {
			--m-pagination-border-radius: ${getToken$1('border-radius-none')};

			--m-pagination-border-top-left-radius: var(--m-pagination-border-radius);
			--m-pagination-border-top-right-radius: var(--m-pagination-border-radius);
			--m-pagination-border-bottom-left-radius: var(
				--m-pagination-border-radius
			);
			--m-pagination-border-bottom-right-radius: var(
				--m-pagination-border-radius
			);

			--m-pagination-border-width: ${getToken$1('border-thin')};
			--m-pagination-border-color: ${getColor('color-border')};
			--m-pagination-border-style: solid;
			--m-pagination-background-color: ${getColor('color-background-primary')};

			display: block;
			width: 100%;

			box-sizing: border-box;

			background-color: var(--m-pagination-background-color);
			border-start-start-radius: var(--m-pagination-border-top-left-radius);
			border-start-end-radius: var(--m-pagination-border-top-right-radius);
			border-end-start-radius: var(--m-pagination-border-bottom-left-radius);
			border-end-end-radius: var(--m-pagination-border-bottom-right-radius);
			border-style: var(--m-pagination-border-style);
			border-width: var(--m-pagination-border-width);
			border-color: var(--m-pagination-border-color);

			text-align: left;

			padding: ${getToken$1('spacing-4')};
		}

		.actions m-button {
			--m-button-base-size: 1rem;
		}

		.icon {
			--m-icon-color: ${getColor('color-text-tertiary')};
		}

		[disabled] .icon {
			--m-icon-color: ${getColor('color-text-disabled')};
		}
	`;
}

const FIST_PAGE = 0;
const DEFAULT_PAGE_SIZE = 100;
class Pagination extends Component {
    static get properties() {
        return {
            count: { type: Number },
            page: { type: Number },
            pageSize: { type: Number, attribute: 'page-size' },
            disabled: { type: Boolean },
        };
    }
    constructor() {
        super();
        this.goToPrev = () => {
            if (this.hasPrev()) {
                this.setPage(this.getPage() - 1);
                this.handleChange();
            }
        };
        this.page = FIST_PAGE;
        this.pageSize = DEFAULT_PAGE_SIZE;
        this.disabled = false;
        this.count = 0;
    }
    getPage() {
        return Math.min(Math.max(this.page, 0), this.lastPage);
    }
    setPage(page) {
        this.page = page;
    }
    getPageSize() {
        return Math.max(1, this.pageSize);
    }
    get totalPages() {
        return Math.ceil(this.count / this.getPageSize());
    }
    get lastPage() {
        return this.totalPages - 1;
    }
    get pageLabel() {
        return `${this.getPage() + 1}`;
    }
    hasPrev() {
        return this.getPage() > FIST_PAGE;
    }
    hasNext() {
        return this.getPage() < this.lastPage;
    }
    goToNext() {
        if (this.hasNext()) {
            this.setPage(this.getPage() + 1);
            this.handleChange();
        }
    }
    goToLast() {
        if (this.hasNext()) {
            this.setPage(this.lastPage);
            this.handleChange();
        }
    }
    goToFist() {
        if (this.hasPrev()) {
            this.setPage(FIST_PAGE);
            this.handleChange();
        }
    }
    handleChange() {
        this.emit('m-change', {
            detail: {
                page: this.getPage(),
                pageSize: this.getPageSize(),
            },
        });
    }
    isPrevDisabled() {
        return this.disabled || !this.hasPrev();
    }
    isNextDisabled() {
        return this.disabled || !this.hasNext();
    }
    renderActions() {
        return x `
			<m-group gap="spacing-4" align="center" class="actions">
				<m-button
					title="go to the first page"
					variant="icon-secondary"
					size="small"
					class="m-pagination-first"
					@click=${this.goToFist}
					?disabled=${this.isPrevDisabled()}
				>
					<m-icon
						aria-label="go to the first page"
						name="double-caret-left"
						class="icon"
					></m-icon>
				</m-button>
				<m-button
					title="go to the previous page"
					variant="icon-secondary"
					size="small"
					class="m-pagination-prev"
					@click=${this.goToPrev}
					?disabled=${this.isPrevDisabled()}
				>
					<m-icon
						aria-label="go to the previous page"
						name="caret-left"
						class="icon"
					></m-icon>
				</m-button>

				<m-group gap="spacing-2" align="center">
					<m-text color="color-text-tertiary">${this.pageLabel}</m-text>
					<m-text color="color-text-tertiary">of</m-text>
					<m-text color="color-text-tertiary">${this.totalPages}</m-text>
				</m-group>

				<m-button
					title="go to the next page"
					variant="icon-secondary"
					size="small"
					class="m-pagination-next"
					@click=${this.goToNext}
					?disabled=${this.isNextDisabled()}
				>
					<m-icon
						aria-label="go to the next page"
						name="caret-right"
						class="icon"
					></m-icon>
				</m-button>
				<m-button
					title="go to the last page"
					variant="icon-secondary"
					size="small"
					class="m-pagination-last"
					@click=${this.goToLast}
					?disabled=${this.isNextDisabled()}
				>
					<m-icon
						aria-label="go to the last page"
						name="double-caret-right"
						class="icon"
					></m-icon>
				</m-button>
			</m-group>
		`;
    }
    render() {
        return x `
			<m-group class="m-pagination" justify="space-between" align="center">
				<m-text color="color-text-tertiary">${this.count} items</m-text>
				${this.renderActions()}
			</m-group>
		`;
    }
}
Pagination.styles = [styles$f()];
window.customElements.define('m-pagination', Pagination);

/**
 * Clamps number within the inclusive `min` and `upper` bounds.
 * @param {number} value - The number to clamp.
 * @param {number} lower - The lower bound.
 * @param {number} upper - The upper bound.
 * @returns {number}
 */
function clamp(value, lower, upper) {
    return Math.min(Math.max(lower, value), upper);
}

function styles$e() {
    return i$5 `
		.bar {
			display: flex;
			flex-grow: 0;
			flex-shrink: 1;
			align-items: center;
			justify-content: center;

			position: relative;
			overflow: hidden;

			width: 100%;
			height: ${toRem('8px')};

			border-radius: ${getToken$1('border-radius-s')};
			background-color: ${getColor('color-background-tertiary')};
		}

		.progress {
			position: absolute;
			top: 0;
			left: 0;

			${transition([{ property: 'width' }, { property: 'background' }])};

			height: ${toRem('8px')};

			border-radius: ${getToken$1('border-radius-s')};

			background: var(--m-progress-bar-progress-background);
		}

		.-default {
			--m-progress-bar-progress-background: linear-gradient(
				45deg,
				${getColor('color-brand-accent-1')} 22%,
				${getColor('color-brand-accent-2')} 88%
			);
		}

		.-success {
			--m-progress-bar-progress-background: ${getColor('color-success-60')};
		}

		.-warning {
			--m-progress-bar-progress-background: ${getColor('color-warning-60')};
		}

		.-danger {
			--m-progress-bar-progress-background: ${getColor('color-danger-60')};
		}
	`;
}

var _ProgressBar_instances, _ProgressBar_safeMaxValue_get, _ProgressBar_safeValue_get;
const DEFAULT_VARIANT = 'default';
const DEFAULT_MAX = 100;
const DEFAULT_MIN = 0;
const DEFAULT_VALUE = 0;
class ProgressBar extends s$7 {
    static get properties() {
        return {
            variant: { type: String, reflect: true },
            value: { type: Number, reflect: true },
            max: { type: Number, reflect: true },
        };
    }
    constructor() {
        super();
        _ProgressBar_instances.add(this);
        this.variant = DEFAULT_VARIANT;
        this.value = DEFAULT_VALUE;
        this.max = DEFAULT_MAX;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'progressbar');
        this.setAttribute('aria-valuemin', '0');
    }
    updated() {
        this.setAttribute('aria-valuenow', String(this.value));
        this.setAttribute('aria-valuemax', String(this.max));
    }
    get percentage() {
        return (__classPrivateFieldGet$1(this, _ProgressBar_instances, "a", _ProgressBar_safeValue_get) * 100) / __classPrivateFieldGet$1(this, _ProgressBar_instances, "a", _ProgressBar_safeMaxValue_get);
    }
    get currentVariant() {
        return this.variant;
    }
    render() {
        return x `
			<div class="bar">
				<span
					class=${o$2({
            progress: true,
            '-default': this.currentVariant === 'default',
            '-success': this.currentVariant === 'success',
            '-warning': this.currentVariant === 'warning',
            '-danger': this.currentVariant === 'danger',
        })}
					style=${o$1({
            width: `${this.percentage}%`,
        })}
				></span>
			</div>
		`;
    }
}
_ProgressBar_instances = new WeakSet(), _ProgressBar_safeMaxValue_get = function _ProgressBar_safeMaxValue_get() {
    return this.max <= 0 ? DEFAULT_MAX : this.max;
}, _ProgressBar_safeValue_get = function _ProgressBar_safeValue_get() {
    return clamp(this.value, DEFAULT_MIN, __classPrivateFieldGet$1(this, _ProgressBar_instances, "a", _ProgressBar_safeMaxValue_get));
};
ProgressBar.styles = [styles$e()];
window.customElements.define('m-progress-bar', ProgressBar);

class ProgressBarCountdown extends ProgressBar {
    get currentVariant() {
        if (this.percentage >= 66)
            return 'success';
        if (this.percentage >= 33)
            return 'warning';
        return 'danger';
    }
}
window.customElements.define('m-progress-bar-countdown', ProgressBarCountdown);

const RADIO_EVENT = 'm-check';

function styles$d() {
    return i$5 `
		:host {
			--m-radio-border-color: ${getColor('color-border-input')};
			--m-radio-dot-check-color: ${getColor('color-primary-60')};
			--m-radio-size: 14px;
			--m-radio-background-color: ${getColor('color-background-primary')};
			--m-radio-border-width: ${getToken$1('border-thin')};
			--m-radio-label-color: ${getColor('color-text-tertiary')};
			--m-radio-outline-color: ${getColor('color-primary-60')};
			--m-radio-outline-offset: 2px;
		}

		.radio-button {
			${typography('body-md')};
			color: var(--m-radio-label-color);

			border: none;
			background: none;

			height: ${getToken$1('global-height-small')};
			display: inline-flex;
			gap: ${getToken$1('spacing-1')};
			align-items: center;
			border-radius: ${getToken$1('border-radius-s')};
			${transition({ property: 'color' })};
		}

		${on('.radio-button').not.disabled.focus} {
			outline: 1px solid var(--m-radio-outline-color);
			outline-offset: var(--m-radio-outline-offset);
		}

		.radio-button .radio-input {
			width: var(--m-radio-size);
			height: var(--m-radio-size);
			background-color: var(--m-radio-background-color);
			border-color: var(--m-radio-border-color);
			border-width: var(--m-radio-border-width);
			border-style: solid;
			border-radius: 50%;
			position: relative;
			display: inline-flex;

			${transition({ property: 'border-color' })};
		}

		.radio-button .radio-input::before {
			content: '';
			width: 0;
			height: 0;
			border-radius: 50%;
			transform: translate(-50%, -50%);
			top: 50%;
			left: 50%;
			display: block;
			position: absolute;
			${transition([
        { property: 'background-color' },
        { property: 'height', duration: '120ms' },
        { property: 'width', duration: '120ms' },
    ])};
		}

		.radio-button[aria-checked='true'] .radio-input::before {
			width: 10px;
			height: 10px;
		}

		${on('.radio-button').disabled} {
			cursor: default;
			--m-radio-label-color: ${getColor('color-text-disabled')};
			--m-radio-background-color: ${getColor('color-background-tertiary')};
		}

		${on('.radio-button[aria-checked="true"]', '.radio-input').disabled} {
			--m-radio-border-color: ${getColor('color-border-input')};
		}

		${on('.radio-button', '.radio-input::before').disabled} {
			--m-radio-dot-check-color: ${getColor('color-neutral-40')};
		}

		.radio-button .radio-input::before {
			background-color: var(--m-radio-dot-check-color);
		}

		.radio-button[aria-checked='true'] .radio-input {
			--m-radio-dot-check-color: ${getColor('color-primary-60')};
			--m-radio-border-color: ${getColor('color-primary-60')};
		}

		.radio-button .radio-input {
			--m-radio-border-color: ${getColor('color-border-input')};
		}

		${on('.radio-button').not.disabled.hover} .radio-input {
			--m-radio-border-color: ${getColor('color-primary-100')};
			--m-radio-dot-check-color: ${getColor('color-primary-100')};
		}

		${on('.radio-button').not.disabled.hover} {
			--m-radio-label-color: ${getColor('color-text-primary')};
		}

		${on('.radio-button', '*').disabled} {
			pointer-events: none;
		}
	`;
}

const radioGroupContext = n$1(Symbol('radio-group'));

var _Radio_instances, _Radio_context, _Radio_button_get, _Radio_isDisabled, _Radio_handleClick, _Radio_setDisabled, _Radio_setChecked;
class Radio extends s$7 {
    static get properties() {
        return {
            value: { type: String },
            disabled: { type: Boolean, reflect: true },
            checked: { type: Boolean, reflect: true },
        };
    }
    constructor() {
        super();
        _Radio_instances.add(this);
        _Radio_context.set(this, void 0);
        _Radio_handleClick.set(this, (event) => {
            if (this.disabled) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            const options = {
                detail: { value: this.value, type: 'select' },
                bubbles: true,
                composed: false,
            };
            this.dispatchEvent(new CustomEvent(RADIO_EVENT, options));
        });
        _Radio_setDisabled.set(this, () => {
            this.setAttribute('aria-disabled', String(__classPrivateFieldGet$1(this, _Radio_instances, "m", _Radio_isDisabled).call(this)));
        });
        _Radio_setChecked.set(this, () => {
            this.setAttribute('aria-checked', String(this.checked ?? false));
        });
        this.disabled = false;
        this.checked = false;
        __classPrivateFieldSet(this, _Radio_context, new s$1(this, {
            context: radioGroupContext,
            subscribe: true,
            callback: () => {
                __classPrivateFieldGet$1(this, _Radio_setDisabled, "f").call(this);
            },
        }), "f");
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'radio');
        this.addEventListener('click', __classPrivateFieldGet$1(this, _Radio_handleClick, "f"));
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('disabled')) {
            __classPrivateFieldGet$1(this, _Radio_setDisabled, "f").call(this);
        }
        if (changedProperties.has('checked')) {
            __classPrivateFieldGet$1(this, _Radio_setChecked, "f").call(this);
        }
    }
    render() {
        return x `
			<button
				type="button"
				class="radio-button"
				role="radio"
				?disabled=${__classPrivateFieldGet$1(this, _Radio_instances, "m", _Radio_isDisabled).call(this)}
				aria-checked=${this.checked}
			>
				<span class="radio-input"></span>
				<slot name="leading"></slot>
				<slot></slot>
			</button>
		`;
    }
    focus(options) {
        __classPrivateFieldGet$1(this, _Radio_instances, "a", _Radio_button_get)?.focus(options);
    }
}
_Radio_context = new WeakMap(), _Radio_handleClick = new WeakMap(), _Radio_setDisabled = new WeakMap(), _Radio_setChecked = new WeakMap(), _Radio_instances = new WeakSet(), _Radio_button_get = function _Radio_button_get() {
    return this.renderRoot?.querySelector('button') ?? null;
}, _Radio_isDisabled = function _Radio_isDisabled() {
    return Boolean(__classPrivateFieldGet$1(this, _Radio_context, "f").value?.disabled || this.hasAttribute('disabled'));
};
Radio.styles = [styles$d()];
window.customElements.define('m-radio', Radio);

const select = (values, selection) => {
    const safeValues = toArray(values);
    if (safeValues.length === 0) {
        return selection;
    }
    // We always start with an empty set, as we are handling single selection
    const newSelection = new Set();
    newSelection.add(String(safeValues.at(-1)));
    return newSelection;
};
const selectMultiple = (values, selection) => {
    const safeValues = toArray(values);
    if (safeValues.length === 0) {
        return selection;
    }
    const newSelection = new Set(selection);
    for (const safeValue of safeValues) {
        newSelection.add(String(safeValue));
    }
    return newSelection;
};
const singleSelectionStrategy = {
    type: 'single',
    init(values) {
        return select(values, new Set());
    },
    select,
    unselect(values, selection) {
        const safeValues = toArray(values);
        if (safeValues.length === 0 || selection.size === 0) {
            return selection;
        }
        const newSelection = new Set(selection);
        for (const safeValue of safeValues) {
            newSelection.delete(String(safeValue));
        }
        return newSelection;
    },
    toggle(values, selection) {
        const safeValues = toArray(values);
        if (safeValues.length === 0) {
            return selection;
        }
        const newSelection = new Set();
        for (const safeValue of safeValues) {
            const value = String(safeValue);
            if (!selection.has(value)) {
                newSelection.clear();
                newSelection.add(value);
            }
        }
        return newSelection;
    },
    reset(selection) {
        if (selection == null) {
            return new Set();
        }
        return selection;
    },
    value(selection) {
        if (selection == null || selection.size === 0) {
            return null;
        }
        const [first] = Array.from(selection);
        return first;
    },
};
const singleStrictSelectionStrategy = {
    type: 'single-strict',
    init(values) {
        return select(values, new Set());
    },
    select,
    unselect(values, selection) {
        const safeValues = toArray(values);
        if (safeValues.length === 0 || selection.size === 0) {
            return selection;
        }
        const newSelection = new Set(selection);
        for (let i = 0; i < safeValues.length && selection.size > 1; i++) {
            newSelection.delete(String(safeValues[i]));
        }
        return newSelection;
    },
    toggle(values, selection) {
        const safeValues = toArray(values);
        if (safeValues.length === 0) {
            return selection;
        }
        const newSelection = new Set(selection);
        for (const safeValue of safeValues) {
            const value = String(safeValue);
            if (!selection.has(value)) {
                newSelection.clear();
                newSelection.add(value);
            }
        }
        return newSelection;
    },
    reset(selection) {
        if (selection == null) {
            return new Set();
        }
        return selection;
    },
    value(selection) {
        if (selection == null || selection.size === 0) {
            return null;
        }
        const [first] = Array.from(selection);
        return first;
    },
};
const multipleSelectionStrategy = {
    type: 'multiple',
    init(values) {
        return selectMultiple(values, new Set());
    },
    select: selectMultiple,
    unselect(values, selection) {
        const safeValues = toArray(values);
        if (safeValues.length === 0 || selection.size === 0) {
            return selection;
        }
        const newSelection = new Set(selection);
        for (const safeValue of safeValues) {
            newSelection.delete(String(safeValue));
        }
        return newSelection;
    },
    toggle(values, selection) {
        const safeValues = toArray(values);
        if (safeValues.length === 0) {
            return selection;
        }
        const newSelection = new Set(selection);
        for (const safeValue of safeValues) {
            const value = String(safeValue);
            if (selection.has(value)) {
                newSelection.delete(value);
            }
            else {
                newSelection.add(value);
            }
        }
        return newSelection;
    },
    reset(selection) {
        if (selection == null) {
            return new Set();
        }
        return selection;
    },
    value(selection) {
        if (selection == null || selection.size === 0) {
            return null;
        }
        return Array.from(selection);
    },
};
/**
 * This strategy requires one or no item to be selected.
 */
const SingleSelectionStrategy = () => {
    return singleSelectionStrategy;
};
/**
 * This strategy requires that once a selection is made,
 * one item has to be selected, always.
 */
const SingleStrictSelectionStrategy = () => {
    return singleStrictSelectionStrategy;
};
/**
 * This strategy requires one or no item to be selected.
 */
const MultipleSelectionStrategy = () => {
    return multipleSelectionStrategy;
};
function createSelectionStrategy(props) {
    const { type = 'multiple' } = props;
    if (type === 'single') {
        return SingleSelectionStrategy();
    }
    if (type === 'single-strict') {
        return SingleStrictSelectionStrategy();
    }
    return MultipleSelectionStrategy();
}

var _SelectionController_instances, _SelectionController_handleSelectionEvent, _SelectionController_publish;
/**
 * Manage selection through the SelectionStrategy.
 * `host` is expected to have a `selection` and a `type` (`SelectionType`) properties/state.
 */
class SelectionController {
    /**
     *
     * @param {SelectionHost} host
     * @param {SelectionType} type - Type of selection to be managed.
     * @param {string} event - Name of the event that should be listened to.
     */
    constructor(host, type, event) {
        _SelectionController_instances.add(this);
        this.disabled = false;
        this.event = 'm-select';
        /**
         * using arrow function so we keep the lexical context this is necessary
         * because the event itself will happen in the context of the host element.
         */
        _SelectionController_handleSelectionEvent.set(this, (e) => {
            if (this.disabled) {
                return;
            }
            if (this.type == null) {
                console.warn('[SelectionController] Did you forget to set the selection type?');
                return;
            }
            // Stops the internal event propagation.
            e.stopPropagation();
            const { detail: { type, value }, } = e;
            switch (type) {
                case 'select':
                    this.select(toArray(value));
                    break;
                case 'unselect':
                    this.unselect(toArray(value));
                    break;
                case 'toggle':
                    this.toggle(toArray(value));
                    break;
            }
        });
        this.init = (values) => {
            this.host.selection = this.strategy.init(values);
        };
        this.select = (values) => {
            this.host.selection = this.strategy.select(values, this.host.selection);
            __classPrivateFieldGet$1(this, _SelectionController_instances, "m", _SelectionController_publish).call(this);
        };
        this.unselect = (values) => {
            this.host.selection = this.strategy.unselect(values, this.host.selection);
            __classPrivateFieldGet$1(this, _SelectionController_instances, "m", _SelectionController_publish).call(this);
        };
        this.toggle = (values) => {
            this.host.selection = this.strategy.toggle(values, this.host.selection);
            __classPrivateFieldGet$1(this, _SelectionController_instances, "m", _SelectionController_publish).call(this);
        };
        this.subscribe = () => {
            this.host.addEventListener(this.event, __classPrivateFieldGet$1(this, _SelectionController_handleSelectionEvent, "f"));
        };
        this.unsubscribe = () => {
            this.host.removeEventListener(this.event, __classPrivateFieldGet$1(this, _SelectionController_handleSelectionEvent, "f"));
        };
        this.host = host;
        this.type = type;
        this.event = event;
        this.strategy = createSelectionStrategy({ type });
        this.host.addController(this);
    }
    hostConnected() {
        this.subscribe();
    }
    hostDisconnected() {
        this.unsubscribe();
    }
    hostUpdate() {
        /**
         * [!] This flow covers the case where the `host` changes its selection strategy (`type`).
         * The `hostUpdate` lifecycle happens before the `host`'s `update` [Source](https://lit.dev/docs/composition/controllers/#lifecycle).
         */
        if (this.host.type != null && this.host.type !== this.type) {
            this.unsubscribe();
            this.host.removeController(this);
        }
    }
}
_SelectionController_handleSelectionEvent = new WeakMap(), _SelectionController_instances = new WeakSet(), _SelectionController_publish = function _SelectionController_publish() {
    const options = {
        detail: {
            type: this.type,
            value: this.strategy.value(this.host.selection),
        },
        bubbles: true,
        composed: false,
    };
    this.host.dispatchEvent(new CustomEvent('m-change', options));
};

function styles$c() {
    return i$5 `
		.radio-group {
			display: flex;
			gap: ${getToken$1('spacing-2')};
		}
		.radio-group.-vertical {
			flex-direction: column;
		}
		.radio-group.-horizontal {
			flex-direction: row;
		}
	`;
}

var _RadioGroup_selectionController, _RadioGroup_defaultSlot, _RadioGroup_contextProvider, _RadioGroup_getDefaultChecked, _RadioGroup_getButtons, _RadioGroup_setButtonChecked;
attachContextRoot();
class RadioGroup extends s$7 {
    static get properties() {
        return {
            value: { type: String, reflect: true },
            disabled: { type: Boolean, reflect: true },
            selection: { state: true },
            orientation: { type: String },
        };
    }
    constructor() {
        super();
        _RadioGroup_selectionController.set(this, null);
        _RadioGroup_defaultSlot.set(this, null);
        _RadioGroup_contextProvider.set(this, new i(this, {
            context: radioGroupContext,
            initialValue: {
                disabled: false,
            },
        }));
        _RadioGroup_getDefaultChecked.set(this, () => {
            /**
             * If no radio component is marked as checked, set the first one as checked and return its value
             */
            const buttons = __classPrivateFieldGet$1(this, _RadioGroup_getButtons, "f").call(this);
            return buttons[0]?.value;
        });
        _RadioGroup_getButtons.set(this, () => {
            if (!__classPrivateFieldGet$1(this, _RadioGroup_defaultSlot, "f")) {
                __classPrivateFieldSet(this, _RadioGroup_defaultSlot, this.shadowRoot && this.shadowRoot.querySelector('slot'), "f");
            }
            const items = __classPrivateFieldGet$1(this, _RadioGroup_defaultSlot, "f")?.assignedElements({ flatten: true }) ?? [];
            return [...items].filter((item) => item.tagName.toLowerCase() === 'm-radio');
        });
        _RadioGroup_setButtonChecked.set(this, (button) => {
            // eslint-disable-next-line no-param-reassign
            button.checked = this.selection.has(button.value);
        });
        this.disabled = false;
        this.selection = new Set();
        this.value = '';
        this.orientation = 'vertical';
        this.type = 'single-strict';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'radio-group');
        __classPrivateFieldSet(this, _RadioGroup_selectionController, new SelectionController(this, this.type, RADIO_EVENT), "f");
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('value') && __classPrivateFieldGet$1(this, _RadioGroup_selectionController, "f")) {
            __classPrivateFieldGet$1(this, _RadioGroup_selectionController, "f").init(toArray(this.value || __classPrivateFieldGet$1(this, _RadioGroup_getDefaultChecked, "f").call(this)));
        }
        if (changedProperties.has('selection')) {
            [this.value] = this.selection;
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('selection')) {
            __classPrivateFieldGet$1(this, _RadioGroup_getButtons, "f").call(this).forEach((toggle) => {
                __classPrivateFieldGet$1(this, _RadioGroup_setButtonChecked, "f").call(this, toggle);
            });
        }
        if (changedProperties.has('disabled')) {
            __classPrivateFieldGet$1(this, _RadioGroup_contextProvider, "f").setValue({
                disabled: Boolean(this.disabled),
            });
        }
    }
    render() {
        return x `
			<div
				class=${o$2({
            'radio-group': true,
            '-vertical': this.orientation === 'vertical',
            '-horizontal': this.orientation === 'horizontal',
        })}
			>
				<slot></slot>
			</div>
		`;
    }
}
_RadioGroup_selectionController = new WeakMap(), _RadioGroup_defaultSlot = new WeakMap(), _RadioGroup_contextProvider = new WeakMap(), _RadioGroup_getDefaultChecked = new WeakMap(), _RadioGroup_getButtons = new WeakMap(), _RadioGroup_setButtonChecked = new WeakMap();
RadioGroup.styles = [styles$c()];
window.customElements.define('m-radio-group', RadioGroup);

function styles$b() {
    return i$5 `
		:host {
			display: block;
		}
	`;
}
function sectionTitleStyles() {
    return i$5 `
		:host {
			color: ${getColor('color-text-primary')};
			display: block;
		}

		slot[name='leading']::slotted(*) {
			display: inline-flex;
			flex-flow: row nowrap;
			align-items: center;
			justify-content: center;
			pointer-events: none;
			margin-inline-end: ${getToken$1('spacing-1')};
		}

		.title {
			height: 100%;
			width: 100%;
		}

		.-size-small {
			${typography('heading-sm')};
			margin: 0 0 ${getToken$1('spacing-1')} 0;
		}
		.-size-default {
			${typography('heading-md')};
			margin: 0 0 ${getToken$1('spacing-2')} 0;
		}
		.-size-large {
			${typography('heading-lg-bold')};
			margin: 0 0 ${getToken$1('spacing-2')} 0;
		}
	`;
}

class Section extends s$7 {
    render() {
        return x `
			<slot name="title"></slot>
			<m-divider></m-divider>
			<slot></slot>
		`;
    }
}
Section.styles = [styles$b()];
window.customElements.define('m-section', Section);

/* eslint-disable lit/binding-positions, lit/no-invalid-html  */
const allowedTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span'];
class SectionTitle extends PolymorphicTagMixin({
    superClass: s$7,
    allowedTags,
    fallbackTag: 'span',
}) {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
            size: { type: String },
        };
    }
    constructor() {
        super();
        // this sets the slot to which the section-title should be assigned inside the section component.
        this.slot = 'title';
        this.size = 'default';
        this.as = 'span';
    }
    render() {
        return n$3 `<${this.tag} class=${o$2({
            title: true,
            '-size-small': this.size === 'small',
            '-size-default': this.size === 'default',
            '-size-large': this.size === 'large',
        })}>
			<slot name="leading"></slot>
			<slot></slot>
		</${this.tag}>`;
    }
}
SectionTitle.styles = [sectionTitleStyles()];
window.customElements.define('m-section-title', SectionTitle);

function styles$a() {
    return i$5 `
		:host {
			inline-size: var(--m-spinner-size);
			block-size: var(--m-spinner-size);
		}

		:host svg {
			height: 100%;
			width: 100%;
			animation: rotate 1.5s linear infinite;
		}

		@keyframes rotate {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(359deg);
			}
		}
	`;
}

const DEFAULT_SIZE$1 = 48;
class SpinnerWheel extends s$7 {
    static get properties() {
        return {
            size: { type: String },
        };
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('size') && this.size != null) {
            this.style.setProperty('--m-spinner-size', `${parseInt(String(this.size), 10) || DEFAULT_SIZE$1}px`);
        }
    }
    render() {
        return b$1 `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill="#CADBDD" fill-rule="evenodd" d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Zm0-10c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14Z" clip-rule="evenodd"/><path fill="url(#a)" d="M24 43.068c0 2.724-2.231 4.983-4.898 4.427a23.999 23.999 0 0 1 0-46.99C21.77-.051 24 2.208 24 4.932c0 2.723-2.273 4.852-4.833 5.783a14.135 14.135 0 0 0-5.163 23.28 14.135 14.135 0 0 0 5.163 3.29c2.56.93 4.833 3.06 4.833 5.783Z"/><defs><linearGradient id="a" x1="9.608" x2="44.189" y1="42.161" y2="7.59" gradientUnits="userSpaceOnUse"><stop offset=".1" stop-color="#00D7D7"/><stop offset="1" stop-color="#84F11E"/></linearGradient></defs></svg>`;
    }
}
SpinnerWheel.styles = [styles$a()];
window.customElements.define('m-spinner-wheel', SpinnerWheel);

function stepsStyles() {
    return [
        i$5 `
			:host {
				--m-steps-circle-size: 24px;

				display: flex;
				flex-direction: column;
				box-sizing: border-box;
				gap: ${getToken$1('spacing-10')};

				width: 100%;
			}

			::slotted(m-step) {
				flex: 1;
			}

			.steps-container {
				display: flex;
				flex-flow: row nowrap;
				justify-content: center;
				align-items: center;

				gap: ${getToken$1('spacing-10')};
			}
		`,
    ];
}
function stepStyles() {
    return [
        i$5 `
			:host {
				--m-steps-circle-margin-inline-end: 8px;

				position: relative;
				display: inline-flex;
				flex-direction: column;
				align-items: center;

				gap: ${getToken$1('spacing-4')};
			}

			:host(:is(:focus, :focus-within, :focus-visible)) {
				outline: none;
			}

			.circle {
				${typography('number-md')};
				${transition([{ property: 'background-color' }])};

				display: flex;
				align-items: center;
				justify-content: center;

				inline-size: var(--m-steps-circle-size);
				block-size: var(--m-steps-circle-size);
				line-height: var(--m-steps-circle-size);

				border-radius: 50%;

				background-color: ${getColor('color-neutral-40')};
				color: ${getColor('color-text-inverted')};
			}

			.label {
				${typography('body-md')};

				display: flex;
				align-items: center;
				justify-content: center;

				color: ${getColor('color-primary-60')};
			}

			:host(:not(:last-of-type))::after,
			:host(:not(:first-of-type))::before {
				${transition([{ property: 'background-color' }])};

				content: '';
				position: absolute;
				display: inline-block;

				block-size: 2px;
				inline-size: 100%;
				background-color: ${getColor('color-neutral-40')};

				top: calc(var(--m-steps-circle-size) / 2);
			}

			:host::after {
				/* half width of the container + half circle + distance between bar and circle */
				left: calc(
					50% + var(--m-steps-circle-size) / 2 +
						var(--m-steps-circle-margin-inline-end)
				);
			}

			:host::before {
				right: calc(
					50% + var(--m-steps-circle-size) / 2 +
						var(--m-steps-circle-margin-inline-end)
				);
			}

			:host([completed])::after {
				background-color: ${getColor('color-primary-60')};
				color: ${getColor('color-text-inverted')};
			}

			:host(:is([completed], [aria-current='step']))::before {
				background-color: ${getColor('color-primary-60')};
				color: ${getColor('color-text-inverted')};
			}

			m-icon[name='check'] {
				display: none;
			}

			:host([completed]:not([aria-current='step'])) m-icon[name='check'] {
				--m-icon-color: ${getColor('color-text-inverted')};

				display: inline-flex;
			}

			:host(:is([aria-current='step'], [completed])) .circle {
				background-color: ${getColor('color-primary-60')};
			}

			:host([aria-current='step']) .label {
				${typography('body-md-bold')};
			}

			:host(:is([aria-current='step'], :not([completed]))) .label {
				display: inline-flex;
			}
		`,
    ];
}

var _Steps_instances, _Steps_stepSequence, _Steps_getDefaultActive, _Steps_queryStep, _Steps_handleSlotChange, _Steps_findStepIndex, _Steps_onNextStep, _Steps_onPreviousStep, _Steps_onNavigateStep, _Steps_onCompleteStep;
class Steps extends Component {
    constructor() {
        super(...arguments);
        _Steps_instances.add(this);
        _Steps_stepSequence.set(this, []);
        _Steps_getDefaultActive.set(this, () => {
            return this.querySelector('m-step')?.name;
        });
        _Steps_queryStep.set(this, (name) => {
            if (!name) {
                return null;
            }
            return this.querySelector(`[name="${name}"]`);
        });
        _Steps_handleSlotChange.set(this, () => {
            const steps = Array.from(this.querySelectorAll('m-step'));
            __classPrivateFieldSet(this, _Steps_stepSequence, [], "f");
            steps.forEach((step, index) => {
                __classPrivateFieldGet$1(this, _Steps_stepSequence, "f").push(step.name);
                step.setAttribute('order', String(index + 1));
            });
            this.requestUpdate();
        });
        _Steps_onNextStep.set(this, () => {
            const activeStepIndex = __classPrivateFieldGet$1(this, _Steps_instances, "m", _Steps_findStepIndex).call(this, this.activeStep);
            if (activeStepIndex === -1 ||
                activeStepIndex >= __classPrivateFieldGet$1(this, _Steps_stepSequence, "f").length - 1) {
                return;
            }
            const newActiveStepIndex = activeStepIndex + 1;
            this.activeStep = __classPrivateFieldGet$1(this, _Steps_stepSequence, "f")[newActiveStepIndex];
            this.emit('m-change', { detail: { active: this.activeStep } });
        });
        _Steps_onPreviousStep.set(this, () => {
            const activeStepIndex = __classPrivateFieldGet$1(this, _Steps_instances, "m", _Steps_findStepIndex).call(this, this.activeStep);
            if (activeStepIndex <= 0) {
                return;
            }
            const newActiveStepIndex = activeStepIndex - 1;
            this.activeStep = __classPrivateFieldGet$1(this, _Steps_stepSequence, "f")[newActiveStepIndex];
            this.emit('m-change', { detail: { active: this.activeStep } });
        });
        _Steps_onNavigateStep.set(this, (event) => {
            const { detail: newStep } = event;
            const newActiveStepIndex = __classPrivateFieldGet$1(this, _Steps_instances, "m", _Steps_findStepIndex).call(this, newStep);
            if (newActiveStepIndex === -1 || newStep === this.activeStep) {
                return;
            }
            this.activeStep = newStep;
            this.emit('m-change', { detail: { active: newStep } });
        });
        _Steps_onCompleteStep.set(this, () => {
            const completedStep = __classPrivateFieldGet$1(this, _Steps_queryStep, "f").call(this, this.activeStep);
            if (completedStep && completedStep.completed !== true) {
                // TODO: should we check the all the previous steps are completed or trust the event emitter knows that?
                completedStep.completed = true;
                this.emit('m-change', { detail: { completed: this.activeStep } });
            }
        });
    }
    static get properties() {
        return {
            activeStep: { type: String, attribute: 'active-step', reflect: true },
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('m-next', __classPrivateFieldGet$1(this, _Steps_onNextStep, "f"));
        this.addEventListener('m-previous', __classPrivateFieldGet$1(this, _Steps_onPreviousStep, "f"));
        this.addEventListener('m-navigate', __classPrivateFieldGet$1(this, _Steps_onNavigateStep, "f"));
        this.addEventListener('m-complete', __classPrivateFieldGet$1(this, _Steps_onCompleteStep, "f"));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('m-next', __classPrivateFieldGet$1(this, _Steps_onNextStep, "f"));
        this.removeEventListener('m-previous', __classPrivateFieldGet$1(this, _Steps_onPreviousStep, "f"));
        this.removeEventListener('m-navigate', __classPrivateFieldGet$1(this, _Steps_onNavigateStep, "f"));
        this.removeEventListener('m-complete', __classPrivateFieldGet$1(this, _Steps_onCompleteStep, "f"));
    }
    update(changedProperties) {
        super.update(changedProperties);
        const previousActiveStep = __classPrivateFieldGet$1(this, _Steps_queryStep, "f").call(this, changedProperties.get('activeStep'));
        if (previousActiveStep) {
            previousActiveStep.removeAttribute('aria-current');
        }
        this.activeStep = this.activeStep ?? __classPrivateFieldGet$1(this, _Steps_getDefaultActive, "f").call(this);
        const currentActiveStep = __classPrivateFieldGet$1(this, _Steps_queryStep, "f").call(this, this.activeStep);
        if (currentActiveStep) {
            currentActiveStep.setAttribute('tabindex', '0');
            currentActiveStep.setAttribute('aria-current', 'step');
        }
    }
    render() {
        return x `<div class="steps-container">
				<slot name="step" @slotchange=${__classPrivateFieldGet$1(this, _Steps_handleSlotChange, "f")}></slot>
			</div>
			<div class="content-container"><slot></slot></div>`;
    }
}
_Steps_stepSequence = new WeakMap(), _Steps_getDefaultActive = new WeakMap(), _Steps_queryStep = new WeakMap(), _Steps_handleSlotChange = new WeakMap(), _Steps_onNextStep = new WeakMap(), _Steps_onPreviousStep = new WeakMap(), _Steps_onNavigateStep = new WeakMap(), _Steps_onCompleteStep = new WeakMap(), _Steps_instances = new WeakSet(), _Steps_findStepIndex = function _Steps_findStepIndex(name) {
    if (!name) {
        return -1;
    }
    return __classPrivateFieldGet$1(this, _Steps_stepSequence, "f").findIndex((value) => value === name);
};
Steps.styles = [stepsStyles()];
window.customElements.define('m-steps', Steps);

class Step extends s$7 {
    static get properties() {
        return {
            name: {
                type: String,
                reflect: true,
            },
            order: {
                type: String,
            },
            completed: {
                type: Boolean,
                reflect: true,
            },
            'aria-current': {
                type: Boolean,
            },
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.slot = 'step';
    }
    render() {
        const isActive = this.getAttribute('aria-current') === 'step';
        return x `
			<span class="circle">
				${this.completed && !isActive ? A$1 : this.order}
				<m-icon name="check" size="12"></m-icon>
			</span>
			<span class="label">
				<slot></slot>
			</span>
		`;
    }
}
Step.styles = [stepStyles()];
window.customElements.define('m-step', Step);

function styles$9() {
    return [
        i$5 `
			:host {
				--m-switch-height: ${getToken$1('global-height-small')};
				--m-switch-background-color: ${getColor('color-neutral-40')};
				--m-switch-outline-color: ${getColor('color-primary-60')};
				--m-switch-outline-offset: 2px;
				--m-switch-thumb-width: 32px;
				--m-switch-thumb-height: 16px;
				--m-switch-circle-distance: 2px;
				--m-switch-circle-size: calc(
					var(--m-switch-thumb-height) - 2 * var(--m-switch-circle-distance)
				);

				${typography('body-md')};

				cursor: pointer;

				display: inline-flex;
				gap: ${getToken$1('spacing-2')};
				align-items: center;

				box-sizing: border-box;
				block-size: var(--m-switch-height);

				color: ${getColor('color-text-tertiary')};
				outline: none;
			}

			:host([size='large']) {
				--m-switch-height: ${getToken$1('global-height-large')};
				--m-switch-thumb-width: 40px;
				--m-switch-thumb-height: 20px;
			}

			:host([disabled]) {
				pointer-events: none;
				user-select: none;

				cursor: default;
			}

			:host([aria-checked='true']) .switch {
				--m-switch-background-color: ${getColor('color-primary-60')};
			}

			:host(:hover) .switch {
				--m-switch-background-color: ${getColor('color-neutral-60')};
			}

			:host([aria-checked='true']:hover) .switch {
				--m-switch-background-color: ${getColor('color-primary-100')};
			}

			:host([disabled]) ::slotted(*) {
				pointer-events: none;
				user-select: none;
			}

			:host([disabled]) .switch {
				--m-switch-background-color: ${getColor('color-primary-20')};
			}

			:host(:is(:focus, :focus-within, :focus-visible, .is-focused)) .switch {
				outline: 1px solid var(--m-switch-outline-color);
				outline-offset: var(--m-switch-outline-offset);
			}

			.switch {
				${transition([{ property: 'background-color' }])};

				background-color: var(--m-switch-background-color);
				border-radius: calc(0.5 * var(--m-switch-thumb-height));

				box-sizing: border-box;
				block-size: var(--m-switch-thumb-height);
				inline-size: var(--m-switch-thumb-width);

				position: relative;
			}

			.switch::after {
				${transition([{ property: 'left' }])};

				content: '';
				display: block;
				position: absolute;

				block-size: var(--m-switch-circle-size);
				inline-size: var(--m-switch-circle-size);
				border-radius: 50%;

				background-color: ${getColor('color-background-primary')};
				left: var(--m-switch-circle-distance);
				top: var(--m-switch-circle-distance);
			}

			:host([aria-checked='true']) .switch::after {
				left: calc(
					100% - var(--m-switch-circle-size) - var(--m-switch-circle-distance)
				);
			}
		`,
    ];
}

var _Switch_instances, _Switch_controllers, _Switch_toggle, _Switch_handleClick;
class Switch extends Component {
    static get properties() {
        return {
            name: { type: String, reflect: true },
            disabled: { type: Boolean, reflect: true },
            checked: { type: Boolean, reflect: true },
            size: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        _Switch_instances.add(this);
        // @ts-expect-error -- 	this is just a wrapper for our controller
        _Switch_controllers.set(this, void 0);
        _Switch_handleClick.set(this, (event) => {
            if (this.disabled) {
                event.stopPropagation();
                event.preventDefault();
                return;
            }
            __classPrivateFieldGet$1(this, _Switch_instances, "m", _Switch_toggle).call(this);
        });
        this.checked = false;
        this.disabled = false;
        __classPrivateFieldSet(this, _Switch_controllers, {
            keyboard: new KeyboardSupportController(this, {
                shortcut: [
                    {
                        key: ' ',
                    },
                    {
                        key: 'Enter',
                    },
                ],
                handler: (event) => {
                    event.stopPropagation();
                    __classPrivateFieldGet$1(this, _Switch_instances, "m", _Switch_toggle).call(this);
                },
            }),
        }, "f");
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'switch');
        this.addEventListener('click', __classPrivateFieldGet$1(this, _Switch_handleClick, "f"));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', __classPrivateFieldGet$1(this, _Switch_handleClick, "f"));
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('checked')) {
            this.setAttribute('aria-checked', String(this.checked ?? false));
        }
        if (changedProperties.has('disabled')) {
            if (this.disabled) {
                this.removeAttribute('tabindex');
            }
            else {
                this.setAttribute('tabindex', '0');
            }
        }
    }
    render() {
        return x `
			<span class="switch"></span>
			<slot></slot>
		`;
    }
}
_Switch_controllers = new WeakMap(), _Switch_handleClick = new WeakMap(), _Switch_instances = new WeakSet(), _Switch_toggle = function _Switch_toggle() {
    this.checked = !this.checked;
    this.emit('m-change', {
        detail: { name: this.name, checked: this.checked },
    });
};
Switch.styles = [styles$9()];
window.customElements.define('m-switch', Switch);

function tableStyles() {
    return i$5 `
		:host {
			--m-table-cell-height: 52px;
			--m-table-border-radius: ${getToken$1('border-radius-s')};

			--m-table-border-top-left-radius: var(--m-table-border-radius);
			--m-table-border-top-right-radius: var(--m-table-border-radius);
			--m-table-border-bottom-left-radius: var(--m-table-border-radius);
			--m-table-border-bottom-right-radius: var(--m-table-border-radius);

			display: flex;
			flex-direction: column;
			width: 100%;
			border-collapse: collapse;

			border-style: solid;
			border-start-start-radius: var(--m-table-border-top-left-radius);
			border-start-end-radius: var(--m-table-border-top-right-radius);
			border-end-start-radius: var(--m-table-border-bottom-left-radius);
			border-end-end-radius: var(--m-table-border-bottom-right-radius);
			border-width: ${getToken$1('border-thin')};
			border-color: ${getColor('color-border')};

			background-color: ${getColor('color-background-primary')};
		}

		::slotted(:not(:first-child)) {
			border-top: ${getToken$1('border-thin')} solid ${getColor('color-divider')};
		}

		::slotted(:first-child) {
			border-start-start-radius: var(--m-table-border-top-left-radius);
			border-start-end-radius: var(--m-table-border-top-right-radius);
		}

		::slotted(:last-child) {
			border-end-start-radius: var(--m-table-border-bottom-left-radius);
			border-end-end-radius: var(--m-table-border-bottom-right-radius);
		}

		.overflow-wrapper {
			display: flex;
			overflow-x: auto;
		}

		.table {
			display: table;
			width: 100%;
		}

		:host([size='small']) {
			--m-table-cell-height: 32px;
			${typography('body-sm')};
		}

		:host([size='default']) {
			--m-table-cell-height: 52px;
			${typography('body-md')};
		}

		:host([size='large']) {
			--m-table-cell-height: 86px;
			${typography('body-md')};
		}
	`;
}
function tableToolbarStyles() {
    return i$5 `
		:host {
			padding: ${getToken$1('spacing-4')};
		}
	`;
}
function tableHeadStyles() {
    return i$5 `
		:host {
			--m-table-cell-height: 44px;

			display: table-header-group;

			background-color: ${getColor('color-background-secondary')};
		}

		slot[name='table-row']::slotted(*) {
			${typography('table-header-sm')};
			color: ${getColor('color-text-tertiary')};
		}
	`;
}
function tableBodyStyles() {
    return i$5 `
		:host {
			display: table-row-group;
		}

		slot[name='table-row']::slotted(*) {
			background-color: ${getColor('color-background-primary')};
			color: ${getColor('color-text-primary')};
		}

		slot[name='table-row']::slotted(*:hover) {
			background-color: ${getColor('color-background-tertiary')};
		}

		::slotted(*:not(:first-child, :only-child)) {
			border-top: ${getToken$1('border-thin')} solid ${getColor('color-divider')};
		}
	`;
}
function tableFootStyles() {
    return i$5 `
		:host {
			--m-table-cell-height: 44px;

			display: table-footer-group;

			background-color: ${getColor('color-background-secondary')};
		}

		slot[name='table-row']::slotted(*) {
			${typography('table-header-sm')};
			color: ${getColor('color-text-tertiary')};
		}
	`;
}
function tableRowStyles() {
    return i$5 `
		:host {
			display: table-row;
		}
	`;
}
function tableCellStyles() {
    return i$5 `
		:host {
			--m-table-cell-text-align: left;
			--m-table-cell-vertical-align: middle;

			display: table-cell;
			box-sizing: border-box;
			height: var(--m-table-cell-height);
			padding-inline-start: ${getToken$1('spacing-4')};
			padding-inline-end: ${getToken$1('spacing-4')};
			vertical-align: var(--m-table-cell-vertical-align);
			text-align: var(--m-table-cell-text-align);
		}
	`;
}
function tableHeadCellStyles() {
    return [
        tableCellStyles(),
        i$5 `
			:host {
				white-space: nowrap;
			}

			:host([sortable]:not([disabled])) {
				cursor: pointer;
			}

			m-icon {
				--m-icon-color: ${getColor('color-text-primary')};
				margin-left: ${getToken$1('spacing-2')};
			}

			:host([disabled]) {
				color: ${getColor('color-text-disabled')};
			}

			:host([disabled]) m-icon {
				--m-icon-color: ${getColor('color-text-disabled')};
			}
		`,
    ];
}
function tableActionsStyles() {
    return i$5 `
		:host {
			background-color: ${getColor('color-background-primary')};
			margin-top: auto;
		}

		::slotted(*:not(:first-child)) {
			border-top: ${getToken$1('border-thin')} solid ${getColor('color-divider')};
		}

		::slotted(:last-child) {
			border-end-start-radius: var(--m-table-border-bottom-left-radius);
			border-end-end-radius: var(--m-table-border-bottom-right-radius);
		}

		::slotted(m-pagination) {
			--m-pagination-border-width: ${getToken$1('border-none')};
			--m-pagination-border-bottom-left-radius: var(
				--m-table-border-bottom-left-radius
			);
			--m-pagination-border-bottom-right-radius: var(
				--m-table-border-bottom-right-radius
			);
		}

		:host([sticky]) {
			position: sticky;
			bottom: 0;
			z-index: 1;
		}
	`;
}

const defaultTableProps = {
    size: 'default',
};
class Table extends s$7 {
    static get properties() {
        return {
            role: { type: String, reflect: true },
            size: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        /**
         * TODO: This component is in reality a container that includes a table, not the table itself.
         * We move this role to the table itself for the next major release to avoid breaking changes.
         */
        this.role = 'table';
        this.size = defaultTableProps.size;
    }
    render() {
        return x `
			<slot name="table-toolbar"></slot>
			<div class="overflow-wrapper">
				<div class="table">
					<slot name="table-head"></slot>
					<slot name="table-body"></slot>
					<slot name="table-foot"></slot>
				</div>
			</div>
			<slot name="table-feedback"></slot>
			<slot name="table-actions"></slot>
		`;
    }
}
Table.styles = [tableStyles()];
window.customElements.define('m-table', Table);

class TableHead extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
            role: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'table-head';
        this.role = 'rowgroup';
    }
    render() {
        return x `<slot name="table-row"></slot>`;
    }
}
TableHead.styles = [tableHeadStyles()];
window.customElements.define('m-table-head', TableHead);

var _TableHeadCell_instances, _TableHeadCell_isSortable, _TableHeadCell_isDisabled, _TableHeadCell_getSortIcon, _TableHeadCell_handleClick;
const defaultTableHeadCellProps = {
    alignment: 'left',
    verticalAlign: 'middle',
    sortable: false,
    sortDirection: undefined,
    disabled: false,
};
class TableHeadCell extends Component {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
            role: { type: String, reflect: true },
            alignment: { type: String },
            verticalAlign: { type: String, attribute: 'vertical-align' },
            columnId: { type: String, attribute: 'column-id' },
            sortable: { type: Boolean, reflect: true },
            sortDirection: { type: String, attribute: 'sort-direction' },
            disabled: { type: Boolean, reflect: true },
        };
    }
    constructor() {
        super();
        _TableHeadCell_instances.add(this);
        _TableHeadCell_isSortable.set(this, () => Boolean(this.sortable));
        _TableHeadCell_isDisabled.set(this, () => Boolean(this.disabled));
        _TableHeadCell_handleClick.set(this, () => {
            if (__classPrivateFieldGet$1(this, _TableHeadCell_isDisabled, "f").call(this) || !__classPrivateFieldGet$1(this, _TableHeadCell_isSortable, "f").call(this)) {
                return;
            }
            // Default sorting cycle: none -> asc -> desc -> none -> ...
            let nextSortDirection = 'asc';
            if (this.sortDirection === 'asc') {
                nextSortDirection = 'desc';
            }
            else if (this.sortDirection === 'desc') {
                nextSortDirection = undefined;
            }
            this.emit('m-sort', {
                detail: {
                    columnId: this.columnId,
                    sortDirection: nextSortDirection,
                },
            });
        });
        this.slot = 'table-cell';
        this.role = 'columnheader';
        this.alignment = defaultTableHeadCellProps.alignment;
        this.verticalAlign = defaultTableHeadCellProps.verticalAlign;
        this.sortable = defaultTableHeadCellProps.sortable;
        this.sortDirection = defaultTableHeadCellProps.sortDirection;
        this.disabled = defaultTableHeadCellProps.disabled;
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', __classPrivateFieldGet$1(this, _TableHeadCell_handleClick, "f"));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', __classPrivateFieldGet$1(this, _TableHeadCell_handleClick, "f"));
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('alignment')) {
            this.style.setProperty('--m-table-cell-text-align', this.alignment ?? defaultTableHeadCellProps.alignment);
        }
        if (changedProperties.has('verticalAlign')) {
            this.style.setProperty('--m-table-cell-vertical-align', this.verticalAlign ?? defaultTableHeadCellProps.verticalAlign);
        }
    }
    render() {
        if (__classPrivateFieldGet$1(this, _TableHeadCell_isSortable, "f").call(this)) {
            return x `
				<slot></slot>
				<m-icon name="${__classPrivateFieldGet$1(this, _TableHeadCell_instances, "m", _TableHeadCell_getSortIcon).call(this)}" size="12"></m-icon>
			`;
        }
        return x `<slot></slot>`;
    }
}
_TableHeadCell_isSortable = new WeakMap(), _TableHeadCell_isDisabled = new WeakMap(), _TableHeadCell_handleClick = new WeakMap(), _TableHeadCell_instances = new WeakSet(), _TableHeadCell_getSortIcon = function _TableHeadCell_getSortIcon() {
    switch (this.sortDirection) {
        case 'asc': {
            return 'arrow-sort-up';
        }
        case 'desc': {
            return 'arrow-sort-down';
        }
        default: {
            return 'up-down';
        }
    }
};
TableHeadCell.styles = [tableHeadCellStyles()];
window.customElements.define('m-table-head-cell', TableHeadCell);

class TableBody extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
            role: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'table-body';
        this.role = 'rowgroup';
    }
    render() {
        return x `<slot name="table-row"></slot>`;
    }
}
TableBody.styles = [tableBodyStyles()];
window.customElements.define('m-table-body', TableBody);

class TableFoot extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
            role: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'table-foot';
        this.role = 'rowgroup';
    }
    render() {
        return x `<slot name="table-row"></slot>`;
    }
}
TableFoot.styles = [tableFootStyles()];
window.customElements.define('m-table-foot', TableFoot);

class TableRow extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
            role: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'table-row';
        this.role = 'row';
    }
    render() {
        return x `<slot name="table-cell"></slot>`;
    }
}
TableRow.styles = [tableRowStyles()];
window.customElements.define('m-table-row', TableRow);

const defaultTableCellProps = {
    alignment: 'left',
    verticalAlign: 'middle',
};
class TableCell extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
            role: { type: String, reflect: true },
            alignment: { type: String },
            verticalAlign: { type: String, attribute: 'vertical-align' },
        };
    }
    constructor() {
        super();
        this.slot = 'table-cell';
        this.alignment = defaultTableCellProps.alignment;
        this.verticalAlign = defaultTableCellProps.verticalAlign;
    }
    /**
     * TODO: This role validation is not necessary anymore since we have a dedicated table-head-cell now.
     * We can remove it for the next major release to avoid breaking changes.
     */
    firstUpdated() {
        const isHeadCell = this.closest('m-table-head') != null;
        this.role = isHeadCell ? 'columnheader' : 'cell';
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('alignment')) {
            this.style.setProperty('--m-table-cell-text-align', this.alignment ?? defaultTableCellProps.alignment);
        }
        if (changedProperties.has('verticalAlign')) {
            this.style.setProperty('--m-table-cell-vertical-align', this.verticalAlign ?? defaultTableCellProps.verticalAlign);
        }
    }
    render() {
        return x `<slot></slot>`;
    }
}
TableCell.styles = [tableCellStyles()];
window.customElements.define('m-table-cell', TableCell);

class TableToolbar extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'table-toolbar';
    }
    render() {
        return x `<slot></slot>`;
    }
}
TableToolbar.styles = [tableToolbarStyles()];
window.customElements.define('m-table-toolbar', TableToolbar);

class TableFeedback extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'table-feedback';
    }
    render() {
        return x `<slot></slot>`;
    }
}
window.customElements.define('m-table-feedback', TableFeedback);

class TableActions extends s$7 {
    static get properties() {
        return {
            slot: { type: String, reflect: true },
            role: { type: String, reflect: true },
            sticky: { type: Boolean, reflect: true },
        };
    }
    constructor() {
        super();
        this.slot = 'table-actions';
    }
    render() {
        return x `<slot></slot>`;
    }
}
TableActions.styles = [tableActionsStyles()];
window.customElements.define('m-table-actions', TableActions);

const tabsContext = n$1(Symbol('tabs'));

const TAB_SELECT_EVENT = 'm-select-tab';

function styles$8() {
    return i$5 `
		:host {
			--m-tabs-border-width: ${getToken$1('border-thin')};
			--m-tabs-border-color: ${getColor('color-divider')};
		}

		.tablist {
			display: flex;
			flex-direction: row;
			gap: 1px;
			border-bottom-style: solid;
			border-bottom-width: var(--m-tabs-border-width);
			border-bottom-color: var(--m-tabs-border-color);
		}
	`;
}

var _Tabs_selectionController, _Tabs_defaultSlot, _Tabs_onSelectionChange, _Tabs_getDefaultSelected, _Tabs_getTabs;
class Tabs extends Component {
    static get properties() {
        return {
            activeTab: { type: String, attribute: 'active-tab', reflect: true },
            disabled: { type: Boolean, reflect: true },
            lazy: { type: Boolean },
            selection: { state: true },
            tabContentDirection: { type: String, attribute: 'tab-content-direction' },
        };
    }
    constructor() {
        super();
        _Tabs_selectionController.set(this, null);
        _Tabs_defaultSlot.set(this, null);
        this.provider = new i(this, tabsContext, {
            tabContentDirection: 'horizontal',
            disabled: false,
            lazy: false,
            selection: new Set(''),
        });
        _Tabs_onSelectionChange.set(this, (event) => {
            event.stopPropagation();
            const [selectedValue] = Array.from(this.selection);
            const options = {
                detail: { value: String(selectedValue) },
            };
            this.emit('m-tab-change', options);
        });
        _Tabs_getDefaultSelected.set(this, () => {
            /**
             * If no tab component is marked as selected, set the first one as selected and return its value
             */
            const tabs = __classPrivateFieldGet$1(this, _Tabs_getTabs, "f").call(this);
            return tabs[0]?.name;
        });
        _Tabs_getTabs.set(this, () => {
            if (!__classPrivateFieldGet$1(this, _Tabs_defaultSlot, "f")) {
                __classPrivateFieldSet(this, _Tabs_defaultSlot, this.shadowRoot && this.shadowRoot.querySelector('slot'), "f");
            }
            const items = __classPrivateFieldGet$1(this, _Tabs_defaultSlot, "f")?.assignedElements({ flatten: true }) ?? [];
            return [...items].filter((item) => item.tagName.toLowerCase() === 'm-tab');
        });
        this.activeTab = '';
        this.tabContentDirection = 'horizontal';
        this.disabled = false;
        this.lazy = false;
        this.type = 'single-strict';
        this.selection = new Set();
    }
    connectedCallback() {
        super.connectedCallback();
        __classPrivateFieldSet(this, _Tabs_selectionController, new SelectionController(this, this.type, TAB_SELECT_EVENT), "f");
        this.addEventListener('m-change', __classPrivateFieldGet$1(this, _Tabs_onSelectionChange, "f"));
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('activeTab') && __classPrivateFieldGet$1(this, _Tabs_selectionController, "f")) {
            __classPrivateFieldGet$1(this, _Tabs_selectionController, "f").init(toArray(this.activeTab || __classPrivateFieldGet$1(this, _Tabs_getDefaultSelected, "f").call(this)));
        }
        const [selectedValue] = Array.from(this.selection);
        if (changedProperties.has('selection') &&
            (!this.activeTab || selectedValue !== this.activeTab)) {
            // Here we are syncing the internal state with the reflected activeTab attribute
            this.activeTab = selectedValue;
        }
        if (changedProperties.has('tabContentDirection') ||
            changedProperties.has('disabled') ||
            changedProperties.has('lazy') ||
            changedProperties.has('selection')) {
            this.provider.setValue({
                tabContentDirection: this.tabContentDirection,
                disabled: this.disabled,
                lazy: this.lazy,
                selection: this.selection,
            });
        }
    }
    render() {
        return x `
			<div class="tablist" role="tablist"><slot name="tab"></slot></div>
			<slot></slot>
		`;
    }
}
_Tabs_selectionController = new WeakMap(), _Tabs_defaultSlot = new WeakMap(), _Tabs_onSelectionChange = new WeakMap(), _Tabs_getDefaultSelected = new WeakMap(), _Tabs_getTabs = new WeakMap();
Tabs.styles = [styles$8()];
window.customElements.define('m-tabs', Tabs);

function styles$7() {
    return i$5 `
		:host {
			--m-tab-border-width: ${getToken$1('border-thin')};
			--m-tab-border-color: ${getColor('color-divider')};
			--m-tab-border-radius: ${getToken$1('border-radius-s')};
			--m-tab-background-color: none;
			--m-tab-label-color: ${getColor('color-text-tertiary')};
			--m-tab-leading-color: ${getColor('color-text-tertiary')};

			--m-tab-outline-color: ${getColor('color-primary-60')};

			--m-tab-padding-x: ${getToken$1('spacing-6')};
			--m-tab-height: ${getToken$1('spacing-12')};
		}

		.tab {
			cursor: pointer;
			position: relative;
			padding-bottom: 1px;
			bottom: -1px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			gap: ${getToken$1('spacing-3')};
			height: var(--m-tab-height);
			padding-inline: var(--m-tab-padding-x);

			${typography('body-md')};
			color: var(--m-tab-label-color);

			background-color: var(--m-tab-background-color);
			border: none;
			border-bottom-style: solid;
			border-bottom-width: var(--m-tab-border-width);
			border-bottom-color: var(--m-tab-border-color);
			border-top-left-radius: var(--m-tab-border-radius);
			border-top-right-radius: var(--m-tab-border-radius);

			@media (prefers-reduced-motion: no-preference) {
				${transition([
        { property: 'background-color' },
        { property: 'border-color' },
        { property: 'color' },
    ])};
			}
		}
		.tab.-vertical {
			flex-direction: column;
			--m-tab-height: ${getToken$1('spacing-20')};
		}
		.tab.-horizontal {
			flex-direction: row;
		}

		slot[name='leading']::slotted(*) {
			display: contents;
			color: var(--m-tab-leading-color);
		}

		${on('.tab').not.disabled.hover} {
			--m-tab-background-color: ${getColor('color-background-tertiary')};
		}

		${on('.tab').not.disabled.focus} {
			outline: 1px solid var(--m-tab-outline-color);
		}

		.tab[aria-selected='true'] {
			--m-tab-border-width: ${getToken$1('border-medium')};
			--m-tab-border-color: ${getColor('color-primary-60')};
			--m-tab-label-color: ${getColor('color-text-secondary')};
			--m-tab-leading-color: ${getColor('color-primary-60')};
			padding-bottom: 0;
		}

		${on('.tab').disabled} {
			cursor: default;
			--m-tab-label-color: ${getColor('color-text-disabled')};
			--m-tab-leading-color: ${getColor('color-text-disabled')};
			--m-tab-border-color: ${getColor('color-divider')};
		}

		${on('.tab', '*').disabled} {
			pointer-events: none;
		}
	`;
}

var _Tab_instances, _Tab_button_get, _Tab_handleClick, _Tab_getContentDirection, _Tab_isSelected, _Tab_isDisabled;
class Tab extends Component {
    static get properties() {
        return {
            name: { type: String },
            disabled: { type: Boolean, reflect: true },
            slot: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        _Tab_instances.add(this);
        this.tabs = new s$1(this, {
            context: tabsContext,
            subscribe: true,
        });
        _Tab_handleClick.set(this, (event) => {
            if (this.disabled) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            const options = {
                detail: { value: this.name, type: 'select' },
                bubbles: true,
                composed: false,
            };
            this.emit(TAB_SELECT_EVENT, options);
        });
        _Tab_getContentDirection.set(this, () => {
            return this.tabs.value?.tabContentDirection;
        });
        _Tab_isSelected.set(this, () => {
            return Boolean(this.tabs.value?.selection.has(this.name));
        });
        _Tab_isDisabled.set(this, () => {
            return this.disabled || Boolean(this.tabs.value?.disabled);
        });
        this.disabled = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.id = `${this.name}-tab`;
        this.setAttribute('slot', 'tab');
        this.setAttribute('role', 'tab');
        this.setAttribute('aria-controls', `${this.name}-panel`);
        this.setAttribute('aria-selected', 'false');
        this.addEventListener('click', __classPrivateFieldGet$1(this, _Tab_handleClick, "f"));
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (__classPrivateFieldGet$1(this, _Tab_isSelected, "f").call(this)) {
            this.setAttribute('aria-selected', 'true');
        }
        else {
            this.setAttribute('aria-selected', 'false');
        }
        if (changedProperties.has('name')) {
            this.id = `${this.name}-tab`;
            this.setAttribute('aria-controls', `${this.name}-panel`);
        }
        if (changedProperties.has('disabled')) {
            this.setAttribute('aria-disabled', String(this.disabled ?? false));
        }
    }
    render() {
        return x `
			<button
				type="button"
				class=${o$2({
            tab: true,
            '-vertical': __classPrivateFieldGet$1(this, _Tab_getContentDirection, "f").call(this) === 'vertical',
            '-horizontal': __classPrivateFieldGet$1(this, _Tab_getContentDirection, "f").call(this) === 'horizontal',
        })}
				?disabled=${__classPrivateFieldGet$1(this, _Tab_isDisabled, "f").call(this)}
				aria-selected=${__classPrivateFieldGet$1(this, _Tab_isSelected, "f").call(this)}
			>
				<slot name="leading"></slot>
				<slot></slot>
			</button>
		`;
    }
    focus(options) {
        __classPrivateFieldGet$1(this, _Tab_instances, "a", _Tab_button_get)?.focus(options);
    }
}
_Tab_handleClick = new WeakMap(), _Tab_getContentDirection = new WeakMap(), _Tab_isSelected = new WeakMap(), _Tab_isDisabled = new WeakMap(), _Tab_instances = new WeakSet(), _Tab_button_get = function _Tab_button_get() {
    return this.renderRoot?.querySelector('button') ?? null;
};
Tab.styles = [styles$7()];
window.customElements.define('m-tab', Tab);

function styles$6() {
    return i$5 `
		:host {
			--m-tab-panel-display: none;

			display: var(--m-tab-panel-display);
		}
	`;
}

var _a, _b, _TabPanel_isSelected, _TabPanel_isLazy;
class TabPanel extends (_b = Box) {
    static get properties() {
        return {
            ...super.properties,
            forTab: { type: String, attribute: 'for-tab' },
            lazy: { type: Boolean },
        };
    }
    constructor() {
        super();
        this.tabs = new s$1(this, {
            context: tabsContext,
            subscribe: true,
        });
        _TabPanel_isSelected.set(this, () => {
            return Boolean(this.tabs.value?.selection.has(this.forTab));
        });
        _TabPanel_isLazy.set(this, () => {
            return this.lazy || Boolean(this.tabs.value?.lazy);
        });
        this.lazy = false;
        this.padding = 'none';
        this.paddingY = 'spacing-8';
    }
    connectedCallback() {
        super.connectedCallback();
        this.id = `${this.forTab}-panel`;
        this.setAttribute('role', 'tabpanel');
        this.setAttribute('aria-labelledby', `${this.forTab}-tab`);
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (__classPrivateFieldGet$1(this, _TabPanel_isSelected, "f").call(this)) {
            this.style.setProperty('--m-tab-panel-display', 'block');
            this.removeAttribute('aria-hidden');
        }
        else {
            this.style.setProperty('--m-tab-panel-display', 'none');
            this.setAttribute('aria-hidden', 'true');
        }
        if (changedProperties.has('forTab')) {
            this.id = `${this.forTab}-panel`;
            this.setAttribute('aria-labelledby', `${this.forTab}-tab`);
        }
    }
    render() {
        if (__classPrivateFieldGet$1(this, _TabPanel_isLazy, "f").call(this) && !__classPrivateFieldGet$1(this, _TabPanel_isSelected, "f").call(this)) {
            return x ``;
        }
        return x `<slot></slot>`;
    }
}
_a = TabPanel, _TabPanel_isSelected = new WeakMap(), _TabPanel_isLazy = new WeakMap();
TabPanel.styles = [...Reflect.get(_b, "styles", _a), styles$6()];
window.customElements.define('m-tab-panel', TabPanel);

function baseTagStyles() {
    return [
        skeleton.styles(),
        i$5 `
			:host {
				--m-tag-skeleton-width: 100px;

				display: contents;
			}

			.tag {
				box-sizing: border-box;
				max-width: 200px;
				border-radius: 100px;
				line-height: ${getToken$1('line-height-1')};
				cursor: default;
			}

			.tag slot[name='leading']::slotted(*) {
				margin-inline-end: ${getToken$1('spacing-1')};
				vertical-align: middle;
			}

			.-size-small {
				${typography('chips-sm')};
				padding: ${getToken$1('spacing-1')} ${getToken$1('spacing-2')};
				block-size: ${toRem('18px')};
			}
			.-size-default {
				${typography('chips-md')};
				padding: ${getToken$1('spacing-2')} ${getToken$1('spacing-3')};
				block-size: ${getToken$1('global-height-small')};
			}
			.-size-large {
				${typography('button-lg')};
				padding: ${getToken$1('spacing-3')} ${getToken$1('spacing-4')};
				block-size: ${getToken$1('global-height-default')};
			}

			.-is-skeleton {
				${skeleton()};
				width: var(--m-tag-skeleton-width);
			}
		`,
    ];
}

function tagStyles() {
    return [
        skeleton.styles(),
        baseTagStyles(),
        i$5 `
			.tag {
				display: inline-block;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.-success {
				color: ${getColor('color-success-60')};
				background: ${getColor('color-success-20')};
			}

			.-neutral {
				color: ${getColor('color-text-tertiary')};
				background: ${getColor('color-background-tertiary')};
			}

			.-warning {
				color: ${getColor('color-warning-100')};
				background: ${getColor('color-warning-20')};
			}

			.-danger {
				color: ${getColor('color-danger-60')};
				background: ${getColor('color-danger-20')};
			}

			.-info {
				color: ${getColor('color-text-highlight')};
				background: ${getColor('color-accent-20')};
			}
		`,
    ];
}

class Tag extends s$7 {
    static get properties() {
        return {
            variant: { type: String },
            size: { type: String },
            isSkeleton: { type: Boolean, attribute: 'is-skeleton' },
        };
    }
    constructor() {
        super();
        this.variant = 'neutral';
        this.size = 'default';
        this.isSkeleton = false;
    }
    render() {
        return x `
			<span
				class=${o$2({
            tag: true,
            '-success': this.variant === 'success',
            '-neutral': this.variant === 'neutral',
            '-warning': this.variant === 'warning',
            '-danger': this.variant === 'danger',
            '-info': this.variant === 'info',
            '-is-skeleton': this.isSkeleton,
            '-size-small': this.size === 'small',
            '-size-default': this.size === 'default',
            '-size-large': this.size === 'large',
        })}
			>
				${this.isSkeleton ? x `` : x `<slot name="leading"></slot>`}
				<slot></slot>
			</span>
		`;
    }
}
Tag.styles = [tagStyles()];
window.customElements.define('m-tag', Tag);

function handleConditionObject(condition) {
    const keys = Object.keys(condition || {});
    const res = keys.reduce((acc, key) => {
        if (condition[key]) {
            return [...acc, key];
        }
        return acc;
    }, []);
    return res.join(' ');
}
/**
 * Concatenate style properties or class names conditionally.
 * Conditions can be functions that consume components props,
 * objects, strings, or numbers (that will be coerced to strings).
 * @example
 * ```jsx
 * // returns 'some-class class-a'
 * conditional('some-class', {
 *  'class-a': true,
 *  'class-b': false,
 * })
 * ```
 * @param conditions
 * @returns {string}
 */
function conditional(...conditions) {
    let classes = [];
    for (let i = 0; i < conditions.length; i++) {
        const condition = conditions[i];
        if (typeof condition === 'string') {
            classes.push(condition);
        }
        else {
            // is an object condition
            classes = classes.concat(handleConditionObject(condition));
        }
    }
    return classes.join(' ');
}

function actionableTagStyles() {
    return [
        skeleton.styles(),
        baseTagStyles(),
        i$5 `
			.tag {
				display: inline-flex;
				flex-wrap: nowrap;
				align-items: center;
				gap: ${getToken$1('spacing-1')};
				border: none;
			}

			.-default {
				color: ${getColor('color-text-tertiary')};
				background: ${getColor('color-background-tertiary')};
			}
			.-default m-text {
				--m-text-color: ${getColor('color-text-tertiary')};
			}

			.-accent {
				color: ${getColor('color-accent-60')};
				background: ${getColor('color-accent-20')};
			}
			.-accent m-text {
				--m-text-color: ${getColor('color-accent-60')};
			}

			.-selectable.-default.-selected {
				background: ${getColor('color-primary-60')};
				color: ${getColor('color-text-inverted')};
			}
			.-selectable.-default.-selected m-text {
				--m-text-color: ${getColor('color-text-inverted')};
			}

			.-selectable.-accent.-selected {
				background: ${getColor('color-accent-100')};
				color: ${getColor('color-text-inverted')};
			}
			.-selectable.-accent.-selected m-text {
				--m-text-color: ${getColor('color-text-inverted')};
			}

			${on('.-selectable').not.disabled} {
				cursor: pointer;
			}

			${on('.-selectable').not.disabled.focus} {
				outline: 1px solid ${getColor('color-primary-60')};
				outline-offset: 2px;
			}

			${on('.-selectable.-default:not(.-selected)').not.disabled.hover},
			${on('.-selectable.-default:not(.-selected)').not.disabled.active} {
				color: ${getColor('color-text-primary')};
			}
			${on('.-selectable.-default:not(.-selected)').not.disabled.hover} m-text,
			${on('.-selectable.-default:not(.-selected)').not.disabled.active} m-text {
				--m-text-color: ${getColor('color-text-primary')};
			}

			${on('.-selectable.-accent:not(.-selected)').not.disabled.hover},
			${on('.-selectable.-accent:not(.-selected)').not.disabled.active} {
				color: ${getColor('color-accent-100')};
			}
			${on('.-selectable.-accent:not(.-selected)').not.disabled.hover} m-text,
			${on('.-selectable.-accent:not(.-selected)').not.disabled.active} m-text {
				--m-text-color: ${getColor('color-accent-100')};
			}

			${on('.-selectable').disabled} {
				color: ${getColor('color-text-disabled')};
			}
			${on('.-selectable').disabled} m-text {
				--m-text-color: ${getColor('color-text-disabled')};
			}

			${on('.-selectable.-default').disabled} {
				background: ${getColor('color-background-tertiary')};
			}

			${on('.-selectable.-accent').disabled} {
				background: ${getColor('color-accent-20')};
			}

			.-accent:not(.-selected) ${on('m-close-button').not.disabled.hover} {
				--m-close-button-color: ${getColor('color-accent-100')};
				--m-close-button-icon-color: ${getColor('color-text-inverted')};
			}

			.-selected ${on('m-close-button').not.disabled.hover} {
				--m-close-button-color: ${getColor('color-text-inverted')};
			}
			.-selected.-default ${on('m-close-button').not.disabled.hover} {
				--m-close-button-icon-color: ${getColor('color-primary-60')};
			}
			.-selected.-accent ${on('m-close-button').not.disabled.hover} {
				--m-close-button-icon-color: ${getColor('color-accent-100')};
			}

			.-size-large.-removable {
				// manual/visual increment
				padding-inline-end: calc(${getToken$1('spacing-2')} + 4px);
			}
		`,
    ];
}

var _ActionableTag_instances, _ActionableTag_isSkeleton, _ActionableTag_isRemovable, _ActionableTag_isSelectable, _ActionableTag_isSelected, _ActionableTag_isDisabled, _ActionableTag_handleClose, _ActionableTag_toggle, _ActionableTag_handleClick;
class ActionableTag extends Component {
    static get properties() {
        return {
            variant: { type: String },
            size: { type: String },
            selectable: { type: Boolean, reflect: true },
            selected: { type: Boolean, reflect: true },
            removable: { type: Boolean, reflect: true },
            disabled: { type: Boolean, reflect: true },
            isSkeleton: { type: Boolean, attribute: 'is-skeleton' },
        };
    }
    constructor() {
        super();
        _ActionableTag_instances.add(this);
        _ActionableTag_isSkeleton.set(this, () => Boolean(this.isSkeleton));
        _ActionableTag_isRemovable.set(this, () => Boolean(this.removable));
        _ActionableTag_isSelectable.set(this, () => Boolean(this.selectable));
        _ActionableTag_isSelected.set(this, () => Boolean(this.selected));
        _ActionableTag_isDisabled.set(this, () => Boolean(this.disabled));
        _ActionableTag_handleClose.set(this, (event) => {
            event.stopPropagation();
            if (this.disabled) {
                event.preventDefault();
                return;
            }
            this.emit('m-remove');
        });
        _ActionableTag_handleClick.set(this, (event) => {
            const closeButton = this.renderRoot.querySelector('m-close-button');
            const isCloseButtonClicked = closeButton && event.composedPath().includes(closeButton);
            if (this.disabled || !__classPrivateFieldGet$1(this, _ActionableTag_isSelectable, "f").call(this) || isCloseButtonClicked) {
                event.stopPropagation();
                event.preventDefault();
                return;
            }
            __classPrivateFieldGet$1(this, _ActionableTag_instances, "m", _ActionableTag_toggle).call(this);
        });
        this.variant = 'default';
        this.size = 'default';
        this.removable = false;
        this.selectable = false;
        this.selected = false;
        this.disabled = false;
        this.isSkeleton = false;
    }
    /**
     * Which HTML tag should be used to render this element.
     */
    get tag() {
        const as = __classPrivateFieldGet$1(this, _ActionableTag_isSelectable, "f").call(this) ? 'button' : 'span';
        return i$3 `${o$3(as)}`;
    }
    render() {
        return n$3 `
			<${this.tag}
				class=${o$2({
            tag: true,
            '-default': this.variant === 'default',
            '-accent': this.variant === 'accent',
            '-size-small': this.size === 'small',
            '-size-default': this.size === 'default',
            '-size-large': this.size === 'large',
            '-removable': __classPrivateFieldGet$1(this, _ActionableTag_isRemovable, "f").call(this),
            '-selectable': __classPrivateFieldGet$1(this, _ActionableTag_isSelectable, "f").call(this),
            '-selected': __classPrivateFieldGet$1(this, _ActionableTag_isSelected, "f").call(this),
            '-is-skeleton': __classPrivateFieldGet$1(this, _ActionableTag_isSkeleton, "f").call(this),
            'is-disabled': __classPrivateFieldGet$1(this, _ActionableTag_isDisabled, "f").call(this),
        })}
				@click=${__classPrivateFieldGet$1(this, _ActionableTag_handleClick, "f")}
				?disabled="${__classPrivateFieldGet$1(this, _ActionableTag_isSelectable, "f").call(this) ? __classPrivateFieldGet$1(this, _ActionableTag_isDisabled, "f").call(this) : A$1}"
				aria-disabled=${__classPrivateFieldGet$1(this, _ActionableTag_isSelectable, "f").call(this) && __classPrivateFieldGet$1(this, _ActionableTag_isDisabled, "f").call(this) ? 'true' : 'false'}
			>
				${this.isSkeleton ? n$3 `` : n$3 `<slot name="leading"></slot>`}
				<m-text
					variant=${conditional({
            'chips-sm': this.size === 'small',
            'chips-md': this.size === 'default',
            'button-lg': this.size === 'large',
        })}
					ellipsized
				>
					<slot></slot>
				</m-text>
				<m-close-button
					?hidden=${!this.removable || this.isSkeleton}
					?inverted=${this.selected}
					?disabled=${__classPrivateFieldGet$1(this, _ActionableTag_isDisabled, "f").call(this)}
					size=${conditional({
            small: this.size && ['small', 'default'].includes(this.size),
            default: this.size === 'large',
        })}
					@m-close=${__classPrivateFieldGet$1(this, _ActionableTag_handleClose, "f")}
				></m-close-button>
			</${this.tag}>
		`;
    }
}
_ActionableTag_isSkeleton = new WeakMap(), _ActionableTag_isRemovable = new WeakMap(), _ActionableTag_isSelectable = new WeakMap(), _ActionableTag_isSelected = new WeakMap(), _ActionableTag_isDisabled = new WeakMap(), _ActionableTag_handleClose = new WeakMap(), _ActionableTag_handleClick = new WeakMap(), _ActionableTag_instances = new WeakSet(), _ActionableTag_toggle = function _ActionableTag_toggle() {
    this.selected = !this.selected;
    this.emit('m-change', {
        detail: { selected: this.selected },
    });
};
ActionableTag.styles = [actionableTagStyles()];
window.customElements.define('m-actionable-tag', ActionableTag);

var e=new Map;function t(t){var o=e.get(t);o&&o.destroy();}function o(t){var o=e.get(t);o&&o.update();}var r=null;"undefined"==typeof window?((r=function(e){return e}).destroy=function(e){return e},r.update=function(e){return e}):((r=function(t,o){return t&&Array.prototype.forEach.call(t.length?t:[t],function(t){return function(t){if(t&&t.nodeName&&"TEXTAREA"===t.nodeName&&!e.has(t)){var o,r=null,n=window.getComputedStyle(t),i=(o=t.value,function(){a({testForHeightReduction:""===o||!t.value.startsWith(o),restoreTextAlign:null}),o=t.value;}),l=function(o){t.removeEventListener("autosize:destroy",l),t.removeEventListener("autosize:update",s),t.removeEventListener("input",i),window.removeEventListener("resize",s),Object.keys(o).forEach(function(e){return t.style[e]=o[e]}),e.delete(t);}.bind(t,{height:t.style.height,resize:t.style.resize,textAlign:t.style.textAlign,overflowY:t.style.overflowY,overflowX:t.style.overflowX,wordWrap:t.style.wordWrap});t.addEventListener("autosize:destroy",l),t.addEventListener("autosize:update",s),t.addEventListener("input",i),window.addEventListener("resize",s),t.style.overflowX="hidden",t.style.wordWrap="break-word",e.set(t,{destroy:l,update:s}),s();}function a(e){var o,i,l=e.restoreTextAlign,s=void 0===l?null:l,d=e.testForHeightReduction,u=void 0===d||d,c=n.overflowY;if(0!==t.scrollHeight&&("vertical"===n.resize?t.style.resize="none":"both"===n.resize&&(t.style.resize="horizontal"),u&&(o=function(e){for(var t=[];e&&e.parentNode&&e.parentNode instanceof Element;)e.parentNode.scrollTop&&t.push([e.parentNode,e.parentNode.scrollTop]),e=e.parentNode;return function(){return t.forEach(function(e){var t=e[0],o=e[1];t.style.scrollBehavior="auto",t.scrollTop=o,t.style.scrollBehavior=null;})}}(t),t.style.height=""),i="content-box"===n.boxSizing?t.scrollHeight-(parseFloat(n.paddingTop)+parseFloat(n.paddingBottom)):t.scrollHeight+parseFloat(n.borderTopWidth)+parseFloat(n.borderBottomWidth),"none"!==n.maxHeight&&i>parseFloat(n.maxHeight)?("hidden"===n.overflowY&&(t.style.overflow="scroll"),i=parseFloat(n.maxHeight)):"hidden"!==n.overflowY&&(t.style.overflow="hidden"),t.style.height=i+"px",s&&(t.style.textAlign=s),o&&o(),r!==i&&(t.dispatchEvent(new Event("autosize:resized",{bubbles:!0})),r=i),c!==n.overflow&&!s)){var v=n.textAlign;"hidden"===n.overflow&&(t.style.textAlign="start"===v?"end":"start"),a({restoreTextAlign:v,testForHeightReduction:!0});}}function s(){a({testForHeightReduction:!0,restoreTextAlign:null});}}(t)}),t}).destroy=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],t),e},r.update=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],o),e});var n=r;

function styles$5() {
    return i$5 `
		:host {
			--m-text-area-background-color: ${getColor('color-background-primary')};
			--m-text-area-border-color: ${getColor('color-border-input')};
			--m-text-area-min-height: 135px;
			--m-text-area-placeholder-color: ${getColor('color-text-placeholder')};
			--m-text-area-color: ${getColor('color-text-primary')};

			${typography('body-md')};
			${transition([
        { property: 'background-color' },
        { property: 'border-color' },
    ])};

			display: inline-flex;
			align-items: center;
			justify-content: start;
			gap: ${getToken$1('spacing-2')};

			overflow: hidden;

			position: relative;
			box-sizing: border-box;
			width: 100%;
			min-block-size: var(--m-text-area-min-height);

			background-color: var(--m-text-area-background-color);
			border-radius: ${getToken$1('border-radius-s')};
			border: 1px solid var(--m-text-area-border-color);

			${p$1(getToken$1('spacing-2'))};
		}

		:host([resize='none']:not([autosize])) textarea {
			resize: none;
		}

		:host([resize='both']:not([autosize])) textarea {
			resize: both;
		}

		:host([resize='horizontal']:not([autosize])) textarea {
			resize: horizontal;
		}

		:host([resize='vertical']:not([autosize])) textarea {
			resize: vertical;
		}

		:host([resize='block']:not([autosize])) textarea {
			resize: block;
		}

		:host([resize='inline']:not([autosize])) textarea {
			resize: inline;
		}

		:host([status='danger']) {
			--m-text-area-border-color: ${getColor('color-danger-60')};
		}

		:host([disabled]) {
			--m-text-area-background-color: ${getColor('color-background-tertiary')};

			cursor: default;
		}

		:host([disabled]) * {
			pointer-events: none;
		}

		:host(:not([disabled]):hover) {
			--m-text-area-border-color: ${getColor('color-primary-60')};
		}

		:host(:not([disabled]):is(:focus, :focus-visible, :focus-within)) {
			--m-text-area-border-color: ${getColor('color-primary-100')};
		}

		${on('textarea').not.disabled.active},
		${on('textarea').not.disabled.focus} {
			-webkit-appearance: none;
			background: none;
			border: none;
			outline: none;
		}

		textarea {
			${typography('body-md')};

			border: none;
			outline: none;
			flex: 1;
			min-width: 0;
			min-block-size: var(--m-text-area-min-height);

			padding: 0;

			background-color: var(--m-text-area-background-color);
			color: var(--m-text-area-color);

			scrollbar-width: thin;
			scrollbar-color: ${getColor('color-border-input')}
				${getColor('color-background-tertiary')};

			outline: none;
		}

		textarea::placeholder {
			color: var(--m-text-area-placeholder-color);
		}

		textarea::-webkit-scrollbar {
			width: 8px;
			border-radius: ${getToken$1('border-radius-m')};
		}

		textarea::-webkit-scrollbar-track {
			background: ${getColor('color-background-tertiary')};
			border-radius: ${getToken$1('border-radius-m')};
		}

		textarea::-webkit-scrollbar-thumb {
			background-color: ${getColor('color-border-input')};
			border-radius: ${getToken$1('border-radius-m')};
			background-clip: padding-box;
		}
	`;
}

var _TextArea_handleInput, _TextArea_updateStatusClass;
class TextArea extends Component {
    static get properties() {
        return {
            autosize: { type: Boolean },
            autocomplete: { type: Boolean },
            autofocus: { type: Boolean },
            cols: { type: Number },
            dirname: { type: String },
            disabled: { type: Boolean, reflect: true },
            maxLength: { type: Number, reflect: true, attribute: 'max-length' },
            minLength: { type: Number, reflect: true, attribute: 'min-length' },
            name: { type: String },
            placeholder: { type: String },
            readOnly: { type: Boolean, reflect: true, attribute: 'read-only' },
            resize: { type: String, reflect: true },
            rows: { type: Number },
            spellcheck: { type: Boolean, reflect: true, attribute: 'spell-check' },
            value: { type: String },
            wrap: { type: String },
            status: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.textAreaElement = null;
        /**
         * If there's a m-field ancestor, we want to consume its context.
         */
        this.field = new s$1(this, {
            context: fieldContext,
            subscribe: true,
            callback: () => {
                __classPrivateFieldGet$1(this, _TextArea_updateStatusClass, "f").call(this);
            },
        });
        _TextArea_handleInput.set(this, (event) => {
            this.value = event.target.value;
            this.reemit(event);
        });
        _TextArea_updateStatusClass.set(this, () => {
            const consolidatedStatus = this.status || this.field.value?.status;
            this.classList.remove('-status-default', '-status-danger');
            this.classList.add(`-status-${consolidatedStatus}`);
        });
        this.cols = 40;
        this.disabled = false;
        this.placeholder = undefined;
        this.resize = 'vertical';
        this.rows = 6;
        this.value = undefined;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'textbox');
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('status')) {
            __classPrivateFieldGet$1(this, _TextArea_updateStatusClass, "f").call(this);
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('autosize')) {
            if (this.autosize) {
                n(this.textarea);
            }
            else {
                n.destroy(this.textarea);
            }
        }
    }
    render() {
        return x `<textarea
			name="${l(this.name)}"
			autocomplete=${l(this.autocomplete)}
			?autofocus=${this.autofocus}
			dirname="${l(this.dirname)}"
			cols="${l(this.cols)}"
			rows="${l(this.rows)}"
			aria-disabled=${this.disabled ? 'true' : 'false'}
			?disabled="${this.disabled}"
			?readonly=${this.readOnly}
			maxlength=${l(this.maxLength != null && this.maxLength > -1
            ? this.maxLength
            : undefined)}
			minlength=${l(this.minLength != null && this.minLength > -1
            ? this.minLength
            : undefined)}
			placeholder="${l(this.placeholder)}"
			@change=${this.reemit}
			@input=${__classPrivateFieldGet$1(this, _TextArea_handleInput, "f")}
			spellcheck=${l(this.spellcheck)}
			wrap=${l(this.wrap)}
		>
${this.value}</textarea
		>`;
    }
    get textarea() {
        if (this.textAreaElement == null) {
            this.textAreaElement = this.renderRoot?.querySelector('textArea') ?? null;
        }
        return this.textAreaElement;
    }
    focus() {
        this.textarea?.focus();
    }
}
_TextArea_handleInput = new WeakMap(), _TextArea_updateStatusClass = new WeakMap();
TextArea.styles = [styles$5()];
window.customElements.define('m-text-area', TextArea);

function styles$4() {
    return i$5 `
		:host {
			--m-text-field-background-color: ${getColor('color-background-primary')};
			--m-text-field-border-color: ${getColor('color-border-input')};
			--m-text-field-height: ${getToken$1('global-height-default')};
			--m-text-field-padding-y: ${getToken$1('spacing-2')};
			--m-text-field-placeholder-color: ${getColor('color-text-placeholder')};
			--m-text-field-color: ${getColor('color-text-primary')};

			${typography('body-md')};
			${transition([
        { property: 'background-color' },
        { property: 'border-color' },
    ])};

			display: inline-flex;
			align-items: center;
			justify-content: start;
			gap: ${getToken$1('spacing-2')};

			position: relative;
			box-sizing: border-box;
			width: 100%;
			block-size: var(--m-text-field-height);

			${px(getToken$1('spacing-2'))};

			background-color: var(--m-text-field-background-color);
			border-radius: ${getToken$1('border-radius-s')};
			border: 1px solid var(--m-text-field-border-color);
		}

		:host([size='small']) {
			--m-text-field-height: ${getToken$1('global-height-small')};
			--m-text-field-padding-y: 0;
		}

		:host([size='small']),
		:host([size='small']) input {
			${typography('body-sm')};
		}

		:host([size='large']) {
			--m-text-field-height: ${getToken$1('global-height-large')};
			--m-text-field-padding-y: ${getToken$1('spacing-3')};
		}

		:host(.-status-danger) {
			--m-text-field-border-color: ${getColor('color-danger-60')};
		}

		:host([disabled]) {
			--m-text-field-background-color: ${getColor('color-background-tertiary')};

			cursor: default;
		}

		:host([disabled]) * {
			pointer-events: none;
		}

		slot[name='leading']::slotted(*),
		slot[name='trailing']::slotted(*) {
			display: inline-flex;
			flex: 0 0 auto;
			align-items: center;
			cursor: default;
		}

		:host(:not([disabled]):hover) {
			--m-text-field-border-color: ${getColor('color-primary-60')};
		}

		:host(:not([disabled]):is(:focus, :focus-visible, :focus-within)) {
			--m-text-field-border-color: ${getColor('color-primary-100')};
		}

		${on('input').not.disabled.active},
		${on('input').not.disabled.focus} {
			-webkit-appearance: none;
			background: none;
			border: none;
			outline: none;
		}

		input {
			${typography('body-md')};

			align-self: stretch;
			border: none;
			outline: none;
			flex: 1;
			min-width: 0;

			${px(0)};
			padding-block: var(--m-text-field-padding-y);

			background-color: var(--m-text-field-background-color);
			color: var(--m-text-field-color);
		}

		input::placeholder {
			color: var(--m-text-field-placeholder-color);
		}

		.clear {
			visibility: hidden;
		}

		.clear.is-visible {
			visibility: visible;
		}
	`;
}

var _TextField_instances, _TextField_isClearVisible, _TextField_updateStatusClass, _TextField_handleInput, _TextField_handleClear;
class TextField extends Component {
    static get properties() {
        return {
            clearable: { type: Boolean },
            disabled: { type: Boolean, reflect: true },
            inputMode: { type: String, attribute: 'input-mode' },
            max: { type: String },
            maxLength: { type: Number, reflect: true, attribute: 'max-length' },
            min: { type: String },
            minLength: { type: Number, reflect: true, attribute: 'min-length' },
            name: { type: String },
            pattern: { type: String },
            placeholder: { type: String },
            readOnly: { type: Boolean, reflect: true, attribute: 'read-only' },
            size: { type: String, reflect: true },
            status: { type: String, reflect: true },
            step: { type: String },
            type: { type: String },
            value: { type: String },
        };
    }
    constructor() {
        super();
        _TextField_instances.add(this);
        this.inputElement = null;
        /**
         * If there's a m-field ancestor, we want to consume its context.
         */
        this.field = new s$1(this, {
            context: fieldContext,
            subscribe: true,
            callback: () => {
                __classPrivateFieldGet$1(this, _TextField_updateStatusClass, "f").call(this);
            },
        });
        _TextField_updateStatusClass.set(this, () => {
            const consolidatedStatus = this.status || this.field.value?.status || 'default';
            this.classList.remove('-status-default', '-status-danger');
            this.classList.add(`-status-${consolidatedStatus}`);
        });
        _TextField_handleInput.set(this, (event) => {
            this.value = event.target.value;
            this.reemit(event);
        });
        _TextField_handleClear.set(this, (event) => {
            event.stopPropagation();
            this.clear();
        });
        this.clearable = false;
        this.disabled = false;
        this.placeholder = undefined;
        this.size = 'default';
        this.type = 'text';
        this.value = undefined;
        this.max = '';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'textbox');
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('status')) {
            __classPrivateFieldGet$1(this, _TextField_updateStatusClass, "f").call(this);
        }
    }
    render() {
        return x `
			<slot name="leading"></slot>
			<input
				?disabled="${this.disabled}"
				?readonly=${this.readOnly}
				@change=${this.reemit}
				@input=${__classPrivateFieldGet$1(this, _TextField_handleInput, "f")}
				aria-disabled=${this.disabled ? 'true' : 'false'}
				autocomplete=${l(this.autocomplete)}
				id="${l(this.id)}"
				inputmode=${l(this.inputMode)}
				max=${(this.max || A$1)}
				maxlength=${l(this.maxLength != null && this.maxLength > -1
            ? this.maxLength
            : undefined)}
				min=${(this.min || A$1)}
				minlength=${l(this.minLength != null && this.minLength > -1
            ? this.minLength
            : undefined)}
				name="${l(this.name)}"
				pattern=${l(this.pattern)}
				placeholder="${l(this.placeholder)}"
				step=${(this.step || A$1)}
				type="${l(this.type)}"
				value="${l(this.value)}"
			/>
			${this.clearable
            ? x `<m-close-button
						class=${o$2({
                clear: true,
                /**
                 * we use this approach to avoid the layout shift
                 * when showing/hiding the clear button as the users
                 * changes the input value.
                 */
                'is-visible': __classPrivateFieldGet$1(this, _TextField_instances, "m", _TextField_isClearVisible).call(this),
            })}
						controls="${l(this.id)}"
						@m-close=${__classPrivateFieldGet$1(this, _TextField_handleClear, "f")}
						label="Clear input"
				  ></m-close-button>`
            : A$1}
			<slot name="trailing"></slot>
		`;
    }
    get input() {
        if (this.inputElement == null) {
            this.inputElement = this.renderRoot?.querySelector('input') ?? null;
        }
        return this.inputElement;
    }
    clear() {
        this.value = '';
        if (this.input) {
            this.input.value = '';
        }
        this.emit('m-clear');
        this.focus();
    }
    focus() {
        this.input?.focus();
    }
}
_TextField_updateStatusClass = new WeakMap(), _TextField_handleInput = new WeakMap(), _TextField_handleClear = new WeakMap(), _TextField_instances = new WeakSet(), _TextField_isClearVisible = function _TextField_isClearVisible() {
    const value = this.value || '';
    return !this.disabled && value.length > 0;
};
TextField.styles = [styles$4()];
window.customElements.define('m-text-field', TextField);

function timelineStyles() {
    return i$5 `
		::slotted(*) {
			width: 100%;
		}

		:host {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: flex-start;

			gap: ${getToken$1('spacing-4')};
		}
	`;
}
function timelineItemStyles() {
    return i$5 `
		::slotted(:not(m-timeline-item-icon)) {
			width: 100%;
		}

		:host {
			--m-timeline-item-circle-size: 22px;
			--m-timeline-item-inner-circle-distance: 3px;

			--m-timeline-item-background-color: ${getColor('color-neutral-40')};
			--m-timeline-item-min-height: ${getToken$1('global-height-large')};

			--m-timeline-item-content-gap: ${getToken$1('spacing-6')};

			position: relative;
			display: flex;
			flex-direction: row nowrap;
			align-items: flex-start;

			box-sizing: border-box;
			min-height: var(--m-timeline-item-min-height);

			gap: ${getToken$1('spacing-6')};

			padding: 0;
			margin: 0;
		}

		.side {
			display: flex;
			flex-direction: column;
			gap: ${getToken$1('spacing-4')};

			align-self: stretch;
			align-items: center;
		}

		.track {
			${transition([{ property: 'background-color' }])};

			display: inline-block;

			inline-size: 2px;
			block-size: 100%;

			background-color: ${getColor('color-border-input')};
		}

		.content {
			${typography('body-md')};

			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
			gap: var(--m-timeline-item-content-gap);

			flex: 1;

			padding: 0 0 ${getToken$1('spacing-6')} 0;
			padding-block-end: ${getToken$1('spacing-6')};
		}

		.content.-divider {
			border-bottom: 1px solid ${getColor('color-border-input')};
		}

		.circle {
			${typography('number-md')};
			${transition([{ property: 'background-color' }])};

			display: flex;
			align-items: center;
			justify-content: center;

			flex: 0 0 var(--m-timeline-item-circle-size);

			box-sizing: border-box;
			inline-size: var(--m-timeline-item-circle-size);
			block-size: var(--m-timeline-item-circle-size);

			border-radius: 50%;

			background-color: var(--m-timeline-item-background-color);
			color: var(--m-timeline-item-background-color);
		}

		.check,
		.dot,
		.exclamation {
			display: none;
		}

		.dot {
			--size: calc(
				var(--m-timeline-item-circle-size) - 2 *
					var(--m-timeline-item-inner-circle-distance)
			);

			inline-size: var(--size);
			block-size: var(--size);
			box-sizing: border-box;

			border-radius: 50%;
			border: var(--m-timeline-item-inner-circle-distance) solid
				${getColor('color-text-inverted')};
			background-color: ${getColor('color-primary-60')};
		}

		.exclamation {
			${typography('body-md-bold')};
			line-height: var(--m-timeline-item-circle-size);
			color: ${getColor('color-text-inverted')};
		}

		:host(:is(:focus, :focus-within, :focus-visible)) {
			outline: none;
		}

		:host(:is([completed], [active])) {
			--m-timeline-item-background-color: ${getColor('color-primary-60')};
		}

		:host([variant='warning']:not([active], [active])) {
			--m-timeline-item-background-color: ${getColor('color-warning-60')};
		}

		:host([completed]:not([active])) .check {
			display: inline-flex;
		}

		:host([completed]:not([active])) .track {
			background-color: ${getColor('color-primary-60')};
		}

		:host([active]) .dot {
			display: inline-flex;
		}

		:host([variant='warning']:not([active], [active])) .exclamation {
			display: inline-flex;
		}
	`;
}
function timelineExpandableItemStyles() {
    return i$5 `
		.m-timeline-item-header-trigger {
			display: flex;
			margin: 0;
			padding: 0;
			cursor: pointer;
			width: 100%;
			outline: none;
			border: none;
			align-items: center;
			background-color: transparent;
		}

		.m-timeline-item-header-trigger[aria-expanded='true'] m-icon {
			transform: rotate(180deg);
		}

		.m-timeline-item-body-section {
			height: auto;
			width: 100%;
			overflow: hidden;
		}

		@media (prefers-reduced-motion: no-preference) {
			m-icon {
				${transition([{ property: 'transform' }])};
			}

			.content {
				${transition([{ property: 'gap' }])};
			}

			.m-timeline-item-body-section {
				${transition([{ property: 'height' }, { property: 'visibility' }])};
				will-change: height;
			}
		}
	`;
}
function timelineItemHeaderStyles() {
    return i$5 `
		:host {
			--m-timeline-item-header-align: baseline;

			display: flex;
			flex-direction: row;
			align-items: var(--m-timeline-item-header-align);
			justify-content: flex-start;

			gap: ${getToken$1('spacing-2')};

			box-sizing: border-box;
		}
	`;
}
function timelineBodyStyles() {
    return i$5 `
		:host {
			display: block;

			box-sizing: border-box;
		}
	`;
}
function timelineFooterStyles() {
    return i$5 `
		:host {
			display: block;

			box-sizing: border-box;
		}
	`;
}
function timelineIconStyles() {
    return i$5 `
		:host {
			display: flex;
			box-sizing: border-box;
		}
	`;
}

class Timeline extends Component {
    update(changedProperties) {
        super.update(changedProperties);
        if (this.activeEntry != null) {
            // set all entries before the active one as completed.
            let completed = true;
            for (const entry of this.entries) {
                if (entry.active) {
                    completed = false;
                }
                else {
                    entry.completed = completed;
                    entry.active = false;
                }
            }
        }
    }
    render() {
        return x `<slot name="item"></slot>`;
    }
    get entries() {
        return Array.from(this.querySelectorAll('m-timeline-item'));
    }
    get activeEntry() {
        return this.querySelector('m-timeline-item[active]');
    }
}
Timeline.styles = [timelineStyles()];
window.customElements.define('m-timeline', Timeline);

const timelineItemContext = n$1(Symbol('timeline-item'));

var _TimelineExpandableItem_instances, _TimelineExpandableItem_contextProvider, _TimelineExpandableItem_timelineItemHeaderTrigger_get, _TimelineExpandableItem_timelineItemBodySection_get, _TimelineExpandableItem_timelineItemBody_get, _TimelineExpandableItem_handleExpand, _TimelineExpandableItem_toggle, _TimelineExpandableItem_handleTransition;
attachContextRoot();
class TimelineExpandableItem extends Component {
    constructor() {
        super(...arguments);
        _TimelineExpandableItem_instances.add(this);
        _TimelineExpandableItem_contextProvider.set(this, new i(this, {
            context: timelineItemContext,
            initialValue: {
                variant: 'neutral',
                completed: false,
                active: false,
            },
        }));
        _TimelineExpandableItem_handleTransition.set(this, () => {
            if (this.expanded) {
                __classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "a", _TimelineExpandableItem_timelineItemBodySection_get).style.height = 'auto';
            }
        });
    }
    static get properties() {
        return {
            completed: { type: Boolean, reflect: true },
            active: { type: Boolean, reflect: true },
            variant: { type: String, reflect: true },
            expanded: { type: Boolean, reflect: true },
            divider: { type: Boolean, reflect: true },
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.slot = 'item';
        this.variant = this.variant ?? 'neutral';
        this.active = this.active ?? false;
        this.completed = this.completed ?? false;
        this.divider = this.divider ?? false;
        this.expanded = this.expanded ?? false;
        this.resizeObserver = new ResizeObserver((records) => {
            this.bodyHeight = records[0].target.scrollHeight;
        });
    }
    firstUpdated() {
        __classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "a", _TimelineExpandableItem_timelineItemBody_get).style.transition = 'visibility 0.35s';
        __classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "a", _TimelineExpandableItem_timelineItemBody_get).setAttribute('role', 'region');
        this.resizeObserver.observe(__classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "a", _TimelineExpandableItem_timelineItemBodySection_get));
        __classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "a", _TimelineExpandableItem_timelineItemBodySection_get).addEventListener('transitionend', __classPrivateFieldGet$1(this, _TimelineExpandableItem_handleTransition, "f"));
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('active')) {
            if (this.active) {
                this.setAttribute('tabindex', '0');
                this.setAttribute('aria-active', 'step');
                this.closest('m-timeline')?.requestUpdate();
            }
            else {
                this.removeAttribute('tabindex');
                this.removeAttribute('aria-active');
            }
        }
        if (changedProperties.has('expanded')) {
            __classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "m", _TimelineExpandableItem_handleExpand).call(this);
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('active') ||
            changedProperties.has('completed') ||
            changedProperties.has('variant')) {
            __classPrivateFieldGet$1(this, _TimelineExpandableItem_contextProvider, "f").setValue({
                variant: this.variant ?? 'neutral',
                completed: Boolean(this.completed),
                active: Boolean(this.active),
            });
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        __classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "a", _TimelineExpandableItem_timelineItemBodySection_get).removeEventListener('transitionend', __classPrivateFieldGet$1(this, _TimelineExpandableItem_handleTransition, "f"));
        this.resizeObserver.disconnect();
    }
    render() {
        return x `
			<div class="side">
				<span aria-hidden="true" class="circle">
					<slot name="item-icon">
						<span class="dot"></span>
						<span class="exclamation">!</span>
						<m-icon
							class="check"
							name="check"
							size="12"
							color="color-text-inverted"
						></m-icon>
					</slot>
				</span>
				<span class="track"></span>
			</div>
			<div
				class="${o$2({
            content: true,
            '-divider': Boolean(this.divider),
        })}"
			>
				<button
					class="m-timeline-item-header-trigger"
					@click="${__classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "m", _TimelineExpandableItem_toggle)}"
					tabindex="0"
					type="button"
				>
					<slot name="item-header"></slot>
					<m-icon name="caret-down"></m-icon>
				</button>
				<section class="m-timeline-item-body-section">
					<slot name="item-body"></slot>
				</section>
				<slot name="item-footer"></slot>
			</div>
		`;
    }
}
_TimelineExpandableItem_contextProvider = new WeakMap(), _TimelineExpandableItem_handleTransition = new WeakMap(), _TimelineExpandableItem_instances = new WeakSet(), _TimelineExpandableItem_timelineItemHeaderTrigger_get = function _TimelineExpandableItem_timelineItemHeaderTrigger_get() {
    return this.renderRoot.querySelector('.m-timeline-item-header-trigger');
}, _TimelineExpandableItem_timelineItemBodySection_get = function _TimelineExpandableItem_timelineItemBodySection_get() {
    return this.renderRoot.querySelector('.m-timeline-item-body-section');
}, _TimelineExpandableItem_timelineItemBody_get = function _TimelineExpandableItem_timelineItemBody_get() {
    return this.querySelector('m-timeline-item-body');
}, _TimelineExpandableItem_handleExpand = function _TimelineExpandableItem_handleExpand() {
    __classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "a", _TimelineExpandableItem_timelineItemHeaderTrigger_get).setAttribute('aria-expanded', `${this.expanded}`);
    __classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "a", _TimelineExpandableItem_timelineItemBodySection_get).style.height = `${this.bodyHeight}px`;
    if (this.expanded) {
        __classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "a", _TimelineExpandableItem_timelineItemBody_get).style.visibility = 'visible';
        this.style.setProperty('--m-timeline-item-content-gap', toSpacingCSSValue_1('spacing-6'));
    }
    else {
        setTimeout(() => {
            __classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "a", _TimelineExpandableItem_timelineItemBodySection_get).style.height = '0px';
            __classPrivateFieldGet$1(this, _TimelineExpandableItem_instances, "a", _TimelineExpandableItem_timelineItemBody_get).style.visibility = 'hidden';
            this.style.setProperty('--m-timeline-item-content-gap', toSpacingCSSValue_1('none'));
        });
    }
}, _TimelineExpandableItem_toggle = function _TimelineExpandableItem_toggle() {
    this.expanded = !this.expanded;
    this.emit('m-toggle', {
        detail: { name: 'timeline-item-expanded', value: this.expanded },
    });
};
TimelineExpandableItem.styles = [
    timelineItemStyles(),
    timelineExpandableItemStyles(),
];
window.customElements.define('m-timeline-expandable-item', TimelineExpandableItem);

var _TimelineItem_contextProvider;
attachContextRoot();
class TimelineItem extends s$7 {
    constructor() {
        super(...arguments);
        _TimelineItem_contextProvider.set(this, new i(this, {
            context: timelineItemContext,
            initialValue: {
                variant: 'neutral',
                completed: false,
                active: false,
            },
        }));
    }
    static get properties() {
        return {
            completed: {
                type: Boolean,
                reflect: true,
            },
            active: {
                type: Boolean,
                reflect: true,
            },
            divider: {
                type: Boolean,
                reflect: true,
            },
            variant: {
                type: String,
                reflect: true,
            },
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.slot = 'item';
        this.variant = this.variant ?? 'neutral';
        this.active = this.active ?? false;
        this.completed = this.completed ?? false;
        this.divider = this.divider ?? false;
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('active')) {
            if (this.active) {
                this.setAttribute('tabindex', '0');
                this.setAttribute('aria-active', 'step');
                this.closest('m-timeline')?.requestUpdate();
            }
            else {
                this.removeAttribute('tabindex');
                this.removeAttribute('aria-active');
            }
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('active') ||
            changedProperties.has('completed') ||
            changedProperties.has('variant')) {
            __classPrivateFieldGet$1(this, _TimelineItem_contextProvider, "f").setValue({
                variant: this.variant ?? 'neutral',
                completed: Boolean(this.completed),
                active: Boolean(this.active),
            });
        }
    }
    render() {
        return x `
			<div class="side">
				<span aria-hidden="true" class="circle">
					<slot name="item-icon">
						<span class="dot"></span>
						<span class="exclamation">!</span>
						<m-icon
							class="check"
							name="check"
							size="12"
							color="color-text-inverted"
						></m-icon>
					</slot>
				</span>
				<span class="track"></span>
			</div>
			<div
				class="${o$2({
            content: true,
            '-divider': Boolean(this.divider),
        })}"
			>
				<slot name="item-header"></slot>
				<slot name="item-body"></slot>
				<slot name="item-footer"></slot>
			</div>
		`;
    }
}
_TimelineItem_contextProvider = new WeakMap();
TimelineItem.styles = [timelineItemStyles()];
window.customElements.define('m-timeline-item', TimelineItem);

class TimelineItemBody extends s$7 {
    connectedCallback() {
        super.connectedCallback();
        this.slot = 'item-body';
        this.classList.add('m-timeline-item-body');
    }
    render() {
        return x `<slot></slot>`;
    }
}
TimelineItemBody.styles = [timelineBodyStyles()];
window.customElements.define('m-timeline-item-body', TimelineItemBody);

class TimelineItemFooter extends s$7 {
    connectedCallback() {
        super.connectedCallback();
        this.slot = 'item-footer';
    }
    render() {
        return x `<slot></slot>`;
    }
}
TimelineItemFooter.styles = [timelineFooterStyles()];
window.customElements.define('m-timeline-item-footer', TimelineItemFooter);

class TimelineItemHeader extends s$7 {
    static get properties() {
        return {
            align: { type: String },
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.slot = 'item-header';
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('align')) {
            this.style.setProperty('--m-timeline-item-header-align', this.align ?? 'baseline');
        }
    }
    render() {
        return x `
			<slot name="item-header-title"></slot>
			<slot name="item-header-subtitle"></slot>
			<slot></slot>
		`;
    }
}
TimelineItemHeader.styles = [timelineItemHeaderStyles()];
window.customElements.define('m-timeline-item-header', TimelineItemHeader);

class TimelineItemHeaderSubtitle extends Text {
    connectedCallback() {
        super.connectedCallback();
        this.slot = 'item-header-subtitle';
        this.variant = 'body-sm';
        this.color = 'color-text-tertiary';
    }
}
window.customElements.define('m-timeline-item-header-subtitle', TimelineItemHeaderSubtitle);

var _TimelineItemHeaderTitle_context, _TimelineItemHeaderTitle_updateTextStyle;
class TimelineItemHeaderTitle extends Text {
    constructor() {
        super();
        _TimelineItemHeaderTitle_context.set(this, void 0);
        _TimelineItemHeaderTitle_updateTextStyle.set(this, () => {
            const { value } = __classPrivateFieldGet$1(this, _TimelineItemHeaderTitle_context, "f");
            if (!value) {
                return;
            }
            if (value.completed) {
                this.color = 'color-text-tertiary';
                this.variant = 'heading-sm';
            }
            else if (value.active) {
                this.color = 'color-primary-60';
                this.variant = 'heading-sm-bold';
            }
            else if (value.variant === 'warning') {
                this.color = 'color-warning-100';
                this.variant = 'heading-sm';
            }
            else {
                this.color = 'color-text-secondary';
                this.variant = 'heading-sm';
            }
        });
        __classPrivateFieldSet(this, _TimelineItemHeaderTitle_context, new s$1(this, {
            context: timelineItemContext,
            subscribe: true,
            callback: __classPrivateFieldGet$1(this, _TimelineItemHeaderTitle_updateTextStyle, "f"),
        }), "f");
    }
    connectedCallback() {
        super.connectedCallback();
        this.slot = 'item-header-title';
        this.variant = 'heading-sm';
        this.color = 'color-text-tertiary';
    }
}
_TimelineItemHeaderTitle_context = new WeakMap(), _TimelineItemHeaderTitle_updateTextStyle = new WeakMap();
window.customElements.define('m-timeline-item-header-title', TimelineItemHeaderTitle);

class TimelineItemIcon extends s$7 {
    connectedCallback() {
        super.connectedCallback();
        this.slot = 'item-icon';
    }
    render() {
        return x `<slot></slot>`;
    }
}
TimelineItemIcon.styles = [timelineIconStyles()];
window.customElements.define('m-timeline-item-icon', TimelineItemIcon);

const TOGGLE_EVENT = 'm-toggle';

function styles$3() {
    return [
        i$5 `
			.toggle-group {
				inline-size: max-content;

				border: 1px solid ${getColor('color-border-input')};
				padding: ${getToken$1('spacing-1')};

				border-radius: ${getToken$1('border-radius-s')};
				box-sizing: border-box;

				block-size: ${getToken$1('global-height-default')};
			}

			.toggle-group.-small {
				block-size: ${getToken$1('global-height-small')};
			}

			.toggle-group.-small ::slotted(m-toggle) {
				--m-toggle-base-size: 18px;
				--m-toggle-font-size: ${getToken$1('font-size-2')};
				--m-toggle-icon-size: 10px;
			}

			.toggle-group.-show-check ::slotted(m-toggle[aria-checked='true']) {
				--m-toggle-icon-display: inline-flex;
			}
		`,
    ];
}

var _ToggleGroup_selectionController, _ToggleGroup_defaultSlot, _ToggleGroup_getToggles, _ToggleGroup_setToggleRole, _ToggleGroup_setToggleChecked, _ToggleGroup_setToggleDisabled;
class ToggleGroup extends s$7 {
    static get properties() {
        return {
            disabled: { type: Boolean },
            name: { type: String, reflect: true },
            role: { type: String, reflect: true },
            showCheck: { type: Boolean, attribute: 'show-check' },
            size: { type: String, reflect: true },
            type: { type: String },
            value: {},
            selection: { state: true },
        };
    }
    constructor() {
        super();
        _ToggleGroup_selectionController.set(this, null);
        _ToggleGroup_defaultSlot.set(this, null);
        _ToggleGroup_getToggles.set(this, () => {
            if (!__classPrivateFieldGet$1(this, _ToggleGroup_defaultSlot, "f")) {
                __classPrivateFieldSet(this, _ToggleGroup_defaultSlot, this.shadowRoot && this.shadowRoot.querySelector('slot'), "f");
            }
            const items = __classPrivateFieldGet$1(this, _ToggleGroup_defaultSlot, "f")?.assignedElements({ flatten: true }) ?? [];
            return [...items].filter((item) => item.tagName.toLowerCase() === 'm-toggle');
        });
        _ToggleGroup_setToggleRole.set(this, (toggle) => {
            toggle.setAttribute('role', ['single', 'single-strict'].includes(this.type) ? 'radio' : 'checkbox');
        });
        _ToggleGroup_setToggleChecked.set(this, (toggle) => {
            // eslint-disable-next-line no-param-reassign
            toggle.checked = this.selection.has(toggle.value);
        });
        _ToggleGroup_setToggleDisabled.set(this, (toggle) => {
            // eslint-disable-next-line no-param-reassign
            toggle.disabled = this.disabled;
        });
        this.showCheck = false;
        this.size = 'default';
        this.type = 'single';
        this.selection = new Set();
    }
    update(changedProperties) {
        super.update(changedProperties);
        /**
         * [!] This flow covers a toggle group changing its selection `type` after being mounted
         * and having its selection controller initialized.
         */
        if ((changedProperties.get('type') != null && this.type != null) ||
            __classPrivateFieldGet$1(this, _ToggleGroup_selectionController, "f") == null) {
            __classPrivateFieldSet(this, _ToggleGroup_selectionController, new SelectionController(this, this.type, TOGGLE_EVENT), "f");
            __classPrivateFieldGet$1(this, _ToggleGroup_selectionController, "f").init(toArray(this.value));
            // eslint-disable-next-line lit/no-property-change-update -- FIXME
            this.role = ['single', 'single-strict'].includes(this.type)
                ? 'radiogroup'
                : 'group';
        }
        if (changedProperties.has('value')) {
            __classPrivateFieldGet$1(this, _ToggleGroup_selectionController, "f").init(toArray(this.value));
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('selection')) {
            __classPrivateFieldGet$1(this, _ToggleGroup_getToggles, "f").call(this).forEach((toggle) => {
                __classPrivateFieldGet$1(this, _ToggleGroup_setToggleChecked, "f").call(this, toggle);
            });
        }
        if (changedProperties.has('disabled')) {
            __classPrivateFieldGet$1(this, _ToggleGroup_getToggles, "f").call(this).forEach((toggle) => {
                __classPrivateFieldGet$1(this, _ToggleGroup_setToggleDisabled, "f").call(this, toggle);
            });
        }
        if (changedProperties.has('role')) {
            __classPrivateFieldGet$1(this, _ToggleGroup_getToggles, "f").call(this).forEach((toggle) => {
                __classPrivateFieldGet$1(this, _ToggleGroup_setToggleRole, "f").call(this, toggle);
            });
        }
    }
    render() {
        return x `
			<m-group
				class=${o$2({
            'toggle-group': true,
            '-single': this.type === 'single',
            '-single-strict': this.type === 'single-strict',
            '-multiple': this.type === 'multiple',
            '-small': this.size === 'small',
            '-show-check': this.showCheck,
        })}
				gap="spacing-1"
			>
				<slot></slot>
			</m-group>
		`;
    }
}
_ToggleGroup_selectionController = new WeakMap(), _ToggleGroup_defaultSlot = new WeakMap(), _ToggleGroup_getToggles = new WeakMap(), _ToggleGroup_setToggleRole = new WeakMap(), _ToggleGroup_setToggleChecked = new WeakMap(), _ToggleGroup_setToggleDisabled = new WeakMap();
ToggleGroup.styles = [styles$3()];
window.customElements.define('m-toggle-group', ToggleGroup);

function styles$2() {
    return [
        styles$G(),
        i$5 `
			:host {
				/*
				 * These custom properties are here because they are meant to be
				 * overriden via toggle-group styles.
				 */
				--m-toggle-base-size: 30px;
				--m-toggle-font-size: ${getToken$1('font-size-3')};
				--m-toggle-icon-size: 12px;
				--m-toggle-icon-display: none;

				--m-button-border-color: transparent;
				--m-button-color: ${getColor('color-primary-100')};
				--m-button-padding-x: ${getToken$1('spacing-2')};
				--m-button-padding-y: 0;

				--m-button-base-size: var(--m-toggle-base-size);
				--m-button-font-size: var(--m-toggle-font-size);
			}

			${on(['.toggle']).disabled} {
				--m-button-color: ${getColor('color-text-disabled')};
			}

			[aria-checked='true'] {
				--m-button-background-color: ${getColor('color-primary-20')};
			}

			${on('.toggle').not.disabled.hover} {
				--m-button-background-color: ${getColor('color-background-tertiary')};
				--m-button-border-color: ${getColor('color-background-tertiary')};
				--m-button-color: ${getColor('color-primary-100')};
			}

			.check-icon {
				--m-icon-size: var(--m-toggle-icon-size);
				--m-icon-color: var(--m-button-color);

				display: var(--m-toggle-icon-display);
			}
		`,
    ];
}

var _Toggle_instances, _Toggle_button_get, _Toggle_handleClick, _Toggle_setDisabled, _Toggle_setChecked;
class Toggle extends s$7 {
    static get properties() {
        return {
            checked: { type: Boolean },
            disabled: { type: Boolean, reflect: true },
            role: { type: String, reflect: true },
            value: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        _Toggle_instances.add(this);
        _Toggle_handleClick.set(this, () => {
            if (this.disabled) {
                return;
            }
            this.checked = !this.checked;
            const options = {
                detail: { value: this.value, type: 'toggle' },
                bubbles: true,
                composed: false,
            };
            this.dispatchEvent(new CustomEvent(TOGGLE_EVENT, options));
        });
        _Toggle_setDisabled.set(this, () => {
            this.setAttribute('aria-disabled', String(this.disabled ?? false));
        });
        _Toggle_setChecked.set(this, () => {
            this.setAttribute('aria-checked', String(this.checked ?? false));
        });
        this.disabled = false;
        this.checked = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', __classPrivateFieldGet$1(this, _Toggle_handleClick, "f"));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', __classPrivateFieldGet$1(this, _Toggle_handleClick, "f"));
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('disabled')) {
            __classPrivateFieldGet$1(this, _Toggle_setDisabled, "f").call(this);
        }
        if (changedProperties.has('checked')) {
            __classPrivateFieldGet$1(this, _Toggle_setChecked, "f").call(this);
        }
    }
    render() {
        return x `
			<button
				type="button"
				class=${o$2({
            button: true,
            toggle: true,
        })}
				role="${this.role}"
				aria-checked="${this.checked}"
				?disabled="${this.disabled}"
			>
				<slot name="leading" slot="leading">
					<m-icon name="check" class="check-icon"></m-icon>
				</slot>

				<slot></slot>
			</button>
		`;
    }
    focus(options) {
        __classPrivateFieldGet$1(this, _Toggle_instances, "a", _Toggle_button_get)?.focus(options);
    }
}
_Toggle_handleClick = new WeakMap(), _Toggle_setDisabled = new WeakMap(), _Toggle_setChecked = new WeakMap(), _Toggle_instances = new WeakSet(), _Toggle_button_get = function _Toggle_button_get() {
    return this.renderRoot?.querySelector('button') ?? null;
};
Toggle.styles = [styles$2()];
window.customElements.define('m-toggle', Toggle);

function trim(value) {
    return value.trim();
}
function convertTriggerFromAttribute(value) {
    if (!value) {
        return ['hover'];
    }
    return String(value)
        .split(/[\s,]+/)
        .map(trim)
        .filter(Boolean);
}

function styles$1() {
    return [
        styles$m({
            floatingSelector: '#floating',
        }),
        i$5 `
			:host {
				--m-popover-width: max-content;
				--m-popover-min-width: 80px;
				--m-popover-max-width: 80ch;
				--m-popover-overflow-x: visible;

				display: inline-flex;
				align-items: center;

				max-width: 100%;
			}
		`,
    ];
}

var _Tooltip_hoverTimeout, _Tooltip_focusTimeout, _Tooltip_handleFocus, _Tooltip_handleBlur, _Tooltip_handleClick, _Tooltip_handleKeyDown, _Tooltip_handleMouseOver, _Tooltip_handleMouseOut, _Tooltip_hasTrigger;
class Tooltip extends Popover {
    static get properties() {
        return {
            ...Popover.properties,
            trigger: {
                type: String,
                converter: { fromAttribute: convertTriggerFromAttribute },
            },
        };
    }
    constructor() {
        super();
        _Tooltip_hoverTimeout.set(this, void 0);
        _Tooltip_focusTimeout.set(this, void 0);
        _Tooltip_handleFocus.set(this, () => {
            if (__classPrivateFieldGet$1(this, _Tooltip_hasTrigger, "f").call(this, 'focus')) {
                clearTimeout(__classPrivateFieldGet$1(this, _Tooltip_focusTimeout, "f"));
                __classPrivateFieldSet(this, _Tooltip_focusTimeout, window.setTimeout(() => this.show(), 450), "f");
            }
        });
        _Tooltip_handleBlur.set(this, () => {
            if (__classPrivateFieldGet$1(this, _Tooltip_hasTrigger, "f").call(this, 'focus')) {
                clearTimeout(__classPrivateFieldGet$1(this, _Tooltip_focusTimeout, "f"));
                __classPrivateFieldSet(this, _Tooltip_focusTimeout, window.setTimeout(() => this.hide(), 450), "f");
            }
        });
        _Tooltip_handleClick.set(this, () => {
            if (__classPrivateFieldGet$1(this, _Tooltip_hasTrigger, "f").call(this, 'click')) {
                this.toggle();
            }
        });
        _Tooltip_handleKeyDown.set(this, (event) => {
            if (this.open && event.key === 'Escape') {
                event.stopPropagation();
                this.hide();
            }
        });
        _Tooltip_handleMouseOver.set(this, () => {
            if (__classPrivateFieldGet$1(this, _Tooltip_hasTrigger, "f").call(this, 'hover')) {
                clearTimeout(__classPrivateFieldGet$1(this, _Tooltip_hoverTimeout, "f"));
                __classPrivateFieldSet(this, _Tooltip_hoverTimeout, window.setTimeout(() => this.show(), 450), "f");
            }
        });
        _Tooltip_handleMouseOut.set(this, () => {
            if (__classPrivateFieldGet$1(this, _Tooltip_hasTrigger, "f").call(this, 'hover')) {
                clearTimeout(__classPrivateFieldGet$1(this, _Tooltip_hoverTimeout, "f"));
                __classPrivateFieldSet(this, _Tooltip_hoverTimeout, window.setTimeout(() => this.hide(), 450), "f");
            }
        });
        _Tooltip_hasTrigger.set(this, (triggerType) => {
            return this.trigger.includes(triggerType);
        });
        this.position = 'fixed';
        this.placement = 'top-start';
        this.trigger = ['hover', 'focus'];
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('blur', __classPrivateFieldGet$1(this, _Tooltip_handleBlur, "f"), true);
        this.addEventListener('click', __classPrivateFieldGet$1(this, _Tooltip_handleClick, "f"));
        this.addEventListener('focus', __classPrivateFieldGet$1(this, _Tooltip_handleFocus, "f"), true);
        this.addEventListener('keydown', __classPrivateFieldGet$1(this, _Tooltip_handleKeyDown, "f"));
        this.addEventListener('mouseout', __classPrivateFieldGet$1(this, _Tooltip_handleMouseOut, "f"));
        this.addEventListener('mouseover', __classPrivateFieldGet$1(this, _Tooltip_handleMouseOver, "f"));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('blur', __classPrivateFieldGet$1(this, _Tooltip_handleBlur, "f"), true);
        this.removeEventListener('focus', __classPrivateFieldGet$1(this, _Tooltip_handleFocus, "f"), true);
        this.removeEventListener('click', __classPrivateFieldGet$1(this, _Tooltip_handleClick, "f"));
        this.removeEventListener('keydown', __classPrivateFieldGet$1(this, _Tooltip_handleKeyDown, "f"));
        this.removeEventListener('mouseover', __classPrivateFieldGet$1(this, _Tooltip_handleMouseOver, "f"));
        this.removeEventListener('mouseout', __classPrivateFieldGet$1(this, _Tooltip_handleMouseOut, "f"));
    }
    getReferenceElement() {
        const referenceSlot = this.shadowRoot.querySelector('slot[name="reference"]');
        const [reference] = referenceSlot.assignedElements({ flatten: true });
        return reference;
    }
    getFloatingElement() {
        return this.shadowRoot.querySelector('#floating');
    }
    getArrowElement() {
        return this.shadowRoot.querySelector('#arrow');
    }
    render() {
        return x `
			<slot name="reference" aria-describedby="floating"></slot>
			<div
				id="floating"
				role="tooltip"
				aria-live=${this.open ? 'polite' : 'off'}
			>
				${this.renderArrow()}
				<slot name="floating" aria-hidden="true"></slot>
			</div>
		`;
    }
}
_Tooltip_hoverTimeout = new WeakMap(), _Tooltip_focusTimeout = new WeakMap(), _Tooltip_handleFocus = new WeakMap(), _Tooltip_handleBlur = new WeakMap(), _Tooltip_handleClick = new WeakMap(), _Tooltip_handleKeyDown = new WeakMap(), _Tooltip_handleMouseOver = new WeakMap(), _Tooltip_handleMouseOut = new WeakMap(), _Tooltip_hasTrigger = new WeakMap();
Tooltip.styles = [styles$1()];
window.customElements.define('m-tooltip', Tooltip);

const TOOLTIP_PLACEMENT_VALUES = POPOVER_PLACEMENT_VALUES;

function styles() {
    return i$5 `
		:host {
			inline-size: var(--m-logo-size);
			block-size: var(--m-logo-size);
			display: block;
		}

		:host linearGradient {
			transform-origin: center;
		}
	`;
}

var _LogoLoader_instances, _LogoLoader_getSize;
const DEFAULT_SIZE = '48';
class LogoLoader extends s$7 {
    constructor() {
        super(...arguments);
        _LogoLoader_instances.add(this);
    }
    static get properties() {
        return {
            size: { type: String, reflect: true },
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.style.setProperty('--m-logo-size', __classPrivateFieldGet$1(this, _LogoLoader_instances, "m", _LogoLoader_getSize).call(this));
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('size')) {
            this.style.setProperty('--m-logo-size', __classPrivateFieldGet$1(this, _LogoLoader_instances, "m", _LogoLoader_getSize).call(this));
        }
    }
    render() {
        return b$1 `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 49 48"><g opacity=".7"><mask id="a" width="49" height="16" x="0" y="32" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M32.1364 48H.5l15.1072-15.2727H48.5L33.4266 47.317c-.3323.3324-.818.683-1.2902.683Z"/></mask><g mask="url(#a)"><path fill="url(#b)" d="M-10.4091-10.9091h69.8182v69.8182h-69.8182z"/></g></g><mask id="c" width="32" height="17" x="17" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M17.9546 16.3636V0H48.5L33.2273 16.3636H17.9546Z"/></mask><g mask="url(#c)"><path fill="url(#d)" d="M-10.4091-10.9091h69.8182v69.8182h-69.8182z"/></g><g opacity=".7"><mask id="e" width="16" height="31" x="33" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M48.5 30.5455H33.2273V16.3637L48.5 0v30.5455Z"/></mask><g mask="url(#e)"><path fill="url(#f)" d="M-10.4091-10.9091h69.8182v69.8182h-69.8182z"/></g></g><mask id="g" width="16" height="48" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M15.7727 0v32.7273L.5 48V16.94c0-.4722.18803-.9226.52036-1.2571L15.7727 0Z"/></mask><g mask="url(#g)"><path fill="url(#h)" d="M-10.4091-10.9091h69.8182v69.8182h-69.8182z"/></g><defs><linearGradient id="b" x1="3.56649" x2="53.8665" y1="50.4164" y2=".131295" gradientUnits="userSpaceOnUse"><stop offset=".1" stop-color="#00D7D7"/><stop offset="1" stop-color="#84F11E"/><animateTransform attributeName="gradientTransform" dur="0.8s" repeatCount="indefinite" type="rotate" values="0; 360"/></linearGradient><linearGradient id="d" x1="3.56649" x2="53.8665" y1="50.4164" y2=".131295" gradientUnits="userSpaceOnUse"><stop offset=".1" stop-color="#00D7D7"/><stop offset="1" stop-color="#84F11E"/><animateTransform attributeName="gradientTransform" dur="0.8s" repeatCount="indefinite" type="rotate" values="0; 360"/></linearGradient><linearGradient id="f" x1="3.56649" x2="53.8665" y1="50.4164" y2=".131295" gradientUnits="userSpaceOnUse"><stop offset=".1" stop-color="#00D7D7"/><stop offset="1" stop-color="#84F11E"/><animateTransform attributeName="gradientTransform" dur="0.8s" repeatCount="indefinite" type="rotate" values="0; 360"/></linearGradient><linearGradient id="h" x1="3.56649" x2="53.8665" y1="50.4164" y2=".131295" gradientUnits="userSpaceOnUse"><stop offset=".1" stop-color="#00D7D7"/><stop offset="1" stop-color="#84F11E"/><animateTransform attributeName="gradientTransform" dur="0.8s" repeatCount="indefinite" type="rotate" values="0; 360"/></linearGradient></defs></svg>`;
    }
}
_LogoLoader_instances = new WeakSet(), _LogoLoader_getSize = function _LogoLoader_getSize() {
    const parsedSize = parseInt(this.size ?? DEFAULT_SIZE, 10);
    if (Number.isNaN(parsedSize)) {
        return `${DEFAULT_SIZE}px`;
    }
    return `${parsedSize || DEFAULT_SIZE}px`;
};
LogoLoader.styles = [styles()];
window.customElements.define('m-logo-loader', LogoLoader);

export { EmptyStateHeader as $, Accordion as A, BackButton as B, Card as C, Dialog as D, DialogActionPrimary as E, DialogActionSecondary as F, DialogActionTertiary as G, DialogActions as H, DialogBody as I, DialogClose as J, DialogFooter as K, DialogHeader as L, Divider as M, Drawer as N, DRAWER_SIZES as O, DrawerActionPrimary as P, DrawerActionSecondary as Q, DrawerActionTertiary as R, DrawerActions as S, DrawerBody as T, DrawerClose as U, DrawerHeader as V, Dropdown as W, DropdownTrigger as X, DropdownMenu as Y, DropdownItem as Z, EmptyStateAction as _, AccordionTitle as a, Tabs as a$, EmptyStateIllustration as a0, EmptyStateMessage as a1, EmptyState as a2, EMPTY_STATE_VARIANTS as a3, Field as a4, FieldHint as a5, FieldLabel as a6, FIELD_STATUSES as a7, Header as a8, HeaderActions as a9, Column as aA, Link as aB, PageContent as aC, Pagination as aD, ProgressBar as aE, ProgressBarCountdown as aF, Radio as aG, RadioGroup as aH, Section as aI, SectionTitle as aJ, SpinnerWheel as aK, Steps as aL, Step as aM, Switch as aN, Table as aO, defaultTableProps as aP, TableHead as aQ, TableHeadCell as aR, defaultTableHeadCellProps as aS, TableBody as aT, TableFoot as aU, TableRow as aV, TableCell as aW, defaultTableCellProps as aX, TableToolbar as aY, TableFeedback as aZ, TableActions as a_, HeaderContent as aa, HeaderTitle as ab, SubHeader as ac, AVAILABLE_ICONS as ad, Icon as ae, Label as af, defaultLabeledValueProps as ag, LabeledValue as ah, LabeledValueLabel as ai, LabeledValueValue as aj, ALIGN_ITEMS_VALUES as ak, JUSTIFY_CONTENT_VALUES as al, Box as am, defaultBoxProps as an, Group as ao, defaultGroupProps as ap, Stack as aq, defaultStackProps as ar, Grid as as, defaultGridProps as at, Sidebar as au, defaultSidebarProps as av, Switcher as aw, defaultSwitcherProps as ax, Container as ay, Row as az, b, Tab as b0, TabPanel as b1, Tag as b2, ActionableTag as b3, Text as b4, TextArea as b5, TextField as b6, Timeline as b7, TimelineExpandableItem as b8, TimelineItem as b9, TimelineItemBody as ba, TimelineItemFooter as bb, TimelineItemHeader as bc, TimelineItemHeaderSubtitle as bd, TimelineItemHeaderTitle as be, TimelineItemIcon as bf, ToggleGroup as bg, Toggle as bh, Tooltip as bi, TOOLTIP_PLACEMENT_VALUES as bj, LogoLoader as bk, DotsLoader as bl, AccordionContent as c, Badge as d, BannerActionPrimary as e, BannerActionSecondary as f, BannerActions as g, BannerDescription as h, BannerIcon as i, BannerTitle as j, Banner as k, Body as l, Button as m, CardBody as n, CardSubtitle as o, CardTitle as p, CardDivider as q, CardFooter as r, CardActionPrimary as s, typographyVariants as t, CardActionSecondary as u, CardActionTertiary as v, Checkbox as w, CloseButton as x, DIALOG_SIZES as y, DIALOG_VARIANTS as z };
